export const gwasData = [
  {
    "accessionId": "GCST90013473",
    "initial_individuals": "2462132",
    "initial_ancestralGroup": "European",
    "pubmedId": "33888908",
    "EFO_ID": "PATO_0000047",
    "EFO_Trait_Name": "biological sex",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90013001-GCST90014000/GCST90013473/harmonised/GCST90013473.h.tsv.gz"
  },
  {
    "accessionId": "GCST90446168",
    "initial_individuals": "2266733",
    "initial_ancestralGroup": "European",
    "pubmedId": "39242605",
    "EFO_ID": "EFO_0008354",
    "EFO_Trait_Name": "cognitive function measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90446001-GCST90447000/GCST90446168/harmonised/GCST90446168.h.tsv.gz"
  },
  {
    "accessionId": "GCST90624411",
    "initial_individuals": "2212177",
    "initial_ancestralGroup": "European",
    "pubmedId": "40645996",
    "EFO_ID": "EFO_0000275",
    "EFO_Trait_Name": "atrial fibrillation",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90624001-GCST90625000/GCST90624411/harmonised/GCST90624411.h.tsv.gz"
  },
  {
    "accessionId": "GCST90245990",
    "initial_individuals": "2200007",
    "initial_ancestralGroup": "European",
    "pubmedId": "36224396",
    "EFO_ID": "OBA_VT0001253",
    "EFO_Trait_Name": "body height",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90245001-GCST90246000/GCST90245990/harmonised/GCST90245990.h.tsv.gz"
  },
  {
    "accessionId": "GCST90627763",
    "initial_individuals": "2106366",
    "initial_ancestralGroup": "European",
    "pubmedId": "41644669",
    "EFO_ID": "EFO_0002892",
    "EFO_Trait_Name": "thyroid carcinoma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90627001-GCST90628000/GCST90627763/harmonised/GCST90627763.h.tsv.gz"
  },
  {
    "accessionId": "GCST90624046",
    "initial_individuals": "2105711",
    "initial_ancestralGroup": "European",
    "pubmedId": "40759756",
    "EFO_ID": "EFO_0009885",
    "EFO_Trait_Name": "frailty measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90624001-GCST90625000/GCST90624046/harmonised/GCST90624046.h.tsv.gz"
  },
  {
    "accessionId": "GCST90651074",
    "initial_individuals": "1984229",
    "initial_ancestralGroup": "European",
    "pubmedId": "41419685",
    "EFO_ID": "EFO_0000266",
    "EFO_Trait_Name": "aortic stenosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90651001-GCST90652000/GCST90651074/harmonised/GCST90651074.h.tsv.gz"
  },
  {
    "accessionId": "GCST90455657",
    "initial_individuals": "1893921",
    "initial_ancestralGroup": "European",
    "pubmedId": "40195560",
    "EFO_ID": "EFO_0003144",
    "EFO_Trait_Name": "heart failure",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90455001-GCST90456000/GCST90455657/harmonised/GCST90455657.h.tsv.gz"
  },
  {
    "accessionId": "GCST90627744",
    "initial_individuals": "1881665",
    "initial_ancestralGroup": "European",
    "pubmedId": "41644669",
    "EFO_ID": "EFO_0004237",
    "EFO_Trait_Name": "Graves disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90627001-GCST90628000/GCST90627744/harmonised/GCST90627744.h.tsv.gz"
  },
  {
    "accessionId": "GCST90627740",
    "initial_individuals": "1807553",
    "initial_ancestralGroup": "European",
    "pubmedId": "41644669",
    "EFO_ID": "EFO_1001062",
    "EFO_Trait_Name": "nodular goiter",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90627001-GCST90628000/GCST90627740/harmonised/GCST90627740.h.tsv.gz"
  },
  {
    "accessionId": "GCST90627749",
    "initial_individuals": "1786062",
    "initial_ancestralGroup": "European",
    "pubmedId": "41644669",
    "EFO_ID": "EFO_0004705",
    "EFO_Trait_Name": "hypothyroidism",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90627001-GCST90628000/GCST90627749/harmonised/GCST90627749.h.tsv.gz"
  },
  {
    "accessionId": "GCST90566795",
    "initial_individuals": "1713110",
    "initial_ancestralGroup": "European",
    "pubmedId": "40205036",
    "EFO_ID": "MONDO_0005178",
    "EFO_Trait_Name": "osteoarthritis",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90566001-GCST90567000/GCST90566795/harmonised/GCST90566795.h.tsv.gz"
  },
  {
    "accessionId": "GCST90319877",
    "initial_individuals": "1580011",
    "initial_ancestralGroup": "European",
    "pubmedId": "38632349",
    "EFO_ID": "EFO_0001422",
    "EFO_Trait_Name": "cirrhosis of liver",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90319001-GCST90320000/GCST90319877/harmonised/GCST90319877.h.tsv.gz"
  },
  {
    "accessionId": "GCST90566700",
    "initial_individuals": "1485217",
    "initial_ancestralGroup": "European",
    "pubmedId": "40360725",
    "EFO_ID": "EFO_0009695",
    "EFO_Trait_Name": "household income",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90566001-GCST90567000/GCST90566700/harmonised/GCST90566700.h.tsv.gz"
  },
  {
    "accessionId": "GCST90627754",
    "initial_individuals": "1420658",
    "initial_ancestralGroup": "European",
    "pubmedId": "41644669",
    "EFO_ID": "EFO_0003779",
    "EFO_Trait_Name": "Hashimoto's thyroiditis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90627001-GCST90628000/GCST90627754/harmonised/GCST90627754.h.tsv.gz"
  },
  {
    "accessionId": "GCST90444487",
    "initial_individuals": "1384348",
    "initial_ancestralGroup": "European",
    "pubmedId": "39349817",
    "EFO_ID": "EFO_0000195",
    "EFO_Trait_Name": "metabolic syndrome",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90444001-GCST90445000/GCST90444487/harmonised/GCST90444487.h.tsv.gz"
  },
  {
    "accessionId": "GCST90132315",
    "initial_individuals": "1378170",
    "initial_ancestralGroup": "European",
    "pubmedId": "36474045",
    "EFO_ID": "EFO_0001645",
    "EFO_Trait_Name": "coronary artery disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90132001-GCST90133000/GCST90132315/harmonised/GCST90132315.h.tsv.gz"
  },
  {
    "accessionId": "GCST90399686",
    "initial_individuals": "1376071",
    "initial_ancestralGroup": "European",
    "pubmedId": "36777996",
    "EFO_ID": "MONDO_0004979",
    "EFO_Trait_Name": "asthma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90399001-GCST90400000/GCST90399686/harmonised/GCST90399686.h.tsv.gz"
  },
  {
    "accessionId": "GCST90503483",
    "initial_individuals": "1374560",
    "initial_ancestralGroup": "European",
    "pubmedId": "40075078",
    "EFO_ID": "MONDO_0019338",
    "EFO_Trait_Name": "sarcoidosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90503001-GCST90504000/GCST90503483/harmonised/GCST90503483.h.tsv.gz"
  },
  {
    "accessionId": "GCST90399736",
    "initial_individuals": "1339769",
    "initial_ancestralGroup": "European",
    "pubmedId": "36777996",
    "EFO_ID": "MONDO_0002108",
    "EFO_Trait_Name": "thyroid cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90399001-GCST90400000/GCST90399736/harmonised/GCST90399736.h.tsv.gz"
  },
  {
    "accessionId": "GCST90239664",
    "initial_individuals": "1320016",
    "initial_ancestralGroup": "European",
    "pubmedId": "34887591",
    "EFO_ID": "EFO_0004530",
    "EFO_Trait_Name": "triglyceride measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90239001-GCST90240000/GCST90239664/harmonised/GCST90239664.h.tsv.gz"
  },
  {
    "accessionId": "GCST90239676",
    "initial_individuals": "1320016",
    "initial_ancestralGroup": "European",
    "pubmedId": "34887591",
    "EFO_ID": "EFO_0004574",
    "EFO_Trait_Name": "total cholesterol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90239001-GCST90240000/GCST90239676/harmonised/GCST90239676.h.tsv.gz"
  },
  {
    "accessionId": "GCST90239670",
    "initial_individuals": "1320016",
    "initial_ancestralGroup": "European",
    "pubmedId": "34887591",
    "EFO_ID": "EFO_0005689",
    "EFO_Trait_Name": "non-high density lipoprotein cholesterol measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90239001-GCST90240000/GCST90239670/harmonised/GCST90239670.h.tsv.gz"
  },
  {
    "accessionId": "GCST90104539",
    "initial_individuals": "1308460",
    "initial_ancestralGroup": "European",
    "pubmedId": "36180795",
    "EFO_ID": "EFO_0000712",
    "EFO_Trait_Name": "stroke",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90104001-GCST90105000/GCST90104539/harmonised/GCST90104539.h.tsv.gz"
  },
  {
    "accessionId": "GCST90104540",
    "initial_individuals": "1296908",
    "initial_ancestralGroup": "European",
    "pubmedId": "36180795",
    "EFO_ID": "HP_0002140",
    "EFO_Trait_Name": "Ischemic stroke",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90104001-GCST90105000/GCST90104540/harmonised/GCST90104540.h.tsv.gz"
  },
  {
    "accessionId": "GCST90652487",
    "initial_individuals": "1282582",
    "initial_ancestralGroup": "European",
    "pubmedId": "40835838",
    "EFO_ID": "EFO_0004212",
    "EFO_Trait_Name": "keloid",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90652001-GCST90653000/GCST90652487/harmonised/GCST90652487.h.tsv.gz"
  },
  {
    "accessionId": "GCST90399672",
    "initial_individuals": "1264918",
    "initial_ancestralGroup": "European",
    "pubmedId": "36777996",
    "EFO_ID": "EFO_0004214",
    "EFO_Trait_Name": "abdominal aortic aneurysm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90399001-GCST90400000/GCST90399672/harmonised/GCST90399672.h.tsv.gz"
  },
  {
    "accessionId": "GCST90624743",
    "initial_individuals": "1258753",
    "initial_ancestralGroup": "European",
    "pubmedId": "40883272",
    "EFO_ID": "EFO_0001642",
    "EFO_Trait_Name": "lymphoid neoplasm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90624001-GCST90625000/GCST90624743/harmonised/GCST90624743.h.tsv.gz"
  },
  {
    "accessionId": "GCST90104541",
    "initial_individuals": "1245612",
    "initial_ancestralGroup": "European",
    "pubmedId": "36180795",
    "EFO_ID": "EFO_1001976",
    "EFO_Trait_Name": "cardioembolic stroke",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90104001-GCST90105000/GCST90104541/harmonised/GCST90104541.h.tsv.gz"
  },
  {
    "accessionId": "GCST90104543",
    "initial_individuals": "1241619",
    "initial_ancestralGroup": "European",
    "pubmedId": "36180795",
    "EFO_ID": "EFO_1001504",
    "EFO_Trait_Name": "small vessel stroke",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90104001-GCST90105000/GCST90104543/harmonised/GCST90104543.h.tsv.gz"
  },
  {
    "accessionId": "GCST90104542",
    "initial_individuals": "1241207",
    "initial_ancestralGroup": "European",
    "pubmedId": "36180795",
    "EFO_ID": "EFO_0005524",
    "EFO_Trait_Name": "large artery stroke",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90104001-GCST90105000/GCST90104542/harmonised/GCST90104542.h.tsv.gz"
  },
  {
    "accessionId": "GCST90624746",
    "initial_individuals": "1232629",
    "initial_ancestralGroup": "European",
    "pubmedId": "40883272",
    "EFO_ID": "EFO_0000203",
    "EFO_Trait_Name": "monoclonal gammopathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90624001-GCST90625000/GCST90624746/harmonised/GCST90624746.h.tsv.gz"
  },
  {
    "accessionId": "GCST90399725",
    "initial_individuals": "1172905",
    "initial_ancestralGroup": "European",
    "pubmedId": "36777996",
    "EFO_ID": "EFO_0004190",
    "EFO_Trait_Name": "open-angle glaucoma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90399001-GCST90400000/GCST90399725/harmonised/GCST90399725.h.tsv.gz"
  },
  {
    "accessionId": "GCST90652486",
    "initial_individuals": "1135463",
    "initial_ancestralGroup": "European",
    "pubmedId": "40650879",
    "EFO_ID": "EFO_1000710",
    "EFO_Trait_Name": "hidradenitis suppurativa",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90652001-GCST90653000/GCST90652486/harmonised/GCST90652486.h.tsv.gz"
  },
  {
    "accessionId": "GCST90566800",
    "initial_individuals": "1127213",
    "initial_ancestralGroup": "European",
    "pubmedId": "40205036",
    "EFO_ID": "EFO_0004616",
    "EFO_Trait_Name": "osteoarthritis, knee",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90566001-GCST90567000/GCST90566800/harmonised/GCST90566800.h.tsv.gz"
  },
  {
    "accessionId": "GCST90448187",
    "initial_individuals": "1118229",
    "initial_ancestralGroup": "European",
    "pubmedId": "39142284",
    "EFO_ID": "EFO_1001145",
    "EFO_Trait_Name": "raynaud disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90448001-GCST90449000/GCST90448187/harmonised/GCST90448187.h.tsv.gz"
  },
  {
    "accessionId": "GCST90624747",
    "initial_individuals": "1109399",
    "initial_ancestralGroup": "European",
    "pubmedId": "40883272",
    "EFO_ID": "EFO_0001378",
    "EFO_Trait_Name": "multiple myeloma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90624001-GCST90625000/GCST90624747/harmonised/GCST90624747.h.tsv.gz"
  },
  {
    "accessionId": "GCST90624738",
    "initial_individuals": "1108777",
    "initial_ancestralGroup": "European",
    "pubmedId": "40883272",
    "EFO_ID": "EFO_0000095",
    "EFO_Trait_Name": "chronic lymphocytic leukemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90624001-GCST90625000/GCST90624738/harmonised/GCST90624738.h.tsv.gz"
  },
  {
    "accessionId": "GCST90624742",
    "initial_individuals": "1108161",
    "initial_ancestralGroup": "European",
    "pubmedId": "40883272",
    "EFO_ID": "EFO_0000183",
    "EFO_Trait_Name": "hodgkins lymphoma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90624001-GCST90625000/GCST90624742/harmonised/GCST90624742.h.tsv.gz"
  },
  {
    "accessionId": "GCST90566798",
    "initial_individuals": "1107086",
    "initial_ancestralGroup": "European",
    "pubmedId": "40205036",
    "EFO_ID": "EFO_1000786",
    "EFO_Trait_Name": "osteoarthritis, hip",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90566001-GCST90567000/GCST90566798/harmonised/GCST90566798.h.tsv.gz"
  },
  {
    "accessionId": "GCST90399701",
    "initial_individuals": "1051653",
    "initial_ancestralGroup": "European",
    "pubmedId": "36777996",
    "EFO_ID": "EFO_0004274",
    "EFO_Trait_Name": "gout",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90399001-GCST90400000/GCST90399701/harmonised/GCST90399701.h.tsv.gz"
  },
  {
    "accessionId": "GCST90310296",
    "initial_individuals": "1028980",
    "initial_ancestralGroup": "European",
    "pubmedId": "38689001",
    "EFO_ID": "EFO_0005763",
    "EFO_Trait_Name": "pulse pressure measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90310001-GCST90311000/GCST90310296/harmonised/GCST90310296.h.tsv.gz"
  },
  {
    "accessionId": "GCST90310294",
    "initial_individuals": "1028980",
    "initial_ancestralGroup": "European",
    "pubmedId": "38689001",
    "EFO_ID": "EFO_0006335",
    "EFO_Trait_Name": "systolic blood pressure",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90310001-GCST90311000/GCST90310294/harmonised/GCST90310294.h.tsv.gz"
  },
  {
    "accessionId": "GCST90310295",
    "initial_individuals": "1028980",
    "initial_ancestralGroup": "European",
    "pubmedId": "38689001",
    "EFO_ID": "EFO_0006336",
    "EFO_Trait_Name": "diastolic blood pressure",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90310001-GCST90311000/GCST90310295/harmonised/GCST90310295.h.tsv.gz"
  },
  {
    "accessionId": "GCST90281273",
    "initial_individuals": "1020094",
    "initial_ancestralGroup": "European",
    "pubmedId": "37919453",
    "EFO_ID": "EFO_0003931",
    "EFO_Trait_Name": "bone fracture",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90281001-GCST90282000/GCST90281273/harmonised/GCST90281273.h.tsv.gz"
  },
  {
    "accessionId": "GCST90399676",
    "initial_individuals": "1010222",
    "initial_ancestralGroup": "European",
    "pubmedId": "36777996",
    "EFO_ID": "EFO_0007149",
    "EFO_Trait_Name": "appendicitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90399001-GCST90400000/GCST90399676/harmonised/GCST90399676.h.tsv.gz"
  },
  {
    "accessionId": "GCST90483474",
    "initial_individuals": "1006868",
    "initial_ancestralGroup": "European",
    "pubmedId": "40229599",
    "EFO_ID": "EFO_0004248",
    "EFO_Trait_Name": "male infertility",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90483001-GCST90484000/GCST90483474/harmonised/GCST90483474.h.tsv.gz"
  },
  {
    "accessionId": "GCST90399694",
    "initial_individuals": "995917",
    "initial_ancestralGroup": "European",
    "pubmedId": "36777996",
    "EFO_ID": "EFO_0000341",
    "EFO_Trait_Name": "chronic obstructive pulmonary disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90399001-GCST90400000/GCST90399694/harmonised/GCST90399694.h.tsv.gz"
  },
  {
    "accessionId": "GCST90693193",
    "initial_individuals": "980757",
    "initial_ancestralGroup": "European",
    "pubmedId": "40472801",
    "EFO_ID": "EFO_0003918",
    "EFO_Trait_Name": "obstructive sleep apnea",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90693001-GCST90694000/GCST90693193/harmonised/GCST90693193.h.tsv.gz"
  },
  {
    "accessionId": "GCST90572735",
    "initial_individuals": "975385",
    "initial_ancestralGroup": "European",
    "pubmedId": "40849414",
    "EFO_ID": "HP_0000486",
    "EFO_Trait_Name": "strabismus",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90572001-GCST90573000/GCST90572735/harmonised/GCST90572735.h.tsv.gz"
  },
  {
    "accessionId": "GCST90399720",
    "initial_individuals": "953873",
    "initial_ancestralGroup": "European",
    "pubmedId": "36777996",
    "EFO_ID": "EFO_0000768",
    "EFO_Trait_Name": "idiopathic pulmonary fibrosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90399001-GCST90400000/GCST90399720/harmonised/GCST90399720.h.tsv.gz"
  },
  {
    "accessionId": "GCST90566708",
    "initial_individuals": "947466",
    "initial_ancestralGroup": "European",
    "pubmedId": "40360725",
    "EFO_ID": "EFO_0022866",
    "EFO_Trait_Name": "socioeconomic status",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90566001-GCST90567000/GCST90566708/harmonised/GCST90566708.h.tsv.gz"
  },
  {
    "accessionId": "GCST90399706",
    "initial_individuals": "922988",
    "initial_ancestralGroup": "European",
    "pubmedId": "36777996",
    "EFO_ID": "EFO_0000318",
    "EFO_Trait_Name": "cardiomyopathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90399001-GCST90400000/GCST90399706/harmonised/GCST90399706.h.tsv.gz"
  },
  {
    "accessionId": "GCST90399744",
    "initial_individuals": "915868",
    "initial_ancestralGroup": "European",
    "pubmedId": "36777996",
    "EFO_ID": "EFO_0004286",
    "EFO_Trait_Name": "venous thromboembolism",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90399001-GCST90400000/GCST90399744/harmonised/GCST90399744.h.tsv.gz"
  },
  {
    "accessionId": "GCST90297795",
    "initial_individuals": "882024",
    "initial_ancestralGroup": "European",
    "pubmedId": "38663478",
    "EFO_ID": "EFO_0000274",
    "EFO_Trait_Name": "atopic eczema",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90297001-GCST90298000/GCST90297795/harmonised/GCST90297795.h.tsv.gz"
  },
  {
    "accessionId": "GCST90449045",
    "initial_individuals": "870171",
    "initial_ancestralGroup": "European",
    "pubmedId": "39633006",
    "EFO_ID": "MONDO_0004975",
    "EFO_Trait_Name": "Alzheimer disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90449001-GCST90450000/GCST90449045/harmonised/GCST90449045.h.tsv.gz"
  },
  {
    "accessionId": "GCST90129575",
    "initial_individuals": "864702",
    "initial_ancestralGroup": "European",
    "pubmedId": "36653343",
    "EFO_ID": "EFO_0004213",
    "EFO_Trait_Name": "otosclerosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129575/harmonised/GCST90129575.h.tsv.gz"
  },
  {
    "accessionId": "GCST90566706",
    "initial_individuals": "862391",
    "initial_ancestralGroup": "European",
    "pubmedId": "40360725",
    "EFO_ID": "EFO_0009696",
    "EFO_Trait_Name": "social deprivation",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90566001-GCST90567000/GCST90566706/harmonised/GCST90566706.h.tsv.gz"
  },
  {
    "accessionId": "GCST90255375",
    "initial_individuals": "855309",
    "initial_ancestralGroup": "European",
    "pubmedId": "36736436",
    "EFO_ID": "EFO_1000652",
    "EFO_Trait_Name": "acute pancreatitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90255001-GCST90256000/GCST90255375/harmonised/GCST90255375.h.tsv.gz"
  },
  {
    "accessionId": "GCST90566797",
    "initial_individuals": "853901",
    "initial_ancestralGroup": "European",
    "pubmedId": "40205036",
    "EFO_ID": "EFO_1000789",
    "EFO_Trait_Name": "osteoarthritis, hand",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90566001-GCST90567000/GCST90566797/harmonised/GCST90566797.h.tsv.gz"
  },
  {
    "accessionId": "GCST90566697",
    "initial_individuals": "848919",
    "initial_ancestralGroup": "European",
    "pubmedId": "40360725",
    "EFO_ID": "EFO_0011015",
    "EFO_Trait_Name": "educational attainment",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90566001-GCST90567000/GCST90566697/harmonised/GCST90566697.h.tsv.gz"
  },
  {
    "accessionId": "GCST90624053",
    "initial_individuals": "832234",
    "initial_ancestralGroup": "European",
    "pubmedId": "40759756",
    "EFO_ID": "EFO_0003106",
    "EFO_Trait_Name": "pneumonia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90624001-GCST90625000/GCST90624053/harmonised/GCST90624053.h.tsv.gz"
  },
  {
    "accessionId": "GCST90483472",
    "initial_individuals": "822191",
    "initial_ancestralGroup": "European",
    "pubmedId": "40229599",
    "EFO_ID": "EFO_0008560",
    "EFO_Trait_Name": "female infertility",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90483001-GCST90484000/GCST90483472/harmonised/GCST90483472.h.tsv.gz"
  },
  {
    "accessionId": "GCST90328150",
    "initial_individuals": "806257",
    "initial_ancestralGroup": "European",
    "pubmedId": "38867047",
    "EFO_ID": "EFO_0022842",
    "EFO_Trait_Name": "mosaic loss of chromosome X measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90328001-GCST90329000/GCST90328150/harmonised/GCST90328150.h.tsv.gz"
  },
  {
    "accessionId": "GCST90566801",
    "initial_individuals": "802795",
    "initial_ancestralGroup": "European",
    "pubmedId": "40205036",
    "EFO_ID": "EFO_1000787",
    "EFO_Trait_Name": "osteoarthritis, spine",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90566001-GCST90567000/GCST90566801/harmonised/GCST90566801.h.tsv.gz"
  },
  {
    "accessionId": "GCST90320054",
    "initial_individuals": "769475",
    "initial_ancestralGroup": "European",
    "pubmedId": "38671320",
    "EFO_ID": "EFO_0002890",
    "EFO_Trait_Name": "renal carcinoma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90320001-GCST90321000/GCST90320054/harmonised/GCST90320054.h.tsv.gz"
  },
  {
    "accessionId": "GCST90320058",
    "initial_individuals": "752817",
    "initial_ancestralGroup": "European",
    "pubmedId": "38671320",
    "EFO_ID": "EFO_0000349",
    "EFO_Trait_Name": "clear cell renal carcinoma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90320001-GCST90321000/GCST90320058/harmonised/GCST90320058.h.tsv.gz"
  },
  {
    "accessionId": "GCST90319319",
    "initial_individuals": "743008",
    "initial_ancestralGroup": "European",
    "pubmedId": "39067062",
    "EFO_ID": "EFO_0009189",
    "EFO_Trait_Name": "hyperthyroidism",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90319001-GCST90320000/GCST90319319/harmonised/GCST90319319.h.tsv.gz"
  },
  {
    "accessionId": "GCST90320056",
    "initial_individuals": "738319",
    "initial_ancestralGroup": "European",
    "pubmedId": "38671320",
    "EFO_ID": "EFO_0000640",
    "EFO_Trait_Name": "papillary renal cell carcinoma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90320001-GCST90321000/GCST90320056/harmonised/GCST90320056.h.tsv.gz"
  },
  {
    "accessionId": "GCST90161240",
    "initial_individuals": "735354",
    "initial_ancestralGroup": "European",
    "pubmedId": "36260985",
    "EFO_ID": "EFO_0003964",
    "EFO_Trait_Name": "hip fracture",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90161001-GCST90162000/GCST90161240/harmonised/GCST90161240.h.tsv.gz"
  },
  {
    "accessionId": "GCST90274714",
    "initial_individuals": "726828",
    "initial_ancestralGroup": "European",
    "pubmedId": "37945903",
    "EFO_ID": "EFO_0001663",
    "EFO_Trait_Name": "prostate carcinoma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90274001-GCST90275000/GCST90274714/harmonised/GCST90274714.h.tsv.gz"
  },
  {
    "accessionId": "GCST90244755",
    "initial_individuals": "716517",
    "initial_ancestralGroup": "European",
    "pubmedId": "38052102",
    "EFO_ID": "GO_0060279",
    "EFO_Trait_Name": "positive regulation of ovulation",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90244001-GCST90245000/GCST90244755/harmonised/GCST90244755.h.tsv.gz"
  },
  {
    "accessionId": "GCST90652532",
    "initial_individuals": "701050",
    "initial_ancestralGroup": "European",
    "pubmedId": "41213931",
    "EFO_ID": "EFO_1002030",
    "EFO_Trait_Name": "chronic rhinosinusitis without nasal polyps",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90652001-GCST90653000/GCST90652532/harmonised/GCST90652532.h.tsv.gz"
  },
  {
    "accessionId": "GCST90270866",
    "initial_individuals": "700649",
    "initial_ancestralGroup": "European",
    "pubmedId": "36773317",
    "EFO_ID": "EFO_0005741",
    "EFO_Trait_Name": "infectious disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90270001-GCST90271000/GCST90270866/harmonised/GCST90270866.h.tsv.gz"
  },
  {
    "accessionId": "GCST90270870",
    "initial_individuals": "698263",
    "initial_ancestralGroup": "European",
    "pubmedId": "36773317",
    "EFO_ID": "MONDO_0002026",
    "EFO_Trait_Name": "candidiasis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90270001-GCST90271000/GCST90270870/harmonised/GCST90270870.h.tsv.gz"
  },
  {
    "accessionId": "GCST90652531",
    "initial_individuals": "695228",
    "initial_ancestralGroup": "European",
    "pubmedId": "41213931",
    "EFO_ID": "EFO_1002029",
    "EFO_Trait_Name": "chronic rhinosinusitis with nasal polyps",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90652001-GCST90653000/GCST90652531/harmonised/GCST90652531.h.tsv.gz"
  },
  {
    "accessionId": "GCST90179150",
    "initial_individuals": "694649",
    "initial_ancestralGroup": "European",
    "pubmedId": "36376304",
    "EFO_ID": "EFO_0004340",
    "EFO_Trait_Name": "body mass index",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90179001-GCST90180000/GCST90179150/harmonised/GCST90179150.h.tsv.gz"
  },
  {
    "accessionId": "GCST90566703",
    "initial_individuals": "683663",
    "initial_ancestralGroup": "European",
    "pubmedId": "40360725",
    "EFO_ID": "EFO_0005241",
    "EFO_Trait_Name": "employment status",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90566001-GCST90567000/GCST90566703/harmonised/GCST90566703.h.tsv.gz"
  },
  {
    "accessionId": "GCST90270871",
    "initial_individuals": "682462",
    "initial_ancestralGroup": "European",
    "pubmedId": "36773317",
    "EFO_ID": "HP_0100806",
    "EFO_Trait_Name": "sepsis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90270001-GCST90271000/GCST90270871/harmonised/GCST90270871.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474667",
    "initial_individuals": "677823",
    "initial_ancestralGroup": "European",
    "pubmedId": "39436105",
    "EFO_ID": "EFO_0009130",
    "EFO_Trait_Name": "clostridium difficile infection",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474667/harmonised/GCST90474667.h.tsv.gz"
  },
  {
    "accessionId": "GCST90319904",
    "initial_individuals": "677373",
    "initial_ancestralGroup": "European",
    "pubmedId": "38658550",
    "EFO_ID": "EFO_0004531",
    "EFO_Trait_Name": "urate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90319001-GCST90320000/GCST90319904/harmonised/GCST90319904.h.tsv.gz"
  },
  {
    "accessionId": "GCST90565360",
    "initial_individuals": "664970",
    "initial_ancestralGroup": "European",
    "pubmedId": "37690594",
    "EFO_ID": "EFO_0005531",
    "EFO_Trait_Name": "urticaria",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90565001-GCST90566000/GCST90565360/harmonised/GCST90565360.h.tsv.gz"
  },
  {
    "accessionId": "GCST90624739",
    "initial_individuals": "658535",
    "initial_ancestralGroup": "European",
    "pubmedId": "40883272",
    "EFO_ID": "EFO_0000403",
    "EFO_Trait_Name": "diffuse large b-cell lymphoma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90624001-GCST90625000/GCST90624739/harmonised/GCST90624739.h.tsv.gz"
  },
  {
    "accessionId": "GCST90624741",
    "initial_individuals": "657982",
    "initial_ancestralGroup": "European",
    "pubmedId": "40883272",
    "EFO_ID": "MONDO_0018906",
    "EFO_Trait_Name": "follicular lymphoma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90624001-GCST90625000/GCST90624741/harmonised/GCST90624741.h.tsv.gz"
  },
  {
    "accessionId": "GCST90624748",
    "initial_individuals": "656878",
    "initial_ancestralGroup": "European",
    "pubmedId": "40883272",
    "EFO_ID": "EFO_1000630",
    "EFO_Trait_Name": "marginal zone B-cell lymphoma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90624001-GCST90625000/GCST90624748/harmonised/GCST90624748.h.tsv.gz"
  },
  {
    "accessionId": "GCST90624744",
    "initial_individuals": "656615",
    "initial_ancestralGroup": "European",
    "pubmedId": "40883272",
    "EFO_ID": "MONDO_0000432",
    "EFO_Trait_Name": "lymphoplasmacytic lymphoma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90624001-GCST90625000/GCST90624744/harmonised/GCST90624744.h.tsv.gz"
  },
  {
    "accessionId": "GCST90558100",
    "initial_individuals": "654677",
    "initial_ancestralGroup": "European",
    "pubmedId": "40262193",
    "EFO_ID": "MONDO_0007915",
    "EFO_Trait_Name": "systemic lupus erythematosus",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90558001-GCST90559000/GCST90558100/harmonised/GCST90558100.h.tsv.gz"
  },
  {
    "accessionId": "GCST90104342",
    "initial_individuals": "636924",
    "initial_ancestralGroup": "European",
    "pubmedId": "36071172",
    "EFO_ID": "EFO_0008002",
    "EFO_Trait_Name": "physical activity measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90104001-GCST90105000/GCST90104342/harmonised/GCST90104342.h.tsv.gz"
  },
  {
    "accessionId": "GCST90483502",
    "initial_individuals": "631401",
    "initial_ancestralGroup": "European",
    "pubmedId": "40229599",
    "EFO_ID": "EFO_0000731",
    "EFO_Trait_Name": "uterine fibroid",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90483001-GCST90484000/GCST90483502/harmonised/GCST90483502.h.tsv.gz"
  },
  {
    "accessionId": "GCST90296666",
    "initial_individuals": "617731",
    "initial_ancestralGroup": "European",
    "pubmedId": "38503741",
    "EFO_ID": "EFO_0008510",
    "EFO_Trait_Name": "Lyme disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90296001-GCST90297000/GCST90296666/harmonised/GCST90296666.h.tsv.gz"
  },
  {
    "accessionId": "GCST90572736",
    "initial_individuals": "594757",
    "initial_ancestralGroup": "European",
    "pubmedId": "40849414",
    "EFO_ID": "HP_0000565",
    "EFO_Trait_Name": "esotropia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90572001-GCST90573000/GCST90572736/harmonised/GCST90572736.h.tsv.gz"
  },
  {
    "accessionId": "GCST90572737",
    "initial_individuals": "587466",
    "initial_ancestralGroup": "European",
    "pubmedId": "40849414",
    "EFO_ID": "HP_0000577",
    "EFO_Trait_Name": "Exotropia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90572001-GCST90573000/GCST90572737/harmonised/GCST90572737.h.tsv.gz"
  },
  {
    "accessionId": "GCST90275127",
    "initial_individuals": "578413",
    "initial_ancestralGroup": "European",
    "pubmedId": "38155330",
    "EFO_ID": "MONDO_0005180",
    "EFO_Trait_Name": "Parkinson disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90275001-GCST90276000/GCST90275127/harmonised/GCST90275127.h.tsv.gz"
  },
  {
    "accessionId": "GCST90102470",
    "initial_individuals": "574377",
    "initial_ancestralGroup": "European",
    "pubmedId": "35739095",
    "EFO_ID": "EFO_0004710",
    "EFO_Trait_Name": "pelvic organ prolapse",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90102001-GCST90103000/GCST90102470/harmonised/GCST90102470.h.tsv.gz"
  },
  {
    "accessionId": "GCST90204144",
    "initial_individuals": "554942",
    "initial_ancestralGroup": "European",
    "pubmedId": "37768647",
    "EFO_ID": "EFO_1001295",
    "EFO_Trait_Name": "microscopic colitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90204001-GCST90205000/GCST90204144/harmonised/GCST90204144.h.tsv.gz"
  },
  {
    "accessionId": "GCST90128518",
    "initial_individuals": "550437",
    "initial_ancestralGroup": "European",
    "pubmedId": "34651315",
    "EFO_ID": "EFO_0004210",
    "EFO_Trait_Name": "gallstones",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90128001-GCST90129000/GCST90128518/harmonised/GCST90128518.h.tsv.gz"
  },
  {
    "accessionId": "GCST90271641",
    "initial_individuals": "513266",
    "initial_ancestralGroup": "European",
    "pubmedId": "37415806",
    "EFO_ID": "MONDO_0005277",
    "EFO_Trait_Name": "migraine disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90271001-GCST90272000/GCST90271641/harmonised/GCST90271641.h.tsv.gz"
  },
  {
    "accessionId": "GCST90225530",
    "initial_individuals": "502481",
    "initial_ancestralGroup": "European",
    "pubmedId": "37259642",
    "EFO_ID": "EFO_1001908",
    "EFO_Trait_Name": "phobic disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90225001-GCST90226000/GCST90225530/harmonised/GCST90225530.h.tsv.gz"
  },
  {
    "accessionId": "GCST90225526",
    "initial_individuals": "502480",
    "initial_ancestralGroup": "European",
    "pubmedId": "37259642",
    "EFO_ID": "MONDO_0041086",
    "EFO_Trait_Name": "mixed anxiety and depressive disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90225001-GCST90226000/GCST90225526/harmonised/GCST90225526.h.tsv.gz"
  },
  {
    "accessionId": "GCST90225527",
    "initial_individuals": "502477",
    "initial_ancestralGroup": "European",
    "pubmedId": "37259642",
    "EFO_ID": "EFO_0006788",
    "EFO_Trait_Name": "anxiety disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90225001-GCST90226000/GCST90225527/harmonised/GCST90225527.h.tsv.gz"
  },
  {
    "accessionId": "GCST90225525",
    "initial_individuals": "502462",
    "initial_ancestralGroup": "European",
    "pubmedId": "37259642",
    "EFO_ID": "EFO_0004262",
    "EFO_Trait_Name": "panic disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90225001-GCST90226000/GCST90225525/harmonised/GCST90225525.h.tsv.gz"
  },
  {
    "accessionId": "GCST90454190",
    "initial_individuals": "500402",
    "initial_ancestralGroup": "European",
    "pubmedId": "39533856",
    "EFO_ID": "EFO_0007299",
    "EFO_Trait_Name": "hemorrhagic fever with renal syndrome",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90454001-GCST90455000/GCST90454190/harmonised/GCST90454190.h.tsv.gz"
  },
  {
    "accessionId": "GCST90472771",
    "initial_individuals": "494544",
    "initial_ancestralGroup": "European",
    "pubmedId": "40021644",
    "EFO_ID": "EFO_0000676",
    "EFO_Trait_Name": "psoriasis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90472001-GCST90473000/GCST90472771/harmonised/GCST90472771.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018875",
    "initial_individuals": "492803",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0001071",
    "EFO_Trait_Name": "lung carcinoma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018875/harmonised/GCST90018875.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018921",
    "initial_individuals": "492203",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0004198",
    "EFO_Trait_Name": "skin neoplasm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018921/harmonised/GCST90018921.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018800",
    "initial_individuals": "491542",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0003833",
    "EFO_Trait_Name": "brain neoplasm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018800/harmonised/GCST90018800.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018878",
    "initial_individuals": "490803",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0000574",
    "EFO_Trait_Name": "lymphoma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018878/harmonised/GCST90018878.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018861",
    "initial_individuals": "489727",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0000538",
    "EFO_Trait_Name": "hypertrophic cardiomyopathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018861/harmonised/GCST90018861.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018857",
    "initial_individuals": "489493",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0004238",
    "EFO_Trait_Name": "hearing loss",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018857/harmonised/GCST90018857.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018865",
    "initial_individuals": "489424",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0007160",
    "EFO_Trait_Name": "autoimmune thrombocytopenic purpura",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018865/harmonised/GCST90018865.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018887",
    "initial_individuals": "488501",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0003882",
    "EFO_Trait_Name": "osteoporosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018887/harmonised/GCST90018887.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018935",
    "initial_individuals": "488346",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "MONDO_0024647",
    "EFO_Trait_Name": "urolithiasis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018935/harmonised/GCST90018935.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018819",
    "initial_individuals": "487553",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0004799",
    "EFO_Trait_Name": "cholelithiasis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018819/harmonised/GCST90018819.h.tsv.gz"
  },
  {
    "accessionId": "GCST90565872",
    "initial_individuals": "486982",
    "initial_ancestralGroup": "European",
    "pubmedId": "40858613",
    "EFO_ID": "EFO_0008343",
    "EFO_Trait_Name": "sex interaction measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90565001-GCST90566000/GCST90565872/harmonised/GCST90565872.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018869",
    "initial_individuals": "486627",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0007876",
    "EFO_Trait_Name": "insomnia measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018869/harmonised/GCST90018869.h.tsv.gz"
  },
  {
    "accessionId": "GCST90281158",
    "initial_individuals": "486484",
    "initial_ancestralGroup": "European",
    "pubmedId": "36716318",
    "EFO_ID": "EFO_0000465",
    "EFO_Trait_Name": "endocarditis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90281001-GCST90282000/GCST90281158/harmonised/GCST90281158.h.tsv.gz"
  },
  {
    "accessionId": "GCST90281156",
    "initial_individuals": "486484",
    "initial_ancestralGroup": "European",
    "pubmedId": "36716318",
    "EFO_ID": "EFO_0003035",
    "EFO_Trait_Name": "cellulitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90281001-GCST90282000/GCST90281156/harmonised/GCST90281156.h.tsv.gz"
  },
  {
    "accessionId": "GCST90281166",
    "initial_individuals": "486484",
    "initial_ancestralGroup": "European",
    "pubmedId": "36716318",
    "EFO_ID": "EFO_0003102",
    "EFO_Trait_Name": "osteomyelitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90281001-GCST90282000/GCST90281166/harmonised/GCST90281166.h.tsv.gz"
  },
  {
    "accessionId": "GCST90281182",
    "initial_individuals": "486484",
    "initial_ancestralGroup": "European",
    "pubmedId": "36716318",
    "EFO_ID": "EFO_0003103",
    "EFO_Trait_Name": "urinary tract infection",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90281001-GCST90282000/GCST90281182/harmonised/GCST90281182.h.tsv.gz"
  },
  {
    "accessionId": "GCST90281164",
    "initial_individuals": "486484",
    "initial_ancestralGroup": "European",
    "pubmedId": "36716318",
    "EFO_ID": "EFO_0009433",
    "EFO_Trait_Name": "lower respiratory tract disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90281001-GCST90282000/GCST90281164/harmonised/GCST90281164.h.tsv.gz"
  },
  {
    "accessionId": "GCST90281157",
    "initial_individuals": "486484",
    "initial_ancestralGroup": "European",
    "pubmedId": "36716318",
    "EFO_ID": "HP_0001082",
    "EFO_Trait_Name": "cholecystitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90281001-GCST90282000/GCST90281157/harmonised/GCST90281157.h.tsv.gz"
  },
  {
    "accessionId": "GCST90281181",
    "initial_individuals": "486484",
    "initial_ancestralGroup": "European",
    "pubmedId": "36716318",
    "EFO_ID": "MONDO_0004867",
    "EFO_Trait_Name": "upper respiratory tract disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90281001-GCST90282000/GCST90281181/harmonised/GCST90281181.h.tsv.gz"
  },
  {
    "accessionId": "GCST90483499",
    "initial_individuals": "486361",
    "initial_ancestralGroup": "European",
    "pubmedId": "40229599",
    "EFO_ID": "EFO_0004908",
    "EFO_Trait_Name": "testosterone measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90483001-GCST90484000/GCST90483499/harmonised/GCST90483499.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018785",
    "initial_individuals": "485234",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0005676",
    "EFO_Trait_Name": "Autoimmune Hepatitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018785/harmonised/GCST90018785.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018852",
    "initial_individuals": "484979",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "MONDO_0005041",
    "EFO_Trait_Name": "glaucoma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018852/harmonised/GCST90018852.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018899",
    "initial_individuals": "484515",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_1001825",
    "EFO_Trait_Name": "pleurisy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018899/harmonised/GCST90018899.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018809",
    "initial_individuals": "484145",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0007503",
    "EFO_Trait_Name": "suppurative otitis media",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018809/harmonised/GCST90018809.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018920",
    "initial_individuals": "484013",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0000699",
    "EFO_Trait_Name": "Sjogren syndrome",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018920/harmonised/GCST90018920.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018924",
    "initial_individuals": "483856",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0003890",
    "EFO_Trait_Name": "drug dependence",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018924/harmonised/GCST90018924.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018927",
    "initial_individuals": "483323",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0004276",
    "EFO_Trait_Name": "Stevens-Johnson syndrome",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018927/harmonised/GCST90018927.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018907",
    "initial_individuals": "483174",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_1001494",
    "EFO_Trait_Name": "psoriasis vulgaris",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018907/harmonised/GCST90018907.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018890",
    "initial_individuals": "483078",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0004265",
    "EFO_Trait_Name": "peripheral arterial disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018890/harmonised/GCST90018890.h.tsv.gz"
  },
  {
    "accessionId": "GCST90572789",
    "initial_individuals": "482873",
    "initial_ancestralGroup": "European",
    "pubmedId": "41238958",
    "EFO_ID": "OBA_1000983",
    "EFO_Trait_Name": "thyroid stimulating hormone amount",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90572001-GCST90573000/GCST90572789/harmonised/GCST90572789.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018822",
    "initial_individuals": "482858",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0003884",
    "EFO_Trait_Name": "chronic kidney disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018822/harmonised/GCST90018822.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018880",
    "initial_individuals": "482774",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0006862",
    "EFO_Trait_Name": "Meniere disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018880/harmonised/GCST90018880.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018872",
    "initial_individuals": "480941",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0004272",
    "EFO_Trait_Name": "anemia (phenotype)",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018872/harmonised/GCST90018872.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018871",
    "initial_individuals": "480742",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_1000997",
    "EFO_Trait_Name": "iritis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018871/harmonised/GCST90018871.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018938",
    "initial_individuals": "480742",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_1001231",
    "EFO_Trait_Name": "uveitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018938/harmonised/GCST90018938.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018813",
    "initial_individuals": "480201",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0004143",
    "EFO_Trait_Name": "carpal tunnel syndrome",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018813/harmonised/GCST90018813.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018789",
    "initial_individuals": "479902",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0000278",
    "EFO_Trait_Name": "pancreatitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018789/harmonised/GCST90018789.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018802",
    "initial_individuals": "479301",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009661",
    "EFO_Trait_Name": "bronchitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018802/harmonised/GCST90018802.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018783",
    "initial_individuals": "479194",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0001666",
    "EFO_Trait_Name": "aortic aneurysm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018783/harmonised/GCST90018783.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018900",
    "initial_individuals": "479040",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "MONDO_0015926",
    "EFO_Trait_Name": "pneumoconiosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018900/harmonised/GCST90018900.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018830",
    "initial_individuals": "478766",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0005319",
    "EFO_Trait_Name": "contact dermatitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018830/harmonised/GCST90018830.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018866",
    "initial_individuals": "477784",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0004194",
    "EFO_Trait_Name": "IgA glomerulonephritis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018866/harmonised/GCST90018866.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018902",
    "initial_individuals": "477734",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "MONDO_0002076",
    "EFO_Trait_Name": "pneumothorax",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018902/harmonised/GCST90018902.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018892",
    "initial_individuals": "477386",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_1000049",
    "EFO_Trait_Name": "pulmonary tuberculosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018892/harmonised/GCST90018892.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018913",
    "initial_individuals": "477240",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0008416",
    "EFO_Trait_Name": "susceptibility to rheumatic fever measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018913/harmonised/GCST90018913.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018911",
    "initial_individuals": "477031",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0005773",
    "EFO_Trait_Name": "retinal detachment",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018911/harmonised/GCST90018911.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018916",
    "initial_individuals": "476853",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0003877",
    "EFO_Trait_Name": "sleep apnea",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018916/harmonised/GCST90018916.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018841",
    "initial_individuals": "476306",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0002916",
    "EFO_Trait_Name": "esophageal carcinoma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018841/harmonised/GCST90018841.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018893",
    "initial_individuals": "476245",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0002618",
    "EFO_Trait_Name": "pancreatic carcinoma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018893/harmonised/GCST90018893.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018849",
    "initial_individuals": "476116",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0000178",
    "EFO_Trait_Name": "gastric carcinoma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018849/harmonised/GCST90018849.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018803",
    "initial_individuals": "476091",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0005221",
    "EFO_Trait_Name": "cholangiocarcinoma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018803/harmonised/GCST90018803.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018884",
    "initial_individuals": "476030",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0004255",
    "EFO_Trait_Name": "nephrotic syndrome",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018884/harmonised/GCST90018884.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018820",
    "initial_individuals": "475821",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "MONDO_0002462",
    "EFO_Trait_Name": "glomerulonephritis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018820/harmonised/GCST90018820.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018792",
    "initial_individuals": "475660",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0005854",
    "EFO_Trait_Name": "allergic rhinitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018792/harmonised/GCST90018792.h.tsv.gz"
  },
  {
    "accessionId": "GCST90244093",
    "initial_individuals": "475645",
    "initial_ancestralGroup": "European",
    "pubmedId": "36914875",
    "EFO_ID": "EFO_0004312",
    "EFO_Trait_Name": "vital capacity",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90244001-GCST90245000/GCST90244093/harmonised/GCST90244093.h.tsv.gz"
  },
  {
    "accessionId": "GCST90244092",
    "initial_individuals": "475645",
    "initial_ancestralGroup": "European",
    "pubmedId": "36914875",
    "EFO_ID": "EFO_0004314",
    "EFO_Trait_Name": "forced expiratory volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90244001-GCST90245000/GCST90244092/harmonised/GCST90244092.h.tsv.gz"
  },
  {
    "accessionId": "GCST90244094",
    "initial_individuals": "475645",
    "initial_ancestralGroup": "European",
    "pubmedId": "36914875",
    "EFO_ID": "EFO_0004713",
    "EFO_Trait_Name": "FEV/FVC ratio",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90244001-GCST90245000/GCST90244094/harmonised/GCST90244094.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018858",
    "initial_individuals": "475638",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_1001513",
    "EFO_Trait_Name": "liver neoplasm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018858/harmonised/GCST90018858.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018903",
    "initial_individuals": "475378",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0003956",
    "EFO_Trait_Name": "seasonal allergic rhinitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018903/harmonised/GCST90018903.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018791",
    "initial_individuals": "475270",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009450",
    "EFO_Trait_Name": "conjunctivitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018791/harmonised/GCST90018791.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018851",
    "initial_individuals": "474278",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009454",
    "EFO_Trait_Name": "gastric ulcer",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018851/harmonised/GCST90018851.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018816",
    "initial_individuals": "473683",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0003870",
    "EFO_Trait_Name": "brain aneurysm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018816/harmonised/GCST90018816.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018870",
    "initial_individuals": "473513",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0005669",
    "EFO_Trait_Name": "intracerebral hemorrhage",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018870/harmonised/GCST90018870.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018794",
    "initial_individuals": "473500",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "HP_0001915",
    "EFO_Trait_Name": "aplastic anemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018794/harmonised/GCST90018794.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018923",
    "initial_individuals": "473255",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0000713",
    "EFO_Trait_Name": "subarachnoid hemorrhage",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018923/harmonised/GCST90018923.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018793",
    "initial_individuals": "470931",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0003913",
    "EFO_Trait_Name": "angina pectoris",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018793/harmonised/GCST90018793.h.tsv.gz"
  },
  {
    "accessionId": "GCST90269970",
    "initial_individuals": "470869",
    "initial_ancestralGroup": "European",
    "pubmedId": "36914876",
    "EFO_ID": "EFO_0001065",
    "EFO_Trait_Name": "endometriosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90269001-GCST90270000/GCST90269970/harmonised/GCST90269970.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018808",
    "initial_individuals": "470002",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "MONDO_0005575",
    "EFO_Trait_Name": "colorectal cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018808/harmonised/GCST90018808.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018863",
    "initial_individuals": "469827",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0004244",
    "EFO_Trait_Name": "interstitial lung disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018863/harmonised/GCST90018863.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018908",
    "initial_individuals": "469126",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009448",
    "EFO_Trait_Name": "pulmonary fibrosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018908/harmonised/GCST90018908.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018797",
    "initial_individuals": "468269",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "HP_0003418",
    "EFO_Trait_Name": "back pain",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018797/harmonised/GCST90018797.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018885",
    "initial_individuals": "467030",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_1000018",
    "EFO_Trait_Name": "bladder disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018885/harmonised/GCST90018885.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018811",
    "initial_individuals": "465527",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009551",
    "EFO_Trait_Name": "heart valve disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018811/harmonised/GCST90018811.h.tsv.gz"
  },
  {
    "accessionId": "GCST90029021",
    "initial_individuals": "464736",
    "initial_ancestralGroup": "European",
    "pubmedId": "29892013",
    "EFO_ID": "HP_0003124",
    "EFO_Trait_Name": "hypercholesterolemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90029001-GCST90030000/GCST90029021/harmonised/GCST90029021.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018843",
    "initial_individuals": "463240",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0007167",
    "EFO_Trait_Name": "Bell's palsy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018843/harmonised/GCST90018843.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018909",
    "initial_individuals": "462487",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_1001141",
    "EFO_Trait_Name": "pyelonephritis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018909/harmonised/GCST90018909.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018877",
    "initial_individuals": "461823",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0000612",
    "EFO_Trait_Name": "myocardial infarction",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018877/harmonised/GCST90018877.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018939",
    "initial_individuals": "459702",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "HP_0002619",
    "EFO_Trait_Name": "Varicose veins",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018939/harmonised/GCST90018939.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018853",
    "initial_individuals": "459653",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0004283",
    "EFO_Trait_Name": "goiter",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018853/harmonised/GCST90018853.h.tsv.gz"
  },
  {
    "accessionId": "GCST90029020",
    "initial_individuals": "459279",
    "initial_ancestralGroup": "European",
    "pubmedId": "29892013",
    "EFO_ID": "EFO_0000701",
    "EFO_Trait_Name": "skin disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90029001-GCST90030000/GCST90029020/harmonised/GCST90029020.h.tsv.gz"
  },
  {
    "accessionId": "GCST90271557",
    "initial_individuals": "458862",
    "initial_ancestralGroup": "European",
    "pubmedId": "37679419",
    "EFO_ID": "EFO_0004468",
    "EFO_Trait_Name": "glucose measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90271001-GCST90272000/GCST90271557/harmonised/GCST90271557.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018930",
    "initial_individuals": "458829",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "MONDO_0002258",
    "EFO_Trait_Name": "pharyngitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018930/harmonised/GCST90018930.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473787",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000217",
    "EFO_Trait_Name": "gastritis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473787/harmonised/GCST90473787.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473822",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000384",
    "EFO_Trait_Name": "crohn's disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473822/harmonised/GCST90473822.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474053",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000398",
    "EFO_Trait_Name": "dermatomyositis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474053/harmonised/GCST90474053.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473176",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000400",
    "EFO_Trait_Name": "diabetes mellitus",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473176/harmonised/GCST90473176.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473893",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000405",
    "EFO_Trait_Name": "digestive system disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473893/harmonised/GCST90473893.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473705",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000464",
    "EFO_Trait_Name": "emphysema",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473705/harmonised/GCST90473705.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473322",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000474",
    "EFO_Trait_Name": "epilepsy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473322/harmonised/GCST90473322.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474080",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000524",
    "EFO_Trait_Name": "head and neck disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474080/harmonised/GCST90474080.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473145",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000540",
    "EFO_Trait_Name": "immune system disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473145/harmonised/GCST90473145.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474035",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000546",
    "EFO_Trait_Name": "injury",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474035/harmonised/GCST90474035.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473585",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000551",
    "EFO_Trait_Name": "intracranial hemorrhage",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473585/harmonised/GCST90473585.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473299",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000584",
    "EFO_Trait_Name": "infectious meningitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473299/harmonised/GCST90473299.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473234",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000589",
    "EFO_Trait_Name": "metabolic disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473234/harmonised/GCST90473234.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473365",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000618",
    "EFO_Trait_Name": "nervous system disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473365/harmonised/GCST90473365.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473024",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000650",
    "EFO_Trait_Name": "whooping cough",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473024/harmonised/GCST90473024.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473290",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000677",
    "EFO_Trait_Name": "mental or behavioural disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473290/harmonised/GCST90473290.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473740",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000684",
    "EFO_Trait_Name": "respiratory system disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473740/harmonised/GCST90473740.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474002",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000685",
    "EFO_Trait_Name": "rheumatoid arthritis",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474002/harmonised/GCST90474002.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474054",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000717",
    "EFO_Trait_Name": "systemic scleroderma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474054/harmonised/GCST90474054.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473823",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000729",
    "EFO_Trait_Name": "ulcerative colitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473823/harmonised/GCST90473823.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473106",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000763",
    "EFO_Trait_Name": "viral disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473106/harmonised/GCST90473106.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473063",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000764",
    "EFO_Trait_Name": "HIV infection",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473063/harmonised/GCST90473063.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473103",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000771",
    "EFO_Trait_Name": "bacterial disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473103/harmonised/GCST90473103.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473660",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000772",
    "EFO_Trait_Name": "pneumococcal infection",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473660/harmonised/GCST90473660.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474092",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0000783",
    "EFO_Trait_Name": "myositis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474092/harmonised/GCST90474092.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473067",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0001062",
    "EFO_Trait_Name": "cytomegalovirus infection",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473067/harmonised/GCST90473067.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473091",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0001068",
    "EFO_Trait_Name": "malaria",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473091/harmonised/GCST90473091.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473209",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0001073",
    "EFO_Trait_Name": "obesity",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473209/harmonised/GCST90473209.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473194",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0001379",
    "EFO_Trait_Name": "endocrine system disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473194/harmonised/GCST90473194.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473876",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0001421",
    "EFO_Trait_Name": "liver disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473876/harmonised/GCST90473876.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474093",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0002970",
    "EFO_Trait_Name": "muscular disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474093/harmonised/GCST90474093.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474278",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0003086",
    "EFO_Trait_Name": "kidney disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474278/harmonised/GCST90474278.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473191",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0003099",
    "EFO_Trait_Name": "Cushing syndrome",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473191/harmonised/GCST90473191.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474255",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0003105",
    "EFO_Trait_Name": "spina bifida",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474255/harmonised/GCST90474255.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473203",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0003762",
    "EFO_Trait_Name": "vitamin D deficiency",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473203/harmonised/GCST90473203.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473593",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0003763",
    "EFO_Trait_Name": "cerebrovascular disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473593/harmonised/GCST90473593.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473330",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0003764",
    "EFO_Trait_Name": "transient ischemic attack",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473330/harmonised/GCST90473330.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473826",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0003767",
    "EFO_Trait_Name": "inflammatory bowel disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473826/harmonised/GCST90473826.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473578",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0003777",
    "EFO_Trait_Name": "heart disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473578/harmonised/GCST90473578.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473716",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0003818",
    "EFO_Trait_Name": "lung disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473716/harmonised/GCST90473716.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473755",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0003819",
    "EFO_Trait_Name": "dental caries",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473755/harmonised/GCST90473755.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473548",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0003827",
    "EFO_Trait_Name": "pulmonary embolism",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473548/harmonised/GCST90473548.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473882",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0003832",
    "EFO_Trait_Name": "gallbladder disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473882/harmonised/GCST90473882.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473427",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0003839",
    "EFO_Trait_Name": "retinopathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473427/harmonised/GCST90473427.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474221",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0003869",
    "EFO_Trait_Name": "breast neoplasm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474221/harmonised/GCST90474221.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474264",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0003875",
    "EFO_Trait_Name": "peripheral vascular disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474264/harmonised/GCST90474264.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473961",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0003894",
    "EFO_Trait_Name": "acne",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473961/harmonised/GCST90473961.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474065",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0003898",
    "EFO_Trait_Name": "ankylosing spondylitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474065/harmonised/GCST90474065.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473596",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0003914",
    "EFO_Trait_Name": "atherosclerosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473596/harmonised/GCST90473596.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473034",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0003955",
    "EFO_Trait_Name": "bacterial sexually transmitted disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473034/harmonised/GCST90473034.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473948",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0003958",
    "EFO_Trait_Name": "sunburn",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473948/harmonised/GCST90473948.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473402",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0003966",
    "EFO_Trait_Name": "eye disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473402/harmonised/GCST90473402.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473358",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0004145",
    "EFO_Trait_Name": "myopathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473358/harmonised/GCST90473358.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473350",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0004149",
    "EFO_Trait_Name": "neuropathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473350/harmonised/GCST90473350.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473957",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0004192",
    "EFO_Trait_Name": "alopecia areata",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473957/harmonised/GCST90473957.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473060",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0004196",
    "EFO_Trait_Name": "viral human hepatitis infection",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473060/harmonised/GCST90473060.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473973",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0004208",
    "EFO_Trait_Name": "vitiligo",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473973/harmonised/GCST90473973.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474274",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0004209",
    "EFO_Trait_Name": "hypospadias",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474274/harmonised/GCST90474274.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473277",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0004242",
    "EFO_Trait_Name": "obsessive-compulsive disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473277/harmonised/GCST90473277.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473270",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0004247",
    "EFO_Trait_Name": "mood disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473270/harmonised/GCST90473270.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473283",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0004257",
    "EFO_Trait_Name": "neurotic disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473283/harmonised/GCST90473283.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474144",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0004259",
    "EFO_Trait_Name": "osteonecrosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474144/harmonised/GCST90474144.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474131",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0004260",
    "EFO_Trait_Name": "bone disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474131/harmonised/GCST90474131.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474145",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0004261",
    "EFO_Trait_Name": "osteitis deformans",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474145/harmonised/GCST90474145.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474051",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0004264",
    "EFO_Trait_Name": "vascular disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474051/harmonised/GCST90474051.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473573",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0004269",
    "EFO_Trait_Name": "cardiac arrhythmia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473573/harmonised/GCST90473573.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474059",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0004273",
    "EFO_Trait_Name": "scoliosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474059/harmonised/GCST90474059.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474233",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0004593",
    "EFO_Trait_Name": "gestational diabetes",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474233/harmonised/GCST90474233.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473781",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0004607",
    "EFO_Trait_Name": "duodenal ulcer",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473781/harmonised/GCST90473781.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473287",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0004714",
    "EFO_Trait_Name": "sexual dysfunction",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473287/harmonised/GCST90473287.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473240",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0004718",
    "EFO_Trait_Name": "vascular dementia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473240/harmonised/GCST90473240.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473478",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0004992",
    "EFO_Trait_Name": "otitis media",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473478/harmonised/GCST90473478.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473565",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0005137",
    "EFO_Trait_Name": "conduction system disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473565/harmonised/GCST90473565.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473285",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0005203",
    "EFO_Trait_Name": "eating disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473285/harmonised/GCST90473285.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473625",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0005251",
    "EFO_Trait_Name": "hypotension",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473625/harmonised/GCST90473625.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474260",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0005269",
    "EFO_Trait_Name": "congenital heart malformation",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474260/harmonised/GCST90474260.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473262",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0005407",
    "EFO_Trait_Name": "psychosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473262/harmonised/GCST90473262.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473261",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0005411",
    "EFO_Trait_Name": "schizoaffective disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473261/harmonised/GCST90473261.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473192",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0005539",
    "EFO_Trait_Name": "adrenal gland disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473192/harmonised/GCST90473192.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474279",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0005541",
    "EFO_Trait_Name": "bone development disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474279/harmonised/GCST90474279.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473292",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0005548",
    "EFO_Trait_Name": "developmental disorder of mental health",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473292/harmonised/GCST90473292.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473126",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0005558",
    "EFO_Trait_Name": "hemolytic anemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473126/harmonised/GCST90473126.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473117",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0005576",
    "EFO_Trait_Name": "pernicious anemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473117/harmonised/GCST90473117.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473976",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0005584",
    "EFO_Trait_Name": "seborrheic keratosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473976/harmonised/GCST90473976.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473188",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0005754",
    "EFO_Trait_Name": "parathyroid disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473188/harmonised/GCST90473188.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473312",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0005772",
    "EFO_Trait_Name": "neurodegenerative disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473312/harmonised/GCST90473312.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473369",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0005774",
    "EFO_Trait_Name": "brain disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473369/harmonised/GCST90473369.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474151",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0005802",
    "EFO_Trait_Name": "cartilage disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474151/harmonised/GCST90474151.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473130",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0005803",
    "EFO_Trait_Name": "hematologic disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473130/harmonised/GCST90473130.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474012",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0005856",
    "EFO_Trait_Name": "arthritis",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474012/harmonised/GCST90474012.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473205",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0005878",
    "EFO_Trait_Name": "vitamin deficiency",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473205/harmonised/GCST90473205.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473704",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0006505",
    "EFO_Trait_Name": "chronic bronchitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473704/harmonised/GCST90473704.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473050",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0006510",
    "EFO_Trait_Name": "Herpes Zoster",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473050/harmonised/GCST90473050.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473279",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0006783",
    "EFO_Trait_Name": "psychosocial stress measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473279/harmonised/GCST90473279.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473331",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0006791",
    "EFO_Trait_Name": "vascular brain injury",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473331/harmonised/GCST90473331.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473980",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007067",
    "EFO_Trait_Name": "decubitus ulcer",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473980/harmonised/GCST90473980.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473987",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007068",
    "EFO_Trait_Name": "ulcer of lower limb",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473987/harmonised/GCST90473987.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473030",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007128",
    "EFO_Trait_Name": "actinomycosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473030/harmonised/GCST90473030.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473087",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007157",
    "EFO_Trait_Name": "aspergillosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473087/harmonised/GCST90473087.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473912",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007187",
    "EFO_Trait_Name": "bullous pemphigoid",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473912/harmonised/GCST90473912.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473048",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007204",
    "EFO_Trait_Name": "chickenpox",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473048/harmonised/GCST90473048.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473635",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007214",
    "EFO_Trait_Name": "common cold",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473635/harmonised/GCST90473635.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473645",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007227",
    "EFO_Trait_Name": "croup",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473645/harmonised/GCST90473645.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473093",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007254",
    "EFO_Trait_Name": "enterobiasis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473093/harmonised/GCST90473093.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473035",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007282",
    "EFO_Trait_Name": "genital herpes",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473035/harmonised/GCST90473035.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473058",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007305",
    "EFO_Trait_Name": "hepatitis A virus infection",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473058/harmonised/GCST90473058.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473375",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007315",
    "EFO_Trait_Name": "hordeolum",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473375/harmonised/GCST90473375.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473069",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007326",
    "EFO_Trait_Name": "infectious mononucleosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473069/harmonised/GCST90473069.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473656",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007328",
    "EFO_Trait_Name": "influenza",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473656/harmonised/GCST90473656.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473620",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007352",
    "EFO_Trait_Name": "lymphatic system disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473620/harmonised/GCST90473620.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473068",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007383",
    "EFO_Trait_Name": "mumps virus infectious disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473068/harmonised/GCST90473068.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473444",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007405",
    "EFO_Trait_Name": "optic neuritis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473444/harmonised/GCST90473444.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473477",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007415",
    "EFO_Trait_Name": "otitis media with effusion",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473477/harmonised/GCST90473477.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473554",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007427",
    "EFO_Trait_Name": "pericarditis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473554/harmonised/GCST90473554.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473694",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007429",
    "EFO_Trait_Name": "peritonsillar abscess",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473694/harmonised/GCST90473694.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474238",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007441",
    "EFO_Trait_Name": "placenta disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474238/harmonised/GCST90474238.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474239",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007442",
    "EFO_Trait_Name": "placenta praevia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474239/harmonised/GCST90474239.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473040",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007450",
    "EFO_Trait_Name": "poliomyelitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473040/harmonised/GCST90473040.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473097",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007454",
    "EFO_Trait_Name": "postpoliomyelitis syndrome",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473097/harmonised/GCST90473097.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473994",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007460",
    "EFO_Trait_Name": "reactive arthritis",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473994/harmonised/GCST90473994.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473025",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007477",
    "EFO_Trait_Name": "scarlet fever",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473025/harmonised/GCST90473025.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473687",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007486",
    "EFO_Trait_Name": "sinusitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473687/harmonised/GCST90473687.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473653",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007541",
    "EFO_Trait_Name": "viral pneumonia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473653/harmonised/GCST90473653.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473263",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007706",
    "EFO_Trait_Name": "manic or hypomanic episode",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473263/harmonised/GCST90473263.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473872",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0008496",
    "EFO_Trait_Name": "chronic hepatitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473872/harmonised/GCST90473872.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473686",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0008521",
    "EFO_Trait_Name": "rhinitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473686/harmonised/GCST90473686.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473305",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0008525",
    "EFO_Trait_Name": "spinal muscular atrophy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473305/harmonised/GCST90473305.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473323",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0008526",
    "EFO_Trait_Name": "status epilepticus",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473323/harmonised/GCST90473323.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473790",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0008533",
    "EFO_Trait_Name": "dyspepsia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473790/harmonised/GCST90473790.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473814",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0008561",
    "EFO_Trait_Name": "diaphragmatic hernia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473814/harmonised/GCST90473814.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473286",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0008568",
    "EFO_Trait_Name": "sleep disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473286/harmonised/GCST90473286.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473195",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0008572",
    "EFO_Trait_Name": "malnutrition",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473195/harmonised/GCST90473195.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473869",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0008573",
    "EFO_Trait_Name": "alcoholic liver disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473869/harmonised/GCST90473869.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474149",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0008577",
    "EFO_Trait_Name": "Juvenile Osteochondrosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474149/harmonised/GCST90474149.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473763",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0008581",
    "EFO_Trait_Name": "salivary gland disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473763/harmonised/GCST90473763.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473864",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0008588",
    "EFO_Trait_Name": "peritonitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473864/harmonised/GCST90473864.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473714",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0008590",
    "EFO_Trait_Name": "Status Asthmaticus",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473714/harmonised/GCST90473714.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473154",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0008614",
    "EFO_Trait_Name": "Iodine Deficiency Hypothyroidism",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473154/harmonised/GCST90473154.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474277",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0008615",
    "EFO_Trait_Name": "cystic kidney disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474277/harmonised/GCST90474277.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473440",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0008624",
    "EFO_Trait_Name": "vitreous body disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473440/harmonised/GCST90473440.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474099",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0008997",
    "EFO_Trait_Name": "synovitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474099/harmonised/GCST90474099.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473143",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009002",
    "EFO_Trait_Name": "splenic disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473143/harmonised/GCST90473143.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473243",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009267",
    "EFO_Trait_Name": "delirium",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473243/harmonised/GCST90473243.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473139",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009314",
    "EFO_Trait_Name": "blood coagulation disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473139/harmonised/GCST90473139.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473298",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009386",
    "EFO_Trait_Name": "central nervous system disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473298/harmonised/GCST90473298.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473337",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009387",
    "EFO_Trait_Name": "peripheral nervous system disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473337/harmonised/GCST90473337.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474271",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009431",
    "EFO_Trait_Name": "intestinal disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474271/harmonised/GCST90474271.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474113",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009432",
    "EFO_Trait_Name": "fibroblastic disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474113/harmonised/GCST90474113.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473398",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009449",
    "EFO_Trait_Name": "keratitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473398/harmonised/GCST90473398.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473187",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009451",
    "EFO_Trait_Name": "hypoparathyroidism",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473187/harmonised/GCST90473187.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473361",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009453",
    "EFO_Trait_Name": "hemiplegia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473361/harmonised/GCST90473361.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473382",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009455",
    "EFO_Trait_Name": "lacrimal apparatus disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473382/harmonised/GCST90473382.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473399",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009464",
    "EFO_Trait_Name": "corneal disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473399/harmonised/GCST90473399.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473762",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009468",
    "EFO_Trait_Name": "jaw disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473762/harmonised/GCST90473762.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474108",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009470",
    "EFO_Trait_Name": "soft tissue disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474108/harmonised/GCST90474108.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473484",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009472",
    "EFO_Trait_Name": "tympanic membrane perforation",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473484/harmonised/GCST90473484.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473691",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009481",
    "EFO_Trait_Name": "paranasal sinus disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473691/harmonised/GCST90473691.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474216",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009483",
    "EFO_Trait_Name": "breast disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474216/harmonised/GCST90474216.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473370",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009488",
    "EFO_Trait_Name": "spinal cord disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473370/harmonised/GCST90473370.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473567",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009492",
    "EFO_Trait_Name": "cardiac arrest",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473567/harmonised/GCST90473567.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473568",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009493",
    "EFO_Trait_Name": "paroxysmal tachycardia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473568/harmonised/GCST90473568.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474040",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009507",
    "EFO_Trait_Name": "knee injury",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474040/harmonised/GCST90474040.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474037",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009509",
    "EFO_Trait_Name": "limb injury",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474037/harmonised/GCST90474037.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474224",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009524",
    "EFO_Trait_Name": "female genital tract fistula",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474224/harmonised/GCST90474224.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473558",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009531",
    "EFO_Trait_Name": "aortic valve disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473558/harmonised/GCST90473558.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473367",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009532",
    "EFO_Trait_Name": "autonomic nervous system disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473367/harmonised/GCST90473367.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473309",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009533",
    "EFO_Trait_Name": "basal ganglia disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473309/harmonised/GCST90473309.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473883",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009534",
    "EFO_Trait_Name": "biliary tract disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473883/harmonised/GCST90473883.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473448",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009535",
    "EFO_Trait_Name": "binocular vision disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473448/harmonised/GCST90473448.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473377",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009536",
    "EFO_Trait_Name": "blepharitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473377/harmonised/GCST90473377.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473863",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009541",
    "EFO_Trait_Name": "disease of peritoneum",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473863/harmonised/GCST90473863.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473795",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009542",
    "EFO_Trait_Name": "disorder of appendix",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473795/harmonised/GCST90473795.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474269",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009544",
    "EFO_Trait_Name": "esophageal disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474269/harmonised/GCST90474269.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473616",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009545",
    "EFO_Trait_Name": "esophageal varices",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473616/harmonised/GCST90473616.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473379",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009547",
    "EFO_Trait_Name": "eyelid disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473379/harmonised/GCST90473379.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474223",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009549",
    "EFO_Trait_Name": "female reproductive system disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474223/harmonised/GCST90474223.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473328",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009550",
    "EFO_Trait_Name": "headache disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473328/harmonised/GCST90473328.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474213",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009555",
    "EFO_Trait_Name": "male reproductive system disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474213/harmonised/GCST90474213.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473225",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009556",
    "EFO_Trait_Name": "mineral metabolism disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473225/harmonised/GCST90473225.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473557",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009557",
    "EFO_Trait_Name": "mitral valve disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473557/harmonised/GCST90473557.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473346",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009558",
    "EFO_Trait_Name": "mononeuropathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473346/harmonised/GCST90473346.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473470",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009560",
    "EFO_Trait_Name": "otitis externa",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473470/harmonised/GCST90473470.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473351",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009562",
    "EFO_Trait_Name": "polyneuropathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473351/harmonised/GCST90473351.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473560",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009564",
    "EFO_Trait_Name": "pulmonary valve disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473560/harmonised/GCST90473560.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473037",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009567",
    "EFO_Trait_Name": "Spirochaetales Infections",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473037/harmonised/GCST90473037.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473559",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009568",
    "EFO_Trait_Name": "tricuspid valve disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473559/harmonised/GCST90473559.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473335",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009569",
    "EFO_Trait_Name": "trigeminal nerve disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473335/harmonised/GCST90473335.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473485",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009570",
    "EFO_Trait_Name": "tympanic membrane disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473485/harmonised/GCST90473485.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474234",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009576",
    "EFO_Trait_Name": "multiple gestation",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474234/harmonised/GCST90474234.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474248",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009578",
    "EFO_Trait_Name": "placental retention",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474248/harmonised/GCST90474248.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473193",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009601",
    "EFO_Trait_Name": "testicular disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473193/harmonised/GCST90473193.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473885",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009605",
    "EFO_Trait_Name": "pancreas disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473885/harmonised/GCST90473885.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473190",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009607",
    "EFO_Trait_Name": "pituitary gland disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473190/harmonised/GCST90473190.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474250",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009636",
    "EFO_Trait_Name": "cesarean section",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474250/harmonised/GCST90474250.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474241",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009639",
    "EFO_Trait_Name": "braxton-hicks contractions",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474241/harmonised/GCST90474241.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473640",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009657",
    "EFO_Trait_Name": "acute pharyngitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473640/harmonised/GCST90473640.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473598",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009659",
    "EFO_Trait_Name": "aneurysm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473598/harmonised/GCST90473598.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473054",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009662",
    "EFO_Trait_Name": "common wart",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473054/harmonised/GCST90473054.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474225",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009663",
    "EFO_Trait_Name": "disease of genitourinary system",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474225/harmonised/GCST90474225.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473465",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009664",
    "EFO_Trait_Name": "disease of orbital region",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473465/harmonised/GCST90473465.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474038",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009665",
    "EFO_Trait_Name": "disorder of patella",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474038/harmonised/GCST90474038.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474119",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009666",
    "EFO_Trait_Name": "enthesopathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474119/harmonised/GCST90474119.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473480",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009667",
    "EFO_Trait_Name": "eustachian tube disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473480/harmonised/GCST90473480.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473468",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009668",
    "EFO_Trait_Name": "external ear disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473468/harmonised/GCST90473468.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473304",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009671",
    "EFO_Trait_Name": "hereditary ataxia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473304/harmonised/GCST90473304.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473488",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009672",
    "EFO_Trait_Name": "inner ear disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473488/harmonised/GCST90473488.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473695",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009673",
    "EFO_Trait_Name": "laryngeal disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473695/harmonised/GCST90473695.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474256",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009674",
    "EFO_Trait_Name": "lens disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474256/harmonised/GCST90474256.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474097",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009676",
    "EFO_Trait_Name": "musculoskeletal system disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474097/harmonised/GCST90474097.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473446",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009678",
    "EFO_Trait_Name": "paralytic strabismus",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473446/harmonised/GCST90473446.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473727",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009680",
    "EFO_Trait_Name": "pleural empyema",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473727/harmonised/GCST90473727.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474242",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009681",
    "EFO_Trait_Name": "post term pregnancy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474242/harmonised/GCST90474242.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473742",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009686",
    "EFO_Trait_Name": "respiratory failure",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473742/harmonised/GCST90473742.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473282",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009687",
    "EFO_Trait_Name": "somatoform disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473282/harmonised/GCST90473282.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473764",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009688",
    "EFO_Trait_Name": "stomatitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473764/harmonised/GCST90473764.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474207",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009689",
    "EFO_Trait_Name": "urethral disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474207/harmonised/GCST90474207.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474210",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009690",
    "EFO_Trait_Name": "urinary system disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474210/harmonised/GCST90474210.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473491",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009691",
    "EFO_Trait_Name": "vestibular disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473491/harmonised/GCST90473491.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473837",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0009959",
    "EFO_Trait_Name": "diverticular disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473837/harmonised/GCST90473837.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474253",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0010238",
    "EFO_Trait_Name": "perinatal disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474253/harmonised/GCST90474253.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473793",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0010282",
    "EFO_Trait_Name": "gastrointestinal disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473793/harmonised/GCST90473793.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474272",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0010284",
    "EFO_Trait_Name": "hepatobiliary disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474272/harmonised/GCST90474272.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473601",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0010671",
    "EFO_Trait_Name": "arterial embolism",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473601/harmonised/GCST90473601.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473756",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0010688",
    "EFO_Trait_Name": "periapical tissue disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473756/harmonised/GCST90473756.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473949",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0020927",
    "EFO_Trait_Name": "skin reaction",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473949/harmonised/GCST90473949.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473761",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0022930",
    "EFO_Trait_Name": "oral cavity cyst",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473761/harmonised/GCST90473761.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474249",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0022939",
    "EFO_Trait_Name": "labor and delivery complications",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474249/harmonised/GCST90474249.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474266",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0022941",
    "EFO_Trait_Name": "congenital respiratory system disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474266/harmonised/GCST90474266.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474199",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000025",
    "EFO_Trait_Name": "cystitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474199/harmonised/GCST90474199.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473216",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000062",
    "EFO_Trait_Name": "lactose intolerance",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473216/harmonised/GCST90473216.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473395",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000203",
    "EFO_Trait_Name": "conjunctival disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473395/harmonised/GCST90473395.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474227",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000298",
    "EFO_Trait_Name": "Hydatidiform Mole",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474227/harmonised/GCST90474227.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473689",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000391",
    "EFO_Trait_Name": "Nasal cavity polyp",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473689/harmonised/GCST90473689.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473152",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000627",
    "EFO_Trait_Name": "thyroid disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473152/harmonised/GCST90473152.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473360",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000632",
    "EFO_Trait_Name": "cerebral palsy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473360/harmonised/GCST90473360.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473721",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000637",
    "EFO_Trait_Name": "acute respiratory distress syndrome",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473721/harmonised/GCST90473721.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473977",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000660",
    "EFO_Trait_Name": "acanthosis nigricans",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473977/harmonised/GCST90473977.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473922",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000668",
    "EFO_Trait_Name": "allergic contact dermatitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473922/harmonised/GCST90473922.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473483",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000678",
    "EFO_Trait_Name": "cholesteatoma of middle ear",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473483/harmonised/GCST90473483.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473945",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000694",
    "EFO_Trait_Name": "erythema multiforme",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473945/harmonised/GCST90473945.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473899",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000714",
    "EFO_Trait_Name": "impetigo",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473899/harmonised/GCST90473899.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473940",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000726",
    "EFO_Trait_Name": "lichen planus",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473940/harmonised/GCST90473940.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473974",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000755",
    "EFO_Trait_Name": "pigmentation disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473974/harmonised/GCST90473974.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473939",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000756",
    "EFO_Trait_Name": "pityriasis rosea",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473939/harmonised/GCST90473939.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473962",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000760",
    "EFO_Trait_Name": "rosacea",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473962/harmonised/GCST90473962.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473921",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000764",
    "EFO_Trait_Name": "seborrheic dermatitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473921/harmonised/GCST90473921.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473981",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000766",
    "EFO_Trait_Name": "skin atrophy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473981/harmonised/GCST90473981.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473967",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000772",
    "EFO_Trait_Name": "sweat gland disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473967/harmonised/GCST90473967.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473911",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000774",
    "EFO_Trait_Name": "vesiculobullous skin disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473911/harmonised/GCST90473911.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473591",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000859",
    "EFO_Trait_Name": "cerebral arterial disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473591/harmonised/GCST90473591.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474042",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1000999",
    "EFO_Trait_Name": "joint disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474042/harmonised/GCST90474042.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474251",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001034",
    "EFO_Trait_Name": "mastitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474251/harmonised/GCST90474251.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473750",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001047",
    "EFO_Trait_Name": "mouth disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473750/harmonised/GCST90473750.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473198",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001067",
    "EFO_Trait_Name": "nutritional deficiency disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473198/harmonised/GCST90473198.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473422",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001119",
    "EFO_Trait_Name": "posterior uveitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473422/harmonised/GCST90473422.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473722",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001134",
    "EFO_Trait_Name": "pulmonary edema",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473722/harmonised/GCST90473722.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473507",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001160",
    "EFO_Trait_Name": "rheumatic fever",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473507/harmonised/GCST90473507.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473509",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001161",
    "EFO_Trait_Name": "rheumatic heart disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473509/harmonised/GCST90473509.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473308",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001175",
    "EFO_Trait_Name": "secondary Parkinson disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473308/harmonised/GCST90473308.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473760",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001216",
    "EFO_Trait_Name": "tooth disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473760/harmonised/GCST90473760.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473041",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001236",
    "EFO_Trait_Name": "viral meningitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473041/harmonised/GCST90473041.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473661",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001272",
    "EFO_Trait_Name": "bacterial pneumonia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473661/harmonised/GCST90473661.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473964",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001329",
    "EFO_Trait_Name": "follicular cyst",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473964/harmonised/GCST90473964.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473092",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001342",
    "EFO_Trait_Name": "Helminthiasis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473092/harmonised/GCST90473092.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473993",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001351",
    "EFO_Trait_Name": "infectious arthritis",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473993/harmonised/GCST90473993.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473539",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001375",
    "EFO_Trait_Name": "myocardial ischemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473539/harmonised/GCST90473539.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474222",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001388",
    "EFO_Trait_Name": "pelvic inflammatory disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474222/harmonised/GCST90474222.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473605",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001395",
    "EFO_Trait_Name": "phlebitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473605/harmonised/GCST90473605.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474185",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001412",
    "EFO_Trait_Name": "renal colic",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474185/harmonised/GCST90474185.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473010",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001418",
    "EFO_Trait_Name": "Salmonella Infections",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473010/harmonised/GCST90473010.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473503",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001455",
    "EFO_Trait_Name": "auditory system disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473503/harmonised/GCST90473503.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473301",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001456",
    "EFO_Trait_Name": "central nervous system infection",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473301/harmonised/GCST90473301.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473031",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001462",
    "EFO_Trait_Name": "erysipelas",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473031/harmonised/GCST90473031.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473820",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001463",
    "EFO_Trait_Name": "gastroenteritis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473820/harmonised/GCST90473820.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473808",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001791",
    "EFO_Trait_Name": "femoral hernia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473808/harmonised/GCST90473808.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473811",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001866",
    "EFO_Trait_Name": "ventral hernia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473811/harmonised/GCST90473811.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473227",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001875",
    "EFO_Trait_Name": "amyloidosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473227/harmonised/GCST90473227.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473355",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001902",
    "EFO_Trait_Name": "neuromuscular disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473355/harmonised/GCST90473355.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474048",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001986",
    "EFO_Trait_Name": "connective tissue disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474048/harmonised/GCST90474048.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473719",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001991",
    "EFO_Trait_Name": "pneumonitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473719/harmonised/GCST90473719.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473123",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1001996",
    "EFO_Trait_Name": "Thalassemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473123/harmonised/GCST90473123.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473046",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1002022",
    "EFO_Trait_Name": "Herpes simplex infection",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473046/harmonised/GCST90473046.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473052",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1002025",
    "EFO_Trait_Name": "measles",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473052/harmonised/GCST90473052.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473053",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1002026",
    "EFO_Trait_Name": "rubella",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473053/harmonised/GCST90473053.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473960",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1002028",
    "EFO_Trait_Name": "cicatricial alopecia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473960/harmonised/GCST90473960.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473526",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1002034",
    "EFO_Trait_Name": "secondary hypertension",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473526/harmonised/GCST90473526.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474178",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1002048",
    "EFO_Trait_Name": "kidney failure",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474178/harmonised/GCST90474178.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474161",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1002049",
    "EFO_Trait_Name": "glomerular disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474161/harmonised/GCST90474161.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474164",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1002050",
    "EFO_Trait_Name": "nephritis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474164/harmonised/GCST90474164.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473336",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_1002051",
    "EFO_Trait_Name": "facial nerve disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473336/harmonised/GCST90473336.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473806",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0000023",
    "EFO_Trait_Name": "inguinal hernia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473806/harmonised/GCST90473806.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474276",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0000079",
    "EFO_Trait_Name": "Abnormality of the urinary system",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474276/harmonised/GCST90474276.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473759",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0000153",
    "EFO_Trait_Name": "abnormality of the mouth",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473759/harmonised/GCST90473759.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473368",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0000238",
    "EFO_Trait_Name": "hydrocephalus",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473368/harmonised/GCST90473368.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473482",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0000265",
    "EFO_Trait_Name": "Mastoiditis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473482/harmonised/GCST90473482.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473461",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0000496",
    "EFO_Trait_Name": "abnormality of eye movement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473461/harmonised/GCST90473461.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473456",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0000504",
    "EFO_Trait_Name": "abnormality of vision",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473456/harmonised/GCST90473456.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473458",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0000505",
    "EFO_Trait_Name": "visual impairment",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473458/harmonised/GCST90473458.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474157",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0000790",
    "EFO_Trait_Name": "Hematuria",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474157/harmonised/GCST90474157.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474058",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0000925",
    "EFO_Trait_Name": "Abnormality of the vertebral column",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474058/harmonised/GCST90474058.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473928",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0000989",
    "EFO_Trait_Name": "Pruritus",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473928/harmonised/GCST90473928.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473401",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0001094",
    "EFO_Trait_Name": "iridocyclitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473401/harmonised/GCST90473401.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473291",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0001249",
    "EFO_Trait_Name": "Intellectual disability",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473291/harmonised/GCST90473291.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473310",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0001332",
    "EFO_Trait_Name": "Dystonia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473310/harmonised/GCST90473310.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473871",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0001399",
    "EFO_Trait_Name": "hepatic failure",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473871/harmonised/GCST90473871.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473810",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0001537",
    "EFO_Trait_Name": "Umbilical hernia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473810/harmonised/GCST90473810.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474281",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0001760",
    "EFO_Trait_Name": "Abnormal foot morphology",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474281/harmonised/GCST90474281.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474244",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0001787",
    "EFO_Trait_Name": "Abnormal delivery",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474244/harmonised/GCST90474244.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473144",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0001871",
    "EFO_Trait_Name": "Abnormality of blood and blood-forming tissues",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473144/harmonised/GCST90473144.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473723",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0001880",
    "EFO_Trait_Name": "Eosinophilia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473723/harmonised/GCST90473723.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473115",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0001891",
    "EFO_Trait_Name": "Iron deficiency anemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473115/harmonised/GCST90473115.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473232",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0001939",
    "EFO_Trait_Name": "abnormality of metabolism/homeostasis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473232/harmonised/GCST90473232.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473890",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0002024",
    "EFO_Trait_Name": "Malabsorption",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473890/harmonised/GCST90473890.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473734",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0002202",
    "EFO_Trait_Name": "Pleural effusion",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473734/harmonised/GCST90473734.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473146",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0002721",
    "EFO_Trait_Name": "Immunodeficiency",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473146/harmonised/GCST90473146.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473619",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0002840",
    "EFO_Trait_Name": "lymphadenitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473619/harmonised/GCST90473619.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474004",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0003040",
    "EFO_Trait_Name": "Arthropathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474004/harmonised/GCST90474004.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473359",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0003470",
    "EFO_Trait_Name": "paralysis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473359/harmonised/GCST90473359.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473816",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0004299",
    "EFO_Trait_Name": "hernia of the abdominal wall",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473816/harmonised/GCST90473816.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474257",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0004329",
    "EFO_Trait_Name": "Abnormal posterior eye segment morphology",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474257/harmonised/GCST90474257.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474162",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0004729",
    "EFO_Trait_Name": "Acute tubulointerstitial nephritis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474162/harmonised/GCST90474162.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474163",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0004743",
    "EFO_Trait_Name": "Chronic tubulointerstitial nephritis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474163/harmonised/GCST90474163.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473303",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0007367",
    "EFO_Trait_Name": "Atrophy/Degeneration affecting the central nervous system",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473303/harmonised/GCST90473303.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474219",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0010313",
    "EFO_Trait_Name": "breast hypertrophy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474219/harmonised/GCST90474219.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473908",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0010769",
    "EFO_Trait_Name": "pilonidal sinus",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473908/harmonised/GCST90473908.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473229",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0011106",
    "EFO_Trait_Name": "hypovolemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473229/harmonised/GCST90473229.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473901",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0011123",
    "EFO_Trait_Name": "inflammatory abnormality of the skin",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473901/harmonised/GCST90473901.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473979",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0011368",
    "EFO_Trait_Name": "epidermal thickening",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473979/harmonised/GCST90473979.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473946",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0012219",
    "EFO_Trait_Name": "erythema nodosum",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473946/harmonised/GCST90473946.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474206",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0012227",
    "EFO_Trait_Name": "Urethral stricture",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474206/harmonised/GCST90474206.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473141",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0012234",
    "EFO_Trait_Name": "Agranulocytosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473141/harmonised/GCST90473141.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473671",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0012388",
    "EFO_Trait_Name": "acute bronchitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473671/harmonised/GCST90473671.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474268",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0025031",
    "EFO_Trait_Name": "abnormality of the digestive system",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474268/harmonised/GCST90474268.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474240",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0025328",
    "EFO_Trait_Name": "antepartum hemorrhage",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474240/harmonised/GCST90474240.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473607",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0030242",
    "EFO_Trait_Name": "portal vein thrombosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473607/harmonised/GCST90473607.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474226",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0031456",
    "EFO_Trait_Name": "ectopic pregnancy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474226/harmonised/GCST90474226.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474280",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0033127",
    "EFO_Trait_Name": "Abnormality of the musculoskeletal system",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474280/harmonised/GCST90474280.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473768",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0100633",
    "EFO_Trait_Name": "Esophagitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473768/harmonised/GCST90473768.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473804",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0100790",
    "EFO_Trait_Name": "Hernia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473804/harmonised/GCST90473804.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474212",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "HP_0100813",
    "EFO_Trait_Name": "testicular torsion",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474212/harmonised/GCST90474212.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473082",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0000254",
    "EFO_Trait_Name": "cutaneous mycosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473082/harmonised/GCST90473082.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473602",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0000473",
    "EFO_Trait_Name": "arterial disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473602/harmonised/GCST90473602.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473555",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0000474",
    "EFO_Trait_Name": "pericardium disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473555/harmonised/GCST90473555.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473293",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0000592",
    "EFO_Trait_Name": "specific developmental disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473293/harmonised/GCST90473293.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473295",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0000594",
    "EFO_Trait_Name": "pervasive developmental disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473295/harmonised/GCST90473295.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474085",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0000812",
    "EFO_Trait_Name": "vertebral column disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474085/harmonised/GCST90474085.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473014",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0000916",
    "EFO_Trait_Name": "intestinal infectious disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473014/harmonised/GCST90473014.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473563",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0000992",
    "EFO_Trait_Name": "heart conduction disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473563/harmonised/GCST90473563.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474166",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0001085",
    "EFO_Trait_Name": "interstitial nephritis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474166/harmonised/GCST90474166.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473522",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0001134",
    "EFO_Trait_Name": "essential hypertension",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473522/harmonised/GCST90473522.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473281",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0001160",
    "EFO_Trait_Name": "dissociative disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473281/harmonised/GCST90473281.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473766",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0001165",
    "EFO_Trait_Name": "tongue disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473766/harmonised/GCST90473766.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473524",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0001302",
    "EFO_Trait_Name": "hypertensive heart disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473524/harmonised/GCST90473524.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474189",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0001343",
    "EFO_Trait_Name": "impaired renal function disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474189/harmonised/GCST90474189.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474066",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0001434",
    "EFO_Trait_Name": "inflammatory spondylopathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474066/harmonised/GCST90474066.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473603",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0001574",
    "EFO_Trait_Name": "capillary disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473603/harmonised/GCST90473603.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473241",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0001627",
    "EFO_Trait_Name": "dementia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473241/harmonised/GCST90473241.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473159",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0001658",
    "EFO_Trait_Name": "nontoxic goiter",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473159/harmonised/GCST90473159.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473306",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0001815",
    "EFO_Trait_Name": "extrapyramidal and movement disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473306/harmonised/GCST90473306.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473118",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0001860",
    "EFO_Trait_Name": "folic acid deficiency anemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473118/harmonised/GCST90473118.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473244",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0002025",
    "EFO_Trait_Name": "psychiatric disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473244/harmonised/GCST90473244.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473288",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0002028",
    "EFO_Trait_Name": "personality disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473288/harmonised/GCST90473288.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473730",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0002037",
    "EFO_Trait_Name": "pleural disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473730/harmonised/GCST90473730.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473078",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0002041",
    "EFO_Trait_Name": "fungal infectious disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473078/harmonised/GCST90473078.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473269",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0002050",
    "EFO_Trait_Name": "depressive disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473269/harmonised/GCST90473269.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473425",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0002089",
    "EFO_Trait_Name": "retinal vascular occlusion",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473425/harmonised/GCST90473425.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473140",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0002243",
    "EFO_Trait_Name": "hemorrhagic disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473140/harmonised/GCST90473140.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474069",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0002253",
    "EFO_Trait_Name": "spondylosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474069/harmonised/GCST90474069.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473113",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0002280",
    "EFO_Trait_Name": "anemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473113/harmonised/GCST90473113.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474254",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0002320",
    "EFO_Trait_Name": "congenital nervous system disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474254/harmonised/GCST90474254.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473925",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0002406",
    "EFO_Trait_Name": "dermatitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473925/harmonised/GCST90473925.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473013",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0002428",
    "EFO_Trait_Name": "protozoa infectious disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473013/harmonised/GCST90473013.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474111",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0002471",
    "EFO_Trait_Name": "bursitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474111/harmonised/GCST90474111.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474172",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0002492",
    "EFO_Trait_Name": "acute kidney failure",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474172/harmonised/GCST90474172.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473757",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0002635",
    "EFO_Trait_Name": "periodontal disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473757/harmonised/GCST90473757.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473094",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0002875",
    "EFO_Trait_Name": "parasitic ectoparasitic infectious disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473094/harmonised/GCST90473094.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473955",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0002884",
    "EFO_Trait_Name": "nail disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473955/harmonised/GCST90473955.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474072",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0003937",
    "EFO_Trait_Name": "spondylitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474072/harmonised/GCST90474072.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473162",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0004126",
    "EFO_Trait_Name": "thyroiditis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473162/harmonised/GCST90473162.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473783",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0004247",
    "EFO_Trait_Name": "peptic ulcer disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473783/harmonised/GCST90473783.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473259",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0004359",
    "EFO_Trait_Name": "delusional disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473259/harmonised/GCST90473259.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473547",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0004596",
    "EFO_Trait_Name": "cor pulmonale",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473547/harmonised/GCST90473547.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473618",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0004634",
    "EFO_Trait_Name": "vein disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473618/harmonised/GCST90473618.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473984",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0004670",
    "EFO_Trait_Name": "lupus erythematosus",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473984/harmonised/GCST90473984.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473080",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0004678",
    "EFO_Trait_Name": "dermatophytosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473080/harmonised/GCST90473080.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473142",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0004805",
    "EFO_Trait_Name": "leukocyte disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473142/harmonised/GCST90473142.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473715",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0004822",
    "EFO_Trait_Name": "bronchiectasis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473715/harmonised/GCST90473715.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474184",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0004828",
    "EFO_Trait_Name": "lower urinary tract calculus",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474184/harmonised/GCST90474184.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473410",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0004847",
    "EFO_Trait_Name": "senile cataract",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473410/harmonised/GCST90473410.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473958",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0004907",
    "EFO_Trait_Name": "alopecia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473958/harmonised/GCST90473958.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473264",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0004985",
    "EFO_Trait_Name": "bipolar disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473264/harmonised/GCST90473264.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473258",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0005090",
    "EFO_Trait_Name": "schizophrenia",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473258/harmonised/GCST90473258.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473316",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0005301",
    "EFO_Trait_Name": "multiple sclerosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473316/harmonised/GCST90473316.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474237",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0012511",
    "EFO_Trait_Name": "preterm premature rupture of the membranes",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474237/harmonised/GCST90474237.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473718",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0017853",
    "EFO_Trait_Name": "hypersensitivity pneumonitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473718/harmonised/GCST90473718.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473018",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0018076",
    "EFO_Trait_Name": "tuberculosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473018/harmonised/GCST90473018.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474275",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0018470",
    "EFO_Trait_Name": "renal agenesis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474275/harmonised/GCST90474275.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474283",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0019054",
    "EFO_Trait_Name": "congenital limb malformation",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474283/harmonised/GCST90474283.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474050",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0019170",
    "EFO_Trait_Name": "polyarteritis nodosa",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474050/harmonised/GCST90474050.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473223",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0019254",
    "EFO_Trait_Name": "inborn disorder of purine or pyrimidine metabolism",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473223/harmonised/GCST90473223.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473302",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0020010",
    "EFO_Trait_Name": "infectious disorder of the nervous system",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473302/harmonised/GCST90473302.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474263",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0020292",
    "EFO_Trait_Name": "congenital anomaly of the great arteries",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474263/harmonised/GCST90474263.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473986",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0020576",
    "EFO_Trait_Name": "cutaneous vasculitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473986/harmonised/GCST90473986.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473643",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0020686",
    "EFO_Trait_Name": "acute tonsillitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473643/harmonised/GCST90473643.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473317",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0020800",
    "EFO_Trait_Name": "demyelinating disease of central nervous system",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473317/harmonised/GCST90473317.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473445",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0021084",
    "EFO_Trait_Name": "vision disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473445/harmonised/GCST90473445.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473300",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0021108",
    "EFO_Trait_Name": "meningitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473300/harmonised/GCST90473300.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474267",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0021147",
    "EFO_Trait_Name": "disorder of development or morphogenesis",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474267/harmonised/GCST90474267.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473897",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0021201",
    "EFO_Trait_Name": "skin infection",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473897/harmonised/GCST90473897.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473505",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0021205",
    "EFO_Trait_Name": "disorder of ear",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473505/harmonised/GCST90473505.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473036",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0021681",
    "EFO_Trait_Name": "sexually transmitted disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473036/harmonised/GCST90473036.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474008",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0022208",
    "EFO_Trait_Name": "crystal arthropathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474008/harmonised/GCST90474008.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474265",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0024239",
    "EFO_Trait_Name": "congenital anomaly of cardiovascular system",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474265/harmonised/GCST90474265.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473633",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0024355",
    "EFO_Trait_Name": "respiratory tract infectious disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473633/harmonised/GCST90473633.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473443",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0024458",
    "EFO_Trait_Name": "disorder of visual system",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473443/harmonised/GCST90473443.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473525",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0024633",
    "EFO_Trait_Name": "hypertensive nephropathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473525/harmonised/GCST90473525.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473217",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0037792",
    "EFO_Trait_Name": "carbohydrate metabolism disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473217/harmonised/GCST90473217.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473200",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0042976",
    "EFO_Trait_Name": "vitamin B deficiency",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473200/harmonised/GCST90473200.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474288",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0042983",
    "EFO_Trait_Name": "neurocutaneous syndrome",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474288/harmonised/GCST90474288.h.tsv.gz"
  },
  {
    "accessionId": "GCST90473059",
    "initial_individuals": "458440",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "MONDO_0100370",
    "EFO_Trait_Name": "acute hepatitis B virus infection",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90473001-GCST90474000/GCST90473059/harmonised/GCST90473059.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474611",
    "initial_individuals": "457594",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "OBA_1001085",
    "EFO_Trait_Name": "waist circumference",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474611/harmonised/GCST90474611.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474616",
    "initial_individuals": "457543",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "OBA_1000032",
    "EFO_Trait_Name": "hip circumference",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474616/harmonised/GCST90474616.h.tsv.gz"
  },
  {
    "accessionId": "GCST90044101",
    "initial_individuals": "456348",
    "initial_ancestralGroup": "European",
    "pubmedId": "34737426",
    "EFO_ID": "EFO_0000649",
    "EFO_Trait_Name": "periodontitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044101/harmonised/GCST90044101.h.tsv.gz"
  },
  {
    "accessionId": "GCST90043769",
    "initial_individuals": "456348",
    "initial_ancestralGroup": "European",
    "pubmedId": "34737426",
    "EFO_ID": "EFO_0004991",
    "EFO_Trait_Name": "myasthenia gravis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043769/harmonised/GCST90043769.h.tsv.gz"
  },
  {
    "accessionId": "GCST90044546",
    "initial_individuals": "456348",
    "initial_ancestralGroup": "European",
    "pubmedId": "34737426",
    "EFO_ID": "EFO_0008518",
    "EFO_Trait_Name": "polymyalgia rheumatica",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044546/harmonised/GCST90044546.h.tsv.gz"
  },
  {
    "accessionId": "GCST90044647",
    "initial_individuals": "456348",
    "initial_ancestralGroup": "European",
    "pubmedId": "34737426",
    "EFO_ID": "EFO_0011023",
    "EFO_Trait_Name": "concussion",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044647/harmonised/GCST90044647.h.tsv.gz"
  },
  {
    "accessionId": "GCST90041859",
    "initial_individuals": "456348",
    "initial_ancestralGroup": "European",
    "pubmedId": "34737426",
    "EFO_ID": "EFO_1000363",
    "EFO_Trait_Name": "malignant urinary system neoplasm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041859/harmonised/GCST90041859.h.tsv.gz"
  },
  {
    "accessionId": "GCST90043833",
    "initial_individuals": "456348",
    "initial_ancestralGroup": "European",
    "pubmedId": "34737426",
    "EFO_ID": "HP_0002321",
    "EFO_Trait_Name": "Vertigo",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043833/harmonised/GCST90043833.h.tsv.gz"
  },
  {
    "accessionId": "GCST90044164",
    "initial_individuals": "456348",
    "initial_ancestralGroup": "European",
    "pubmedId": "34737426",
    "EFO_ID": "HP_0011024",
    "EFO_Trait_Name": "Abnormality of the gastrointestinal tract",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044164/harmonised/GCST90044164.h.tsv.gz"
  },
  {
    "accessionId": "GCST90043784",
    "initial_individuals": "456348",
    "initial_ancestralGroup": "European",
    "pubmedId": "34737426",
    "EFO_ID": "HP_0011141",
    "EFO_Trait_Name": "age-related cataract",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043784/harmonised/GCST90043784.h.tsv.gz"
  },
  {
    "accessionId": "GCST90043847",
    "initial_individuals": "456348",
    "initial_ancestralGroup": "European",
    "pubmedId": "34737426",
    "EFO_ID": "MONDO_0001056",
    "EFO_Trait_Name": "gastric cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043847/harmonised/GCST90043847.h.tsv.gz"
  },
  {
    "accessionId": "GCST90449060",
    "initial_individuals": "455258",
    "initial_ancestralGroup": "European",
    "pubmedId": "39537608",
    "EFO_ID": "EFO_0006514",
    "EFO_Trait_Name": "Alzheimer's disease biomarker measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90449001-GCST90450000/GCST90449060/harmonised/GCST90449060.h.tsv.gz"
  },
  {
    "accessionId": "GCST90704617",
    "initial_individuals": "453377",
    "initial_ancestralGroup": "European",
    "pubmedId": "41501457",
    "EFO_ID": "EFO_0004972",
    "EFO_Trait_Name": "somatic genotype",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90704001-GCST90705000/GCST90704617/harmonised/GCST90704617.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018823",
    "initial_individuals": "452495",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_1000024",
    "EFO_Trait_Name": "chronic rhinosinusitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018823/harmonised/GCST90018823.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018832",
    "initial_individuals": "452280",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0000401",
    "EFO_Trait_Name": "diabetic nephropathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018832/harmonised/GCST90018832.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475866",
    "initial_individuals": "451195",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0010676",
    "EFO_Trait_Name": "cornea transplantation",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475866/harmonised/GCST90475866.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477661",
    "initial_individuals": "451195",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0015486",
    "EFO_Trait_Name": "keratoconus",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477661/harmonised/GCST90477661.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476182",
    "initial_individuals": "451163",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0003834",
    "EFO_Trait_Name": "cutaneous lupus erythematosus",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476182/harmonised/GCST90476182.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475695",
    "initial_individuals": "451138",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009452",
    "EFO_Trait_Name": "hyperaldosteronism",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475695/harmonised/GCST90475695.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478538",
    "initial_individuals": "451116",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0010134",
    "EFO_Trait_Name": "kidney transplant",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478538/harmonised/GCST90478538.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477252",
    "initial_individuals": "451030",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001901",
    "EFO_Trait_Name": "neuroendocrine neoplasm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477252/harmonised/GCST90477252.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475614",
    "initial_individuals": "450986",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0004643",
    "EFO_Trait_Name": "myeloid leukemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475614/harmonised/GCST90475614.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475662",
    "initial_individuals": "450937",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1000897",
    "EFO_Trait_Name": "diabetic ketoacidosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475662/harmonised/GCST90475662.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475613",
    "initial_individuals": "450932",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0004289",
    "EFO_Trait_Name": "lymphoid leukemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475613/harmonised/GCST90475613.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477168",
    "initial_individuals": "450927",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0044743",
    "EFO_Trait_Name": "major salivary gland cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477168/harmonised/GCST90477168.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477353",
    "initial_individuals": "450855",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0000823",
    "EFO_Trait_Name": "Delayed puberty",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477353/harmonised/GCST90477353.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477365",
    "initial_individuals": "450833",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0000833",
    "EFO_Trait_Name": "bone remodeling disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477365/harmonised/GCST90477365.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476180",
    "initial_individuals": "450830",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0000589",
    "EFO_Trait_Name": "autoimmune disorder of musculoskeletal system",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476180/harmonised/GCST90476180.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477335",
    "initial_individuals": "450825",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1000973",
    "EFO_Trait_Name": "hyperpituitarism",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477335/harmonised/GCST90477335.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475694",
    "initial_individuals": "450761",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1000797",
    "EFO_Trait_Name": "adrenal gland hyperfunction",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475694/harmonised/GCST90475694.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477171",
    "initial_individuals": "450707",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001931",
    "EFO_Trait_Name": "oropharynx cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477171/harmonised/GCST90477171.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477562",
    "initial_individuals": "450691",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0021107",
    "EFO_Trait_Name": "narcolepsy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477562/harmonised/GCST90477562.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477173",
    "initial_individuals": "450592",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0002358",
    "EFO_Trait_Name": "laryngeal carcinoma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477173/harmonised/GCST90477173.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477167",
    "initial_individuals": "450559",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0004631",
    "EFO_Trait_Name": "tongue cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477167/harmonised/GCST90477167.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475846",
    "initial_individuals": "450525",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0004579",
    "EFO_Trait_Name": "retinoschisis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475846/harmonised/GCST90475846.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475781",
    "initial_individuals": "450479",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0019050",
    "EFO_Trait_Name": "inherited hemoglobinopathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475781/harmonised/GCST90475781.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477219",
    "initial_individuals": "450464",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0001657",
    "EFO_Trait_Name": "brain cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477219/harmonised/GCST90477219.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477722",
    "initial_individuals": "450441",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0004577",
    "EFO_Trait_Name": "corneal ulcer",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477722/harmonised/GCST90477722.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479140",
    "initial_individuals": "450440",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0000118",
    "EFO_Trait_Name": "Phenotypic abnormality",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479140/harmonised/GCST90479140.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477778",
    "initial_individuals": "450423",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0001718",
    "EFO_Trait_Name": "Scleritis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477778/harmonised/GCST90477778.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477300",
    "initial_individuals": "450416",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0000520",
    "EFO_Trait_Name": "Proptosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477300/harmonised/GCST90477300.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477174",
    "initial_individuals": "450395",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0007576",
    "EFO_Trait_Name": "esophageal cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477174/harmonised/GCST90477174.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478526",
    "initial_individuals": "450337",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0010690",
    "EFO_Trait_Name": "renal dialysis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478526/harmonised/GCST90478526.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477211",
    "initial_individuals": "450329",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0044919",
    "EFO_Trait_Name": "malignant renal pelvis neoplasm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477211/harmonised/GCST90477211.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477311",
    "initial_individuals": "450298",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0004996",
    "EFO_Trait_Name": "type 1 diabetes nephropathy",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477311/harmonised/GCST90477311.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477345",
    "initial_individuals": "450265",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0008733",
    "EFO_Trait_Name": "familial glucocorticoid deficiency",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477345/harmonised/GCST90477345.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478369",
    "initial_individuals": "450150",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009608",
    "EFO_Trait_Name": "stomach disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478369/harmonised/GCST90478369.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479068",
    "initial_individuals": "450119",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "-",
    "EFO_Trait_Name": "-",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479068/harmonised/GCST90479068.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475568",
    "initial_individuals": "450110",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0001487",
    "EFO_Trait_Name": "intrahepatic bile duct cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475568/harmonised/GCST90475568.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475601",
    "initial_individuals": "450093",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0003769",
    "EFO_Trait_Name": "endocrine neoplasm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475601/harmonised/GCST90475601.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478834",
    "initial_individuals": "450080",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0002260",
    "EFO_Trait_Name": "hidradenitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478834/harmonised/GCST90478834.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478541",
    "initial_individuals": "450068",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001152",
    "EFO_Trait_Name": "renal osteodystrophy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478541/harmonised/GCST90478541.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477451",
    "initial_individuals": "450062",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0001639",
    "EFO_Trait_Name": "deficiency anemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477451/harmonised/GCST90477451.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477344",
    "initial_individuals": "450050",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0015129",
    "EFO_Trait_Name": "chronic primary adrenal insufficiency",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477344/harmonised/GCST90477344.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476055",
    "initial_individuals": "450033",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009744",
    "EFO_Trait_Name": "surgical resection",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476055/harmonised/GCST90476055.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479283",
    "initial_individuals": "449984",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009888",
    "EFO_Trait_Name": "trauma complication",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479283/harmonised/GCST90479283.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475779",
    "initial_individuals": "449984",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0003689",
    "EFO_Trait_Name": "familial hemolytic anemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475779/harmonised/GCST90475779.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478476",
    "initial_individuals": "449974",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0002887",
    "EFO_Trait_Name": "bile duct disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478476/harmonised/GCST90478476.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477616",
    "initial_individuals": "449967",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0004207",
    "EFO_Trait_Name": "pathological myopia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477616/harmonised/GCST90477616.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477565",
    "initial_individuals": "449951",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0001291",
    "EFO_Trait_Name": "brain compression",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477565/harmonised/GCST90477565.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475605",
    "initial_individuals": "449927",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "GO_0009314",
    "EFO_Trait_Name": "response to radiation",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475605/harmonised/GCST90475605.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475804",
    "initial_individuals": "449913",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009315",
    "EFO_Trait_Name": "thrombophilia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475804/harmonised/GCST90475804.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477748",
    "initial_individuals": "449874",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0001604",
    "EFO_Trait_Name": "lagophthalmos",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477748/harmonised/GCST90477748.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479172",
    "initial_individuals": "449789",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0031273",
    "EFO_Trait_Name": "shock",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479172/harmonised/GCST90479172.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475597",
    "initial_individuals": "449772",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0002367",
    "EFO_Trait_Name": "kidney cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475597/harmonised/GCST90475597.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479314",
    "initial_individuals": "449689",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0043797",
    "EFO_Trait_Name": "spinal cord injury",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479314/harmonised/GCST90479314.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479091",
    "initial_individuals": "449678",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0001574",
    "EFO_Trait_Name": "Abnormality of the integument",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479091/harmonised/GCST90479091.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477135",
    "initial_individuals": "449676",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009632",
    "EFO_Trait_Name": "amputation",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477135/harmonised/GCST90477135.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477940",
    "initial_individuals": "449576",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0004287",
    "EFO_Trait_Name": "ventricular fibrillation",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477940/harmonised/GCST90477940.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479186",
    "initial_individuals": "449558",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001792",
    "EFO_Trait_Name": "femoral neck fracture",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479186/harmonised/GCST90479186.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478996",
    "initial_individuals": "449514",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0002970",
    "EFO_Trait_Name": "Genu varum",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478996/harmonised/GCST90478996.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477514",
    "initial_individuals": "449486",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0001336",
    "EFO_Trait_Name": "Myoclonus",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477514/harmonised/GCST90477514.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475862",
    "initial_individuals": "449482",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1000879",
    "EFO_Trait_Name": "corneal edema",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475862/harmonised/GCST90475862.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475743",
    "initial_individuals": "449432",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0002279",
    "EFO_Trait_Name": "iron metabolism disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475743/harmonised/GCST90475743.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477217",
    "initial_individuals": "449425",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0000326",
    "EFO_Trait_Name": "central nervous system cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477217/harmonised/GCST90477217.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477638",
    "initial_individuals": "449417",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0004580",
    "EFO_Trait_Name": "retinal degeneration",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477638/harmonised/GCST90477638.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477911",
    "initial_individuals": "449381",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0000465",
    "EFO_Trait_Name": "atrioventricular block",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477911/harmonised/GCST90477911.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478013",
    "initial_individuals": "449372",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0004622",
    "EFO_Trait_Name": "chronic intestinal vascular insufficiency",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478013/harmonised/GCST90478013.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477056",
    "initial_individuals": "449365",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0004197",
    "EFO_Trait_Name": "hepatitis B virus infection",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477056/harmonised/GCST90477056.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478517",
    "initial_individuals": "449339",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0000112",
    "EFO_Trait_Name": "nephropathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478517/harmonised/GCST90478517.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477357",
    "initial_individuals": "449331",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0004326",
    "EFO_Trait_Name": "Cachexia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477357/harmonised/GCST90477357.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476011",
    "initial_individuals": "449304",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0010675",
    "EFO_Trait_Name": "chronic venous hypertension",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476011/harmonised/GCST90476011.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477583",
    "initial_individuals": "449223",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009543",
    "EFO_Trait_Name": "disturbances of sensation of smell and taste",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477583/harmonised/GCST90477583.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477258",
    "initial_individuals": "449217",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0024470",
    "EFO_Trait_Name": "benign chondrogenic neoplasm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477258/harmonised/GCST90477258.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478363",
    "initial_individuals": "449196",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1000948",
    "EFO_Trait_Name": "gastroparesis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478363/harmonised/GCST90478363.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478767",
    "initial_individuals": "449161",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0022096",
    "EFO_Trait_Name": "pyogenic granuloma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478767/harmonised/GCST90478767.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477123",
    "initial_individuals": "449139",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0000719",
    "EFO_Trait_Name": "temporal measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477123/harmonised/GCST90477123.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477516",
    "initial_individuals": "449079",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0000476",
    "EFO_Trait_Name": "generalized dystonia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477516/harmonised/GCST90477516.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479132",
    "initial_individuals": "448964",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0003867",
    "EFO_Trait_Name": "rhabdomyolysis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479132/harmonised/GCST90479132.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479307",
    "initial_individuals": "448958",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0100053",
    "EFO_Trait_Name": "anaphylaxis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479307/harmonised/GCST90479307.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478976",
    "initial_individuals": "448943",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0002342",
    "EFO_Trait_Name": "chondromalacia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478976/harmonised/GCST90478976.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478557",
    "initial_individuals": "448936",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0001730",
    "EFO_Trait_Name": "urethral syndrome",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478557/harmonised/GCST90478557.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479330",
    "initial_individuals": "448886",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009482",
    "EFO_Trait_Name": "drug allergy",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479330/harmonised/GCST90479330.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477500",
    "initial_individuals": "448873",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0024361",
    "EFO_Trait_Name": "circadian rhythm sleep disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477500/harmonised/GCST90477500.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476089",
    "initial_individuals": "448825",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0000666",
    "EFO_Trait_Name": "portal hypertension",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476089/harmonised/GCST90476089.h.tsv.gz"
  },
  {
    "accessionId": "GCST90133002",
    "initial_individuals": "448817",
    "initial_ancestralGroup": "European",
    "pubmedId": "32193382",
    "EFO_ID": "EFO_0010088",
    "EFO_Trait_Name": "beverage consumption measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90133001-GCST90134000/GCST90133002/harmonised/GCST90133002.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478090",
    "initial_individuals": "448802",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0001369",
    "EFO_Trait_Name": "chronic laryngitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478090/harmonised/GCST90478090.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475610",
    "initial_individuals": "448784",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0000612",
    "EFO_Trait_Name": "lymphatic system cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475610/harmonised/GCST90475610.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478309",
    "initial_individuals": "448716",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0004844",
    "EFO_Trait_Name": "oral mucosa leukoplakia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478309/harmonised/GCST90478309.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477024",
    "initial_individuals": "448715",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0021679",
    "EFO_Trait_Name": "gram-positive bacterial infections",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477024/harmonised/GCST90477024.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475915",
    "initial_individuals": "448713",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0003906",
    "EFO_Trait_Name": "heart valve prosthesis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475915/harmonised/GCST90475915.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475865",
    "initial_individuals": "448712",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0005321",
    "EFO_Trait_Name": "Fuchs' endothelial dystrophy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475865/harmonised/GCST90475865.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477166",
    "initial_individuals": "448696",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0003868",
    "EFO_Trait_Name": "mouth neoplasm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477166/harmonised/GCST90477166.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477985",
    "initial_individuals": "448639",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1000860",
    "EFO_Trait_Name": "cerebral atherosclerosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477985/harmonised/GCST90477985.h.tsv.gz"
  },
  {
    "accessionId": "GCST90132923",
    "initial_individuals": "448623",
    "initial_ancestralGroup": "European",
    "pubmedId": "32193382",
    "EFO_ID": "EFO_0004329",
    "EFO_Trait_Name": "alcohol drinking",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90132001-GCST90133000/GCST90132923/harmonised/GCST90132923.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476138",
    "initial_individuals": "448588",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0001530",
    "EFO_Trait_Name": "secondary hyperparathyroidism of renal origin",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476138/harmonised/GCST90476138.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475961",
    "initial_individuals": "448576",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0010674",
    "EFO_Trait_Name": "cardioverter defibrillator",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475961/harmonised/GCST90475961.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478204",
    "initial_individuals": "448570",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0007233",
    "EFO_Trait_Name": "diaphragm disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478204/harmonised/GCST90478204.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479124",
    "initial_individuals": "448566",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0004323",
    "EFO_Trait_Name": "muscular atrophy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479124/harmonised/GCST90479124.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479197",
    "initial_individuals": "448533",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009618",
    "EFO_Trait_Name": "foot fracture",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479197/harmonised/GCST90479197.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476064",
    "initial_individuals": "448414",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0004872",
    "EFO_Trait_Name": "Incisional hernia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476064/harmonised/GCST90476064.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477282",
    "initial_individuals": "448342",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0004180",
    "EFO_Trait_Name": "benign urinary system neoplasm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477282/harmonised/GCST90477282.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479324",
    "initial_individuals": "448320",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "GO_0009410",
    "EFO_Trait_Name": "response to xenobiotic stimulus",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479324/harmonised/GCST90479324.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475822",
    "initial_individuals": "448315",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0005804",
    "EFO_Trait_Name": "polycythemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475822/harmonised/GCST90475822.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478832",
    "initial_individuals": "448285",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1000688",
    "EFO_Trait_Name": "dyshidrosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478832/harmonised/GCST90478832.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477785",
    "initial_individuals": "448247",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0007686",
    "EFO_Trait_Name": "Abnormal pupillary function",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477785/harmonised/GCST90477785.h.tsv.gz"
  },
  {
    "accessionId": "GCST90132984",
    "initial_individuals": "448204",
    "initial_ancestralGroup": "European",
    "pubmedId": "32193382",
    "EFO_ID": "EFO_0006781",
    "EFO_Trait_Name": "coffee consumption measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90132001-GCST90133000/GCST90132984/harmonised/GCST90132984.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478974",
    "initial_individuals": "448173",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0001858",
    "EFO_Trait_Name": "Tietze syndrome",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478974/harmonised/GCST90478974.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475852",
    "initial_individuals": "448076",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009606",
    "EFO_Trait_Name": "macular degeneration",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475852/harmonised/GCST90475852.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475630",
    "initial_individuals": "448062",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0000627",
    "EFO_Trait_Name": "benign endocrine neoplasm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475630/harmonised/GCST90475630.h.tsv.gz"
  },
  {
    "accessionId": "GCST90132983",
    "initial_individuals": "448060",
    "initial_ancestralGroup": "European",
    "pubmedId": "32193382",
    "EFO_ID": "EFO_0010091",
    "EFO_Trait_Name": "tea consumption measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90132001-GCST90133000/GCST90132983/harmonised/GCST90132983.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476019",
    "initial_individuals": "448041",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0100582",
    "EFO_Trait_Name": "Nasal polyposis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476019/harmonised/GCST90476019.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478912",
    "initial_individuals": "448020",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009951",
    "EFO_Trait_Name": "response to surgery",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478912/harmonised/GCST90478912.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478407",
    "initial_individuals": "447981",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0004571",
    "EFO_Trait_Name": "intestinal impaction",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478407/harmonised/GCST90478407.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477475",
    "initial_individuals": "447950",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0001877",
    "EFO_Trait_Name": "Abnormal erythrocyte morphology",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477475/harmonised/GCST90477475.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479334",
    "initial_individuals": "447924",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009786",
    "EFO_Trait_Name": "encounter with health service",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479334/harmonised/GCST90479334.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477115",
    "initial_individuals": "447871",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009787",
    "EFO_Trait_Name": "encounter with health service related to reproduction",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477115/harmonised/GCST90477115.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475946",
    "initial_individuals": "447859",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001408",
    "EFO_Trait_Name": "Pulmonary Infarction",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475946/harmonised/GCST90475946.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478123",
    "initial_individuals": "447834",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0007278",
    "EFO_Trait_Name": "fungal lung infectious disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478123/harmonised/GCST90478123.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478031",
    "initial_individuals": "447816",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0005775",
    "EFO_Trait_Name": "aortic disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478031/harmonised/GCST90478031.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478207",
    "initial_individuals": "447784",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009628",
    "EFO_Trait_Name": "abnormal result of function studies",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478207/harmonised/GCST90478207.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477644",
    "initial_individuals": "447780",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0019118",
    "EFO_Trait_Name": "inherited retinal dystrophy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477644/harmonised/GCST90477644.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477601",
    "initial_individuals": "447744",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001998",
    "EFO_Trait_Name": "complex regional pain syndrome",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477601/harmonised/GCST90477601.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479322",
    "initial_individuals": "447732",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "GO_0050896",
    "EFO_Trait_Name": "response to stimulus",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479322/harmonised/GCST90479322.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476088",
    "initial_individuals": "447708",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0100523",
    "EFO_Trait_Name": "Liver abscess",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476088/harmonised/GCST90476088.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477504",
    "initial_individuals": "447691",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009846",
    "EFO_Trait_Name": "muscle cramp",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477504/harmonised/GCST90477504.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478124",
    "initial_individuals": "447657",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001362",
    "EFO_Trait_Name": "Lung Abscess",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478124/harmonised/GCST90478124.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477434",
    "initial_individuals": "447637",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0011565",
    "EFO_Trait_Name": "metabolic syndrome X",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477434/harmonised/GCST90477434.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479339",
    "initial_individuals": "447605",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001478",
    "EFO_Trait_Name": "systemic inflammatory response syndrome",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479339/harmonised/GCST90479339.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475784",
    "initial_individuals": "447568",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0001876",
    "EFO_Trait_Name": "Pancytopenia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475784/harmonised/GCST90475784.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478653",
    "initial_individuals": "447547",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0000769",
    "EFO_Trait_Name": "Abnormality of the breast",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478653/harmonised/GCST90478653.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479075",
    "initial_individuals": "447529",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0000078",
    "EFO_Trait_Name": "Abnormality of the genital system",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479075/harmonised/GCST90479075.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478320",
    "initial_individuals": "447518",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0044782",
    "EFO_Trait_Name": "esophageal ulcer",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478320/harmonised/GCST90478320.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479344",
    "initial_individuals": "447490",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0006834",
    "EFO_Trait_Name": "septic shock",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479344/harmonised/GCST90479344.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475810",
    "initial_individuals": "447460",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0001198",
    "EFO_Trait_Name": "acquired thrombocytopenia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475810/harmonised/GCST90475810.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478066",
    "initial_individuals": "447406",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0010672",
    "EFO_Trait_Name": "blood vessel replacement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478066/harmonised/GCST90478066.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476245",
    "initial_individuals": "447363",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0004229",
    "EFO_Trait_Name": "dupuytren contracture",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476245/harmonised/GCST90476245.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477418",
    "initial_individuals": "447354",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0001948",
    "EFO_Trait_Name": "Alkalosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477418/harmonised/GCST90477418.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477044",
    "initial_individuals": "447296",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1000961",
    "EFO_Trait_Name": "Helicobacter pylori infectious disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477044/harmonised/GCST90477044.h.tsv.gz"
  },
  {
    "accessionId": "GCST90132994",
    "initial_individuals": "447289",
    "initial_ancestralGroup": "European",
    "pubmedId": "32193382",
    "EFO_ID": "EFO_0010139",
    "EFO_Trait_Name": "fish consumption measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90132001-GCST90133000/GCST90132994/harmonised/GCST90132994.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475756",
    "initial_individuals": "447281",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0024431",
    "EFO_Trait_Name": "bilirubin metabolism disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475756/harmonised/GCST90475756.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477397",
    "initial_individuals": "447279",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0002901",
    "EFO_Trait_Name": "Hypocalcemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477397/harmonised/GCST90477397.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477407",
    "initial_individuals": "447258",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0003228",
    "EFO_Trait_Name": "Hypernatremia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477407/harmonised/GCST90477407.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478202",
    "initial_individuals": "447238",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0002104",
    "EFO_Trait_Name": "Apnea",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478202/harmonised/GCST90478202.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477374",
    "initial_individuals": "447183",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0004736",
    "EFO_Trait_Name": "inborn disorder of amino acid metabolism",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477374/harmonised/GCST90477374.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477715",
    "initial_individuals": "447123",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0020950",
    "EFO_Trait_Name": "viral eye infection",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477715/harmonised/GCST90477715.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478674",
    "initial_individuals": "447121",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001366",
    "EFO_Trait_Name": "Mastodynia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478674/harmonised/GCST90478674.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478998",
    "initial_individuals": "447108",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0100559",
    "EFO_Trait_Name": "Lower limb asymmetry",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478998/harmonised/GCST90478998.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477023",
    "initial_individuals": "447055",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0021678",
    "EFO_Trait_Name": "gram-negative bacterial infections",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477023/harmonised/GCST90477023.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475608",
    "initial_individuals": "447038",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0004251",
    "EFO_Trait_Name": "myeloproliferative disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475608/harmonised/GCST90475608.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475864",
    "initial_individuals": "447038",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0018102",
    "EFO_Trait_Name": "corneal dystrophy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475864/harmonised/GCST90475864.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475783",
    "initial_individuals": "447020",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0012197",
    "EFO_Trait_Name": "idiopathic aplastic anemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475783/harmonised/GCST90475783.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475643",
    "initial_individuals": "446946",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009190",
    "EFO_Trait_Name": "thyrotoxicosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475643/harmonised/GCST90475643.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477834",
    "initial_individuals": "446919",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0042981",
    "EFO_Trait_Name": "aortic valve stenosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477834/harmonised/GCST90477834.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475603",
    "initial_individuals": "446749",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0006859",
    "EFO_Trait_Name": "head and neck malignant neoplasia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475603/harmonised/GCST90475603.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477161",
    "initial_individuals": "446732",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0001067",
    "EFO_Trait_Name": "parasitic infection",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477161/harmonised/GCST90477161.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478097",
    "initial_individuals": "446687",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0001039",
    "EFO_Trait_Name": "tonsillitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478097/harmonised/GCST90478097.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477361",
    "initial_individuals": "446676",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0001508",
    "EFO_Trait_Name": "Failure to thrive",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477361/harmonised/GCST90477361.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478875",
    "initial_individuals": "446553",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0012317",
    "EFO_Trait_Name": "Sacroiliac arthritis",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478875/harmonised/GCST90478875.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476111",
    "initial_individuals": "446547",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0001744",
    "EFO_Trait_Name": "splenomegaly",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476111/harmonised/GCST90476111.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477660",
    "initial_individuals": "446422",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0001515",
    "EFO_Trait_Name": "corneal degeneration",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477660/harmonised/GCST90477660.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475999",
    "initial_individuals": "446376",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0001907",
    "EFO_Trait_Name": "Thromboembolism",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475999/harmonised/GCST90475999.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477968",
    "initial_individuals": "446332",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0010673",
    "EFO_Trait_Name": "cardiac transplant",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477968/harmonised/GCST90477968.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475638",
    "initial_individuals": "446291",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009191",
    "EFO_Trait_Name": "Toxic Nodular Goiter",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475638/harmonised/GCST90475638.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477724",
    "initial_individuals": "446223",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1000880",
    "EFO_Trait_Name": "corneal neovascularization",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477724/harmonised/GCST90477724.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478134",
    "initial_individuals": "446212",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009759",
    "EFO_Trait_Name": "Chronic Obstructive Asthma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478134/harmonised/GCST90478134.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475748",
    "initial_individuals": "446173",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0003072",
    "EFO_Trait_Name": "Hypercalcemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475748/harmonised/GCST90475748.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479276",
    "initial_individuals": "446168",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0005756",
    "EFO_Trait_Name": "skin wound",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479276/harmonised/GCST90479276.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477226",
    "initial_individuals": "446160",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0000727",
    "EFO_Trait_Name": "treatment",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477226/harmonised/GCST90477226.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475859",
    "initial_individuals": "446142",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0004037",
    "EFO_Trait_Name": "retinal edema",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475859/harmonised/GCST90475859.h.tsv.gz"
  },
  {
    "accessionId": "GCST90017142",
    "initial_individuals": "446108",
    "initial_ancestralGroup": "European",
    "pubmedId": "34131076",
    "EFO_ID": "EFO_0004344",
    "EFO_Trait_Name": "birth weight",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90017001-GCST90018000/GCST90017142/harmonised/GCST90017142.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478411",
    "initial_individuals": "446104",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0004565",
    "EFO_Trait_Name": "intestinal obstruction",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478411/harmonised/GCST90478411.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478909",
    "initial_individuals": "446073",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0004994",
    "EFO_Trait_Name": "lumbar disc degeneration",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478909/harmonised/GCST90478909.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475980",
    "initial_individuals": "445835",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0000469",
    "EFO_Trait_Name": "sinoatrial node disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475980/harmonised/GCST90475980.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477763",
    "initial_individuals": "445766",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0003608",
    "EFO_Trait_Name": "optic atrophy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477763/harmonised/GCST90477763.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478121",
    "initial_individuals": "445681",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001474",
    "EFO_Trait_Name": "pneumococcal pneumonia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478121/harmonised/GCST90478121.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477561",
    "initial_individuals": "445674",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0024654",
    "EFO_Trait_Name": "skull disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477561/harmonised/GCST90477561.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475899",
    "initial_individuals": "445542",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0002289",
    "EFO_Trait_Name": "iris disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475899/harmonised/GCST90475899.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478406",
    "initial_individuals": "445476",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0002590",
    "EFO_Trait_Name": "Paralytic ileus",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478406/harmonised/GCST90478406.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477399",
    "initial_individuals": "445448",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0002319",
    "EFO_Trait_Name": "phosphorus metabolism disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477399/harmonised/GCST90477399.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477037",
    "initial_individuals": "445429",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0008555",
    "EFO_Trait_Name": "Methicillin-Resistant Staphylococcus Aureus Infection",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477037/harmonised/GCST90477037.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478555",
    "initial_individuals": "445385",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0001650",
    "EFO_Trait_Name": "acute cystitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478555/harmonised/GCST90478555.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477506",
    "initial_individuals": "445230",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0007313",
    "EFO_Trait_Name": "Cerebral degeneration",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477506/harmonised/GCST90477506.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018825",
    "initial_individuals": "445096",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0000337",
    "EFO_Trait_Name": "chronic gastritis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018825/harmonised/GCST90018825.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478897",
    "initial_individuals": "445058",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0002196",
    "EFO_Trait_Name": "myelopathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478897/harmonised/GCST90478897.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475565",
    "initial_individuals": "445032",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0002040",
    "EFO_Trait_Name": "dermatomycosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475565/harmonised/GCST90475565.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478593",
    "initial_individuals": "444886",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009571",
    "EFO_Trait_Name": "urinary tract obstruction",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478593/harmonised/GCST90478593.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477041",
    "initial_individuals": "444816",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001318",
    "EFO_Trait_Name": "Escherichia coli Infections",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477041/harmonised/GCST90477041.h.tsv.gz"
  },
  {
    "accessionId": "GCST90483500",
    "initial_individuals": "444734",
    "initial_ancestralGroup": "European",
    "pubmedId": "40229599",
    "EFO_ID": "EFO_0000660",
    "EFO_Trait_Name": "polycystic ovary syndrome",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90483001-GCST90484000/GCST90483500/harmonised/GCST90483500.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479291",
    "initial_individuals": "444624",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0008066",
    "EFO_Trait_Name": "Abnormal blistering of the skin",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479291/harmonised/GCST90479291.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477496",
    "initial_individuals": "444621",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0004698",
    "EFO_Trait_Name": "insomnia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477496/harmonised/GCST90477496.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476293",
    "initial_individuals": "444617",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0043458",
    "EFO_Trait_Name": "radiation injury",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476293/harmonised/GCST90476293.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475815",
    "initial_individuals": "444578",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0001882",
    "EFO_Trait_Name": "Decreased total leukocyte count",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475815/harmonised/GCST90475815.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477086",
    "initial_individuals": "444421",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0007803",
    "EFO_Trait_Name": "emotional symptom measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477086/harmonised/GCST90477086.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477264",
    "initial_individuals": "444329",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0044335",
    "EFO_Trait_Name": "benign soft tissue neoplasm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477264/harmonised/GCST90477264.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476092",
    "initial_individuals": "444296",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0002240",
    "EFO_Trait_Name": "hepatomegaly",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476092/harmonised/GCST90476092.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479253",
    "initial_individuals": "444201",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0002571",
    "EFO_Trait_Name": "medical procedure",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479253/harmonised/GCST90479253.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479057",
    "initial_individuals": "444151",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0002756",
    "EFO_Trait_Name": "Pathologic fracture",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479057/harmonised/GCST90479057.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476032",
    "initial_individuals": "444066",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0001438",
    "EFO_Trait_Name": "postinflammatory pulmonary fibrosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476032/harmonised/GCST90476032.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475829",
    "initial_individuals": "443920",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0004270",
    "EFO_Trait_Name": "restless legs syndrome",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475829/harmonised/GCST90475829.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477039",
    "initial_individuals": "443873",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001476",
    "EFO_Trait_Name": "streptococcal infection",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477039/harmonised/GCST90477039.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477948",
    "initial_individuals": "443802",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009277",
    "EFO_Trait_Name": "supraventricular ectopy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477948/harmonised/GCST90477948.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477582",
    "initial_individuals": "443636",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0001310",
    "EFO_Trait_Name": "Dysmetria",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477582/harmonised/GCST90477582.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477424",
    "initial_individuals": "443589",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0011105",
    "EFO_Trait_Name": "hypervolemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477424/harmonised/GCST90477424.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478353",
    "initial_individuals": "443565",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0004627",
    "EFO_Trait_Name": "duodenitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478353/harmonised/GCST90478353.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475832",
    "initial_individuals": "443514",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0003108",
    "EFO_Trait_Name": "essential tremor",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475832/harmonised/GCST90475832.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477427",
    "initial_individuals": "443332",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0019052",
    "EFO_Trait_Name": "inborn errors of metabolism",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477427/harmonised/GCST90477427.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477703",
    "initial_individuals": "443169",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0012803",
    "EFO_Trait_Name": "anisometropia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477703/harmonised/GCST90477703.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479178",
    "initial_individuals": "443093",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0004540",
    "EFO_Trait_Name": "chronic fatigue syndrome",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479178/harmonised/GCST90479178.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475839",
    "initial_individuals": "443049",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0001298",
    "EFO_Trait_Name": "Encephalopathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475839/harmonised/GCST90475839.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478212",
    "initial_individuals": "443023",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0032016",
    "EFO_Trait_Name": "abnormal sputum",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478212/harmonised/GCST90478212.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479250",
    "initial_individuals": "442915",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MP_0001914",
    "EFO_Trait_Name": "hemorrhage",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479250/harmonised/GCST90479250.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477730",
    "initial_individuals": "442819",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0001097",
    "EFO_Trait_Name": "Keratoconjunctivitis sicca",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477730/harmonised/GCST90477730.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475678",
    "initial_individuals": "442724",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0004997",
    "EFO_Trait_Name": "type 2 diabetes nephropathy",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475678/harmonised/GCST90475678.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478201",
    "initial_individuals": "442720",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0002791",
    "EFO_Trait_Name": "Hypoventilation",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478201/harmonised/GCST90478201.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477658",
    "initial_individuals": "442478",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0007957",
    "EFO_Trait_Name": "Corneal opacity",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477658/harmonised/GCST90477658.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477653",
    "initial_individuals": "442329",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0007777",
    "EFO_Trait_Name": "Chorioretinal scar",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477653/harmonised/GCST90477653.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477641",
    "initial_individuals": "442293",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0002311",
    "EFO_Trait_Name": "retinal vascular disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477641/harmonised/GCST90477641.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477891",
    "initial_individuals": "442285",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0024636",
    "EFO_Trait_Name": "inflammation of heart layer",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477891/harmonised/GCST90477891.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476037",
    "initial_individuals": "442256",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0010720",
    "EFO_Trait_Name": "invasive mechanical ventilation",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476037/harmonised/GCST90476037.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475776",
    "initial_individuals": "442192",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0000734",
    "EFO_Trait_Name": "vitamin b12 deficiency",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475776/harmonised/GCST90475776.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475680",
    "initial_individuals": "442188",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0004467",
    "EFO_Trait_Name": "insulin measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475680/harmonised/GCST90475680.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475629",
    "initial_individuals": "442157",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0021454",
    "EFO_Trait_Name": "benign neoplasm of eye",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475629/harmonised/GCST90475629.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474506",
    "initial_individuals": "442094",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007985",
    "EFO_Trait_Name": "platelet crit",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474506/harmonised/GCST90474506.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477329",
    "initial_individuals": "441994",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0001943",
    "EFO_Trait_Name": "hypoglycemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477329/harmonised/GCST90477329.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477256",
    "initial_individuals": "441884",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0000385",
    "EFO_Trait_Name": "benign digestive system neoplasm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477256/harmonised/GCST90477256.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477439",
    "initial_individuals": "441857",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0004566",
    "EFO_Trait_Name": "body weight gain",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477439/harmonised/GCST90477439.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478012",
    "initial_individuals": "441778",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0000980",
    "EFO_Trait_Name": "aortic atherosclerosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478012/harmonised/GCST90478012.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479239",
    "initial_individuals": "441696",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001250",
    "EFO_Trait_Name": "rotator cuff tear",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479239/harmonised/GCST90479239.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477646",
    "initial_individuals": "441567",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0000573",
    "EFO_Trait_Name": "Retinal hemorrhage",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477646/harmonised/GCST90477646.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475957",
    "initial_individuals": "441537",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0011712",
    "EFO_Trait_Name": "right bundle branch block",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475957/harmonised/GCST90475957.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474551",
    "initial_individuals": "441305",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007989",
    "EFO_Trait_Name": "monocyte percentage of leukocytes",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474551/harmonised/GCST90474551.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474556",
    "initial_individuals": "441305",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007990",
    "EFO_Trait_Name": "neutrophil percentage of leukocytes",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474556/harmonised/GCST90474556.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474561",
    "initial_individuals": "441305",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007991",
    "EFO_Trait_Name": "eosinophil percentage of leukocytes",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474561/harmonised/GCST90474561.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474566",
    "initial_individuals": "441305",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007992",
    "EFO_Trait_Name": "basophil percentage of leukocytes",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474566/harmonised/GCST90474566.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474546",
    "initial_individuals": "441305",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007993",
    "EFO_Trait_Name": "lymphocyte percentage of leukocytes",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474546/harmonised/GCST90474546.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475619",
    "initial_individuals": "441079",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0000964",
    "EFO_Trait_Name": "skin lipoma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475619/harmonised/GCST90475619.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477991",
    "initial_individuals": "440985",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0000944",
    "EFO_Trait_Name": "cerebral artery occlusion",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477991/harmonised/GCST90477991.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477727",
    "initial_individuals": "440982",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0004768",
    "EFO_Trait_Name": "keratoconjunctivitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477727/harmonised/GCST90477727.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475896",
    "initial_individuals": "440918",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0002135",
    "EFO_Trait_Name": "optic nerve disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475896/harmonised/GCST90475896.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475973",
    "initial_individuals": "440917",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0003911",
    "EFO_Trait_Name": "atrial flutter",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475973/harmonised/GCST90475973.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477482",
    "initial_individuals": "440739",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0005246",
    "EFO_Trait_Name": "hypersomnia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477482/harmonised/GCST90477482.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475774",
    "initial_individuals": "440680",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0001700",
    "EFO_Trait_Name": "megaloblastic anemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475774/harmonised/GCST90475774.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478795",
    "initial_individuals": "440420",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0021739",
    "EFO_Trait_Name": "prurigo",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478795/harmonised/GCST90478795.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478562",
    "initial_individuals": "440312",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0012587",
    "EFO_Trait_Name": "Macroscopic hematuria",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478562/harmonised/GCST90478562.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478579",
    "initial_individuals": "440253",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0000009",
    "EFO_Trait_Name": "Functional abnormality of the bladder",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478579/harmonised/GCST90478579.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478094",
    "initial_individuals": "440137",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009692",
    "EFO_Trait_Name": "voice disorders",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478094/harmonised/GCST90478094.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478765",
    "initial_individuals": "440018",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0020083",
    "EFO_Trait_Name": "Furuncle",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478765/harmonised/GCST90478765.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475686",
    "initial_individuals": "439904",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0001583",
    "EFO_Trait_Name": "diabetic polyneuropathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475686/harmonised/GCST90475686.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478269",
    "initial_individuals": "439801",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0000164",
    "EFO_Trait_Name": "abnormality of the dentition",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478269/harmonised/GCST90478269.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477138",
    "initial_individuals": "439731",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009124",
    "EFO_Trait_Name": "organ extraction",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477138/harmonised/GCST90477138.h.tsv.gz"
  },
  {
    "accessionId": "GCST90104907",
    "initial_individuals": "439487",
    "initial_ancestralGroup": "European",
    "pubmedId": "36043126",
    "EFO_ID": "EFO_0010822",
    "EFO_Trait_Name": "stenosing tenosynovitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90104001-GCST90105000/GCST90104907/harmonised/GCST90104907.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478245",
    "initial_individuals": "439347",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001139",
    "EFO_Trait_Name": "pulpitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478245/harmonised/GCST90478245.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476077",
    "initial_individuals": "439248",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0004235",
    "EFO_Trait_Name": "diverticulitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476077/harmonised/GCST90476077.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477706",
    "initial_individuals": "439226",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0001123",
    "EFO_Trait_Name": "Visual field defect",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477706/harmonised/GCST90477706.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476288",
    "initial_individuals": "439219",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1000753",
    "EFO_Trait_Name": "phototoxic dermatitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476288/harmonised/GCST90476288.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477032",
    "initial_individuals": "439004",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001849",
    "EFO_Trait_Name": "staphylococcal skin infections",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477032/harmonised/GCST90477032.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477878",
    "initial_individuals": "439004",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0001493",
    "EFO_Trait_Name": "chronic pulmonary heart disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477878/harmonised/GCST90477878.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476094",
    "initial_individuals": "438981",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0010695",
    "EFO_Trait_Name": "elevated lactate dehydrogenase",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476094/harmonised/GCST90476094.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475894",
    "initial_individuals": "438974",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0010750",
    "EFO_Trait_Name": "Dermatochalasis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475894/harmonised/GCST90475894.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477499",
    "initial_individuals": "438864",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0025234",
    "EFO_Trait_Name": "Parasomnia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477499/harmonised/GCST90477499.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475712",
    "initial_individuals": "438861",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1000060",
    "EFO_Trait_Name": "intestinal disaccharide deficiency and disaccharide malabsorption",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475712/harmonised/GCST90475712.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018895",
    "initial_individuals": "438843",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "MONDO_0005405",
    "EFO_Trait_Name": "childhood onset asthma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018895/harmonised/GCST90018895.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475984",
    "initial_individuals": "438747",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1000899",
    "EFO_Trait_Name": "diastolic heart failure",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475984/harmonised/GCST90475984.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478551",
    "initial_individuals": "438514",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0003878",
    "EFO_Trait_Name": "urethritis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478551/harmonised/GCST90478551.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475983",
    "initial_individuals": "438433",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001207",
    "EFO_Trait_Name": "systolic heart failure",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475983/harmonised/GCST90475983.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475711",
    "initial_individuals": "438422",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0019214",
    "EFO_Trait_Name": "inborn carbohydrate metabolic disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475711/harmonised/GCST90475711.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435144",
    "initial_individuals": "438351",
    "initial_ancestralGroup": "European",
    "pubmedId": "39192095",
    "EFO_ID": "OBA_0003784",
    "EFO_Trait_Name": "chromosome, telomeric region length",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435144/harmonised/GCST90435144.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477740",
    "initial_individuals": "438171",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0007141",
    "EFO_Trait_Name": "allergic conjunctivitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477740/harmonised/GCST90477740.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476098",
    "initial_individuals": "437561",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009826",
    "EFO_Trait_Name": "abnormality of serum enzyme levels",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476098/harmonised/GCST90476098.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478266",
    "initial_individuals": "437502",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0006343",
    "EFO_Trait_Name": "chronic periodontitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478266/harmonised/GCST90478266.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478248",
    "initial_individuals": "437408",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001202",
    "EFO_Trait_Name": "suppurative periapical periodontitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478248/harmonised/GCST90478248.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475809",
    "initial_individuals": "437350",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0012775",
    "EFO_Trait_Name": "thrombocytopenia 4",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475809/harmonised/GCST90475809.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477970",
    "initial_individuals": "437237",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0001626",
    "EFO_Trait_Name": "Abnormality of the cardiovascular system",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477970/harmonised/GCST90477970.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477417",
    "initial_individuals": "436878",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1000014",
    "EFO_Trait_Name": "acidosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477417/harmonised/GCST90477417.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475724",
    "initial_individuals": "436724",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0009387",
    "EFO_Trait_Name": "familial lipoprotein lipase deficiency",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475724/harmonised/GCST90475724.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476261",
    "initial_individuals": "436022",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0002461",
    "EFO_Trait_Name": "skeletal system disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476261/harmonised/GCST90476261.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475633",
    "initial_individuals": "435972",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1000707",
    "EFO_Trait_Name": "hemangioma of subcutaneous tissue",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475633/harmonised/GCST90475633.h.tsv.gz"
  },
  {
    "accessionId": "GCST90129439",
    "initial_individuals": "435971",
    "initial_ancestralGroup": "European",
    "pubmedId": "37219871",
    "EFO_ID": "EFO_0005687",
    "EFO_Trait_Name": "fibromyalgia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129439/harmonised/GCST90129439.h.tsv.gz"
  },
  {
    "accessionId": "GCST90129436",
    "initial_individuals": "435971",
    "initial_ancestralGroup": "European",
    "pubmedId": "37219871",
    "EFO_ID": "EFO_1000783",
    "EFO_Trait_Name": "diabetic neuropathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129436/harmonised/GCST90129436.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475956",
    "initial_individuals": "435856",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0004138",
    "EFO_Trait_Name": "bundle branch block",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475956/harmonised/GCST90475956.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478501",
    "initial_individuals": "435418",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0002239",
    "EFO_Trait_Name": "gastrointestinal hemorrhage",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478501/harmonised/GCST90478501.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476142",
    "initial_individuals": "435367",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0002907",
    "EFO_Trait_Name": "microscopic hematuria",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476142/harmonised/GCST90476142.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475559",
    "initial_individuals": "435319",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0012418",
    "EFO_Trait_Name": "Hypoxemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475559/harmonised/GCST90475559.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475827",
    "initial_individuals": "435255",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0004280",
    "EFO_Trait_Name": "movement disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475827/harmonised/GCST90475827.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477604",
    "initial_individuals": "435055",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0024317",
    "EFO_Trait_Name": "chronic pain syndrome",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477604/harmonised/GCST90477604.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477789",
    "initial_individuals": "434927",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0010679",
    "EFO_Trait_Name": "eye swelling",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477789/harmonised/GCST90477789.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475930",
    "initial_individuals": "434858",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1000985",
    "EFO_Trait_Name": "intermediate coronary syndrome",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475930/harmonised/GCST90475930.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499226",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0005001",
    "EFO_Trait_Name": "phenylalanine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499226/harmonised/GCST90499226.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500145",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0005058",
    "EFO_Trait_Name": "tyrosine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500145/harmonised/GCST90500145.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500000",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0005134",
    "EFO_Trait_Name": "amino acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90500000/harmonised/GCST90500000.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499173",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0005680",
    "EFO_Trait_Name": "omega-6 polyunsaturated fatty acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499173/harmonised/GCST90499173.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498314",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0006807",
    "EFO_Trait_Name": "linoleic acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498314/harmonised/GCST90498314.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498342",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0007745",
    "EFO_Trait_Name": "lactate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498342/harmonised/GCST90498342.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497265",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0007761",
    "EFO_Trait_Name": "docosahexaenoic acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497265/harmonised/GCST90497265.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497339",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0007805",
    "EFO_Trait_Name": "HDL cholesterol change measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497339/harmonised/GCST90497339.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500039",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0008589",
    "EFO_Trait_Name": "esterified cholesterol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500039/harmonised/GCST90500039.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500071",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0008591",
    "EFO_Trait_Name": "free cholesterol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500071/harmonised/GCST90500071.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497605",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0008595",
    "EFO_Trait_Name": "intermediate density lipoprotein measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497605/harmonised/GCST90497605.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497090",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0009765",
    "EFO_Trait_Name": "alanine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497090/harmonised/GCST90497090.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497308",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0009767",
    "EFO_Trait_Name": "glycine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497308/harmonised/GCST90497308.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497278",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0009768",
    "EFO_Trait_Name": "glutamine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497278/harmonised/GCST90497278.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497483",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0009769",
    "EFO_Trait_Name": "histidine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497483/harmonised/GCST90497483.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498484",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0009770",
    "EFO_Trait_Name": "leucine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498484/harmonised/GCST90498484.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500183",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0009792",
    "EFO_Trait_Name": "valine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500183/harmonised/GCST90500183.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497691",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0009793",
    "EFO_Trait_Name": "isoleucine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497691/harmonised/GCST90497691.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497059",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0010111",
    "EFO_Trait_Name": "acetoacetate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497059/harmonised/GCST90497059.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497047",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0010112",
    "EFO_Trait_Name": "acetate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497047/harmonised/GCST90497047.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497196",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0010114",
    "EFO_Trait_Name": "citrate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497196/harmonised/GCST90497196.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497177",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0010116",
    "EFO_Trait_Name": "choline measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497177/harmonised/GCST90497177.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499326",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0010117",
    "EFO_Trait_Name": "pyruvate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499326/harmonised/GCST90499326.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499980",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0010118",
    "EFO_Trait_Name": "sphingomyelin measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499980/harmonised/GCST90499980.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499165",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0010119",
    "EFO_Trait_Name": "omega-3 polyunsaturated fatty acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499165/harmonised/GCST90499165.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499410",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0010351",
    "EFO_Trait_Name": "cholesteryl ester measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499410/harmonised/GCST90499410.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499193",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0010732",
    "EFO_Trait_Name": "omega-6:omega-3 polyunsaturated fatty acid ratio",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499193/harmonised/GCST90499193.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499312",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0010733",
    "EFO_Trait_Name": "polyunsaturated fatty acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499312/harmonised/GCST90499312.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499341",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0010815",
    "EFO_Trait_Name": "remnant cholesterol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499341/harmonised/GCST90499341.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497162",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0010982",
    "EFO_Trait_Name": "3-hydroxybutyrate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497162/harmonised/GCST90497162.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497074",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0010989",
    "EFO_Trait_Name": "acetone measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497074/harmonised/GCST90497074.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499489",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0020946",
    "EFO_Trait_Name": "Phospholipids:total lipids ratio",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499489/harmonised/GCST90499489.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500927",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0021898",
    "EFO_Trait_Name": "cholesterol in chylomicrons and extremely large VLDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500927/harmonised/GCST90500927.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497512",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0021899",
    "EFO_Trait_Name": "cholesterol in IDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497512/harmonised/GCST90497512.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497722",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0021900",
    "EFO_Trait_Name": "cholesterol in large HDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497722/harmonised/GCST90497722.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497939",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0021901",
    "EFO_Trait_Name": "cholesterol in large LDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497939/harmonised/GCST90497939.h.tsv.gz"
  },
  {
    "accessionId": "GCST90501158",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0021902",
    "EFO_Trait_Name": "cholesterol in large VLDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90501001-GCST90502000/GCST90501158/harmonised/GCST90501158.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498511",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0021903",
    "EFO_Trait_Name": "cholesterol in medium HDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498511/harmonised/GCST90498511.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500887",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022144",
    "EFO_Trait_Name": "triglycerides in very small VLDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500887/harmonised/GCST90500887.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499935",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022145",
    "EFO_Trait_Name": "triglycerides in small VLDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499935/harmonised/GCST90499935.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499890",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022146",
    "EFO_Trait_Name": "phospholipids in small VLDL measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499890/harmonised/GCST90499890.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499858",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022147",
    "EFO_Trait_Name": "concentration of small VLDL particles",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499858/harmonised/GCST90499858.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499853",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022148",
    "EFO_Trait_Name": "total lipids in small VLDL",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499853/harmonised/GCST90499853.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497684",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022149",
    "EFO_Trait_Name": "triglycerides in IDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497684/harmonised/GCST90497684.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500831",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022151",
    "EFO_Trait_Name": "concentration of very small VLDL particles",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500831/harmonised/GCST90500831.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499010",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022152",
    "EFO_Trait_Name": "concentration of medium VLDL particles",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499010/harmonised/GCST90499010.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499002",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022153",
    "EFO_Trait_Name": "total lipids in medium VLDL",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499002/harmonised/GCST90499002.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499038",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022154",
    "EFO_Trait_Name": "phospholipids in medium VLDL measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499038/harmonised/GCST90499038.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499080",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022155",
    "EFO_Trait_Name": "triglycerides in medium VLDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499080/harmonised/GCST90499080.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500815",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022156",
    "EFO_Trait_Name": "total lipids in very small VLDL measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500815/harmonised/GCST90500815.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497804",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022157",
    "EFO_Trait_Name": "free cholesterol in large HDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497804/harmonised/GCST90497804.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499531",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022158",
    "EFO_Trait_Name": "triglycerides in small HDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499531/harmonised/GCST90499531.h.tsv.gz"
  },
  {
    "accessionId": "GCST90501136",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022159",
    "EFO_Trait_Name": "cholesterol esters in large HDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90501001-GCST90502000/GCST90501136/harmonised/GCST90501136.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498033",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022160",
    "EFO_Trait_Name": "concentration of large LDL particles measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498033/harmonised/GCST90498033.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497604",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022161",
    "EFO_Trait_Name": "total lipids in IDL",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497604/harmonised/GCST90497604.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498019",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022163",
    "EFO_Trait_Name": "total lipids in large LDL",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498019/harmonised/GCST90498019.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497645",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022164",
    "EFO_Trait_Name": "phospholipids in IDL measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497645/harmonised/GCST90497645.h.tsv.gz"
  },
  {
    "accessionId": "GCST90501148",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022165",
    "EFO_Trait_Name": "cholesterol esters in large LDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90501001-GCST90502000/GCST90501148/harmonised/GCST90501148.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499661",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022166",
    "EFO_Trait_Name": "concentration of small LDL particles measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499661/harmonised/GCST90499661.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499641",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022168",
    "EFO_Trait_Name": "total lipids in small LDL",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499641/harmonised/GCST90499641.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498256",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022169",
    "EFO_Trait_Name": "phospholipids in large VLDL measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498256/harmonised/GCST90498256.h.tsv.gz"
  },
  {
    "accessionId": "GCST90501160",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022170",
    "EFO_Trait_Name": "cholesterol esters in large VLDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90501001-GCST90502000/GCST90501160/harmonised/GCST90501160.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498812",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022172",
    "EFO_Trait_Name": "concentration of medium LDL particles measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498812/harmonised/GCST90498812.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498227",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022173",
    "EFO_Trait_Name": "concentration of large VLDL particles measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498227/harmonised/GCST90498227.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498064",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022174",
    "EFO_Trait_Name": "phospholipids in large LDL measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498064/harmonised/GCST90498064.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498211",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022175",
    "EFO_Trait_Name": "total lipids in large VLDL",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498211/harmonised/GCST90498211.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497997",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022176",
    "EFO_Trait_Name": "free cholesterol in large LDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497997/harmonised/GCST90497997.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498290",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022178",
    "EFO_Trait_Name": "triglycerides in large VLDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498290/harmonised/GCST90498290.h.tsv.gz"
  },
  {
    "accessionId": "GCST90501246",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022179",
    "EFO_Trait_Name": "total cholesterol in small LDL",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90501001-GCST90502000/GCST90501246/harmonised/GCST90501246.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498795",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022180",
    "EFO_Trait_Name": "total lipids in medium LDL",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498795/harmonised/GCST90498795.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497587",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022181",
    "EFO_Trait_Name": "free cholesterol in IDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497587/harmonised/GCST90497587.h.tsv.gz"
  },
  {
    "accessionId": "GCST90501208",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022182",
    "EFO_Trait_Name": "cholesterol esters in medium VLDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90501001-GCST90502000/GCST90501208/harmonised/GCST90501208.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498857",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022183",
    "EFO_Trait_Name": "phospholipids in medium LDL measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498857/harmonised/GCST90498857.h.tsv.gz"
  },
  {
    "accessionId": "GCST90501194",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022185",
    "EFO_Trait_Name": "total cholesterol in medium LDL",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90501001-GCST90502000/GCST90501194/harmonised/GCST90501194.h.tsv.gz"
  },
  {
    "accessionId": "GCST90501196",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022186",
    "EFO_Trait_Name": "cholesterol esters in medium LDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90501001-GCST90502000/GCST90501196/harmonised/GCST90501196.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499102",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022187",
    "EFO_Trait_Name": "monounsaturated fatty acids; 16:1, 18:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499102/harmonised/GCST90499102.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497831",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022188",
    "EFO_Trait_Name": "concentration of large HDL particles measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497831/harmonised/GCST90497831.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497820",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022189",
    "EFO_Trait_Name": "total lipids in large HDL",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497820/harmonised/GCST90497820.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497859",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022190",
    "EFO_Trait_Name": "phospholipids in large HDL measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497859/harmonised/GCST90497859.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498725",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022224",
    "EFO_Trait_Name": "cholesterol in medium LDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498725/harmonised/GCST90498725.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498916",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022225",
    "EFO_Trait_Name": "cholesterol in medium VLDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498916/harmonised/GCST90498916.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499376",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022226",
    "EFO_Trait_Name": "cholesterol in small HDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499376/harmonised/GCST90499376.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499570",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022227",
    "EFO_Trait_Name": "cholesterol in small LDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499570/harmonised/GCST90499570.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499761",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022228",
    "EFO_Trait_Name": "cholesterol in small VLDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499761/harmonised/GCST90499761.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500338",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022229",
    "EFO_Trait_Name": "cholesterol in very large HDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500338/harmonised/GCST90500338.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500530",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022230",
    "EFO_Trait_Name": "cholesterol in very large VLDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500530/harmonised/GCST90500530.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500722",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022231",
    "EFO_Trait_Name": "cholesterol in very small VLDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500722/harmonised/GCST90500722.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500908",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022232",
    "EFO_Trait_Name": "cholesterol to total lipids in chylomicrons and extremely large VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500908/harmonised/GCST90500908.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497494",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022233",
    "EFO_Trait_Name": "cholesterol to total lipids in IDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497494/harmonised/GCST90497494.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497706",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022234",
    "EFO_Trait_Name": "cholesterol to total lipids in large HDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497706/harmonised/GCST90497706.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497921",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022235",
    "EFO_Trait_Name": "cholesterol to total lipids in large LDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497921/harmonised/GCST90497921.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498118",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022236",
    "EFO_Trait_Name": "cholesterol to total lipids in large VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498118/harmonised/GCST90498118.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498494",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022237",
    "EFO_Trait_Name": "cholesterol to total lipids in medium HDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498494/harmonised/GCST90498494.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498696",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022238",
    "EFO_Trait_Name": "cholesterol to total lipids in medium LDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498696/harmonised/GCST90498696.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498908",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022239",
    "EFO_Trait_Name": "cholesterol to total lipids in medium VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498908/harmonised/GCST90498908.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499357",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022240",
    "EFO_Trait_Name": "cholesterol to total lipids in small HDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499357/harmonised/GCST90499357.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499561",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022241",
    "EFO_Trait_Name": "cholesterol to total lipids in small LDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499561/harmonised/GCST90499561.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499741",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022242",
    "EFO_Trait_Name": "cholesterol to total lipids in small VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499741/harmonised/GCST90499741.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500307",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022243",
    "EFO_Trait_Name": "cholesterol to total lipids in very large HDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500307/harmonised/GCST90500307.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500521",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022244",
    "EFO_Trait_Name": "cholesterol to total lipids in very large VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500521/harmonised/GCST90500521.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500709",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022245",
    "EFO_Trait_Name": "cholesterol to total lipids in very small VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500709/harmonised/GCST90500709.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500936",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022246",
    "EFO_Trait_Name": "cholesteryl esters to total lipids in chylomicrons and extremely large VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500936/harmonised/GCST90500936.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497524",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022247",
    "EFO_Trait_Name": "cholesteryl esters to total lipids in IDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497524/harmonised/GCST90497524.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497745",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022248",
    "EFO_Trait_Name": "cholesteryl esters to total lipids in large HDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497745/harmonised/GCST90497745.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497947",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022249",
    "EFO_Trait_Name": "cholesteryl esters to total lipids in large LDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497947/harmonised/GCST90497947.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498147",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022250",
    "EFO_Trait_Name": "cholesteryl esters to total lipids in large VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498147/harmonised/GCST90498147.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498533",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022251",
    "EFO_Trait_Name": "cholesteryl esters to total lipids in medium HDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498533/harmonised/GCST90498533.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498743",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022252",
    "EFO_Trait_Name": "cholesteryl esters to total lipids in medium LDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498743/harmonised/GCST90498743.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498936",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022253",
    "EFO_Trait_Name": "cholesteryl esters to total lipids in medium VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498936/harmonised/GCST90498936.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499389",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022254",
    "EFO_Trait_Name": "cholesteryl esters to total lipids in small HDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499389/harmonised/GCST90499389.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499585",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022255",
    "EFO_Trait_Name": "cholesteryl esters to total lipids in small LDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499585/harmonised/GCST90499585.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499780",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022256",
    "EFO_Trait_Name": "cholesteryl esters to total lipids in small VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499780/harmonised/GCST90499780.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500357",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022257",
    "EFO_Trait_Name": "cholesteryl esters to total lipids in very large HDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500357/harmonised/GCST90500357.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500553",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022258",
    "EFO_Trait_Name": "cholesteryl esters to total lipids in very large VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500553/harmonised/GCST90500553.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500744",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022259",
    "EFO_Trait_Name": "cholesteryl esters to total lipids in very small VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500744/harmonised/GCST90500744.h.tsv.gz"
  },
  {
    "accessionId": "GCST90501014",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022260",
    "EFO_Trait_Name": "concentration of chylomicrons and extremely large VLDL particles measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90501001-GCST90502000/GCST90501014/harmonised/GCST90501014.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500164",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022261",
    "EFO_Trait_Name": "degree of unsaturation measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500164/harmonised/GCST90500164.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497247",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022262",
    "EFO_Trait_Name": "docosahexaenoic acid to total fatty acids percentage ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497247/harmonised/GCST90497247.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500989",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022263",
    "EFO_Trait_Name": "free cholesterol in chylomicrons and extremely large VLDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500989/harmonised/GCST90500989.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497372",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022264",
    "EFO_Trait_Name": "free cholesterol in HDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497372/harmonised/GCST90497372.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498196",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022265",
    "EFO_Trait_Name": "free cholesterol in large VLDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498196/harmonised/GCST90498196.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498383",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022266",
    "EFO_Trait_Name": "free cholesterol in LDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498383/harmonised/GCST90498383.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498589",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022267",
    "EFO_Trait_Name": "free cholesterol in medium HDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498589/harmonised/GCST90498589.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498790",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022268",
    "EFO_Trait_Name": "free cholesterol in medium LDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498790/harmonised/GCST90498790.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498981",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022269",
    "EFO_Trait_Name": "free cholesterol in medium VLDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498981/harmonised/GCST90498981.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499434",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022270",
    "EFO_Trait_Name": "free cholesterol in small HDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499434/harmonised/GCST90499434.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499639",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022271",
    "EFO_Trait_Name": "free cholesterol in small LDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499639/harmonised/GCST90499639.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499829",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022272",
    "EFO_Trait_Name": "free cholesterol in small VLDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499829/harmonised/GCST90499829.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500400",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022273",
    "EFO_Trait_Name": "free cholesterol in very large HDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500400/harmonised/GCST90500400.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500594",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022274",
    "EFO_Trait_Name": "free cholesterol in very large VLDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500594/harmonised/GCST90500594.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500794",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022275",
    "EFO_Trait_Name": "free cholesterol in very small VLDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500794/harmonised/GCST90500794.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500225",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022276",
    "EFO_Trait_Name": "free cholesterol in VLDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500225/harmonised/GCST90500225.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500969",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022277",
    "EFO_Trait_Name": "free cholesterol to total lipids in chylomicrons and extremely large VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500969/harmonised/GCST90500969.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497567",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022278",
    "EFO_Trait_Name": "free cholesterol to total lipids in IDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497567/harmonised/GCST90497567.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497784",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022279",
    "EFO_Trait_Name": "free cholesterol to total lipids in large HDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497784/harmonised/GCST90497784.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497977",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022280",
    "EFO_Trait_Name": "free cholesterol to total lipids in large LDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497977/harmonised/GCST90497977.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498187",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022281",
    "EFO_Trait_Name": "free cholesterol to total lipids in large VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498187/harmonised/GCST90498187.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498570",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022282",
    "EFO_Trait_Name": "free cholesterol to total lipids in medium HDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498570/harmonised/GCST90498570.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498769",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022283",
    "EFO_Trait_Name": "free cholesterol to total lipids in medium LDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498769/harmonised/GCST90498769.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498959",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022284",
    "EFO_Trait_Name": "free cholesterol to total lipids in medium VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498959/harmonised/GCST90498959.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499419",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022285",
    "EFO_Trait_Name": "free cholesterol to total lipids in small HDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499419/harmonised/GCST90499419.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499614",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022286",
    "EFO_Trait_Name": "free cholesterol to total lipids in small LDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499614/harmonised/GCST90499614.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499819",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022287",
    "EFO_Trait_Name": "free cholesterol to total lipids in small VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499819/harmonised/GCST90499819.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500379",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022288",
    "EFO_Trait_Name": "free cholesterol to total lipids in very large HDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500379/harmonised/GCST90500379.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500583",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022289",
    "EFO_Trait_Name": "free cholesterol to total lipids in very large VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500583/harmonised/GCST90500583.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500779",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022290",
    "EFO_Trait_Name": "free cholesterol to total lipids in very small VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500779/harmonised/GCST90500779.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499263",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022291",
    "EFO_Trait_Name": "phosphoglycerides measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499263/harmonised/GCST90499263.h.tsv.gz"
  },
  {
    "accessionId": "GCST90501055",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022292",
    "EFO_Trait_Name": "phospholipids in chylomicrons and extremely large VLDL measurement ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90501001-GCST90502000/GCST90501055/harmonised/GCST90501055.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497428",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022293",
    "EFO_Trait_Name": "phospholipids in HDL measurement ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497428/harmonised/GCST90497428.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498435",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022294",
    "EFO_Trait_Name": "phospholipids in LDL measurement ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498435/harmonised/GCST90498435.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498654",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022295",
    "EFO_Trait_Name": "phospholipids in medium HDL measurement ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498654/harmonised/GCST90498654.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499503",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022296",
    "EFO_Trait_Name": "phospholipids in small HDL measurement ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499503/harmonised/GCST90499503.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499695",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022297",
    "EFO_Trait_Name": "phospholipids in small LDL measurement ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499695/harmonised/GCST90499695.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500470",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022298",
    "EFO_Trait_Name": "phospholipids in very large HDL measurement ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500470/harmonised/GCST90500470.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500658",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022299",
    "EFO_Trait_Name": "phospholipids in very large VLDL measurement ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500658/harmonised/GCST90500658.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500857",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022300",
    "EFO_Trait_Name": "phospholipids in very small VLDL measurement ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500857/harmonised/GCST90500857.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500265",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022301",
    "EFO_Trait_Name": "phospholipids in VLDL measurement ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500265/harmonised/GCST90500265.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499291",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022302",
    "EFO_Trait_Name": "polyunsaturated fatty acids to monounsaturated fatty acids ratio ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499291/harmonised/GCST90499291.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499269",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022303",
    "EFO_Trait_Name": "polyunsaturated fatty acids to total fatty acids percentage ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499269/harmonised/GCST90499269.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499965",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022304",
    "EFO_Trait_Name": "saturated fatty acids measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499965/harmonised/GCST90499965.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499938",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022305",
    "EFO_Trait_Name": "saturated fatty acids to total fatty acids percentage ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499938/harmonised/GCST90499938.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500999",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022306",
    "EFO_Trait_Name": "total lipids in chylomicrons and extremely large VLDL measurement ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500999/harmonised/GCST90500999.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497404",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022307",
    "EFO_Trait_Name": "total lipids in HDL measurement ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497404/harmonised/GCST90497404.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498395",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022308",
    "EFO_Trait_Name": "total lipids in LDL measurement ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498395/harmonised/GCST90498395.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498595",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022310",
    "EFO_Trait_Name": "total lipids in medium HDL measurement ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498595/harmonised/GCST90498595.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499454",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022311",
    "EFO_Trait_Name": "total lipids in small HDL measurement ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499454/harmonised/GCST90499454.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500421",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022312",
    "EFO_Trait_Name": "total lipids in very large HDL measurement ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500421/harmonised/GCST90500421.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500616",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022313",
    "EFO_Trait_Name": "total lipids in very large VLDL measurement ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500616/harmonised/GCST90500616.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500244",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022314",
    "EFO_Trait_Name": "total lipids in VLDL measurement ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500244/harmonised/GCST90500244.h.tsv.gz"
  },
  {
    "accessionId": "GCST90501089",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022316",
    "EFO_Trait_Name": "triglycerides in chylomicrons and extremely large VLDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90501001-GCST90502000/GCST90501089/harmonised/GCST90501089.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497461",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022317",
    "EFO_Trait_Name": "triglycerides in HDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497461/harmonised/GCST90497461.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497905",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022318",
    "EFO_Trait_Name": "triglycerides in large HDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497905/harmonised/GCST90497905.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498103",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022319",
    "EFO_Trait_Name": "triglycerides in large LDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498103/harmonised/GCST90498103.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498464",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022320",
    "EFO_Trait_Name": "triglycerides in LDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498464/harmonised/GCST90498464.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498690",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022321",
    "EFO_Trait_Name": "triglycerides in medium HDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498690/harmonised/GCST90498690.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498892",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022322",
    "EFO_Trait_Name": "triglycerides in medium LDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498892/harmonised/GCST90498892.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499733",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022323",
    "EFO_Trait_Name": "triglycerides in small LDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499733/harmonised/GCST90499733.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500498",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022324",
    "EFO_Trait_Name": "triglycerides in very large HDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500498/harmonised/GCST90500498.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500683",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022325",
    "EFO_Trait_Name": "triglycerides in very large VLDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500683/harmonised/GCST90500683.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500299",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022326",
    "EFO_Trait_Name": "triglycerides in VLDL measurement ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500299/harmonised/GCST90500299.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499991",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022327",
    "EFO_Trait_Name": "triglycerides to phosphoglycerides ratio ",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499991/harmonised/GCST90499991.h.tsv.gz"
  },
  {
    "accessionId": "GCST90501065",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022328",
    "EFO_Trait_Name": "triglycerides to total lipids in chylomicrons and extremely large VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90501001-GCST90502000/GCST90501065/harmonised/GCST90501065.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497665",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022329",
    "EFO_Trait_Name": "triglycerides to total lipids in IDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497665/harmonised/GCST90497665.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497887",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022330",
    "EFO_Trait_Name": "triglycerides to total lipids in large HDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497887/harmonised/GCST90497887.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498077",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022331",
    "EFO_Trait_Name": "triglycerides to total lipids in large LDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498077/harmonised/GCST90498077.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498276",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022332",
    "EFO_Trait_Name": "triglycerides to total lipids in large VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498276/harmonised/GCST90498276.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498674",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022333",
    "EFO_Trait_Name": "triglycerides to total lipids in medium HDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498674/harmonised/GCST90498674.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498877",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022334",
    "EFO_Trait_Name": "triglycerides to total lipids in medium LDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498877/harmonised/GCST90498877.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499054",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022335",
    "EFO_Trait_Name": "triglycerides to total lipids in medium VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499054/harmonised/GCST90499054.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499524",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022336",
    "EFO_Trait_Name": "triglycerides to total lipids in small HDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499524/harmonised/GCST90499524.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499708",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022337",
    "EFO_Trait_Name": "triglycerides to total lipids in small LDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499708/harmonised/GCST90499708.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499905",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022338",
    "EFO_Trait_Name": "triglycerides to total lipids in small VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499905/harmonised/GCST90499905.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500485",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022339",
    "EFO_Trait_Name": "triglycerides to total lipids in very large HDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500485/harmonised/GCST90500485.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500675",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022340",
    "EFO_Trait_Name": "triglycerides to total lipids in very large VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500675/harmonised/GCST90500675.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500879",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0022341",
    "EFO_Trait_Name": "triglycerides to total lipids in very small VLDL percentage ",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500879/harmonised/GCST90500879.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500202",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0920021",
    "EFO_Trait_Name": "cholesteryl esters in VLDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500202/harmonised/GCST90500202.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497355",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0920022",
    "EFO_Trait_Name": "cholesteryl esters in HDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497355/harmonised/GCST90497355.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498364",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0920023",
    "EFO_Trait_Name": "cholesteryl esters in LDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498364/harmonised/GCST90498364.h.tsv.gz"
  },
  {
    "accessionId": "GCST90501308",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0920024",
    "EFO_Trait_Name": "cholesteryl esters in very large VLDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90501001-GCST90502000/GCST90501308/harmonised/GCST90501308.h.tsv.gz"
  },
  {
    "accessionId": "GCST90501260",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0920025",
    "EFO_Trait_Name": "cholesteryl esters in small VLDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90501001-GCST90502000/GCST90501260/harmonised/GCST90501260.h.tsv.gz"
  },
  {
    "accessionId": "GCST90501184",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0920026",
    "EFO_Trait_Name": "cholesteryl esters in medium HDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90501001-GCST90502000/GCST90501184/harmonised/GCST90501184.h.tsv.gz"
  },
  {
    "accessionId": "GCST90501236",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0920027",
    "EFO_Trait_Name": "cholesteryl esters in small HDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90501001-GCST90502000/GCST90501236/harmonised/GCST90501236.h.tsv.gz"
  },
  {
    "accessionId": "GCST90501248",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0920028",
    "EFO_Trait_Name": "cholesteryl esters in small LDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90501001-GCST90502000/GCST90501248/harmonised/GCST90501248.h.tsv.gz"
  },
  {
    "accessionId": "GCST90501123",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0920029",
    "EFO_Trait_Name": "cholesteryl esters in IDL measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90501001-GCST90502000/GCST90501123/harmonised/GCST90501123.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500623",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0920030",
    "EFO_Trait_Name": "concentration of very large VLDL particles measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500623/harmonised/GCST90500623.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500440",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0920031",
    "EFO_Trait_Name": "concentration of very large HDL particles measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500440/harmonised/GCST90500440.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498623",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0920032",
    "EFO_Trait_Name": "concentration of medium HDL particles measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498623/harmonised/GCST90498623.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499474",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "EFO_0920033",
    "EFO_Trait_Name": "concentration of small HDL particles measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499474/harmonised/GCST90499474.h.tsv.gz"
  },
  {
    "accessionId": "GCST90499237",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "OBA_2040179",
    "EFO_Trait_Name": "level of phosphatidylcholine",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90499001-GCST90500000/GCST90499237/harmonised/GCST90499237.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497106",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "OBA_2050068",
    "EFO_Trait_Name": "serum albumin amount",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497106/harmonised/GCST90497106.h.tsv.gz"
  },
  {
    "accessionId": "GCST90498454",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "OBA_2050113",
    "EFO_Trait_Name": "LDL particle size",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90498001-GCST90499000/GCST90498454/harmonised/GCST90498454.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500275",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "OBA_2050114",
    "EFO_Trait_Name": "VLDL particle size",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500275/harmonised/GCST90500275.h.tsv.gz"
  },
  {
    "accessionId": "GCST90497442",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "OBA_2050115",
    "EFO_Trait_Name": "HDL particle size",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90497001-GCST90498000/GCST90497442/harmonised/GCST90497442.h.tsv.gz"
  },
  {
    "accessionId": "GCST90500201",
    "initial_individuals": "434646",
    "initial_ancestralGroup": "European",
    "pubmedId": "41044249",
    "EFO_ID": "OBA_VT0005144",
    "EFO_Trait_Name": "blood VLDL cholesterol amount",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90500001-GCST90501000/GCST90500201/harmonised/GCST90500201.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477414",
    "initial_individuals": "434483",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0041261",
    "EFO_Trait_Name": "disorder of acid-base balance",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477414/harmonised/GCST90477414.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475977",
    "initial_individuals": "434418",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0006699",
    "EFO_Trait_Name": "Premature atrial contractions",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475977/harmonised/GCST90475977.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476208",
    "initial_individuals": "434365",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0019283",
    "EFO_Trait_Name": "nail anomaly",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476208/harmonised/GCST90476208.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478827",
    "initial_individuals": "434111",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0019278",
    "EFO_Trait_Name": "hair anomaly",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478827/harmonised/GCST90478827.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476016",
    "initial_individuals": "434110",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0007940",
    "EFO_Trait_Name": "chronic venous insufficiency",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476016/harmonised/GCST90476016.h.tsv.gz"
  },
  {
    "accessionId": "GCST90129441",
    "initial_individuals": "433905",
    "initial_ancestralGroup": "European",
    "pubmedId": "37219871",
    "EFO_ID": "EFO_0010099",
    "EFO_Trait_Name": "chronic widespread pain",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129441/harmonised/GCST90129441.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478256",
    "initial_individuals": "433623",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0002508",
    "EFO_Trait_Name": "gingivitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478256/harmonised/GCST90478256.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476143",
    "initial_individuals": "433456",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1000839",
    "EFO_Trait_Name": "bladder calculus",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476143/harmonised/GCST90476143.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478325",
    "initial_individuals": "433166",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001095",
    "EFO_Trait_Name": "peptic esophagitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478325/harmonised/GCST90478325.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477081",
    "initial_individuals": "433110",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009525",
    "EFO_Trait_Name": "foreign body",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477081/harmonised/GCST90477081.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478361",
    "initial_individuals": "433042",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0001318",
    "EFO_Trait_Name": "functional gastric disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478361/harmonised/GCST90478361.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479168",
    "initial_individuals": "432459",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009827",
    "EFO_Trait_Name": "abnormal result of diagnostic imaging",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479168/harmonised/GCST90479168.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478943",
    "initial_individuals": "432305",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0002181",
    "EFO_Trait_Name": "exostosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478943/harmonised/GCST90478943.h.tsv.gz"
  },
  {
    "accessionId": "GCST90179115",
    "initial_individuals": "432297",
    "initial_ancestralGroup": "European",
    "pubmedId": "36150907",
    "EFO_ID": "EFO_0008393",
    "EFO_Trait_Name": "reaction time measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90179001-GCST90180000/GCST90179115/harmonised/GCST90179115.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475916",
    "initial_individuals": "432123",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0010670",
    "EFO_Trait_Name": "abnormal chest sounds",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475916/harmonised/GCST90475916.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474304",
    "initial_individuals": "431897",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0802260",
    "EFO_Trait_Name": "alanine aminotransferase 1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474304/harmonised/GCST90474304.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474329",
    "initial_individuals": "431752",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0011005",
    "EFO_Trait_Name": "urea measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474329/harmonised/GCST90474329.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475765",
    "initial_individuals": "431717",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0001074",
    "EFO_Trait_Name": "morbid obesity",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475765/harmonised/GCST90475765.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476044",
    "initial_individuals": "431689",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001133",
    "EFO_Trait_Name": "pulmonary coin lesion",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476044/harmonised/GCST90476044.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475673",
    "initial_individuals": "431357",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009486",
    "EFO_Trait_Name": "diabetic eye disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475673/harmonised/GCST90475673.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475575",
    "initial_individuals": "431198",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0002898",
    "EFO_Trait_Name": "skin cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475575/harmonised/GCST90475575.h.tsv.gz"
  },
  {
    "accessionId": "GCST90079078",
    "initial_individuals": "430929",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0000689",
    "EFO_Trait_Name": "sampling time",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90079001-GCST90080000/GCST90079078/harmonised/GCST90079078.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479312",
    "initial_individuals": "430786",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0012393",
    "EFO_Trait_Name": "Allergy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479312/harmonised/GCST90479312.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475632",
    "initial_individuals": "430584",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0002013",
    "EFO_Trait_Name": "lymphangioma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475632/harmonised/GCST90475632.h.tsv.gz"
  },
  {
    "accessionId": "GCST90077617",
    "initial_individuals": "430494",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0009711",
    "EFO_Trait_Name": "townsend deprivation index",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90077001-GCST90078000/GCST90077617/harmonised/GCST90077617.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477577",
    "initial_individuals": "430422",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0100022",
    "EFO_Trait_Name": "abnormality of movement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477577/harmonised/GCST90477577.h.tsv.gz"
  },
  {
    "accessionId": "GCST90078245",
    "initial_individuals": "430080",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0011011",
    "EFO_Trait_Name": "sitting height measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90078001-GCST90079000/GCST90078245/harmonised/GCST90078245.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477155",
    "initial_individuals": "429983",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0000493",
    "EFO_Trait_Name": "family history",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477155/harmonised/GCST90477155.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478598",
    "initial_individuals": "429900",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0003901",
    "EFO_Trait_Name": "dysuria",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478598/harmonised/GCST90478598.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477098",
    "initial_individuals": "429863",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0000720",
    "EFO_Trait_Name": "test result",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477098/harmonised/GCST90477098.h.tsv.gz"
  },
  {
    "accessionId": "GCST90078685",
    "initial_individuals": "429785",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0004338",
    "EFO_Trait_Name": "body weight",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90078001-GCST90079000/GCST90078685/harmonised/GCST90078685.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475683",
    "initial_individuals": "429358",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009406",
    "EFO_Trait_Name": "glucose metabolism disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475683/harmonised/GCST90475683.h.tsv.gz"
  },
  {
    "accessionId": "GCST90079219",
    "initial_individuals": "429337",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0006941",
    "EFO_Trait_Name": "grip strength measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90079001-GCST90080000/GCST90079219/harmonised/GCST90079219.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478498",
    "initial_individuals": "429331",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009685",
    "EFO_Trait_Name": "rectal disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478498/harmonised/GCST90478498.h.tsv.gz"
  },
  {
    "accessionId": "GCST90077583",
    "initial_individuals": "429145",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0007875",
    "EFO_Trait_Name": "excessive daytime sleepiness measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90077001-GCST90078000/GCST90077583/harmonised/GCST90077583.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479127",
    "initial_individuals": "429044",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0003394",
    "EFO_Trait_Name": "Muscle spasm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479127/harmonised/GCST90479127.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478358",
    "initial_individuals": "428876",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0004628",
    "EFO_Trait_Name": "gastroduodenitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478358/harmonised/GCST90478358.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476150",
    "initial_individuals": "427934",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0000016",
    "EFO_Trait_Name": "Urinary retention",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476150/harmonised/GCST90476150.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018882",
    "initial_individuals": "427911",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009609",
    "EFO_Trait_Name": "myocarditis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018882/harmonised/GCST90018882.h.tsv.gz"
  },
  {
    "accessionId": "GCST90162547",
    "initial_individuals": "427037",
    "initial_ancestralGroup": "European",
    "pubmedId": "36150907",
    "EFO_ID": "EFO_0009332",
    "EFO_Trait_Name": "executive function measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90162001-GCST90163000/GCST90162547/harmonised/GCST90162547.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477119",
    "initial_individuals": "426947",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009788",
    "EFO_Trait_Name": "encounter with health service related to socioeconomic and psychosocial circumstances",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477119/harmonised/GCST90477119.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475849",
    "initial_individuals": "426887",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0002175",
    "EFO_Trait_Name": "degeneration of macula and posterior pole",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475849/harmonised/GCST90475849.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475718",
    "initial_individuals": "426603",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0021187",
    "EFO_Trait_Name": "hyperlipidemia",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475718/harmonised/GCST90475718.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475563",
    "initial_individuals": "425897",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0007512",
    "EFO_Trait_Name": "tinea pedis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475563/harmonised/GCST90475563.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476334",
    "initial_individuals": "425748",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "OBA_1001087",
    "EFO_Trait_Name": "heart rate",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476334/harmonised/GCST90476334.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475255",
    "initial_individuals": "425743",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0006945",
    "EFO_Trait_Name": "diastolic blood pressure change measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475255/harmonised/GCST90475255.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475755",
    "initial_individuals": "425737",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0003019",
    "EFO_Trait_Name": "potassium deficiency disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475755/harmonised/GCST90475755.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478608",
    "initial_individuals": "425520",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0012590",
    "EFO_Trait_Name": "Abnormal urine output",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478608/harmonised/GCST90478608.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476170",
    "initial_individuals": "425227",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1000695",
    "EFO_Trait_Name": "erythematosquamous dermatosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476170/harmonised/GCST90476170.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477713",
    "initial_individuals": "424248",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0043885",
    "EFO_Trait_Name": "eye infectious disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477713/harmonised/GCST90477713.h.tsv.gz"
  },
  {
    "accessionId": "GCST90078910",
    "initial_individuals": "424024",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "HP_0000924",
    "EFO_Trait_Name": "abnormality of the skeletal system",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90078001-GCST90079000/GCST90078910/harmonised/GCST90078910.h.tsv.gz"
  },
  {
    "accessionId": "GCST90078906",
    "initial_individuals": "423698",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0009805",
    "EFO_Trait_Name": "whole body water mass",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90078001-GCST90079000/GCST90078906/harmonised/GCST90078906.h.tsv.gz"
  },
  {
    "accessionId": "GCST90078914",
    "initial_individuals": "423666",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0007800",
    "EFO_Trait_Name": "body fat percentage",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90078001-GCST90079000/GCST90078914/harmonised/GCST90078914.h.tsv.gz"
  },
  {
    "accessionId": "GCST90078905",
    "initial_individuals": "423664",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0004995",
    "EFO_Trait_Name": "lean body mass",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90078001-GCST90079000/GCST90078905/harmonised/GCST90078905.h.tsv.gz"
  },
  {
    "accessionId": "GCST90078915",
    "initial_individuals": "423659",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "OBA_0004528",
    "EFO_Trait_Name": "fat pad mass",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90078001-GCST90079000/GCST90078915/harmonised/GCST90078915.h.tsv.gz"
  },
  {
    "accessionId": "GCST90078917",
    "initial_individuals": "423649",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0004302",
    "EFO_Trait_Name": "anthropometric measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90078001-GCST90079000/GCST90078917/harmonised/GCST90078917.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478232",
    "initial_individuals": "423470",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0002220",
    "EFO_Trait_Name": "tooth hard tissue disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478232/harmonised/GCST90478232.h.tsv.gz"
  },
  {
    "accessionId": "GCST90078930",
    "initial_individuals": "423451",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0004324",
    "EFO_Trait_Name": "body weights and measures",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90078001-GCST90079000/GCST90078930/harmonised/GCST90078930.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475623",
    "initial_individuals": "422967",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0022749",
    "EFO_Trait_Name": "non-neoplastic nevus",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475623/harmonised/GCST90475623.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475622",
    "initial_individuals": "422515",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0010566",
    "EFO_Trait_Name": "Hamartoma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475622/harmonised/GCST90475622.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476310",
    "initial_individuals": "421506",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009283",
    "EFO_Trait_Name": "potassium measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476310/harmonised/GCST90476310.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478775",
    "initial_individuals": "421412",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0010683",
    "EFO_Trait_Name": "localized superficial swelling, mass, or lump",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478775/harmonised/GCST90478775.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476395",
    "initial_individuals": "421240",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009282",
    "EFO_Trait_Name": "sodium measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476395/harmonised/GCST90476395.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479130",
    "initial_individuals": "421115",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0001324",
    "EFO_Trait_Name": "Muscle weakness",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479130/harmonised/GCST90479130.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691948",
    "initial_individuals": "420531",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0000352",
    "EFO_Trait_Name": "clinical history",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691948/harmonised/GCST90691948.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691929",
    "initial_individuals": "420531",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0003768",
    "EFO_Trait_Name": "nicotine dependence",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691929/harmonised/GCST90691929.h.tsv.gz"
  },
  {
    "accessionId": "GCST90692005",
    "initial_individuals": "420531",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0007010",
    "EFO_Trait_Name": "drug use measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90692001-GCST90693000/GCST90692005/harmonised/GCST90692005.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691930",
    "initial_individuals": "420531",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0007634",
    "EFO_Trait_Name": "major depressive episode",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691930/harmonised/GCST90691930.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691942",
    "initial_individuals": "420531",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0009477",
    "EFO_Trait_Name": "vertebral joint disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691942/harmonised/GCST90691942.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691946",
    "initial_individuals": "420531",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0010724",
    "EFO_Trait_Name": "lifestyle measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691946/harmonised/GCST90691946.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691626",
    "initial_individuals": "420473",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0007924",
    "EFO_Trait_Name": "tonsillectomy risk measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691626/harmonised/GCST90691626.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691745",
    "initial_individuals": "420473",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0009801",
    "EFO_Trait_Name": "number of non-cancer illnesses, self-reported",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691745/harmonised/GCST90691745.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474438",
    "initial_individuals": "420204",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0007934",
    "EFO_Trait_Name": "creatinine clearance measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474438/harmonised/GCST90474438.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691903",
    "initial_individuals": "420134",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0006340",
    "EFO_Trait_Name": "mean arterial pressure",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691903/harmonised/GCST90691903.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691673",
    "initial_individuals": "419992",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0020922",
    "EFO_Trait_Name": "hospitalisation",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691673/harmonised/GCST90691673.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476215",
    "initial_individuals": "419938",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1000763",
    "EFO_Trait_Name": "sebaceous gland disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476215/harmonised/GCST90476215.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691646",
    "initial_individuals": "419936",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0007645",
    "EFO_Trait_Name": "longitudinal alcohol consumption measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691646/harmonised/GCST90691646.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691705",
    "initial_individuals": "419768",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0004778",
    "EFO_Trait_Name": "self rated health",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691705/harmonised/GCST90691705.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691701",
    "initial_individuals": "419624",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0004298",
    "EFO_Trait_Name": "cardiovascular measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691701/harmonised/GCST90691701.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691712",
    "initial_individuals": "419588",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0010639",
    "EFO_Trait_Name": "pain measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691712/harmonised/GCST90691712.h.tsv.gz"
  },
  {
    "accessionId": "GCST90271700",
    "initial_individuals": "419548",
    "initial_ancestralGroup": "European",
    "pubmedId": "38375614",
    "EFO_ID": "EFO_0009595",
    "EFO_Trait_Name": "guilt measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90271001-GCST90272000/GCST90271700/harmonised/GCST90271700.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691601",
    "initial_individuals": "419469",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0003924",
    "EFO_Trait_Name": "hair color",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691601/harmonised/GCST90691601.h.tsv.gz"
  },
  {
    "accessionId": "GCST90255613",
    "initial_individuals": "419380",
    "initial_ancestralGroup": "European",
    "pubmedId": "37081098",
    "EFO_ID": "EFO_0004292",
    "EFO_Trait_Name": "vaccination",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90255001-GCST90256000/GCST90255613/harmonised/GCST90255613.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691715",
    "initial_individuals": "419219",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0003940",
    "EFO_Trait_Name": "physical activity",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691715/harmonised/GCST90691715.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691725",
    "initial_individuals": "419194",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0600007",
    "EFO_Trait_Name": "fish oil supplement exposure measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691725/harmonised/GCST90691725.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691726",
    "initial_individuals": "419194",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0600066",
    "EFO_Trait_Name": "nutritional supplement exposure measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691726/harmonised/GCST90691726.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475168",
    "initial_individuals": "419128",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "OBA_VT0005265",
    "EFO_Trait_Name": "blood urea nitrogen amount",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475168/harmonised/GCST90475168.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691699",
    "initial_individuals": "418978",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0007780",
    "EFO_Trait_Name": "periodontal measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691699/harmonised/GCST90691699.h.tsv.gz"
  },
  {
    "accessionId": "GCST90079009",
    "initial_individuals": "418307",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "OBA_2050095",
    "EFO_Trait_Name": "urine potassium amount",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90079001-GCST90080000/GCST90079009/harmonised/GCST90079009.h.tsv.gz"
  },
  {
    "accessionId": "GCST90271702",
    "initial_individuals": "418255",
    "initial_ancestralGroup": "European",
    "pubmedId": "38375614",
    "EFO_ID": "EFO_0009599",
    "EFO_Trait_Name": "feeling emotionally hurt measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90271001-GCST90272000/GCST90271702/harmonised/GCST90271702.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691735",
    "initial_individuals": "418009",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "OBA_2040171",
    "EFO_Trait_Name": "sleep duration trait",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691735/harmonised/GCST90691735.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475562",
    "initial_individuals": "417664",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0001628",
    "EFO_Trait_Name": "tinea unguium",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475562/harmonised/GCST90475562.h.tsv.gz"
  },
  {
    "accessionId": "GCST90042684",
    "initial_individuals": "417332",
    "initial_ancestralGroup": "European",
    "pubmedId": "34737426",
    "EFO_ID": "EFO_0006953",
    "EFO_Trait_Name": "family history of lung cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042684/harmonised/GCST90042684.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477207",
    "initial_individuals": "416269",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0007355",
    "EFO_Trait_Name": "male reproductive organ cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477207/harmonised/GCST90477207.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476160",
    "initial_individuals": "416103",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0008231",
    "EFO_Trait_Name": "Peyronie disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476160/harmonised/GCST90476160.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478640",
    "initial_individuals": "415697",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001015",
    "EFO_Trait_Name": "leukoplakia of penis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478640/harmonised/GCST90478640.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478631",
    "initial_individuals": "415657",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0000284",
    "EFO_Trait_Name": "benign prostatic hyperplasia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478631/harmonised/GCST90478631.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478651",
    "initial_individuals": "415276",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0000022",
    "EFO_Trait_Name": "Abnormal male internal genitalia morphology",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478651/harmonised/GCST90478651.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691754",
    "initial_individuals": "415018",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "OBA_VT0002095",
    "EFO_Trait_Name": "skin pigmentation",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691754/harmonised/GCST90691754.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476158",
    "initial_individuals": "414460",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001189",
    "EFO_Trait_Name": "spermatocele",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476158/harmonised/GCST90476158.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478626",
    "initial_individuals": "414338",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0001618",
    "EFO_Trait_Name": "balanoposthitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478626/harmonised/GCST90478626.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478649",
    "initial_individuals": "414168",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0000279",
    "EFO_Trait_Name": "azoospermia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478649/harmonised/GCST90478649.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475727",
    "initial_individuals": "413728",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0003077",
    "EFO_Trait_Name": "Hyperlipidemia",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475727/harmonised/GCST90475727.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691753",
    "initial_individuals": "413682",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "OBA_2045231",
    "EFO_Trait_Name": "height growth attribute",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691753/harmonised/GCST90691753.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691790",
    "initial_individuals": "413157",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "OBA_VT0010482",
    "EFO_Trait_Name": "body fat mass",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691790/harmonised/GCST90691790.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691792",
    "initial_individuals": "413146",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0005106",
    "EFO_Trait_Name": "body composition measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691792/harmonised/GCST90691792.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477860",
    "initial_individuals": "412766",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0006943",
    "EFO_Trait_Name": "blood pressure change measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477860/harmonised/GCST90477860.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475194",
    "initial_individuals": "412569",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "OBA_1000959",
    "EFO_Trait_Name": "chloride amount",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475194/harmonised/GCST90475194.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475150",
    "initial_individuals": "412527",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "OBA_2050094",
    "EFO_Trait_Name": "blood sodium bicarbonate amount",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475150/harmonised/GCST90475150.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478618",
    "initial_individuals": "412012",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0003830",
    "EFO_Trait_Name": "prostatitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478618/harmonised/GCST90478618.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476157",
    "initial_individuals": "411784",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001859",
    "EFO_Trait_Name": "testicular hydrocele",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476157/harmonised/GCST90476157.h.tsv.gz"
  },
  {
    "accessionId": "GCST90271703",
    "initial_individuals": "411674",
    "initial_ancestralGroup": "European",
    "pubmedId": "38375614",
    "EFO_ID": "EFO_0009594",
    "EFO_Trait_Name": "irritability measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90271001-GCST90272000/GCST90271703/harmonised/GCST90271703.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478623",
    "initial_individuals": "409645",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001078",
    "EFO_Trait_Name": "orchitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478623/harmonised/GCST90478623.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475700",
    "initial_individuals": "409645",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0024298",
    "EFO_Trait_Name": "vitamin deficiency disorder",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475700/harmonised/GCST90475700.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476241",
    "initial_individuals": "409575",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0056802",
    "EFO_Trait_Name": "synovial bursa disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476241/harmonised/GCST90476241.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018873",
    "initial_individuals": "409217",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0002609",
    "EFO_Trait_Name": "juvenile idiopathic arthritis",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018873/harmonised/GCST90018873.h.tsv.gz"
  },
  {
    "accessionId": "GCST90246358",
    "initial_individuals": "409197",
    "initial_ancestralGroup": "European",
    "pubmedId": "36929174",
    "EFO_ID": "MONDO_0002974",
    "EFO_Trait_Name": "cervical cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90246001-GCST90247000/GCST90246358/harmonised/GCST90246358.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436554",
    "initial_individuals": "408961",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0006922",
    "EFO_Trait_Name": "delivery measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436554/harmonised/GCST90436554.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436810",
    "initial_individuals": "408961",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0009641",
    "EFO_Trait_Name": "malaise",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436810/harmonised/GCST90436810.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435546",
    "initial_individuals": "408961",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0009886",
    "EFO_Trait_Name": "blood vessel injury",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435546/harmonised/GCST90435546.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436843",
    "initial_individuals": "408961",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0020989",
    "EFO_Trait_Name": "bone marrow transplantation",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436843/harmonised/GCST90436843.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436546",
    "initial_individuals": "408961",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_1000971",
    "EFO_Trait_Name": "hyperemesis gravidarum",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436546/harmonised/GCST90436546.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436791",
    "initial_individuals": "408961",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0002045",
    "EFO_Trait_Name": "Hypothermia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436791/harmonised/GCST90436791.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435785",
    "initial_individuals": "408961",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0003916",
    "EFO_Trait_Name": "overnutrition",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435785/harmonised/GCST90435785.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436794",
    "initial_individuals": "408793",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0009373",
    "EFO_Trait_Name": "edema",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436794/harmonised/GCST90436794.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436566",
    "initial_individuals": "408743",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0009683",
    "EFO_Trait_Name": "puerperal disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436566/harmonised/GCST90436566.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435592",
    "initial_individuals": "408665",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_1000350",
    "EFO_Trait_Name": "Malignant Bone Neoplasm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435592/harmonised/GCST90435592.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435886",
    "initial_individuals": "408542",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0004681",
    "EFO_Trait_Name": "learning disability",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435886/harmonised/GCST90435886.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436873",
    "initial_individuals": "408525",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0007686",
    "EFO_Trait_Name": "surgical shock",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436873/harmonised/GCST90436873.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435887",
    "initial_individuals": "408467",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0004730",
    "EFO_Trait_Name": "speech disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435887/harmonised/GCST90435887.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435883",
    "initial_individuals": "408455",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0003852",
    "EFO_Trait_Name": "developmental disability",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435883/harmonised/GCST90435883.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435884",
    "initial_individuals": "408432",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0003758",
    "EFO_Trait_Name": "autism",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435884/harmonised/GCST90435884.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435663",
    "initial_individuals": "408340",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0021440",
    "EFO_Trait_Name": "benign neoplasm of skin",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435663/harmonised/GCST90435663.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435750",
    "initial_individuals": "408299",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0002616",
    "EFO_Trait_Name": "macroglobulinemia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435750/harmonised/GCST90435750.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435895",
    "initial_individuals": "408233",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0019956",
    "EFO_Trait_Name": "encephalitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435895/harmonised/GCST90435895.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436778",
    "initial_individuals": "408126",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0019040",
    "EFO_Trait_Name": "chromosomal disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436778/harmonised/GCST90436778.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691955",
    "initial_individuals": "408116",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "MONDO_0021698",
    "EFO_Trait_Name": "alcohol-related disorders",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691955/harmonised/GCST90691955.h.tsv.gz"
  },
  {
    "accessionId": "GCST90477920",
    "initial_individuals": "408101",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0004327",
    "EFO_Trait_Name": "electrocardiography",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90477001-GCST90478000/GCST90477920/harmonised/GCST90477920.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475750",
    "initial_individuals": "408039",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0003111",
    "EFO_Trait_Name": "Abnormal blood ion concentration",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475750/harmonised/GCST90475750.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435896",
    "initial_individuals": "407962",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0015342",
    "EFO_Trait_Name": "acute transverse myelitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435896/harmonised/GCST90435896.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436774",
    "initial_individuals": "407938",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_1000648",
    "EFO_Trait_Name": "developmental dysplasia of the hip",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436774/harmonised/GCST90436774.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691838",
    "initial_individuals": "407610",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "HP_0012603",
    "EFO_Trait_Name": "Abnormal urine sodium concentration",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691838/harmonised/GCST90691838.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436048",
    "initial_individuals": "407438",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0009847",
    "EFO_Trait_Name": "dizziness",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436048/harmonised/GCST90436048.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435622",
    "initial_individuals": "407415",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0002236",
    "EFO_Trait_Name": "ocular cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435622/harmonised/GCST90435622.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435739",
    "initial_individuals": "407327",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0002039",
    "EFO_Trait_Name": "Anorexia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435739/harmonised/GCST90435739.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436795",
    "initial_individuals": "407320",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0031284",
    "EFO_Trait_Name": "flushing",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436795/harmonised/GCST90436795.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435676",
    "initial_individuals": "407298",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0021506",
    "EFO_Trait_Name": "benign neoplasm of spinal cord",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435676/harmonised/GCST90435676.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436509",
    "initial_individuals": "407265",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0008622",
    "EFO_Trait_Name": "female genital tract polyp",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436509/harmonised/GCST90436509.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436763",
    "initial_individuals": "407069",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0019719",
    "EFO_Trait_Name": "congenital anomaly of kidney and urinary tract",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436763/harmonised/GCST90436763.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435957",
    "initial_individuals": "406977",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0020121",
    "EFO_Trait_Name": "muscular dystrophy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435957/harmonised/GCST90435957.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435852",
    "initial_individuals": "406882",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0005950",
    "EFO_Trait_Name": "head and neck neoplasia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435852/harmonised/GCST90435852.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435575",
    "initial_individuals": "406878",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0001128",
    "EFO_Trait_Name": "nasal cavity cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435575/harmonised/GCST90435575.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435571",
    "initial_individuals": "406875",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0021320",
    "EFO_Trait_Name": "malignant tumor of floor of mouth",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435571/harmonised/GCST90435571.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435353",
    "initial_individuals": "406826",
    "initial_ancestralGroup": "European",
    "pubmedId": "39948438",
    "EFO_ID": "EFO_0010819",
    "EFO_Trait_Name": "clonal hematopoiesis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435353/harmonised/GCST90435353.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436746",
    "initial_individuals": "406751",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_1000825",
    "EFO_Trait_Name": "atrial heart septal defect",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436746/harmonised/GCST90436746.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478630",
    "initial_individuals": "406719",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009602",
    "EFO_Trait_Name": "prostate disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478630/harmonised/GCST90478630.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436534",
    "initial_individuals": "406409",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0005268",
    "EFO_Trait_Name": "Miscarriage",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436534/harmonised/GCST90436534.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435820",
    "initial_individuals": "406409",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0031364",
    "EFO_Trait_Name": "Ecchymosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435820/harmonised/GCST90435820.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435814",
    "initial_individuals": "406379",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0024574",
    "EFO_Trait_Name": "von Willebrand disease (hereditary or acquired)",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435814/harmonised/GCST90435814.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435816",
    "initial_individuals": "406344",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0010602",
    "EFO_Trait_Name": "hemophilia A",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435816/harmonised/GCST90435816.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435821",
    "initial_individuals": "406332",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_1000965",
    "EFO_Trait_Name": "Henoch-Schoenlein purpura",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435821/harmonised/GCST90435821.h.tsv.gz"
  },
  {
    "accessionId": "GCST90565837",
    "initial_individuals": "405979",
    "initial_ancestralGroup": "European",
    "pubmedId": "40374629",
    "EFO_ID": "EFO_0007652",
    "EFO_Trait_Name": "health trait",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90565001-GCST90566000/GCST90565837/harmonised/GCST90565837.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435732",
    "initial_individuals": "405630",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0009003",
    "EFO_Trait_Name": "ovarian dysfunction",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435732/harmonised/GCST90435732.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436042",
    "initial_individuals": "405496",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_1000675",
    "EFO_Trait_Name": "cholesteatoma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436042/harmonised/GCST90436042.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435722",
    "initial_individuals": "405481",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_1001485",
    "EFO_Trait_Name": "acromegaly",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435722/harmonised/GCST90435722.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435724",
    "initial_individuals": "405479",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0004782",
    "EFO_Trait_Name": "diabetes insipidus",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435724/harmonised/GCST90435724.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436516",
    "initial_individuals": "405433",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0010992",
    "EFO_Trait_Name": "stress urinary incontinence",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436516/harmonised/GCST90436516.h.tsv.gz"
  },
  {
    "accessionId": "GCST90013411",
    "initial_individuals": "405346",
    "initial_ancestralGroup": "European",
    "pubmedId": "33662382",
    "EFO_ID": "EFO_1001489",
    "EFO_Trait_Name": "skin and soft tissue Staphylococcus aureus infection",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90013001-GCST90014000/GCST90013411/harmonised/GCST90013411.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436053",
    "initial_individuals": "405077",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0000360",
    "EFO_Trait_Name": "tinnitus",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436053/harmonised/GCST90436053.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436051",
    "initial_individuals": "405018",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0000407",
    "EFO_Trait_Name": "Sensorineural hearing impairment",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436051/harmonised/GCST90436051.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436866",
    "initial_individuals": "404921",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0006802",
    "EFO_Trait_Name": "response to red blood cell transfusion",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436866/harmonised/GCST90436866.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435613",
    "initial_individuals": "404769",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0005088",
    "EFO_Trait_Name": "testicular carcinoma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435613/harmonised/GCST90435613.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436618",
    "initial_individuals": "404332",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_1000705",
    "EFO_Trait_Name": "granulomatous dermatitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436618/harmonised/GCST90436618.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436510",
    "initial_individuals": "404294",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0009484",
    "EFO_Trait_Name": "uterine polyp",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436510/harmonised/GCST90436510.h.tsv.gz"
  },
  {
    "accessionId": "GCST90013954",
    "initial_individuals": "403833",
    "initial_ancestralGroup": "European",
    "pubmedId": "34017140",
    "EFO_ID": "MONDO_0019200",
    "EFO_Trait_Name": "retinitis pigmentosa",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90013001-GCST90014000/GCST90013954/harmonised/GCST90013954.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436047",
    "initial_individuals": "403594",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0009604",
    "EFO_Trait_Name": "labyrinthitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436047/harmonised/GCST90436047.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436583",
    "initial_individuals": "403515",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_1000697",
    "EFO_Trait_Name": "exanthem",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436583/harmonised/GCST90436583.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436291",
    "initial_individuals": "403408",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0003938",
    "EFO_Trait_Name": "aphthous ulcer",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436291/harmonised/GCST90436291.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436503",
    "initial_individuals": "402965",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0002654",
    "EFO_Trait_Name": "uterine disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436503/harmonised/GCST90436503.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436592",
    "initial_individuals": "402789",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0019293",
    "EFO_Trait_Name": "skin vascular disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436592/harmonised/GCST90436592.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436594",
    "initial_individuals": "402781",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0010783",
    "EFO_Trait_Name": "Erythema",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436594/harmonised/GCST90436594.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436730",
    "initial_individuals": "402744",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_1001344",
    "EFO_Trait_Name": "Hemarthrosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436730/harmonised/GCST90436730.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436596",
    "initial_individuals": "402729",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_1000684",
    "EFO_Trait_Name": "dermatitis herpetiformis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436596/harmonised/GCST90436596.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435850",
    "initial_individuals": "402691",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0000738",
    "EFO_Trait_Name": "hallucinations",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435850/harmonised/GCST90435850.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436465",
    "initial_individuals": "402674",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0003014",
    "EFO_Trait_Name": "breast fibrocystic disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436465/harmonised/GCST90436465.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435847",
    "initial_individuals": "402574",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0100543",
    "EFO_Trait_Name": "cognitive impairment",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435847/harmonised/GCST90435847.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436005",
    "initial_individuals": "402480",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0005752",
    "EFO_Trait_Name": "eye inflammation",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436005/harmonised/GCST90436005.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436801",
    "initial_individuals": "402426",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0003565",
    "EFO_Trait_Name": "Elevated erythrocyte sedimentation rate",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436801/harmonised/GCST90436801.h.tsv.gz"
  },
  {
    "accessionId": "GCST90295949",
    "initial_individuals": "402398",
    "initial_ancestralGroup": "European",
    "pubmedId": "38200128",
    "EFO_ID": "EFO_0007929",
    "EFO_Trait_Name": "triglyceride:HDL cholesterol ratio",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90295001-GCST90296000/GCST90295949/harmonised/GCST90295949.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435666",
    "initial_individuals": "402263",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0000632",
    "EFO_Trait_Name": "uterine benign neoplasm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435666/harmonised/GCST90435666.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436498",
    "initial_individuals": "402158",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_1001864",
    "EFO_Trait_Name": "uterine prolapse",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436498/harmonised/GCST90436498.h.tsv.gz"
  },
  {
    "accessionId": "GCST90129451",
    "initial_individuals": "402144",
    "initial_ancestralGroup": "European",
    "pubmedId": "37219871",
    "EFO_ID": "HP_0030834",
    "EFO_Trait_Name": "shoulder pain",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129451/harmonised/GCST90129451.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436640",
    "initial_individuals": "402124",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0007374",
    "EFO_Trait_Name": "mixed connective tissue disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436640/harmonised/GCST90436640.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436466",
    "initial_individuals": "402052",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0006891",
    "EFO_Trait_Name": "breast adenosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436466/harmonised/GCST90436466.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436467",
    "initial_individuals": "402048",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_1000145",
    "EFO_Trait_Name": "breast fibrosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436467/harmonised/GCST90436467.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435667",
    "initial_individuals": "401998",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0000131",
    "EFO_Trait_Name": "uterine leiomyoma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435667/harmonised/GCST90435667.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436471",
    "initial_individuals": "401803",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0005941",
    "EFO_Trait_Name": "mammographic density measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436471/harmonised/GCST90436471.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435780",
    "initial_individuals": "401634",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0001959",
    "EFO_Trait_Name": "Polydipsia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435780/harmonised/GCST90435780.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436541",
    "initial_individuals": "401563",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0003917",
    "EFO_Trait_Name": "premature birth",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436541/harmonised/GCST90436541.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435600",
    "initial_individuals": "401447",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0007254",
    "EFO_Trait_Name": "breast cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435600/harmonised/GCST90435600.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436505",
    "initial_individuals": "401405",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0001433",
    "EFO_Trait_Name": "vaginal disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436505/harmonised/GCST90436505.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436490",
    "initial_individuals": "401080",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0030160",
    "EFO_Trait_Name": "cervicitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436490/harmonised/GCST90436490.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436543",
    "initial_individuals": "400982",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0009573",
    "EFO_Trait_Name": "high-risk pregnancy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436543/harmonised/GCST90436543.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436148",
    "initial_individuals": "400708",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0001876",
    "EFO_Trait_Name": "renal artery atheroma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436148/harmonised/GCST90436148.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436518",
    "initial_individuals": "400701",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0030016",
    "EFO_Trait_Name": "dyspareunia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436518/harmonised/GCST90436518.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436158",
    "initial_individuals": "400650",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0010820",
    "EFO_Trait_Name": "Spontaneous coronary artery dissection",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436158/harmonised/GCST90436158.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436492",
    "initial_individuals": "400515",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0004593",
    "EFO_Trait_Name": "Bartholin duct cyst",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436492/harmonised/GCST90436492.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436491",
    "initial_individuals": "400185",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0002234",
    "EFO_Trait_Name": "vaginitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436491/harmonised/GCST90436491.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436376",
    "initial_individuals": "400151",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0010682",
    "EFO_Trait_Name": "liver transplant",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436376/harmonised/GCST90436376.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436488",
    "initial_individuals": "400035",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0009572",
    "EFO_Trait_Name": "uterine inflammatory disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436488/harmonised/GCST90436488.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436493",
    "initial_individuals": "400031",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0001551",
    "EFO_Trait_Name": "ulceration of vulva",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436493/harmonised/GCST90436493.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476197",
    "initial_individuals": "399076",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_1001174",
    "EFO_Trait_Name": "secondary hypertrophic osteoarthropathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476197/harmonised/GCST90476197.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018867",
    "initial_individuals": "398632",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "MONDO_0004567",
    "EFO_Trait_Name": "ileus",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018867/harmonised/GCST90018867.h.tsv.gz"
  },
  {
    "accessionId": "GCST90455661",
    "initial_individuals": "398238",
    "initial_ancestralGroup": "European",
    "pubmedId": "41266372",
    "EFO_ID": "EFO_1001516",
    "EFO_Trait_Name": "ovarian serous carcinoma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90455001-GCST90456000/GCST90455661/harmonised/GCST90455661.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436278",
    "initial_individuals": "398197",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "OBA_VT0003743",
    "EFO_Trait_Name": "facial morphology trait",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436278/harmonised/GCST90436278.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436421",
    "initial_individuals": "397780",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0009471",
    "EFO_Trait_Name": "small kidney",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436421/harmonised/GCST90436421.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436408",
    "initial_individuals": "397681",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0003134",
    "EFO_Trait_Name": "proliferative glomerulonephritis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436408/harmonised/GCST90436408.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436423",
    "initial_individuals": "397679",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0002286",
    "EFO_Trait_Name": "renal artery disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436423/harmonised/GCST90436423.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436508",
    "initial_individuals": "397517",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_1000525",
    "EFO_Trait_Name": "Simple Endometrial Hyperplasia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436508/harmonised/GCST90436508.h.tsv.gz"
  },
  {
    "accessionId": "GCST90478130",
    "initial_individuals": "397509",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0002465",
    "EFO_Trait_Name": "bronchiolitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90478001-GCST90479000/GCST90478130/harmonised/GCST90478130.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436227",
    "initial_individuals": "397490",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_1001321",
    "EFO_Trait_Name": "extrinsic allergic alveolitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436227/harmonised/GCST90436227.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436500",
    "initial_individuals": "397411",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0020006",
    "EFO_Trait_Name": "enterocele",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436500/harmonised/GCST90436500.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691776",
    "initial_individuals": "396520",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0022039",
    "EFO_Trait_Name": "ultraviolet radiation exposure measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691776/harmonised/GCST90691776.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436519",
    "initial_individuals": "396437",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0010270",
    "EFO_Trait_Name": "Menstrual disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436519/harmonised/GCST90436519.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435936",
    "initial_individuals": "395570",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0001259",
    "EFO_Trait_Name": "coma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435936/harmonised/GCST90435936.h.tsv.gz"
  },
  {
    "accessionId": "GCST90079019",
    "initial_individuals": "395451",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0009718",
    "EFO_Trait_Name": "peak expiratory flow",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90079001-GCST90080000/GCST90079019/harmonised/GCST90079019.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435912",
    "initial_individuals": "395430",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0003782",
    "EFO_Trait_Name": "motor neuron disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435912/harmonised/GCST90435912.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435935",
    "initial_individuals": "395345",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0003760",
    "EFO_Trait_Name": "central nervous system cyst",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435935/harmonised/GCST90435935.h.tsv.gz"
  },
  {
    "accessionId": "GCST90134252",
    "initial_individuals": "395096",
    "initial_ancestralGroup": "European",
    "pubmedId": "35701873",
    "EFO_ID": "OBA_2040083",
    "EFO_Trait_Name": "trait in response to thiazide",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90134001-GCST90135000/GCST90134252/harmonised/GCST90134252.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474402",
    "initial_individuals": "394680",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0010968",
    "EFO_Trait_Name": "phosphate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474402/harmonised/GCST90474402.h.tsv.gz"
  },
  {
    "accessionId": "GCST90468156",
    "initial_individuals": "394642",
    "initial_ancestralGroup": "European",
    "pubmedId": "39789286",
    "EFO_ID": "EFO_0004847",
    "EFO_Trait_Name": "age at onset",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90468001-GCST90469000/GCST90468156/harmonised/GCST90468156.h.tsv.gz"
  },
  {
    "accessionId": "GCST90468153",
    "initial_individuals": "394626",
    "initial_ancestralGroup": "European",
    "pubmedId": "39789286",
    "EFO_ID": "EFO_0008008",
    "EFO_Trait_Name": "lower urinary tract symptom",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90468001-GCST90469000/GCST90468153/harmonised/GCST90468153.h.tsv.gz"
  },
  {
    "accessionId": "GCST90551884",
    "initial_individuals": "393833",
    "initial_ancestralGroup": "European",
    "pubmedId": "40021682",
    "EFO_ID": "OBA_VT0005372",
    "EFO_Trait_Name": "life span trait",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90551001-GCST90552000/GCST90551884/harmonised/GCST90551884.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435587",
    "initial_individuals": "393556",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0007466",
    "EFO_Trait_Name": "retroperitoneal cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435587/harmonised/GCST90435587.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435609",
    "initial_individuals": "392158",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_1001331",
    "EFO_Trait_Name": "Genital neoplasm, female",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435609/harmonised/GCST90435609.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436671",
    "initial_individuals": "392024",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0000473",
    "EFO_Trait_Name": "Torticollis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436671/harmonised/GCST90436671.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435610",
    "initial_individuals": "391822",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0008170",
    "EFO_Trait_Name": "ovarian cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435610/harmonised/GCST90435610.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436699",
    "initial_individuals": "391100",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0010886",
    "EFO_Trait_Name": "Osteochondritis Dissecans",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436699/harmonised/GCST90436699.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435806",
    "initial_individuals": "390133",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_1001264",
    "EFO_Trait_Name": "Anemia, Hemolytic, Autoimmune",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435806/harmonised/GCST90435806.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435604",
    "initial_individuals": "389981",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0020987",
    "EFO_Trait_Name": "mastectomy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435604/harmonised/GCST90435604.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475118",
    "initial_individuals": "389396",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0010934",
    "EFO_Trait_Name": "aspartate aminotransferase to alanine aminotransferase ratio",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475118/harmonised/GCST90475118.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435712",
    "initial_individuals": "388887",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0002919",
    "EFO_Trait_Name": "ketonuria",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435712/harmonised/GCST90435712.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436528",
    "initial_individuals": "388556",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0010685",
    "EFO_Trait_Name": "menopausal or post-menopausal disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436528/harmonised/GCST90436528.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435891",
    "initial_individuals": "388323",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0030955",
    "EFO_Trait_Name": "Addictive alcohol use",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435891/harmonised/GCST90435891.h.tsv.gz"
  },
  {
    "accessionId": "GCST90080264",
    "initial_individuals": "387930",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "HP_0002035",
    "EFO_Trait_Name": "rectal prolapse",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90080001-GCST90081000/GCST90080264/harmonised/GCST90080264.h.tsv.gz"
  },
  {
    "accessionId": "GCST90080269",
    "initial_individuals": "387923",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_1000987",
    "EFO_Trait_Name": "intestinal perforation",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90080001-GCST90081000/GCST90080269/harmonised/GCST90080269.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436366",
    "initial_individuals": "387487",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0003872",
    "EFO_Trait_Name": "colitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436366/harmonised/GCST90436366.h.tsv.gz"
  },
  {
    "accessionId": "GCST90080107",
    "initial_individuals": "387391",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0007361",
    "EFO_Trait_Name": "maxillary sinusitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90080001-GCST90081000/GCST90080107/harmonised/GCST90080107.h.tsv.gz"
  },
  {
    "accessionId": "GCST90080540",
    "initial_individuals": "387364",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_1001370",
    "EFO_Trait_Name": "metatarsalgia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90080001-GCST90081000/GCST90080540/harmonised/GCST90080540.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691739",
    "initial_individuals": "387100",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0008360",
    "EFO_Trait_Name": "environmental exposure measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691739/harmonised/GCST90691739.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435605",
    "initial_individuals": "385555",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0008501",
    "EFO_Trait_Name": "dysplasia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435605/harmonised/GCST90435605.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436457",
    "initial_individuals": "385037",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0009530",
    "EFO_Trait_Name": "anuria",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436457/harmonised/GCST90436457.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691755",
    "initial_individuals": "384866",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0005422",
    "EFO_Trait_Name": "skin aging",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691755/harmonised/GCST90691755.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435607",
    "initial_individuals": "383992",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_1000910",
    "EFO_Trait_Name": "dysplasia of cervix",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435607/harmonised/GCST90435607.h.tsv.gz"
  },
  {
    "accessionId": "GCST90079548",
    "initial_individuals": "383961",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0007309",
    "EFO_Trait_Name": "herpesviridae infectious disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90079001-GCST90080000/GCST90079548/harmonised/GCST90079548.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435608",
    "initial_individuals": "383251",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0002715",
    "EFO_Trait_Name": "uterine cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435608/harmonised/GCST90435608.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436885",
    "initial_individuals": "382947",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0008541",
    "EFO_Trait_Name": "response to opioid",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436885/harmonised/GCST90436885.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436533",
    "initial_individuals": "382634",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0000138",
    "EFO_Trait_Name": "ovarian cyst",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436533/harmonised/GCST90436533.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476161",
    "initial_individuals": "382509",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0004234",
    "EFO_Trait_Name": "erectile dysfunction",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476161/harmonised/GCST90476161.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436804",
    "initial_individuals": "382001",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0009511",
    "EFO_Trait_Name": "abnormal pap smear",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436804/harmonised/GCST90436804.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436893",
    "initial_individuals": "381882",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0005405",
    "EFO_Trait_Name": "response to antihypertensive drug",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436893/harmonised/GCST90436893.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435669",
    "initial_individuals": "381807",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_1000116",
    "EFO_Trait_Name": "Benign Ovarian Neoplasm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435669/harmonised/GCST90435669.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691731",
    "initial_individuals": "381494",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0600081",
    "EFO_Trait_Name": "time spent outdoors measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691731/harmonised/GCST90691731.h.tsv.gz"
  },
  {
    "accessionId": "GCST90080836",
    "initial_individuals": "381480",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "HP_0003011",
    "EFO_Trait_Name": "abnormality of the musculature",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90080001-GCST90081000/GCST90080836/harmonised/GCST90080836.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436108",
    "initial_individuals": "381152",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0005305",
    "EFO_Trait_Name": "atrioventricular node disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436108/harmonised/GCST90436108.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435888",
    "initial_individuals": "379747",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0002494",
    "EFO_Trait_Name": "substance-related disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435888/harmonised/GCST90435888.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436525",
    "initial_individuals": "379644",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0100607",
    "EFO_Trait_Name": "dysmenorrhea",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436525/harmonised/GCST90436525.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475557",
    "initial_individuals": "379130",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0021523",
    "EFO_Trait_Name": "examination for neoplasm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475557/harmonised/GCST90475557.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436531",
    "initial_individuals": "378972",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0001410",
    "EFO_Trait_Name": "postmenopausal atrophic vaginitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436531/harmonised/GCST90436531.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436694",
    "initial_individuals": "378814",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_1000746",
    "EFO_Trait_Name": "panniculitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436694/harmonised/GCST90436694.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436530",
    "initial_individuals": "378043",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "GO_0042697",
    "EFO_Trait_Name": "menopause",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436530/harmonised/GCST90436530.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436526",
    "initial_individuals": "378016",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0004169",
    "EFO_Trait_Name": "premenstrual tension",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436526/harmonised/GCST90436526.h.tsv.gz"
  },
  {
    "accessionId": "GCST90436521",
    "initial_individuals": "378001",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0000876",
    "EFO_Trait_Name": "Oligomenorrhea",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90436001-GCST90437000/GCST90436521/harmonised/GCST90436521.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435639",
    "initial_individuals": "370700",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0008514",
    "EFO_Trait_Name": "neurofibromatosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435639/harmonised/GCST90435639.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691887",
    "initial_individuals": "368642",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0005128",
    "EFO_Trait_Name": "albumin:globulin ratio measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691887/harmonised/GCST90691887.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435861",
    "initial_individuals": "365819",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0004320",
    "EFO_Trait_Name": "suicidal ideation",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435861/harmonised/GCST90435861.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435874",
    "initial_individuals": "365798",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "MONDO_0000595",
    "EFO_Trait_Name": "sexual and gender identity disorders",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435874/harmonised/GCST90435874.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435862",
    "initial_individuals": "365795",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0007623",
    "EFO_Trait_Name": "suicide behaviour",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435862/harmonised/GCST90435862.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435870",
    "initial_individuals": "365601",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0005223",
    "EFO_Trait_Name": "acute stress reaction",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435870/harmonised/GCST90435870.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435873",
    "initial_individuals": "365595",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "HP_0012076",
    "EFO_Trait_Name": "borderline personality disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435873/harmonised/GCST90435873.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435871",
    "initial_individuals": "365589",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0001358",
    "EFO_Trait_Name": "post-traumatic stress disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435871/harmonised/GCST90435871.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435869",
    "initial_individuals": "365529",
    "initial_ancestralGroup": "European",
    "pubmedId": "30104761",
    "EFO_ID": "EFO_0008623",
    "EFO_Trait_Name": "dysthymic disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435869/harmonised/GCST90435869.h.tsv.gz"
  },
  {
    "accessionId": "GCST90302892",
    "initial_individuals": "365499",
    "initial_ancestralGroup": "European",
    "pubmedId": "37377600",
    "EFO_ID": "EFO_0007789",
    "EFO_Trait_Name": "BMI-adjusted waist circumference",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90302001-GCST90303000/GCST90302892/harmonised/GCST90302892.h.tsv.gz"
  },
  {
    "accessionId": "GCST90044774",
    "initial_individuals": "362396",
    "initial_ancestralGroup": "European",
    "pubmedId": "34847940",
    "EFO_ID": "EFO_0009720",
    "EFO_Trait_Name": "able to hear with hearing aids",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044774/harmonised/GCST90044774.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691773",
    "initial_individuals": "361940",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0021781",
    "EFO_Trait_Name": "age at initiation of corrective lens use",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691773/harmonised/GCST90691773.h.tsv.gz"
  },
  {
    "accessionId": "GCST90309354",
    "initial_individuals": "360656",
    "initial_ancestralGroup": "European",
    "pubmedId": "38965376",
    "EFO_ID": "EFO_0007863",
    "EFO_Trait_Name": "illness severity status",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90309001-GCST90310000/GCST90309354/harmonised/GCST90309354.h.tsv.gz"
  },
  {
    "accessionId": "GCST90026480",
    "initial_individuals": "358426",
    "initial_ancestralGroup": "European",
    "pubmedId": "34426668",
    "EFO_ID": "OBA_2045293",
    "EFO_Trait_Name": "sexual activity behaviour attribute",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90026001-GCST90027000/GCST90026480/harmonised/GCST90026480.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018787",
    "initial_individuals": "357658",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_1001434",
    "EFO_Trait_Name": "Tendinopathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018787/harmonised/GCST90018787.h.tsv.gz"
  },
  {
    "accessionId": "GCST90309367",
    "initial_individuals": "357605",
    "initial_ancestralGroup": "European",
    "pubmedId": "38965376",
    "EFO_ID": "EFO_0009583",
    "EFO_Trait_Name": "place of residence measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90309001-GCST90310000/GCST90309367/harmonised/GCST90309367.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018904",
    "initial_individuals": "355855",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0008620",
    "EFO_Trait_Name": "Polycystic Kidney Disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018904/harmonised/GCST90018904.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018914",
    "initial_individuals": "354544",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0007510",
    "EFO_Trait_Name": "tinea",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018914/harmonised/GCST90018914.h.tsv.gz"
  },
  {
    "accessionId": "GCST90568461",
    "initial_individuals": "354387",
    "initial_ancestralGroup": "European",
    "pubmedId": "40495383",
    "EFO_ID": "EFO_1000616",
    "EFO_Trait_Name": "uveal melanoma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90568001-GCST90569000/GCST90568461/harmonised/GCST90568461.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018835",
    "initial_individuals": "354015",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0005549",
    "EFO_Trait_Name": "diphtheria",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018835/harmonised/GCST90018835.h.tsv.gz"
  },
  {
    "accessionId": "GCST90165285",
    "initial_individuals": "353621",
    "initial_ancestralGroup": "European",
    "pubmedId": "36450978",
    "EFO_ID": "EFO_0000336",
    "EFO_Trait_Name": "chromosomal aberration",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90165001-GCST90166000/GCST90165285/harmonised/GCST90165285.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018805",
    "initial_individuals": "352013",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0004220",
    "EFO_Trait_Name": "chronic hepatitis C virus infection",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018805/harmonised/GCST90018805.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018804",
    "initial_individuals": "351885",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0004239",
    "EFO_Trait_Name": "chronic hepatitis B virus infection",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018804/harmonised/GCST90018804.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018845",
    "initial_individuals": "351086",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0007016",
    "EFO_Trait_Name": "food allergy measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018845/harmonised/GCST90018845.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018891",
    "initial_individuals": "350272",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0003063",
    "EFO_Trait_Name": "polymyositis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018891/harmonised/GCST90018891.h.tsv.gz"
  },
  {
    "accessionId": "GCST90483501",
    "initial_individuals": "349819",
    "initial_ancestralGroup": "European",
    "pubmedId": "40229599",
    "EFO_ID": "HP_0000132",
    "EFO_Trait_Name": "Menorrhagia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90483001-GCST90484000/GCST90483501/harmonised/GCST90483501.h.tsv.gz"
  },
  {
    "accessionId": "GCST90309369",
    "initial_individuals": "349613",
    "initial_ancestralGroup": "European",
    "pubmedId": "38965376",
    "EFO_ID": "EFO_0803548",
    "EFO_Trait_Name": "neutrophil measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90309001-GCST90310000/GCST90309369/harmonised/GCST90309369.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018931",
    "initial_individuals": "349422",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0006789",
    "EFO_Trait_Name": "typhoid fever",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018931/harmonised/GCST90018931.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018836",
    "initial_individuals": "349422",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_1001869",
    "EFO_Trait_Name": "dysentery",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018836/harmonised/GCST90018836.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018958",
    "initial_individuals": "344182",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0007629",
    "EFO_Trait_Name": "hemoglobin A1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018958/harmonised/GCST90018958.h.tsv.gz"
  },
  {
    "accessionId": "GCST90268400",
    "initial_individuals": "344013",
    "initial_ancestralGroup": "European",
    "pubmedId": "37079300",
    "EFO_ID": "EFO_0009784",
    "EFO_Trait_Name": "central serous retinopathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90268001-GCST90269000/GCST90268400/harmonised/GCST90268400.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018977",
    "initial_individuals": "343836",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0004761",
    "EFO_Trait_Name": "uric acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018977/harmonised/GCST90018977.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018886",
    "initial_individuals": "341610",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009429",
    "EFO_Trait_Name": "Mycobacterium infection",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018886/harmonised/GCST90018886.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018846",
    "initial_individuals": "340541",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "MONDO_0021416",
    "EFO_Trait_Name": "polyp of gallbladder",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018846/harmonised/GCST90018846.h.tsv.gz"
  },
  {
    "accessionId": "GCST90179151",
    "initial_individuals": "337334",
    "initial_ancestralGroup": "European",
    "pubmedId": "36376304",
    "EFO_ID": "EFO_0006525",
    "EFO_Trait_Name": "cigarettes per day measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90179001-GCST90180000/GCST90179151/harmonised/GCST90179151.h.tsv.gz"
  },
  {
    "accessionId": "GCST90277452",
    "initial_individuals": "337126",
    "initial_ancestralGroup": "European",
    "pubmedId": "37985819",
    "EFO_ID": "EFO_0007585",
    "EFO_Trait_Name": "Cannabis use",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90277001-GCST90278000/GCST90277452/harmonised/GCST90277452.h.tsv.gz"
  },
  {
    "accessionId": "GCST90310148",
    "initial_individuals": "330900",
    "initial_ancestralGroup": "European",
    "pubmedId": "39901012",
    "EFO_ID": "EFO_0006784",
    "EFO_Trait_Name": "body height at birth",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90310001-GCST90311000/GCST90310148/harmonised/GCST90310148.h.tsv.gz"
  },
  {
    "accessionId": "GCST90095047",
    "initial_individuals": "330340",
    "initial_ancestralGroup": "European",
    "pubmedId": "35290122",
    "EFO_ID": "HP_0001522",
    "EFO_Trait_Name": "Death in infancy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90095001-GCST90096000/GCST90095047/harmonised/GCST90095047.h.tsv.gz"
  },
  {
    "accessionId": "GCST90309355",
    "initial_individuals": "329172",
    "initial_ancestralGroup": "European",
    "pubmedId": "38965376",
    "EFO_ID": "EFO_0001695",
    "EFO_Trait_Name": "size",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90309001-GCST90310000/GCST90309355/harmonised/GCST90309355.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018940",
    "initial_individuals": "328216",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "HP_0004308",
    "EFO_Trait_Name": "ventricular arrhythmia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018940/harmonised/GCST90018940.h.tsv.gz"
  },
  {
    "accessionId": "GCST90014440",
    "initial_individuals": "324933",
    "initial_ancestralGroup": "European",
    "pubmedId": "34278373",
    "EFO_ID": "EFO_0006812",
    "EFO_Trait_Name": "autoimmune thyroid disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90014001-GCST90015000/GCST90014440/harmonised/GCST90014440.h.tsv.gz"
  },
  {
    "accessionId": "GCST90077614",
    "initial_individuals": "324038",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0009712",
    "EFO_Trait_Name": "father's age at death",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90077001-GCST90078000/GCST90077614/harmonised/GCST90077614.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018798",
    "initial_individuals": "317252",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0003780",
    "EFO_Trait_Name": "Behcet's syndrome",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018798/harmonised/GCST90018798.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475545",
    "initial_individuals": "315668",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0001072",
    "EFO_Trait_Name": "memory impairment",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475545/harmonised/GCST90475545.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475273",
    "initial_individuals": "315668",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009910",
    "EFO_Trait_Name": "chronic lung disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475273/harmonised/GCST90475273.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475239",
    "initial_individuals": "315668",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0600083",
    "EFO_Trait_Name": "family history of prostate cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475239/harmonised/GCST90475239.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475381",
    "initial_individuals": "315668",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0000618",
    "EFO_Trait_Name": "Blindness",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475381/harmonised/GCST90475381.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476936",
    "initial_individuals": "315668",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "HP_0007185",
    "EFO_Trait_Name": "Loss of consciousness",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476936/harmonised/GCST90476936.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476927",
    "initial_individuals": "315668",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0004976",
    "EFO_Trait_Name": "amyotrophic lateral sclerosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476927/harmonised/GCST90476927.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475180",
    "initial_individuals": "315668",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0008903",
    "EFO_Trait_Name": "lung cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475180/harmonised/GCST90475180.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476971",
    "initial_individuals": "315668",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0043510",
    "EFO_Trait_Name": "brain injury",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476971/harmonised/GCST90476971.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476926",
    "initial_individuals": "309636",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0009439",
    "EFO_Trait_Name": "multiple births measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476926/harmonised/GCST90476926.h.tsv.gz"
  },
  {
    "accessionId": "GCST90448958",
    "initial_individuals": "309027",
    "initial_ancestralGroup": "European",
    "pubmedId": "39500877",
    "EFO_ID": "EFO_0003959",
    "EFO_Trait_Name": "cleft lip",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90448001-GCST90449000/GCST90448958/harmonised/GCST90448958.h.tsv.gz"
  },
  {
    "accessionId": "GCST90101826",
    "initial_individuals": "308381",
    "initial_ancestralGroup": "European",
    "pubmedId": "35760791",
    "EFO_ID": "EFO_0021487",
    "EFO_Trait_Name": "cryptic phenotype measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90101001-GCST90102000/GCST90101826/harmonised/GCST90101826.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018990",
    "initial_individuals": "305582",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009933",
    "EFO_Trait_Name": "Thyroid preparation use measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018990/harmonised/GCST90018990.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018998",
    "initial_individuals": "304162",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009940",
    "EFO_Trait_Name": "Antidepressant use measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018998/harmonised/GCST90018998.h.tsv.gz"
  },
  {
    "accessionId": "GCST90568441",
    "initial_individuals": "299017",
    "initial_ancestralGroup": "European",
    "pubmedId": "40962958",
    "EFO_ID": "EFO_0003888",
    "EFO_Trait_Name": "attention deficit hyperactivity disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90568001-GCST90569000/GCST90568441/harmonised/GCST90568441.h.tsv.gz"
  },
  {
    "accessionId": "GCST90454203",
    "initial_individuals": "295291",
    "initial_ancestralGroup": "European",
    "pubmedId": "40069456",
    "EFO_ID": "EFO_0003893",
    "EFO_Trait_Name": "ovarian neoplasm",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90454001-GCST90455000/GCST90454203/harmonised/GCST90454203.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475187",
    "initial_individuals": "293201",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "MONDO_0008315",
    "EFO_Trait_Name": "prostate cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475187/harmonised/GCST90475187.h.tsv.gz"
  },
  {
    "accessionId": "GCST90454226",
    "initial_individuals": "291046",
    "initial_ancestralGroup": "European",
    "pubmedId": "40069456",
    "EFO_ID": "EFO_0005771",
    "EFO_Trait_Name": "ovarian disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90454001-GCST90455000/GCST90454226/harmonised/GCST90454226.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018989",
    "initial_individuals": "290385",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009932",
    "EFO_Trait_Name": "HMG CoA reductase inhibitor use measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018989/harmonised/GCST90018989.h.tsv.gz"
  },
  {
    "accessionId": "GCST90454234",
    "initial_individuals": "287862",
    "initial_ancestralGroup": "European",
    "pubmedId": "40069456",
    "EFO_ID": "HP_0100601",
    "EFO_Trait_Name": "Eclampsia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90454001-GCST90455000/GCST90454234/harmonised/GCST90454234.h.tsv.gz"
  },
  {
    "accessionId": "GCST90454211",
    "initial_individuals": "284356",
    "initial_ancestralGroup": "European",
    "pubmedId": "40069456",
    "EFO_ID": "EFO_0009469",
    "EFO_Trait_Name": "bartholin gland disease",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90454001-GCST90455000/GCST90454211/harmonised/GCST90454211.h.tsv.gz"
  },
  {
    "accessionId": "GCST90454212",
    "initial_individuals": "284261",
    "initial_ancestralGroup": "European",
    "pubmedId": "40069456",
    "EFO_ID": "EFO_0005757",
    "EFO_Trait_Name": "vaginal inflammation",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90454001-GCST90455000/GCST90454212/harmonised/GCST90454212.h.tsv.gz"
  },
  {
    "accessionId": "GCST90454238",
    "initial_individuals": "274607",
    "initial_ancestralGroup": "European",
    "pubmedId": "40069456",
    "EFO_ID": "EFO_0006917",
    "EFO_Trait_Name": "spontaneous preterm birth",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90454001-GCST90455000/GCST90454238/harmonised/GCST90454238.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018991",
    "initial_individuals": "272602",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009934",
    "EFO_Trait_Name": "Immunosuppressant use measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018991/harmonised/GCST90018991.h.tsv.gz"
  },
  {
    "accessionId": "GCST90270865",
    "initial_individuals": "270794",
    "initial_ancestralGroup": "European",
    "pubmedId": "36773317",
    "EFO_ID": "EFO_0004459",
    "EFO_Trait_Name": "ferritin measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90270001-GCST90271000/GCST90270865/harmonised/GCST90270865.h.tsv.gz"
  },
  {
    "accessionId": "GCST90454240",
    "initial_individuals": "270006",
    "initial_ancestralGroup": "European",
    "pubmedId": "40069456",
    "EFO_ID": "EFO_1001754",
    "EFO_Trait_Name": "Abruptio Placentae",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90454001-GCST90455000/GCST90454240/harmonised/GCST90454240.h.tsv.gz"
  },
  {
    "accessionId": "GCST90682412",
    "initial_individuals": "264451",
    "initial_ancestralGroup": "European",
    "pubmedId": "41606330",
    "EFO_ID": "EFO_0008007",
    "EFO_Trait_Name": "age at assessment",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90682001-GCST90683000/GCST90682412/harmonised/GCST90682412.h.tsv.gz"
  },
  {
    "accessionId": "GCST90079060",
    "initial_individuals": "263428",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0009721",
    "EFO_Trait_Name": "mother's age at death",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90079001-GCST90080000/GCST90079060/harmonised/GCST90079060.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018786",
    "initial_individuals": "257561",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_1001491",
    "EFO_Trait_Name": "abortion",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018786/harmonised/GCST90018786.h.tsv.gz"
  },
  {
    "accessionId": "GCST90102253",
    "initial_individuals": "248847",
    "initial_ancestralGroup": "European",
    "pubmedId": "34613391",
    "EFO_ID": "EFO_0020977",
    "EFO_Trait_Name": "occupational attainment",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90102001-GCST90103000/GCST90102253/harmonised/GCST90102253.h.tsv.gz"
  },
  {
    "accessionId": "GCST90043927",
    "initial_individuals": "247540",
    "initial_ancestralGroup": "European",
    "pubmedId": "34737426",
    "EFO_ID": "MONDO_0004658",
    "EFO_Trait_Name": "breast carcinoma in situ",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043927/harmonised/GCST90043927.h.tsv.gz"
  },
  {
    "accessionId": "GCST90079051",
    "initial_individuals": "246319",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0004514",
    "EFO_Trait_Name": "bone quantitative ultrasound measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90079001-GCST90080000/GCST90079051/harmonised/GCST90079051.h.tsv.gz"
  },
  {
    "accessionId": "GCST90079050",
    "initial_individuals": "246319",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0005654",
    "EFO_Trait_Name": "velocity of sound measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90079001-GCST90080000/GCST90079050/harmonised/GCST90079050.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018983",
    "initial_individuals": "242659",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009926",
    "EFO_Trait_Name": "Vasodilators used in cardiac diseases use measurement",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018983/harmonised/GCST90018983.h.tsv.gz"
  },
  {
    "accessionId": "GCST90308774",
    "initial_individuals": "241736",
    "initial_ancestralGroup": "European",
    "pubmedId": "38335777",
    "EFO_ID": "EFO_0010650",
    "EFO_Trait_Name": "creativity measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90308001-GCST90309000/GCST90308774/harmonised/GCST90308774.h.tsv.gz"
  },
  {
    "accessionId": "GCST90502051",
    "initial_individuals": "239268",
    "initial_ancestralGroup": "European",
    "pubmedId": "40545721",
    "EFO_ID": "OBA_VT0010046",
    "EFO_Trait_Name": "fatty acid amount",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90502001-GCST90503000/GCST90502051/harmonised/GCST90502051.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018988",
    "initial_individuals": "237530",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009931",
    "EFO_Trait_Name": "Agents acting on the renin-angiotensin system use measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018988/harmonised/GCST90018988.h.tsv.gz"
  },
  {
    "accessionId": "GCST90319609",
    "initial_individuals": "236452",
    "initial_ancestralGroup": "European",
    "pubmedId": "38584764",
    "EFO_ID": "EFO_0010593",
    "EFO_Trait_Name": "cystatin B measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90319001-GCST90320000/GCST90319609/harmonised/GCST90319609.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018985",
    "initial_individuals": "229086",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009928",
    "EFO_Trait_Name": "Diuretic use measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018985/harmonised/GCST90018985.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018986",
    "initial_individuals": "224024",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009929",
    "EFO_Trait_Name": "Beta blocking agent use measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018986/harmonised/GCST90018986.h.tsv.gz"
  },
  {
    "accessionId": "GCST90454219",
    "initial_individuals": "222924",
    "initial_ancestralGroup": "European",
    "pubmedId": "40069456",
    "EFO_ID": "MONDO_0001836",
    "EFO_Trait_Name": "amenorrhea",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90454001-GCST90455000/GCST90454219/harmonised/GCST90454219.h.tsv.gz"
  },
  {
    "accessionId": "GCST90454224",
    "initial_individuals": "222355",
    "initial_ancestralGroup": "European",
    "pubmedId": "40069456",
    "EFO_ID": "EFO_0021795",
    "EFO_Trait_Name": "tubal factor infertility",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90454001-GCST90455000/GCST90454224/harmonised/GCST90454224.h.tsv.gz"
  },
  {
    "accessionId": "GCST90454217",
    "initial_individuals": "221885",
    "initial_ancestralGroup": "European",
    "pubmedId": "40069456",
    "EFO_ID": "EFO_1000862",
    "EFO_Trait_Name": "cervix erosion",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90454001-GCST90455000/GCST90454217/harmonised/GCST90454217.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475136",
    "initial_individuals": "221657",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0803539",
    "EFO_Trait_Name": "basophil measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475136/harmonised/GCST90475136.h.tsv.gz"
  },
  {
    "accessionId": "GCST90454222",
    "initial_individuals": "221596",
    "initial_ancestralGroup": "European",
    "pubmedId": "40069456",
    "EFO_ID": "EFO_1000954",
    "EFO_Trait_Name": "habitual abortion",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90454001-GCST90455000/GCST90454222/harmonised/GCST90454222.h.tsv.gz"
  },
  {
    "accessionId": "GCST90020028",
    "initial_individuals": "219872",
    "initial_ancestralGroup": "European",
    "pubmedId": "34021172",
    "EFO_ID": "EFO_0008039",
    "EFO_Trait_Name": "BMI-adjusted hip circumference",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90020001-GCST90021000/GCST90020028/harmonised/GCST90020028.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018993",
    "initial_individuals": "215668",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009936",
    "EFO_Trait_Name": "Drugs affecting bone structure and mineralization use measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018993/harmonised/GCST90018993.h.tsv.gz"
  },
  {
    "accessionId": "GCST90483376",
    "initial_individuals": "207119",
    "initial_ancestralGroup": "European",
    "pubmedId": "41350255",
    "EFO_ID": "EFO_0004697",
    "EFO_Trait_Name": "estradiol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90483001-GCST90484000/GCST90483376/harmonised/GCST90483376.h.tsv.gz"
  },
  {
    "accessionId": "GCST90019000",
    "initial_individuals": "205700",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009942",
    "EFO_Trait_Name": "Glucocorticoid use measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90019000/harmonised/GCST90019000.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018987",
    "initial_individuals": "204378",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009930",
    "EFO_Trait_Name": "Calcium channel blocker use measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018987/harmonised/GCST90018987.h.tsv.gz"
  },
  {
    "accessionId": "GCST90572790",
    "initial_individuals": "191449",
    "initial_ancestralGroup": "European",
    "pubmedId": "41238958",
    "EFO_ID": "OBA_1001010",
    "EFO_Trait_Name": "thyroxine amount",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90572001-GCST90573000/GCST90572790/harmonised/GCST90572790.h.tsv.gz"
  },
  {
    "accessionId": "GCST90565841",
    "initial_individuals": "181587",
    "initial_ancestralGroup": "European",
    "pubmedId": "40374629",
    "EFO_ID": "EFO_0009098",
    "EFO_Trait_Name": "cognitive domain measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90565001-GCST90566000/GCST90565841/harmonised/GCST90565841.h.tsv.gz"
  },
  {
    "accessionId": "GCST90572755",
    "initial_individuals": "180580",
    "initial_ancestralGroup": "European",
    "pubmedId": "41249154",
    "EFO_ID": "EFO_0803362",
    "EFO_Trait_Name": "response to COVID-19 vaccine",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90572001-GCST90573000/GCST90572755/harmonised/GCST90572755.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018996",
    "initial_individuals": "179810",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009938",
    "EFO_Trait_Name": "Anilide use measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018996/harmonised/GCST90018996.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018999",
    "initial_individuals": "176445",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009941",
    "EFO_Trait_Name": "Inhalant adrenergic use measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018999/harmonised/GCST90018999.h.tsv.gz"
  },
  {
    "accessionId": "GCST90078247",
    "initial_individuals": "176200",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0004333",
    "EFO_Trait_Name": "episodic memory",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90078001-GCST90079000/GCST90078247/harmonised/GCST90078247.h.tsv.gz"
  },
  {
    "accessionId": "GCST90309836",
    "initial_individuals": "174488",
    "initial_ancestralGroup": "European",
    "pubmedId": "38351177",
    "EFO_ID": "EFO_0005115",
    "EFO_Trait_Name": "metabolic rate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90309001-GCST90310000/GCST90309836/harmonised/GCST90309836.h.tsv.gz"
  },
  {
    "accessionId": "GCST90309924",
    "initial_individuals": "174488",
    "initial_ancestralGroup": "European",
    "pubmedId": "38351177",
    "EFO_ID": "EFO_0008385",
    "EFO_Trait_Name": "visual acuity measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90309001-GCST90310000/GCST90309924/harmonised/GCST90309924.h.tsv.gz"
  },
  {
    "accessionId": "GCST90292553",
    "initial_individuals": "173424",
    "initial_ancestralGroup": "European",
    "pubmedId": "37543033",
    "EFO_ID": "EFO_0004704",
    "EFO_Trait_Name": "age at menopause",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90292001-GCST90293000/GCST90292553/harmonised/GCST90292553.h.tsv.gz"
  },
  {
    "accessionId": "GCST90079161",
    "initial_individuals": "173103",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0009804",
    "EFO_Trait_Name": "pulse wave reflection index measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90079001-GCST90080000/GCST90079161/harmonised/GCST90079161.h.tsv.gz"
  },
  {
    "accessionId": "GCST90078687",
    "initial_individuals": "172449",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0004517",
    "EFO_Trait_Name": "arterial stiffness measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90078001-GCST90079000/GCST90078687/harmonised/GCST90078687.h.tsv.gz"
  },
  {
    "accessionId": "GCST90565484",
    "initial_individuals": "167966",
    "initial_ancestralGroup": "European",
    "pubmedId": "41558814",
    "EFO_ID": "OBA_2045221",
    "EFO_Trait_Name": "bowel opening frequency",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90565001-GCST90566000/GCST90565484/harmonised/GCST90565484.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475390",
    "initial_individuals": "165985",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0008390",
    "EFO_Trait_Name": "prothrombin time measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475390/harmonised/GCST90475390.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018992",
    "initial_individuals": "164520",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009935",
    "EFO_Trait_Name": "Non-steroidal anti-inflammatory and antirheumatic product use measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018992/harmonised/GCST90018992.h.tsv.gz"
  },
  {
    "accessionId": "GCST90179116",
    "initial_individuals": "162335",
    "initial_ancestralGroup": "European",
    "pubmedId": "36150907",
    "EFO_ID": "EFO_0004874",
    "EFO_Trait_Name": "memory performance",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90179001-GCST90180000/GCST90179116/harmonised/GCST90179116.h.tsv.gz"
  },
  {
    "accessionId": "GCST90239823",
    "initial_individuals": "162068",
    "initial_ancestralGroup": "European",
    "pubmedId": "36653534",
    "EFO_ID": "EFO_0007005",
    "EFO_Trait_Name": "free androgen index",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90239001-GCST90240000/GCST90239823/harmonised/GCST90239823.h.tsv.gz"
  },
  {
    "accessionId": "GCST90270117",
    "initial_individuals": "161906",
    "initial_ancestralGroup": "European",
    "pubmedId": "37277458",
    "EFO_ID": "EFO_0010578",
    "EFO_Trait_Name": "complex trait",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90270001-GCST90271000/GCST90270117/harmonised/GCST90270117.h.tsv.gz"
  },
  {
    "accessionId": "GCST90270116",
    "initial_individuals": "161906",
    "initial_ancestralGroup": "European",
    "pubmedId": "37277458",
    "EFO_ID": "EFO_0021796",
    "EFO_Trait_Name": "sexual dimorphism measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90270001-GCST90271000/GCST90270116/harmonised/GCST90270116.h.tsv.gz"
  },
  {
    "accessionId": "GCST90429776",
    "initial_individuals": "161564",
    "initial_ancestralGroup": "European",
    "pubmedId": "38987242",
    "EFO_ID": "EFO_0005937",
    "EFO_Trait_Name": "longitudinal BMI measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90429001-GCST90430000/GCST90429776/harmonised/GCST90429776.h.tsv.gz"
  },
  {
    "accessionId": "GCST90246355",
    "initial_individuals": "161509",
    "initial_ancestralGroup": "European",
    "pubmedId": "36929174",
    "EFO_ID": "HP_0030158",
    "EFO_Trait_Name": "Cervical ectropion",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90246001-GCST90247000/GCST90246355/harmonised/GCST90246355.h.tsv.gz"
  },
  {
    "accessionId": "GCST90246319",
    "initial_individuals": "159715",
    "initial_ancestralGroup": "European",
    "pubmedId": "36918541",
    "EFO_ID": "EFO_0020097",
    "EFO_Trait_Name": "QRS-T angle",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90246001-GCST90247000/GCST90246319/harmonised/GCST90246319.h.tsv.gz"
  },
  {
    "accessionId": "GCST90094816",
    "initial_individuals": "159579",
    "initial_ancestralGroup": "European",
    "pubmedId": "35585065",
    "EFO_ID": "EFO_0010155",
    "EFO_Trait_Name": "taste liking measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90094001-GCST90095000/GCST90094816/harmonised/GCST90094816.h.tsv.gz"
  },
  {
    "accessionId": "GCST90094867",
    "initial_individuals": "158532",
    "initial_ancestralGroup": "European",
    "pubmedId": "35585065",
    "EFO_ID": "EFO_0006948",
    "EFO_Trait_Name": "white wine liking measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90094001-GCST90095000/GCST90094867/harmonised/GCST90094867.h.tsv.gz"
  },
  {
    "accessionId": "GCST90078958",
    "initial_individuals": "158514",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0009440",
    "EFO_Trait_Name": "age at last pregnancy measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90078001-GCST90079000/GCST90078958/harmonised/GCST90078958.h.tsv.gz"
  },
  {
    "accessionId": "GCST90094820",
    "initial_individuals": "158425",
    "initial_ancestralGroup": "European",
    "pubmedId": "35585065",
    "EFO_ID": "EFO_0006947",
    "EFO_Trait_Name": "red wine liking measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90094001-GCST90095000/GCST90094820/harmonised/GCST90094820.h.tsv.gz"
  },
  {
    "accessionId": "GCST90095084",
    "initial_individuals": "154780",
    "initial_ancestralGroup": "European",
    "pubmedId": "35977952",
    "EFO_ID": "EFO_0009048",
    "EFO_Trait_Name": "intrahepatic cholestasis of pregnancy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90095001-GCST90096000/GCST90095084/harmonised/GCST90095084.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018982",
    "initial_individuals": "153639",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009925",
    "EFO_Trait_Name": "Antithrombotic agent use measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018982/harmonised/GCST90018982.h.tsv.gz"
  },
  {
    "accessionId": "GCST90688375",
    "initial_individuals": "153394",
    "initial_ancestralGroup": "European",
    "pubmedId": "41606330",
    "EFO_ID": "EFO_0004529",
    "EFO_Trait_Name": "lipid measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90688001-GCST90689000/GCST90688375/harmonised/GCST90688375.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018984",
    "initial_individuals": "152380",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009927",
    "EFO_Trait_Name": "Antihypertensive use measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018984/harmonised/GCST90018984.h.tsv.gz"
  },
  {
    "accessionId": "GCST90019001",
    "initial_individuals": "151636",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009943",
    "EFO_Trait_Name": "Antihistamine use measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90019001-GCST90020000/GCST90019001/harmonised/GCST90019001.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479460",
    "initial_individuals": "150651",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0021784",
    "EFO_Trait_Name": "age at initiation of smoking",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479460/harmonised/GCST90479460.h.tsv.gz"
  },
  {
    "accessionId": "GCST90454345",
    "initial_individuals": "148877",
    "initial_ancestralGroup": "European",
    "pubmedId": "32424353",
    "EFO_ID": "MONDO_0021116",
    "EFO_Trait_Name": "luminal A breast carcinoma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90454001-GCST90455000/GCST90454345/harmonised/GCST90454345.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475482",
    "initial_individuals": "145581",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0004845",
    "EFO_Trait_Name": "magnesium measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475482/harmonised/GCST90475482.h.tsv.gz"
  },
  {
    "accessionId": "GCST90225523",
    "initial_individuals": "139363",
    "initial_ancestralGroup": "European",
    "pubmedId": "37259642",
    "EFO_ID": "EFO_0007795",
    "EFO_Trait_Name": "anxiety disorder measurement",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90225001-GCST90226000/GCST90225523/harmonised/GCST90225523.h.tsv.gz"
  },
  {
    "accessionId": "GCST90271688",
    "initial_individuals": "139088",
    "initial_ancestralGroup": "European",
    "pubmedId": "38375614",
    "EFO_ID": "EFO_0009587",
    "EFO_Trait_Name": "anhedonia measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90271001-GCST90272000/GCST90271688/harmonised/GCST90271688.h.tsv.gz"
  },
  {
    "accessionId": "GCST90570522",
    "initial_individuals": "136349",
    "initial_ancestralGroup": "European",
    "pubmedId": "41495267",
    "EFO_ID": "HP_0031217",
    "EFO_Trait_Name": "Hot flashes",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90570001-GCST90571000/GCST90570522/harmonised/GCST90570522.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691767",
    "initial_individuals": "136086",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0007946",
    "EFO_Trait_Name": "tiredness measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691767/harmonised/GCST90691767.h.tsv.gz"
  },
  {
    "accessionId": "GCST90079007",
    "initial_individuals": "133436",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0010967",
    "EFO_Trait_Name": "urinary microalbumin measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90079001-GCST90080000/GCST90079007/harmonised/GCST90079007.h.tsv.gz"
  },
  {
    "accessionId": "GCST90566392",
    "initial_individuals": "133184",
    "initial_ancestralGroup": "European",
    "pubmedId": "40497443",
    "EFO_ID": "EFO_0022597",
    "EFO_Trait_Name": "aging",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90566001-GCST90567000/GCST90566392/harmonised/GCST90566392.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018980",
    "initial_individuals": "132367",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009923",
    "EFO_Trait_Name": "Peptic ulcer and gastro-oesophageal reflux disease (GORD) drug use measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018980/harmonised/GCST90018980.h.tsv.gz"
  },
  {
    "accessionId": "GCST90565852",
    "initial_individuals": "131736",
    "initial_ancestralGroup": "European",
    "pubmedId": "40374629",
    "EFO_ID": "EFO_0007710",
    "EFO_Trait_Name": "cognitive decline measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90565001-GCST90566000/GCST90565852/harmonised/GCST90565852.h.tsv.gz"
  },
  {
    "accessionId": "GCST90551833",
    "initial_individuals": "129017",
    "initial_ancestralGroup": "European",
    "pubmedId": "39979475",
    "EFO_ID": "EFO_0007979",
    "EFO_Trait_Name": "childhood trauma measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90551001-GCST90552000/GCST90551833/harmonised/GCST90551833.h.tsv.gz"
  },
  {
    "accessionId": "GCST90081533",
    "initial_individuals": "126399",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0007778",
    "EFO_Trait_Name": "urinary albumin to creatinine ratio",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90081001-GCST90082000/GCST90081533/harmonised/GCST90081533.h.tsv.gz"
  },
  {
    "accessionId": "GCST90244168",
    "initial_individuals": "121312",
    "initial_ancestralGroup": "European",
    "pubmedId": "38723632",
    "EFO_ID": "EFO_1001958",
    "EFO_Trait_Name": "high grade ovarian serous adenocarcinoma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90244001-GCST90245000/GCST90244168/harmonised/GCST90244168.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018997",
    "initial_individuals": "119844",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009939",
    "EFO_Trait_Name": "Antimigraine preparation use measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018997/harmonised/GCST90018997.h.tsv.gz"
  },
  {
    "accessionId": "GCST010100",
    "initial_individuals": "118987",
    "initial_ancestralGroup": "European",
    "pubmedId": "32424353",
    "EFO_ID": "EFO_0005537",
    "EFO_Trait_Name": "triple-negative breast cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST010001-GCST011000/GCST010100/harmonised/GCST010100.h.tsv.gz"
  },
  {
    "accessionId": "GCST90449061",
    "initial_individuals": "113578",
    "initial_ancestralGroup": "European",
    "pubmedId": "39537608",
    "EFO_ID": "OBA_2050108",
    "EFO_Trait_Name": "carotid artery thickness",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90449001-GCST90450000/GCST90449061/harmonised/GCST90449061.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018995",
    "initial_individuals": "112010",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0007013",
    "EFO_Trait_Name": "aspirin use measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018995/harmonised/GCST90018995.h.tsv.gz"
  },
  {
    "accessionId": "GCST90244170",
    "initial_individuals": "108601",
    "initial_ancestralGroup": "European",
    "pubmedId": "38723632",
    "EFO_ID": "EFO_1000416",
    "EFO_Trait_Name": "ovarian endometrioid adenocarcinoma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90244001-GCST90245000/GCST90244170/harmonised/GCST90244170.h.tsv.gz"
  },
  {
    "accessionId": "GCST90244169",
    "initial_individuals": "108473",
    "initial_ancestralGroup": "European",
    "pubmedId": "38723632",
    "EFO_ID": "EFO_0002917",
    "EFO_Trait_Name": "ovarian serous adenocarcinoma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90244001-GCST90245000/GCST90244169/harmonised/GCST90244169.h.tsv.gz"
  },
  {
    "accessionId": "GCST90078969",
    "initial_individuals": "108447",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0004319",
    "EFO_Trait_Name": "smoking cessation",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90078001-GCST90079000/GCST90078969/harmonised/GCST90078969.h.tsv.gz"
  },
  {
    "accessionId": "GCST90244172",
    "initial_individuals": "108311",
    "initial_ancestralGroup": "European",
    "pubmedId": "38723632",
    "EFO_ID": "EFO_0006462",
    "EFO_Trait_Name": "ovarian mucinous adenocarcinoma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90244001-GCST90245000/GCST90244172/harmonised/GCST90244172.h.tsv.gz"
  },
  {
    "accessionId": "GCST90244171",
    "initial_individuals": "107151",
    "initial_ancestralGroup": "European",
    "pubmedId": "38723632",
    "EFO_ID": "MONDO_0000548",
    "EFO_Trait_Name": "ovarian clear cell cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90244001-GCST90245000/GCST90244171/harmonised/GCST90244171.h.tsv.gz"
  },
  {
    "accessionId": "GCST90079334",
    "initial_individuals": "105888",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0004695",
    "EFO_Trait_Name": "intraocular pressure measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90079001-GCST90080000/GCST90079334/harmonised/GCST90079334.h.tsv.gz"
  },
  {
    "accessionId": "GCST90079335",
    "initial_individuals": "105888",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0010066",
    "EFO_Trait_Name": "corneal hysteresis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90079001-GCST90080000/GCST90079335/harmonised/GCST90079335.h.tsv.gz"
  },
  {
    "accessionId": "GCST90079336",
    "initial_individuals": "105888",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0010067",
    "EFO_Trait_Name": "corneal resistance factor",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90079001-GCST90080000/GCST90079336/harmonised/GCST90079336.h.tsv.gz"
  },
  {
    "accessionId": "GCST90454347",
    "initial_individuals": "105277",
    "initial_ancestralGroup": "European",
    "pubmedId": "32424353",
    "EFO_ID": "MONDO_0021115",
    "EFO_Trait_Name": "luminal B breast carcinoma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90454001-GCST90455000/GCST90454347/harmonised/GCST90454347.h.tsv.gz"
  },
  {
    "accessionId": "GCST90081480",
    "initial_individuals": "103540",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_1002040",
    "EFO_Trait_Name": "corneal astigmatism",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90081001-GCST90082000/GCST90081480/harmonised/GCST90081480.h.tsv.gz"
  },
  {
    "accessionId": "GCST90503316",
    "initial_individuals": "102635",
    "initial_ancestralGroup": "European",
    "pubmedId": "40316537",
    "EFO_ID": "MONDO_0002146",
    "EFO_Trait_Name": "hypogonadism",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90503001-GCST90504000/GCST90503316/harmonised/GCST90503316.h.tsv.gz"
  },
  {
    "accessionId": "GCST90019002",
    "initial_individuals": "100868",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009944",
    "EFO_Trait_Name": "Antiglaucoma preparations and miotics use measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90019001-GCST90020000/GCST90019002/harmonised/GCST90019002.h.tsv.gz"
  },
  {
    "accessionId": "GCST90454348",
    "initial_individuals": "97877",
    "initial_ancestralGroup": "European",
    "pubmedId": "32424353",
    "EFO_ID": "EFO_1000294",
    "EFO_Trait_Name": "HER2 positive breast carcinoma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90454001-GCST90455000/GCST90454348/harmonised/GCST90454348.h.tsv.gz"
  },
  {
    "accessionId": "GCST90451683",
    "initial_individuals": "91675",
    "initial_ancestralGroup": "European",
    "pubmedId": "39643614",
    "EFO_ID": "EFO_0020440",
    "EFO_Trait_Name": "hepcidin measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90451001-GCST90452000/GCST90451683/harmonised/GCST90451683.h.tsv.gz"
  },
  {
    "accessionId": "GCST90165291",
    "initial_individuals": "86165",
    "initial_ancestralGroup": "European",
    "pubmedId": "36271874",
    "EFO_ID": "EFO_0004682",
    "EFO_Trait_Name": "QT interval",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90165001-GCST90166000/GCST90165291/harmonised/GCST90165291.h.tsv.gz"
  },
  {
    "accessionId": "GCST90691870",
    "initial_individuals": "85881",
    "initial_ancestralGroup": "European",
    "pubmedId": "40968291",
    "EFO_ID": "EFO_0007814",
    "EFO_Trait_Name": "refractive error measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90691001-GCST90692000/GCST90691870/harmonised/GCST90691870.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475405",
    "initial_individuals": "84125",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "OBA_2050055",
    "EFO_Trait_Name": "serum iron amount",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475405/harmonised/GCST90475405.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476413",
    "initial_individuals": "82594",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0004534",
    "EFO_Trait_Name": "creatine kinase measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476413/harmonised/GCST90476413.h.tsv.gz"
  },
  {
    "accessionId": "GCST90179120",
    "initial_individuals": "81701",
    "initial_ancestralGroup": "European",
    "pubmedId": "36150907",
    "EFO_ID": "EFO_0004335",
    "EFO_Trait_Name": "short-term memory",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90179001-GCST90180000/GCST90179120/harmonised/GCST90179120.h.tsv.gz"
  },
  {
    "accessionId": "GCST007406",
    "initial_individuals": "81099",
    "initial_ancestralGroup": "European",
    "pubmedId": "30729179",
    "EFO_ID": "EFO_0009762",
    "EFO_Trait_Name": "healthspan",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST007001-GCST008000/GCST007406/harmonised/GCST007406.h.tsv.gz"
  },
  {
    "accessionId": "GCST90079419",
    "initial_individuals": "80492",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_0009184",
    "EFO_Trait_Name": "heart rate response to exercise",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90079001-GCST90080000/GCST90079419/harmonised/GCST90079419.h.tsv.gz"
  },
  {
    "accessionId": "GCST90309361",
    "initial_individuals": "80058",
    "initial_ancestralGroup": "European",
    "pubmedId": "38965376",
    "EFO_ID": "HP_0000529",
    "EFO_Trait_Name": "progressive visual loss",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90309001-GCST90310000/GCST90309361/harmonised/GCST90309361.h.tsv.gz"
  },
  {
    "accessionId": "GCST90446641",
    "initial_individuals": "79940",
    "initial_ancestralGroup": "European",
    "pubmedId": "39349818",
    "EFO_ID": "EFO_0007785",
    "EFO_Trait_Name": "femoral neck bone mineral density",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90446001-GCST90447000/GCST90446641/harmonised/GCST90446641.h.tsv.gz"
  },
  {
    "accessionId": "GCST90018994",
    "initial_individuals": "78808",
    "initial_ancestralGroup": "European",
    "pubmedId": "34594039",
    "EFO_ID": "EFO_0009937",
    "EFO_Trait_Name": "Opioid use measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90018001-GCST90019000/GCST90018994/harmonised/GCST90018994.h.tsv.gz"
  },
  {
    "accessionId": "GCST90301958",
    "initial_individuals": "74743",
    "initial_ancestralGroup": "European",
    "pubmedId": "38448586",
    "EFO_ID": "EFO_0020875",
    "EFO_Trait_Name": "fatty acid change measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90301001-GCST90302000/GCST90301958/harmonised/GCST90301958.h.tsv.gz"
  },
  {
    "accessionId": "GCST90301953",
    "initial_individuals": "74743",
    "initial_ancestralGroup": "European",
    "pubmedId": "38448586",
    "EFO_ID": "OBA_2040178",
    "EFO_Trait_Name": "level of diglyceride",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90301001-GCST90302000/GCST90301953/harmonised/GCST90301953.h.tsv.gz"
  },
  {
    "accessionId": "GCST90565863",
    "initial_individuals": "72792",
    "initial_ancestralGroup": "European",
    "pubmedId": "40374629",
    "EFO_ID": "OBA_0005494",
    "EFO_Trait_Name": "aging rate",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90565001-GCST90566000/GCST90565863/harmonised/GCST90565863.h.tsv.gz"
  },
  {
    "accessionId": "GCST005076",
    "initial_individuals": "72261",
    "initial_ancestralGroup": "European",
    "pubmedId": "29058716",
    "EFO_ID": "EFO_1000650",
    "EFO_Trait_Name": "estrogen-receptor negative breast cancer",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST005001-GCST006000/GCST005076/harmonised/GCST005076.h.tsv.gz"
  },
  {
    "accessionId": "GCST90651078",
    "initial_individuals": "70560",
    "initial_ancestralGroup": "European",
    "pubmedId": "40335706",
    "EFO_ID": "EFO_0008237",
    "EFO_Trait_Name": "motor development measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90651001-GCST90652000/GCST90651078/harmonised/GCST90651078.h.tsv.gz"
  },
  {
    "accessionId": "GCST90483490",
    "initial_individuals": "69004",
    "initial_ancestralGroup": "European",
    "pubmedId": "40229599",
    "EFO_ID": "EFO_0004768",
    "EFO_Trait_Name": "follicle stimulating hormone measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90483001-GCST90484000/GCST90483490/harmonised/GCST90483490.h.tsv.gz"
  },
  {
    "accessionId": "GCST90446768",
    "initial_individuals": "68249",
    "initial_ancestralGroup": "European",
    "pubmedId": "39505872",
    "EFO_ID": "EFO_0010554",
    "EFO_Trait_Name": "retinal vasculature measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90446001-GCST90447000/GCST90446768/harmonised/GCST90446768.h.tsv.gz"
  },
  {
    "accessionId": "GCST90432158",
    "initial_individuals": "66507",
    "initial_ancestralGroup": "European",
    "pubmedId": "39537604",
    "EFO_ID": "EFO_1001490",
    "EFO_Trait_Name": "late-onset myasthenia gravis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90432001-GCST90433000/GCST90432158/harmonised/GCST90432158.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267930",
    "initial_individuals": "65791",
    "initial_ancestralGroup": "European",
    "pubmedId": "37337106",
    "EFO_ID": "EFO_0005035",
    "EFO_Trait_Name": "hippocampal volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267930/harmonised/GCST90267930.h.tsv.gz"
  },
  {
    "accessionId": "GCST90129592",
    "initial_individuals": "65680",
    "initial_ancestralGroup": "European",
    "pubmedId": "34077760",
    "EFO_ID": "EFO_0006939",
    "EFO_Trait_Name": "cup-to-disc ratio measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129592/harmonised/GCST90129592.h.tsv.gz"
  },
  {
    "accessionId": "GCST90275197",
    "initial_individuals": "65651",
    "initial_ancestralGroup": "European",
    "pubmedId": "37798380",
    "EFO_ID": "EFO_0007959",
    "EFO_Trait_Name": "fetal genotype effect measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90275001-GCST90276000/GCST90275197/harmonised/GCST90275197.h.tsv.gz"
  },
  {
    "accessionId": "GCST90268467",
    "initial_individuals": "65137",
    "initial_ancestralGroup": "European",
    "pubmedId": "37587338",
    "EFO_ID": "EFO_0600008",
    "EFO_Trait_Name": "mitochondrial heteroplasmy measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90268001-GCST90269000/GCST90268467/harmonised/GCST90268467.h.tsv.gz"
  },
  {
    "accessionId": "GCST90054778",
    "initial_individuals": "64641",
    "initial_ancestralGroup": "European",
    "pubmedId": "35378236",
    "EFO_ID": "EFO_0020971",
    "EFO_Trait_Name": "internalizing disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90054001-GCST90055000/GCST90054778/harmonised/GCST90054778.h.tsv.gz"
  },
  {
    "accessionId": "GCST90002227",
    "initial_individuals": "63396",
    "initial_ancestralGroup": "European",
    "pubmedId": "34059833",
    "EFO_ID": "EFO_0004307",
    "EFO_Trait_Name": "glucose tolerance test",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90002001-GCST90003000/GCST90002227/harmonised/GCST90002227.h.tsv.gz"
  },
  {
    "accessionId": "GCST90012612",
    "initial_individuals": "62164",
    "initial_ancestralGroup": "European",
    "pubmedId": "33441150",
    "EFO_ID": "EFO_0803344",
    "EFO_Trait_Name": "anion gap measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90012001-GCST90013000/GCST90012612/harmonised/GCST90012612.h.tsv.gz"
  },
  {
    "accessionId": "GCST90275198",
    "initial_individuals": "61241",
    "initial_ancestralGroup": "European",
    "pubmedId": "37798380",
    "EFO_ID": "EFO_0005939",
    "EFO_Trait_Name": "parental genotype effect measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90275001-GCST90276000/GCST90275198/harmonised/GCST90275198.h.tsv.gz"
  },
  {
    "accessionId": "GCST90483492",
    "initial_individuals": "58500",
    "initial_ancestralGroup": "European",
    "pubmedId": "40229599",
    "EFO_ID": "OBA_1001009",
    "EFO_Trait_Name": "Luteinizing hormone amount",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90483001-GCST90484000/GCST90483492/harmonised/GCST90483492.h.tsv.gz"
  },
  {
    "accessionId": "GCST90652517",
    "initial_individuals": "56029",
    "initial_ancestralGroup": "European",
    "pubmedId": "40754711",
    "EFO_ID": "GO_0036273",
    "EFO_Trait_Name": "response to statin",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90652001-GCST90653000/GCST90652517/harmonised/GCST90652517.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476442",
    "initial_individuals": "55782",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0006333",
    "EFO_Trait_Name": "transferrin saturation measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476442/harmonised/GCST90476442.h.tsv.gz"
  },
  {
    "accessionId": "GCST90446639",
    "initial_individuals": "55688",
    "initial_ancestralGroup": "European",
    "pubmedId": "39349818",
    "EFO_ID": "EFO_0020105",
    "EFO_Trait_Name": "trunk bone mineral density",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90446001-GCST90447000/GCST90446639/harmonised/GCST90446639.h.tsv.gz"
  },
  {
    "accessionId": "GCST90134327",
    "initial_individuals": "55579",
    "initial_ancestralGroup": "European",
    "pubmedId": "36238604",
    "EFO_ID": "MONDO_0019640",
    "EFO_Trait_Name": "posterior urethral valve",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90134001-GCST90135000/GCST90134327/harmonised/GCST90134327.h.tsv.gz"
  },
  {
    "accessionId": "GCST90446638",
    "initial_individuals": "54408",
    "initial_ancestralGroup": "European",
    "pubmedId": "39349818",
    "EFO_ID": "EFO_0007701",
    "EFO_Trait_Name": "spine bone mineral density",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90446001-GCST90447000/GCST90446638/harmonised/GCST90446638.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267574",
    "initial_individuals": "53710",
    "initial_ancestralGroup": "European",
    "pubmedId": "37291194",
    "EFO_ID": "HP_0000855",
    "EFO_Trait_Name": "Insulin resistance",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267574/harmonised/GCST90267574.h.tsv.gz"
  },
  {
    "accessionId": "GCST90448693",
    "initial_individuals": "53207",
    "initial_ancestralGroup": "European",
    "pubmedId": "39384777",
    "EFO_ID": "EFO_0803360",
    "EFO_Trait_Name": "SARS-CoV-2 antibody measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90448001-GCST90449000/GCST90448693/harmonised/GCST90448693.h.tsv.gz"
  },
  {
    "accessionId": "GCST90281365",
    "initial_individuals": "50745",
    "initial_ancestralGroup": "European",
    "pubmedId": "37619450",
    "EFO_ID": "EFO_0007873",
    "EFO_Trait_Name": "cartilage thickness measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90281001-GCST90282000/GCST90281365/harmonised/GCST90281365.h.tsv.gz"
  },
  {
    "accessionId": "GCST90446636",
    "initial_individuals": "50593",
    "initial_ancestralGroup": "European",
    "pubmedId": "39349818",
    "EFO_ID": "EFO_0020104",
    "EFO_Trait_Name": "pelvis bone mineral density",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90446001-GCST90447000/GCST90446636/harmonised/GCST90446636.h.tsv.gz"
  },
  {
    "accessionId": "GCST90244658",
    "initial_individuals": "50412",
    "initial_ancestralGroup": "European",
    "pubmedId": "37286573",
    "EFO_ID": "EFO_0008098",
    "EFO_Trait_Name": "complement factor H-related protein 5 measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90244001-GCST90245000/GCST90244658/harmonised/GCST90244658.h.tsv.gz"
  },
  {
    "accessionId": "GCST90446631",
    "initial_individuals": "50070",
    "initial_ancestralGroup": "European",
    "pubmedId": "39349818",
    "EFO_ID": "EFO_0020095",
    "EFO_Trait_Name": "trochanter bone mineral density",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90446001-GCST90447000/GCST90446631/harmonised/GCST90446631.h.tsv.gz"
  },
  {
    "accessionId": "GCST007435",
    "initial_individuals": "48434",
    "initial_ancestralGroup": "European",
    "pubmedId": "30510157",
    "EFO_ID": "EFO_0009783",
    "EFO_Trait_Name": "carotid atherosclerosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST007001-GCST008000/GCST007435/harmonised/GCST007435.h.tsv.gz"
  },
  {
    "accessionId": "GCST90079068",
    "initial_individuals": "46881",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "OBA_2045215",
    "EFO_Trait_Name": "menstrual cycle attribute",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90079001-GCST90080000/GCST90079068/harmonised/GCST90079068.h.tsv.gz"
  },
  {
    "accessionId": "GCST90672012",
    "initial_individuals": "46685",
    "initial_ancestralGroup": "European",
    "pubmedId": "41188267",
    "EFO_ID": "EFO_0004346",
    "EFO_Trait_Name": "neuroimaging measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90672001-GCST90673000/GCST90672012/harmonised/GCST90672012.h.tsv.gz"
  },
  {
    "accessionId": "GCST90281264",
    "initial_individuals": "46075",
    "initial_ancestralGroup": "European",
    "pubmedId": "37803156",
    "EFO_ID": "EFO_0008003",
    "EFO_Trait_Name": "heart rate variability measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90281001-GCST90282000/GCST90281264/harmonised/GCST90281264.h.tsv.gz"
  },
  {
    "accessionId": "GCST90475307",
    "initial_individuals": "45436",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "OBA_2045235",
    "EFO_Trait_Name": "blood sedimentation trait",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90475001-GCST90476000/GCST90475307/harmonised/GCST90475307.h.tsv.gz"
  },
  {
    "accessionId": "GCST90451684",
    "initial_individuals": "45330",
    "initial_ancestralGroup": "European",
    "pubmedId": "39643614",
    "EFO_ID": "EFO_0004460",
    "EFO_Trait_Name": "soluble transferrin receptor measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90451001-GCST90452000/GCST90451684/harmonised/GCST90451684.h.tsv.gz"
  },
  {
    "accessionId": "GCST90250898",
    "initial_individuals": "44643",
    "initial_ancestralGroup": "European",
    "pubmedId": "37105979",
    "EFO_ID": "EFO_0022611",
    "EFO_Trait_Name": "Magnetic Resonance Imaging of the Heart",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90250001-GCST90251000/GCST90250898/harmonised/GCST90250898.h.tsv.gz"
  },
  {
    "accessionId": "GCST90078642",
    "initial_individuals": "44277",
    "initial_ancestralGroup": "European",
    "pubmedId": "34662886",
    "EFO_ID": "EFO_1001917",
    "EFO_Trait_Name": "social anxiety disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90078001-GCST90079000/GCST90078642/harmonised/GCST90078642.h.tsv.gz"
  },
  {
    "accessionId": "GCST90129635",
    "initial_individuals": "44214",
    "initial_ancestralGroup": "European",
    "pubmedId": "36662418",
    "EFO_ID": "EFO_0020071",
    "EFO_Trait_Name": "alpha angle measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129635/harmonised/GCST90129635.h.tsv.gz"
  },
  {
    "accessionId": "GCST90455726",
    "initial_individuals": "43153",
    "initial_ancestralGroup": "European",
    "pubmedId": "39904976",
    "EFO_ID": "OBA_2050110",
    "EFO_Trait_Name": "retinal layer thickness",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90455001-GCST90456000/GCST90455726/harmonised/GCST90455726.h.tsv.gz"
  },
  {
    "accessionId": "GCST90278516",
    "initial_individuals": "42194",
    "initial_ancestralGroup": "European",
    "pubmedId": "38036550",
    "EFO_ID": "EFO_0008205",
    "EFO_Trait_Name": "left ventricular structural measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90278001-GCST90279000/GCST90278516/harmonised/GCST90278516.h.tsv.gz"
  },
  {
    "accessionId": "GCST90244711",
    "initial_individuals": "41855",
    "initial_ancestralGroup": "European",
    "pubmedId": "36944631",
    "EFO_ID": "EFO_0009289",
    "EFO_Trait_Name": "left ventricular mass",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90244001-GCST90245000/GCST90244711/harmonised/GCST90244711.h.tsv.gz"
  },
  {
    "accessionId": "GCST90244710",
    "initial_individuals": "41855",
    "initial_ancestralGroup": "European",
    "pubmedId": "36944631",
    "EFO_ID": "EFO_0009290",
    "EFO_Trait_Name": "left ventricular mass index",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90244001-GCST90245000/GCST90244710/harmonised/GCST90244710.h.tsv.gz"
  },
  {
    "accessionId": "GCST90012767",
    "initial_individuals": "40547",
    "initial_ancestralGroup": "European",
    "pubmedId": "33441150",
    "EFO_ID": "OBA_2045259",
    "EFO_Trait_Name": "urine relative density",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90012001-GCST90013000/GCST90012767/harmonised/GCST90012767.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267389",
    "initial_individuals": "40028",
    "initial_ancestralGroup": "European",
    "pubmedId": "37019578",
    "EFO_ID": "EFO_0020865",
    "EFO_Trait_Name": "aortic measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267389/harmonised/GCST90267389.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267391",
    "initial_individuals": "39893",
    "initial_ancestralGroup": "European",
    "pubmedId": "37019578",
    "EFO_ID": "OBA_2050002",
    "EFO_Trait_Name": "descending aorta diameter",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267391/harmonised/GCST90267391.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267894",
    "initial_individuals": "38977",
    "initial_ancestralGroup": "European",
    "pubmedId": "37337106",
    "EFO_ID": "EFO_0009394",
    "EFO_Trait_Name": "hippocampal CA1 volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267894/harmonised/GCST90267894.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267897",
    "initial_individuals": "38977",
    "initial_ancestralGroup": "European",
    "pubmedId": "37337106",
    "EFO_ID": "EFO_0009395",
    "EFO_Trait_Name": "hippocampal CA3 volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267897/harmonised/GCST90267897.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267898",
    "initial_individuals": "38977",
    "initial_ancestralGroup": "European",
    "pubmedId": "37337106",
    "EFO_ID": "EFO_0009396",
    "EFO_Trait_Name": "hippocampal CA4 volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267898/harmonised/GCST90267898.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267925",
    "initial_individuals": "38977",
    "initial_ancestralGroup": "European",
    "pubmedId": "37337106",
    "EFO_ID": "EFO_0009401",
    "EFO_Trait_Name": "hippocampal amigdala transition area volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267925/harmonised/GCST90267925.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267924",
    "initial_individuals": "38977",
    "initial_ancestralGroup": "European",
    "pubmedId": "37337106",
    "EFO_ID": "OBA_2045237",
    "EFO_Trait_Name": "dentate gyrus volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267924/harmonised/GCST90267924.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267900",
    "initial_individuals": "38977",
    "initial_ancestralGroup": "European",
    "pubmedId": "37337106",
    "EFO_ID": "OBA_2045245",
    "EFO_Trait_Name": "hippocampus fimbria volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267900/harmonised/GCST90267900.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267933",
    "initial_individuals": "38977",
    "initial_ancestralGroup": "European",
    "pubmedId": "37337106",
    "EFO_ID": "OBA_2050005",
    "EFO_Trait_Name": "parasubiculum volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267933/harmonised/GCST90267933.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267937",
    "initial_individuals": "38977",
    "initial_ancestralGroup": "European",
    "pubmedId": "37337106",
    "EFO_ID": "OBA_2050024",
    "EFO_Trait_Name": "subiculum volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267937/harmonised/GCST90267937.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267912",
    "initial_individuals": "38977",
    "initial_ancestralGroup": "European",
    "pubmedId": "37337106",
    "EFO_ID": "OBA_2050049",
    "EFO_Trait_Name": "presubiculum volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267912/harmonised/GCST90267912.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267909",
    "initial_individuals": "38977",
    "initial_ancestralGroup": "European",
    "pubmedId": "37337106",
    "EFO_ID": "OBA_2050050",
    "EFO_Trait_Name": "hippocampus molecular layer volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267909/harmonised/GCST90267909.h.tsv.gz"
  },
  {
    "accessionId": "GCST90244153",
    "initial_individuals": "38903",
    "initial_ancestralGroup": "European",
    "pubmedId": "37069360",
    "EFO_ID": "EFO_0803382",
    "EFO_Trait_Name": "perivascular space measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90244001-GCST90245000/GCST90244153/harmonised/GCST90244153.h.tsv.gz"
  },
  {
    "accessionId": "GCST90667997",
    "initial_individuals": "38816",
    "initial_ancestralGroup": "European",
    "pubmedId": "41077127",
    "EFO_ID": "OBA_2050015",
    "EFO_Trait_Name": "kidney volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90667001-GCST90668000/GCST90667997/harmonised/GCST90667997.h.tsv.gz"
  },
  {
    "accessionId": "GCST90667998",
    "initial_individuals": "38816",
    "initial_ancestralGroup": "European",
    "pubmedId": "41077127",
    "EFO_ID": "OBA_2100003",
    "EFO_Trait_Name": "cortex of kidney volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90667001-GCST90668000/GCST90667998/harmonised/GCST90667998.h.tsv.gz"
  },
  {
    "accessionId": "GCST90667999",
    "initial_individuals": "38816",
    "initial_ancestralGroup": "European",
    "pubmedId": "41077127",
    "EFO_ID": "OBA_2100004",
    "EFO_Trait_Name": "renal medulla volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90667001-GCST90668000/GCST90667999/harmonised/GCST90667999.h.tsv.gz"
  },
  {
    "accessionId": "GCST90668000",
    "initial_individuals": "38816",
    "initial_ancestralGroup": "European",
    "pubmedId": "41077127",
    "EFO_ID": "OBA_2100005",
    "EFO_Trait_Name": "renal sinus volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90667001-GCST90668000/GCST90668000/harmonised/GCST90668000.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267390",
    "initial_individuals": "38372",
    "initial_ancestralGroup": "European",
    "pubmedId": "37019578",
    "EFO_ID": "OBA_2050001",
    "EFO_Trait_Name": "ascending aorta diameter",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267390/harmonised/GCST90267390.h.tsv.gz"
  },
  {
    "accessionId": "GCST90474404",
    "initial_individuals": "38206",
    "initial_ancestralGroup": "European",
    "pubmedId": "40770095",
    "EFO_ID": "EFO_0005767",
    "EFO_Trait_Name": "rheumatoid factor measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90474001-GCST90475000/GCST90474404/harmonised/GCST90474404.h.tsv.gz"
  },
  {
    "accessionId": "GCST90482712",
    "initial_individuals": "38175",
    "initial_ancestralGroup": "European",
    "pubmedId": "39574169",
    "EFO_ID": "EFO_0004685",
    "EFO_Trait_Name": "hip geometry",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90482001-GCST90483000/GCST90482712/harmonised/GCST90482712.h.tsv.gz"
  },
  {
    "accessionId": "GCST90566690",
    "initial_individuals": "37367",
    "initial_ancestralGroup": "European",
    "pubmedId": "40360725",
    "EFO_ID": "EFO_0005420",
    "EFO_Trait_Name": "grey matter volume measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90566001-GCST90567000/GCST90566690/harmonised/GCST90566690.h.tsv.gz"
  },
  {
    "accessionId": "GCST90566688",
    "initial_individuals": "37366",
    "initial_ancestralGroup": "European",
    "pubmedId": "40360725",
    "EFO_ID": "EFO_0005089",
    "EFO_Trait_Name": "whole-brain volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90566001-GCST90567000/GCST90566688/harmonised/GCST90566688.h.tsv.gz"
  },
  {
    "accessionId": "GCST90566694",
    "initial_individuals": "37362",
    "initial_ancestralGroup": "European",
    "pubmedId": "40360725",
    "EFO_ID": "EFO_0008320",
    "EFO_Trait_Name": "white matter volume measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90566001-GCST90567000/GCST90566694/harmonised/GCST90566694.h.tsv.gz"
  },
  {
    "accessionId": "GCST90472808",
    "initial_individuals": "37355",
    "initial_ancestralGroup": "European",
    "pubmedId": "38527140",
    "EFO_ID": "EFO_0005665",
    "EFO_Trait_Name": "white matter hyperintensity measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90472001-GCST90473000/GCST90472808/harmonised/GCST90472808.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085866",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "EFO_0004830",
    "EFO_Trait_Name": "caudate nucleus volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085866/harmonised/GCST90085866.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085900",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "EFO_0006935",
    "EFO_Trait_Name": "thalamus volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085900/harmonised/GCST90085900.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085823",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2045238",
    "EFO_Trait_Name": "caudal anterior cingulate cortex volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085823/harmonised/GCST90085823.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085824",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2045239",
    "EFO_Trait_Name": "caudal middle frontal gyrus volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085824/harmonised/GCST90085824.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085830",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2045240",
    "EFO_Trait_Name": "fusiform gyrus volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085830/harmonised/GCST90085830.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085877",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2045241",
    "EFO_Trait_Name": "lateral occipital cortex volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085877/harmonised/GCST90085877.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085837",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2045242",
    "EFO_Trait_Name": "lateral orbital frontal cortex volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085837/harmonised/GCST90085837.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085822",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2045246",
    "EFO_Trait_Name": "banks of the superior temporal sulcus volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085822/harmonised/GCST90085822.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085835",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2045250",
    "EFO_Trait_Name": "isthmus cingulate cortex volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085835/harmonised/GCST90085835.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085845",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2045251",
    "EFO_Trait_Name": "pars orbitalis volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085845/harmonised/GCST90085845.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085901",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2045252",
    "EFO_Trait_Name": "transverse temporal cortex volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085901/harmonised/GCST90085901.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085868",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2045253",
    "EFO_Trait_Name": "ventral diencephalon volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085868/harmonised/GCST90085868.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085892",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050004",
    "EFO_Trait_Name": "precuneus cortex volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085892/harmonised/GCST90085892.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085856",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050007",
    "EFO_Trait_Name": "superior parietal cortex volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085856/harmonised/GCST90085856.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085842",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050008",
    "EFO_Trait_Name": "paracentral lobule volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085842/harmonised/GCST90085842.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085829",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050011",
    "EFO_Trait_Name": "frontal pole volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085829/harmonised/GCST90085829.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085846",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050013",
    "EFO_Trait_Name": "pars triangularis volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085846/harmonised/GCST90085846.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085893",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050016",
    "EFO_Trait_Name": "putamen volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085893/harmonised/GCST90085893.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085853",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050017",
    "EFO_Trait_Name": "rostral anterior cingulate cortex volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085853/harmonised/GCST90085853.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085898",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050019",
    "EFO_Trait_Name": "superior temporal gyrus volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085898/harmonised/GCST90085898.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085861",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050020",
    "EFO_Trait_Name": "nucleus accumbens volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085861/harmonised/GCST90085861.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085819",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050021",
    "EFO_Trait_Name": "brain stem volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085819/harmonised/GCST90085819.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085884",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050022",
    "EFO_Trait_Name": "parahippocampal gyrus volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085884/harmonised/GCST90085884.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085847",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050023",
    "EFO_Trait_Name": "pericalcarine cortex volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085847/harmonised/GCST90085847.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085895",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050026",
    "EFO_Trait_Name": "rostral middle frontal gyrus volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085895/harmonised/GCST90085895.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085882",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050027",
    "EFO_Trait_Name": "pallidum volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085882/harmonised/GCST90085882.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085826",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050028",
    "EFO_Trait_Name": "cuneus cortex volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085826/harmonised/GCST90085826.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085879",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050029",
    "EFO_Trait_Name": "lingual gyrus volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085879/harmonised/GCST90085879.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085858",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050030",
    "EFO_Trait_Name": "supramarginal gyrus volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085858/harmonised/GCST90085858.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085844",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050031",
    "EFO_Trait_Name": "pars opercularis volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085844/harmonised/GCST90085844.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085889",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050032",
    "EFO_Trait_Name": "postcentral gyrus volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085889/harmonised/GCST90085889.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085862",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050034",
    "EFO_Trait_Name": "amygdala volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085862/harmonised/GCST90085862.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085855",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050035",
    "EFO_Trait_Name": "superior frontal gyrus volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085855/harmonised/GCST90085855.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085869",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050036",
    "EFO_Trait_Name": "entorhinal cortex volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085869/harmonised/GCST90085869.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085880",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050037",
    "EFO_Trait_Name": "medial orbital frontal cortex volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085880/harmonised/GCST90085880.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085890",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050038",
    "EFO_Trait_Name": "posterior cingulate cortex volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085890/harmonised/GCST90085890.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085832",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050040",
    "EFO_Trait_Name": "inferior parietal cortex volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085832/harmonised/GCST90085832.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085891",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050042",
    "EFO_Trait_Name": "precentral gyrus volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085891/harmonised/GCST90085891.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085840",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050044",
    "EFO_Trait_Name": "middle temporal gyrus volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085840/harmonised/GCST90085840.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085834",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050045",
    "EFO_Trait_Name": "insular cortex volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085834/harmonised/GCST90085834.h.tsv.gz"
  },
  {
    "accessionId": "GCST90085874",
    "initial_individuals": "36778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36987996",
    "EFO_ID": "OBA_2050048",
    "EFO_Trait_Name": "inferior temporal gyrus volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90085001-GCST90086000/GCST90085874/harmonised/GCST90085874.h.tsv.gz"
  },
  {
    "accessionId": "GCST90472810",
    "initial_individuals": "36533",
    "initial_ancestralGroup": "European",
    "pubmedId": "38527140",
    "EFO_ID": "EFO_0004641",
    "EFO_Trait_Name": "white matter integrity",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90472001-GCST90473000/GCST90472810/harmonised/GCST90472810.h.tsv.gz"
  },
  {
    "accessionId": "GCST90726498",
    "initial_individuals": "36334",
    "initial_ancestralGroup": "European",
    "pubmedId": "40510220",
    "EFO_ID": "EFO_0005658",
    "EFO_Trait_Name": "response to selective serotonin reuptake inhibitor",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90726001-GCST90727000/GCST90726498/harmonised/GCST90726498.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435262",
    "initial_individuals": "36083",
    "initial_ancestralGroup": "European",
    "pubmedId": "39966646",
    "EFO_ID": "EFO_0004295",
    "EFO_Trait_Name": "left ventricular function",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435262/harmonised/GCST90435262.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435258",
    "initial_individuals": "36083",
    "initial_ancestralGroup": "European",
    "pubmedId": "39966646",
    "EFO_ID": "EFO_0008204",
    "EFO_Trait_Name": "left ventricular diastolic function measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435258/harmonised/GCST90435258.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435259",
    "initial_individuals": "36083",
    "initial_ancestralGroup": "European",
    "pubmedId": "39966646",
    "EFO_ID": "EFO_0008206",
    "EFO_Trait_Name": "left ventricular systolic function measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435259/harmonised/GCST90435259.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435261",
    "initial_individuals": "36083",
    "initial_ancestralGroup": "European",
    "pubmedId": "39966646",
    "EFO_ID": "EFO_0008373",
    "EFO_Trait_Name": "left ventricular ejection fraction measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435261/harmonised/GCST90435261.h.tsv.gz"
  },
  {
    "accessionId": "GCST90268141",
    "initial_individuals": "35941",
    "initial_ancestralGroup": "European",
    "pubmedId": "37126556",
    "EFO_ID": "EFO_0021814",
    "EFO_Trait_Name": "right ventricular diastolic volume measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90268001-GCST90269000/GCST90268141/harmonised/GCST90268141.h.tsv.gz"
  },
  {
    "accessionId": "GCST90268147",
    "initial_individuals": "35932",
    "initial_ancestralGroup": "European",
    "pubmedId": "37126556",
    "EFO_ID": "EFO_0021817",
    "EFO_Trait_Name": "right ventricular stroke volume measurement",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90268001-GCST90269000/GCST90268147/harmonised/GCST90268147.h.tsv.gz"
  },
  {
    "accessionId": "GCST90268143",
    "initial_individuals": "35928",
    "initial_ancestralGroup": "European",
    "pubmedId": "37126556",
    "EFO_ID": "EFO_0021815",
    "EFO_Trait_Name": "right ventricular systolic volume measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90268001-GCST90269000/GCST90268143/harmonised/GCST90268143.h.tsv.gz"
  },
  {
    "accessionId": "GCST90268120",
    "initial_individuals": "35928",
    "initial_ancestralGroup": "European",
    "pubmedId": "37126556",
    "EFO_ID": "EFO_0021816",
    "EFO_Trait_Name": "right ventricular ejection fraction measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90268001-GCST90269000/GCST90268120/harmonised/GCST90268120.h.tsv.gz"
  },
  {
    "accessionId": "GCST90268144",
    "initial_individuals": "35899",
    "initial_ancestralGroup": "European",
    "pubmedId": "37126556",
    "EFO_ID": "EFO_0020939",
    "EFO_Trait_Name": "right ventricular function",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90268001-GCST90269000/GCST90268144/harmonised/GCST90268144.h.tsv.gz"
  },
  {
    "accessionId": "GCST90558034",
    "initial_individuals": "35702",
    "initial_ancestralGroup": "European",
    "pubmedId": "40795387",
    "EFO_ID": "EFO_0010602",
    "EFO_Trait_Name": "brain age measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90558001-GCST90559000/GCST90558034/harmonised/GCST90558034.h.tsv.gz"
  },
  {
    "accessionId": "GCST90448483",
    "initial_individuals": "35055",
    "initial_ancestralGroup": "European",
    "pubmedId": "39543113",
    "EFO_ID": "OBA_VT0000277",
    "EFO_Trait_Name": "heart shape trait",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90448001-GCST90449000/GCST90448483/harmonised/GCST90448483.h.tsv.gz"
  },
  {
    "accessionId": "GCST90319315",
    "initial_individuals": "33882",
    "initial_ancestralGroup": "European",
    "pubmedId": "38228779",
    "EFO_ID": "GO_0007610",
    "EFO_Trait_Name": "behavior",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90319001-GCST90320000/GCST90319315/harmonised/GCST90319315.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267357",
    "initial_individuals": "33542",
    "initial_ancestralGroup": "European",
    "pubmedId": "36402844",
    "EFO_ID": "OBA_2045224",
    "EFO_Trait_Name": "visceral adipose tissue quantity",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267357/harmonised/GCST90267357.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267347",
    "initial_individuals": "33532",
    "initial_ancestralGroup": "European",
    "pubmedId": "36402844",
    "EFO_ID": "OBA_1000023",
    "EFO_Trait_Name": "subcutaneous adipose tissue quality",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267347/harmonised/GCST90267347.h.tsv.gz"
  },
  {
    "accessionId": "GCST90134532",
    "initial_individuals": "33413",
    "initial_ancestralGroup": "European",
    "pubmedId": "37156767",
    "EFO_ID": "EFO_0007236",
    "EFO_Trait_Name": "diffuse idiopathic skeletal hyperostosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90134001-GCST90135000/GCST90134532/harmonised/GCST90134532.h.tsv.gz"
  },
  {
    "accessionId": "GCST90570047",
    "initial_individuals": "33413",
    "initial_ancestralGroup": "European",
    "pubmedId": "40652108",
    "EFO_ID": "HP_0002808",
    "EFO_Trait_Name": "Kyphosis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90570001-GCST90571000/GCST90570047/harmonised/GCST90570047.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267352",
    "initial_individuals": "33235",
    "initial_ancestralGroup": "European",
    "pubmedId": "36402844",
    "EFO_ID": "EFO_0010821",
    "EFO_Trait_Name": "liver fat measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267352/harmonised/GCST90267352.h.tsv.gz"
  },
  {
    "accessionId": "GCST90559116",
    "initial_individuals": "33156",
    "initial_ancestralGroup": "European",
    "pubmedId": "41054853",
    "EFO_ID": "OBA_2050102",
    "EFO_Trait_Name": "heart wall thickness",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90559001-GCST90560000/GCST90559116/harmonised/GCST90559116.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267353",
    "initial_individuals": "33022",
    "initial_ancestralGroup": "European",
    "pubmedId": "36402844",
    "EFO_ID": "EFO_0020931",
    "EFO_Trait_Name": "posterior thigh muscle volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267353/harmonised/GCST90267353.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267349",
    "initial_individuals": "32978",
    "initial_ancestralGroup": "European",
    "pubmedId": "36402844",
    "EFO_ID": "EFO_0020935",
    "EFO_Trait_Name": "anterior thigh muscle volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267349/harmonised/GCST90267349.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267359",
    "initial_individuals": "32970",
    "initial_ancestralGroup": "European",
    "pubmedId": "36402844",
    "EFO_ID": "EFO_0020099",
    "EFO_Trait_Name": "weight-to-muscle ratio",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267359/harmonised/GCST90267359.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267355",
    "initial_individuals": "32956",
    "initial_ancestralGroup": "European",
    "pubmedId": "36402844",
    "EFO_ID": "EFO_0020934",
    "EFO_Trait_Name": "posterior thigh muscle fat infiltration measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267355/harmonised/GCST90267355.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267360",
    "initial_individuals": "32939",
    "initial_ancestralGroup": "European",
    "pubmedId": "36402844",
    "EFO_ID": "EFO_0020098",
    "EFO_Trait_Name": "abdominal fat ratio",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267360/harmonised/GCST90267360.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267351",
    "initial_individuals": "32911",
    "initial_ancestralGroup": "European",
    "pubmedId": "36402844",
    "EFO_ID": "EFO_0020936",
    "EFO_Trait_Name": "anterior thigh muscle fat infiltration measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267351/harmonised/GCST90267351.h.tsv.gz"
  },
  {
    "accessionId": "GCST90652471",
    "initial_individuals": "32877",
    "initial_ancestralGroup": "European",
    "pubmedId": "41219506",
    "EFO_ID": "EFO_0008381",
    "EFO_Trait_Name": "total cortical area measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90652001-GCST90653000/GCST90652471/harmonised/GCST90652471.h.tsv.gz"
  },
  {
    "accessionId": "GCST90268139",
    "initial_individuals": "32528",
    "initial_ancestralGroup": "European",
    "pubmedId": "37126556",
    "EFO_ID": "EFO_0010555",
    "EFO_Trait_Name": "left ventricular stroke volume measurement",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90268001-GCST90269000/GCST90268139/harmonised/GCST90268139.h.tsv.gz"
  },
  {
    "accessionId": "GCST90268140",
    "initial_individuals": "32520",
    "initial_ancestralGroup": "European",
    "pubmedId": "37126556",
    "EFO_ID": "EFO_0010556",
    "EFO_Trait_Name": "left ventricular mass to end-diastolic volume ratio",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90268001-GCST90269000/GCST90268140/harmonised/GCST90268140.h.tsv.gz"
  },
  {
    "accessionId": "GCST90267356",
    "initial_individuals": "31977",
    "initial_ancestralGroup": "European",
    "pubmedId": "36402844",
    "EFO_ID": "EFO_0020107",
    "EFO_Trait_Name": "thigh muscle volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267356/harmonised/GCST90267356.h.tsv.gz"
  },
  {
    "accessionId": "GCST90134614",
    "initial_individuals": "31786",
    "initial_ancestralGroup": "European",
    "pubmedId": "36277789",
    "EFO_ID": "EFO_0004859",
    "EFO_Trait_Name": "abdominal aortic artery calcification",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90134001-GCST90135000/GCST90134614/harmonised/GCST90134614.h.tsv.gz"
  },
  {
    "accessionId": "GCST90435146",
    "initial_individuals": "31583",
    "initial_ancestralGroup": "European",
    "pubmedId": "39214992",
    "EFO_ID": "EFO_1000739",
    "EFO_Trait_Name": "neonatal jaundice",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90435001-GCST90436000/GCST90435146/harmonised/GCST90435146.h.tsv.gz"
  },
  {
    "accessionId": "GCST90239749",
    "initial_individuals": "31475",
    "initial_ancestralGroup": "European",
    "pubmedId": "37604819",
    "EFO_ID": "EFO_0803380",
    "EFO_Trait_Name": "cardiovascular age measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90239001-GCST90240000/GCST90239749/harmonised/GCST90239749.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243953",
    "initial_individuals": "31135",
    "initial_ancestralGroup": "European",
    "pubmedId": "36848389",
    "EFO_ID": "EFO_0803371",
    "EFO_Trait_Name": "outer nuclear layer thickness measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243953/harmonised/GCST90243953.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243955",
    "initial_individuals": "31135",
    "initial_ancestralGroup": "European",
    "pubmedId": "36848389",
    "EFO_ID": "EFO_0803373",
    "EFO_Trait_Name": "outer segment thickness measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243955/harmonised/GCST90243955.h.tsv.gz"
  },
  {
    "accessionId": "GCST90165317",
    "initial_individuals": "30810",
    "initial_ancestralGroup": "European",
    "pubmedId": "36800424",
    "EFO_ID": "OBA_2045295",
    "EFO_Trait_Name": "brain connectivity attribute",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90165001-GCST90166000/GCST90165317/harmonised/GCST90165317.h.tsv.gz"
  },
  {
    "accessionId": "GCST90711138",
    "initial_individuals": "29806",
    "initial_ancestralGroup": "European",
    "pubmedId": "37647652",
    "EFO_ID": "OBA_2045287",
    "EFO_Trait_Name": "platelet reactivity efficacy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90711001-GCST90712000/GCST90711138/harmonised/GCST90711138.h.tsv.gz"
  },
  {
    "accessionId": "GCST90278455",
    "initial_individuals": "28655",
    "initial_ancestralGroup": "European",
    "pubmedId": "37770635",
    "EFO_ID": "EFO_0004723",
    "EFO_Trait_Name": "coronary artery calcification",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90278001-GCST90279000/GCST90278455/harmonised/GCST90278455.h.tsv.gz"
  },
  {
    "accessionId": "GCST90105076",
    "initial_individuals": "27486",
    "initial_ancestralGroup": "European",
    "pubmedId": "35842455",
    "EFO_ID": "EFO_0021789",
    "EFO_Trait_Name": "cerebral volume measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90105001-GCST90106000/GCST90105076/harmonised/GCST90105076.h.tsv.gz"
  },
  {
    "accessionId": "GCST90105077",
    "initial_individuals": "27486",
    "initial_ancestralGroup": "European",
    "pubmedId": "35842455",
    "EFO_ID": "EFO_0021790",
    "EFO_Trait_Name": "subcortical volume measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90105001-GCST90106000/GCST90105077/harmonised/GCST90105077.h.tsv.gz"
  },
  {
    "accessionId": "GCST90479489",
    "initial_individuals": "27254",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0010071",
    "EFO_Trait_Name": "cardiac troponin I measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90479001-GCST90480000/GCST90479489/harmonised/GCST90479489.h.tsv.gz"
  },
  {
    "accessionId": "GCST90104462",
    "initial_individuals": "27180",
    "initial_ancestralGroup": "European",
    "pubmedId": "35998220",
    "EFO_ID": "EFO_0005300",
    "EFO_Trait_Name": "word reading",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90104001-GCST90105000/GCST90104462/harmonised/GCST90104462.h.tsv.gz"
  },
  {
    "accessionId": "GCST90503076",
    "initial_individuals": "26807",
    "initial_ancestralGroup": "European",
    "pubmedId": "40164586",
    "EFO_ID": "EFO_0006501",
    "EFO_Trait_Name": "carotid plaque build",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90503001-GCST90504000/GCST90503076/harmonised/GCST90503076.h.tsv.gz"
  },
  {
    "accessionId": "GCST90590338",
    "initial_individuals": "25637",
    "initial_ancestralGroup": "European",
    "pubmedId": "40272846",
    "EFO_ID": "EFO_0004341",
    "EFO_Trait_Name": "body fat distribution",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90590001-GCST90591000/GCST90590338/harmonised/GCST90590338.h.tsv.gz"
  },
  {
    "accessionId": "GCST90590337",
    "initial_individuals": "25637",
    "initial_ancestralGroup": "European",
    "pubmedId": "40272846",
    "EFO_ID": "EFO_0004515",
    "EFO_Trait_Name": "muscle measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90590001-GCST90591000/GCST90590337/harmonised/GCST90590337.h.tsv.gz"
  },
  {
    "accessionId": "GCST90503075",
    "initial_individuals": "24811",
    "initial_ancestralGroup": "European",
    "pubmedId": "40164586",
    "EFO_ID": "EFO_0005278",
    "EFO_Trait_Name": "cardiovascular disease biomarker measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90503001-GCST90504000/GCST90503075/harmonised/GCST90503075.h.tsv.gz"
  },
  {
    "accessionId": "GCST90271752",
    "initial_individuals": "24391",
    "initial_ancestralGroup": "European",
    "pubmedId": "37871108",
    "EFO_ID": "EFO_0005112",
    "EFO_Trait_Name": "gestational age",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90271001-GCST90272000/GCST90271752/harmonised/GCST90271752.h.tsv.gz"
  },
  {
    "accessionId": "GCST90019012",
    "initial_individuals": "23321",
    "initial_ancestralGroup": "European",
    "pubmedId": "35479509",
    "EFO_ID": "OBA_VT0004063",
    "EFO_Trait_Name": "left atrium capacity",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90019001-GCST90020000/GCST90019012/harmonised/GCST90019012.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476312",
    "initial_individuals": "23211",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0006920",
    "EFO_Trait_Name": "BNP measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476312/harmonised/GCST90476312.h.tsv.gz"
  },
  {
    "accessionId": "GCST90268402",
    "initial_individuals": "22528",
    "initial_ancestralGroup": "European",
    "pubmedId": "36996817",
    "EFO_ID": "EFO_0020938",
    "EFO_Trait_Name": "Left ventricle sphericity index",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90268001-GCST90269000/GCST90268402/harmonised/GCST90268402.h.tsv.gz"
  },
  {
    "accessionId": "GCST90132630",
    "initial_individuals": "21540",
    "initial_ancestralGroup": "European",
    "pubmedId": "27005778",
    "EFO_ID": "OBA_2050296",
    "EFO_Trait_Name": "chylomicron amount",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90132001-GCST90133000/GCST90132630/harmonised/GCST90132630.h.tsv.gz"
  },
  {
    "accessionId": "GCST90628030",
    "initial_individuals": "21495",
    "initial_ancestralGroup": "European",
    "pubmedId": "40593737",
    "EFO_ID": "GO_0007608",
    "EFO_Trait_Name": "sensory perception of smell",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90628001-GCST90629000/GCST90628030/harmonised/GCST90628030.h.tsv.gz"
  },
  {
    "accessionId": "GCST90003896",
    "initial_individuals": "20860",
    "initial_ancestralGroup": "European",
    "pubmedId": "33875891",
    "EFO_ID": "EFO_0008399",
    "EFO_Trait_Name": "mean fractional anisotropy measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90003001-GCST90004000/GCST90003896/harmonised/GCST90003896.h.tsv.gz"
  },
  {
    "accessionId": "GCST90004436",
    "initial_individuals": "20859",
    "initial_ancestralGroup": "European",
    "pubmedId": "33875891",
    "EFO_ID": "EFO_0005674",
    "EFO_Trait_Name": "white matter microstructure measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90004001-GCST90005000/GCST90004436/harmonised/GCST90004436.h.tsv.gz"
  },
  {
    "accessionId": "GCST90428110",
    "initial_individuals": "20579",
    "initial_ancestralGroup": "European",
    "pubmedId": "37989062",
    "EFO_ID": "EFO_0006899",
    "EFO_Trait_Name": "PCSK9 protein measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90428001-GCST90429000/GCST90428110/harmonised/GCST90428110.h.tsv.gz"
  },
  {
    "accessionId": "GCST90132726",
    "initial_individuals": "20235",
    "initial_ancestralGroup": "European",
    "pubmedId": "27005778",
    "EFO_ID": "OBA_1000966",
    "EFO_Trait_Name": "glycerol amount",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90132001-GCST90133000/GCST90132726/harmonised/GCST90132726.h.tsv.gz"
  },
  {
    "accessionId": "GCST90483496",
    "initial_individuals": "20024",
    "initial_ancestralGroup": "European",
    "pubmedId": "40229599",
    "EFO_ID": "OBA_1000994",
    "EFO_Trait_Name": "progesterone amount",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90483001-GCST90484000/GCST90483496/harmonised/GCST90483496.h.tsv.gz"
  },
  {
    "accessionId": "GCST90559210",
    "initial_individuals": "19862",
    "initial_ancestralGroup": "European",
    "pubmedId": "40512868",
    "EFO_ID": "OBA_2050041",
    "EFO_Trait_Name": "cerebellar cortex volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90559001-GCST90560000/GCST90559210/harmonised/GCST90559210.h.tsv.gz"
  },
  {
    "accessionId": "GCST90559227",
    "initial_individuals": "19862",
    "initial_ancestralGroup": "European",
    "pubmedId": "40512868",
    "EFO_ID": "OBA_2050047",
    "EFO_Trait_Name": "fourth ventricle volume",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90559001-GCST90560000/GCST90559227/harmonised/GCST90559227.h.tsv.gz"
  },
  {
    "accessionId": "GCST90455659",
    "initial_individuals": "19675",
    "initial_ancestralGroup": "European",
    "pubmedId": "41266372",
    "EFO_ID": "EFO_0920034",
    "EFO_Trait_Name": "age at high-grade serous ovarian cancer diagnosis",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90455001-GCST90456000/GCST90455659/harmonised/GCST90455659.h.tsv.gz"
  },
  {
    "accessionId": "GCST90429796",
    "initial_individuals": "19128",
    "initial_ancestralGroup": "European",
    "pubmedId": "38924601",
    "EFO_ID": "EFO_0022959",
    "EFO_Trait_Name": "hand eczema",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90429001-GCST90430000/GCST90429796/harmonised/GCST90429796.h.tsv.gz"
  },
  {
    "accessionId": "GCST90444480",
    "initial_individuals": "18532",
    "initial_ancestralGroup": "European",
    "pubmedId": "39251807",
    "EFO_ID": "OBA_2050255",
    "EFO_Trait_Name": "neurofilament light polypeptide amount",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90444001-GCST90445000/GCST90444480/harmonised/GCST90444480.h.tsv.gz"
  },
  {
    "accessionId": "GCST90104932",
    "initial_individuals": "18101",
    "initial_ancestralGroup": "European",
    "pubmedId": "36442731",
    "EFO_ID": "EFO_0022046",
    "EFO_Trait_Name": "sulcal opening distance",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90104001-GCST90105000/GCST90104932/harmonised/GCST90104932.h.tsv.gz"
  },
  {
    "accessionId": "GCST90104913",
    "initial_individuals": "18101",
    "initial_ancestralGroup": "European",
    "pubmedId": "36442731",
    "EFO_ID": "EFO_0022047",
    "EFO_Trait_Name": "sulcal depth",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90104001-GCST90105000/GCST90104913/harmonised/GCST90104913.h.tsv.gz"
  },
  {
    "accessionId": "GCST90104466",
    "initial_individuals": "17278",
    "initial_ancestralGroup": "European",
    "pubmedId": "35998220",
    "EFO_ID": "EFO_0005301",
    "EFO_Trait_Name": "reading and spelling ability",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90104001-GCST90105000/GCST90104466/harmonised/GCST90104466.h.tsv.gz"
  },
  {
    "accessionId": "GCST90104465",
    "initial_individuals": "16746",
    "initial_ancestralGroup": "European",
    "pubmedId": "35998220",
    "EFO_ID": "EFO_0005299",
    "EFO_Trait_Name": "non-word reading",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90104001-GCST90105000/GCST90104465/harmonised/GCST90104465.h.tsv.gz"
  },
  {
    "accessionId": "GCST90225536",
    "initial_individuals": "15432",
    "initial_ancestralGroup": "European",
    "pubmedId": "36167494",
    "EFO_ID": "EFO_0008419",
    "EFO_Trait_Name": "susceptibility to chronic sinus infection measurement",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90225001-GCST90226000/GCST90225536/harmonised/GCST90225536.h.tsv.gz"
  },
  {
    "accessionId": "GCST90204145",
    "initial_individuals": "14985",
    "initial_ancestralGroup": "European",
    "pubmedId": "37768647",
    "EFO_ID": "EFO_1001293",
    "EFO_Trait_Name": "collagenous colitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90204001-GCST90205000/GCST90204145/harmonised/GCST90204145.h.tsv.gz"
  },
  {
    "accessionId": "GCST90274770",
    "initial_individuals": "14744",
    "initial_ancestralGroup": "European",
    "pubmedId": "37563310",
    "EFO_ID": "EFO_0021848",
    "EFO_Trait_Name": "C-C motif chemokine 4-like measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90274001-GCST90275000/GCST90274770/harmonised/GCST90274770.h.tsv.gz"
  },
  {
    "accessionId": "GCST90274772",
    "initial_individuals": "14736",
    "initial_ancestralGroup": "European",
    "pubmedId": "37563310",
    "EFO_ID": "EFO_0010586",
    "EFO_Trait_Name": "CD40 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90274001-GCST90275000/GCST90274772/harmonised/GCST90274772.h.tsv.gz"
  },
  {
    "accessionId": "GCST90060220",
    "initial_individuals": "13814",
    "initial_ancestralGroup": "European",
    "pubmedId": "34503513",
    "EFO_ID": "EFO_0010345",
    "EFO_Trait_Name": "cholesteryl ester 18:2 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90060001-GCST90061000/GCST90060220/harmonised/GCST90060220.h.tsv.gz"
  },
  {
    "accessionId": "GCST90060128",
    "initial_individuals": "13814",
    "initial_ancestralGroup": "European",
    "pubmedId": "34503513",
    "EFO_ID": "EFO_0020044",
    "EFO_Trait_Name": "ecosanoids measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90060001-GCST90061000/GCST90060128/harmonised/GCST90060128.h.tsv.gz"
  },
  {
    "accessionId": "GCST90060161",
    "initial_individuals": "13814",
    "initial_ancestralGroup": "European",
    "pubmedId": "34503513",
    "EFO_ID": "EFO_0020052",
    "EFO_Trait_Name": "diacylglycerol 30:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90060001-GCST90061000/GCST90060161/harmonised/GCST90060161.h.tsv.gz"
  },
  {
    "accessionId": "GCST90060292",
    "initial_individuals": "13814",
    "initial_ancestralGroup": "European",
    "pubmedId": "34503513",
    "EFO_ID": "OBA_2040180",
    "EFO_Trait_Name": "level of phosphatidylethanolamine",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90060001-GCST90061000/GCST90060292/harmonised/GCST90060292.h.tsv.gz"
  },
  {
    "accessionId": "GCST90726356",
    "initial_individuals": "12728",
    "initial_ancestralGroup": "European",
    "pubmedId": "40495575",
    "EFO_ID": "HP_0000713",
    "EFO_Trait_Name": "agitation",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90726001-GCST90727000/GCST90726356/harmonised/GCST90726356.h.tsv.gz"
  },
  {
    "accessionId": "GCST90726358",
    "initial_individuals": "12727",
    "initial_ancestralGroup": "European",
    "pubmedId": "40495575",
    "EFO_ID": "HP_0000741",
    "EFO_Trait_Name": "Apathy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90726001-GCST90727000/GCST90726358/harmonised/GCST90726358.h.tsv.gz"
  },
  {
    "accessionId": "GCST90726359",
    "initial_individuals": "12723",
    "initial_ancestralGroup": "European",
    "pubmedId": "40495575",
    "EFO_ID": "HP_0000746",
    "EFO_Trait_Name": "Delusion",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90726001-GCST90727000/GCST90726359/harmonised/GCST90726359.h.tsv.gz"
  },
  {
    "accessionId": "GCST90726364",
    "initial_individuals": "12716",
    "initial_ancestralGroup": "European",
    "pubmedId": "40495575",
    "EFO_ID": "OBA_1000905",
    "EFO_Trait_Name": "sleeping behavior quality",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90726001-GCST90727000/GCST90726364/harmonised/GCST90726364.h.tsv.gz"
  },
  {
    "accessionId": "GCST90710748",
    "initial_individuals": "12519",
    "initial_ancestralGroup": "European",
    "pubmedId": "41606319",
    "EFO_ID": "EFO_0801229",
    "EFO_Trait_Name": "oral microbiome measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90710001-GCST90711000/GCST90710748/harmonised/GCST90710748.h.tsv.gz"
  },
  {
    "accessionId": "GCST90501352",
    "initial_individuals": "12448",
    "initial_ancestralGroup": "European",
    "pubmedId": "41406505",
    "EFO_ID": "EFO_0802910",
    "EFO_Trait_Name": "procalcitonin measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90501001-GCST90502000/GCST90501352/harmonised/GCST90501352.h.tsv.gz"
  },
  {
    "accessionId": "GCST90104468",
    "initial_individuals": "12411",
    "initial_ancestralGroup": "European",
    "pubmedId": "35998220",
    "EFO_ID": "EFO_0021812",
    "EFO_Trait_Name": "phoneme awareness",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90104001-GCST90105000/GCST90104468/harmonised/GCST90104468.h.tsv.gz"
  },
  {
    "accessionId": "GCST011942",
    "initial_individuals": "12369",
    "initial_ancestralGroup": "European",
    "pubmedId": "34002480",
    "EFO_ID": "EFO_0005659",
    "EFO_Trait_Name": "plasma beta-amyloid 1-40 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST011001-GCST012000/GCST011942/harmonised/GCST011942.h.tsv.gz"
  },
  {
    "accessionId": "GCST011941",
    "initial_individuals": "12369",
    "initial_ancestralGroup": "European",
    "pubmedId": "34002480",
    "EFO_ID": "EFO_0005660",
    "EFO_Trait_Name": "plasma beta-amyloid 1-42 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST011001-GCST012000/GCST011941/harmonised/GCST011941.h.tsv.gz"
  },
  {
    "accessionId": "GCST011943",
    "initial_individuals": "12369",
    "initial_ancestralGroup": "European",
    "pubmedId": "34002480",
    "EFO_ID": "EFO_0600016",
    "EFO_Trait_Name": "plasma beta-amyloid 1-40:1-42 ratio measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST011001-GCST012000/GCST011943/harmonised/GCST011943.h.tsv.gz"
  },
  {
    "accessionId": "GCST90274813",
    "initial_individuals": "11793",
    "initial_ancestralGroup": "European",
    "pubmedId": "37563310",
    "EFO_ID": "EFO_0802661",
    "EFO_Trait_Name": "interleukin-4 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90274001-GCST90275000/GCST90274813/harmonised/GCST90274813.h.tsv.gz"
  },
  {
    "accessionId": "GCST90274812",
    "initial_individuals": "11793",
    "initial_ancestralGroup": "European",
    "pubmedId": "37563310",
    "EFO_ID": "OBA_2050335",
    "EFO_Trait_Name": "level of interleukin-33 in blood plasma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90274001-GCST90275000/GCST90274812/harmonised/GCST90274812.h.tsv.gz"
  },
  {
    "accessionId": "GCST90274814",
    "initial_individuals": "11792",
    "initial_ancestralGroup": "European",
    "pubmedId": "37563310",
    "EFO_ID": "EFO_0801729",
    "EFO_Trait_Name": "interleukin-5 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90274001-GCST90275000/GCST90274814/harmonised/GCST90274814.h.tsv.gz"
  },
  {
    "accessionId": "GCST90274828",
    "initial_individuals": "11791",
    "initial_ancestralGroup": "European",
    "pubmedId": "37563310",
    "EFO_ID": "OBA_2050334",
    "EFO_Trait_Name": "level of neurturin in blood plasma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90274001-GCST90275000/GCST90274828/harmonised/GCST90274828.h.tsv.gz"
  },
  {
    "accessionId": "GCST90274806",
    "initial_individuals": "11789",
    "initial_ancestralGroup": "European",
    "pubmedId": "37563310",
    "EFO_ID": "EFO_0801723",
    "EFO_Trait_Name": "interleukin-2 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90274001-GCST90275000/GCST90274806/harmonised/GCST90274806.h.tsv.gz"
  },
  {
    "accessionId": "GCST007228",
    "initial_individuals": "11744",
    "initial_ancestralGroup": "European",
    "pubmedId": "30527956",
    "EFO_ID": "EFO_0001361",
    "EFO_Trait_Name": "pulmonary arterial hypertension",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST007001-GCST008000/GCST007228/harmonised/GCST007228.h.tsv.gz"
  },
  {
    "accessionId": "GCST90225544",
    "initial_individuals": "10967",
    "initial_ancestralGroup": "European",
    "pubmedId": "36167494",
    "EFO_ID": "EFO_1002024",
    "EFO_Trait_Name": "streptococcal pharyngitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90225001-GCST90226000/GCST90225544/harmonised/GCST90225544.h.tsv.gz"
  },
  {
    "accessionId": "GCST90301368",
    "initial_individuals": "10857",
    "initial_ancestralGroup": "European",
    "pubmedId": "39286457",
    "EFO_ID": "OBA_2040155",
    "EFO_Trait_Name": "age of onset of stroke disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90301001-GCST90302000/GCST90301368/harmonised/GCST90301368.h.tsv.gz"
  },
  {
    "accessionId": "GCST90476730",
    "initial_individuals": "10854",
    "initial_ancestralGroup": "European",
    "pubmedId": "39024449",
    "EFO_ID": "EFO_0006864",
    "EFO_Trait_Name": "breastfeeding duration",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90476001-GCST90477000/GCST90476730/harmonised/GCST90476730.h.tsv.gz"
  },
  {
    "accessionId": "GCST90296098",
    "initial_individuals": "10348",
    "initial_ancestralGroup": "European",
    "pubmedId": "38036550",
    "EFO_ID": "MONDO_0005149",
    "EFO_Trait_Name": "pulmonary hypertension",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90296001-GCST90297000/GCST90296098/harmonised/GCST90296098.h.tsv.gz"
  },
  {
    "accessionId": "GCST90709864",
    "initial_individuals": "10181",
    "initial_ancestralGroup": "European",
    "pubmedId": "41075272",
    "EFO_ID": "HP_0000202",
    "EFO_Trait_Name": "Orofacial cleft",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90709001-GCST90710000/GCST90709864/harmonised/GCST90709864.h.tsv.gz"
  },
  {
    "accessionId": "GCST90668767",
    "initial_individuals": "10172",
    "initial_ancestralGroup": "European",
    "pubmedId": "40593539",
    "EFO_ID": "EFO_0004999",
    "EFO_Trait_Name": "N-glycan measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90668001-GCST90669000/GCST90668767/harmonised/GCST90668767.h.tsv.gz"
  },
  {
    "accessionId": "GCST90672046",
    "initial_individuals": "10103",
    "initial_ancestralGroup": "European",
    "pubmedId": "41325371",
    "EFO_ID": "EFO_0005116",
    "EFO_Trait_Name": "urinary metabolite measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90672001-GCST90673000/GCST90672046/harmonised/GCST90672046.h.tsv.gz"
  },
  {
    "accessionId": "GCST90428625",
    "initial_individuals": "9668",
    "initial_ancestralGroup": "European",
    "pubmedId": "38815977",
    "EFO_ID": "EFO_0004769",
    "EFO_Trait_Name": "anti-Mullerian hormone measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90428001-GCST90429000/GCST90428625/harmonised/GCST90428625.h.tsv.gz"
  },
  {
    "accessionId": "GCST90012782",
    "initial_individuals": "9523",
    "initial_ancestralGroup": "European",
    "pubmedId": "33441150",
    "EFO_ID": "EFO_0803355",
    "EFO_Trait_Name": "calcitriol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90012001-GCST90013000/GCST90012782/harmonised/GCST90012782.h.tsv.gz"
  },
  {
    "accessionId": "GCST90204200",
    "initial_individuals": "9447",
    "initial_ancestralGroup": "European",
    "pubmedId": "36470867",
    "EFO_ID": "EFO_0007462",
    "EFO_Trait_Name": "REM sleep behavior disorder",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90204001-GCST90205000/GCST90204200/harmonised/GCST90204200.h.tsv.gz"
  },
  {
    "accessionId": "GCST90010744",
    "initial_individuals": "9256",
    "initial_ancestralGroup": "European",
    "pubmedId": "33414548",
    "EFO_ID": "EFO_0006523",
    "EFO_Trait_Name": "symmetrical dimethylarginine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90010001-GCST90011000/GCST90010744/harmonised/GCST90010744.h.tsv.gz"
  },
  {
    "accessionId": "GCST90399838",
    "initial_individuals": "8916",
    "initial_ancestralGroup": "European",
    "pubmedId": "39144724",
    "EFO_ID": "EFO_0800164",
    "EFO_Trait_Name": "2-O-methylascorbic acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90399001-GCST90400000/GCST90399838/harmonised/GCST90399838.h.tsv.gz"
  },
  {
    "accessionId": "GCST90709869",
    "initial_individuals": "8786",
    "initial_ancestralGroup": "European",
    "pubmedId": "41075272",
    "EFO_ID": "HP_0000175",
    "EFO_Trait_Name": "cleft palate",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90709001-GCST90710000/GCST90709869/harmonised/GCST90709869.h.tsv.gz"
  },
  {
    "accessionId": "GCST90006917",
    "initial_individuals": "8735",
    "initial_ancestralGroup": "European",
    "pubmedId": "33204752",
    "EFO_ID": "EFO_0007036",
    "EFO_Trait_Name": "herpes virus seropositivity",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90006001-GCST90007000/GCST90006917/harmonised/GCST90006917.h.tsv.gz"
  },
  {
    "accessionId": "GCST90006893",
    "initial_individuals": "8735",
    "initial_ancestralGroup": "European",
    "pubmedId": "33204752",
    "EFO_ID": "EFO_0007037",
    "EFO_Trait_Name": "cytomegalovirus seropositivity",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90006001-GCST90007000/GCST90006893/harmonised/GCST90006893.h.tsv.gz"
  },
  {
    "accessionId": "GCST90006925",
    "initial_individuals": "8735",
    "initial_ancestralGroup": "European",
    "pubmedId": "33204752",
    "EFO_ID": "EFO_0007047",
    "EFO_Trait_Name": "Toxoplasma gondii seropositivity",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90006001-GCST90007000/GCST90006925/harmonised/GCST90006925.h.tsv.gz"
  },
  {
    "accessionId": "GCST90006905",
    "initial_individuals": "8735",
    "initial_ancestralGroup": "European",
    "pubmedId": "33204752",
    "EFO_ID": "EFO_0007048",
    "EFO_Trait_Name": "human herpesvirus 6 seropositivity",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90006001-GCST90007000/GCST90006905/harmonised/GCST90006905.h.tsv.gz"
  },
  {
    "accessionId": "GCST90006886",
    "initial_individuals": "8735",
    "initial_ancestralGroup": "European",
    "pubmedId": "33204752",
    "EFO_ID": "EFO_0009330",
    "EFO_Trait_Name": "Chlamydia trachomatis seropositivity",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90006001-GCST90007000/GCST90006886/harmonised/GCST90006886.h.tsv.gz"
  },
  {
    "accessionId": "GCST90006919",
    "initial_individuals": "8735",
    "initial_ancestralGroup": "European",
    "pubmedId": "33204752",
    "EFO_ID": "EFO_0009339",
    "EFO_Trait_Name": "Herpes simplex virus 2 seropositivity",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90006001-GCST90007000/GCST90006919/harmonised/GCST90006919.h.tsv.gz"
  },
  {
    "accessionId": "GCST90006928",
    "initial_individuals": "8735",
    "initial_ancestralGroup": "European",
    "pubmedId": "33204752",
    "EFO_ID": "EFO_0009340",
    "EFO_Trait_Name": "Varicella zoster virus seropositivity",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90006001-GCST90007000/GCST90006928/harmonised/GCST90006928.h.tsv.gz"
  },
  {
    "accessionId": "GCST90006910",
    "initial_individuals": "8735",
    "initial_ancestralGroup": "European",
    "pubmedId": "33204752",
    "EFO_ID": "EFO_0009341",
    "EFO_Trait_Name": "Helicobacter pylori seropositivity",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90006001-GCST90007000/GCST90006910/harmonised/GCST90006910.h.tsv.gz"
  },
  {
    "accessionId": "GCST90006884",
    "initial_individuals": "8735",
    "initial_ancestralGroup": "European",
    "pubmedId": "33204752",
    "EFO_ID": "EFO_0010905",
    "EFO_Trait_Name": "BK polyomavirus seropositivity",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90006001-GCST90007000/GCST90006884/harmonised/GCST90006884.h.tsv.gz"
  },
  {
    "accessionId": "GCST90006923",
    "initial_individuals": "8735",
    "initial_ancestralGroup": "European",
    "pubmedId": "33204752",
    "EFO_ID": "EFO_0010906",
    "EFO_Trait_Name": "merkel cell virus seropositivity",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90006001-GCST90007000/GCST90006923/harmonised/GCST90006923.h.tsv.gz"
  },
  {
    "accessionId": "GCST90006921",
    "initial_individuals": "8735",
    "initial_ancestralGroup": "European",
    "pubmedId": "33204752",
    "EFO_ID": "EFO_0010907",
    "EFO_Trait_Name": "polyomavirus 2 seropositivity",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90006001-GCST90007000/GCST90006921/harmonised/GCST90006921.h.tsv.gz"
  },
  {
    "accessionId": "GCST90006897",
    "initial_individuals": "8735",
    "initial_ancestralGroup": "European",
    "pubmedId": "33204752",
    "EFO_ID": "EFO_0010908",
    "EFO_Trait_Name": "Epstein-Barr virus seropositivity",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90006001-GCST90007000/GCST90006897/harmonised/GCST90006897.h.tsv.gz"
  },
  {
    "accessionId": "GCST90006908",
    "initial_individuals": "8735",
    "initial_ancestralGroup": "European",
    "pubmedId": "33204752",
    "EFO_ID": "EFO_0600006",
    "EFO_Trait_Name": "human herpesvirus 7 seropositivity",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90006001-GCST90007000/GCST90006908/harmonised/GCST90006908.h.tsv.gz"
  },
  {
    "accessionId": "GCST90026612",
    "initial_individuals": "8656",
    "initial_ancestralGroup": "European",
    "pubmedId": "34654805",
    "EFO_ID": "EFO_1000938",
    "EFO_Trait_Name": "fibromuscular dysplasia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90026001-GCST90027000/GCST90026612/harmonised/GCST90026612.h.tsv.gz"
  },
  {
    "accessionId": "GCST90006885",
    "initial_individuals": "8555",
    "initial_ancestralGroup": "European",
    "pubmedId": "33204752",
    "EFO_ID": "EFO_0010904",
    "EFO_Trait_Name": "anti-BK polyomavirus antibody measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90006001-GCST90007000/GCST90006885/harmonised/GCST90006885.h.tsv.gz"
  },
  {
    "accessionId": "GCST90006909",
    "initial_individuals": "8528",
    "initial_ancestralGroup": "European",
    "pubmedId": "33204752",
    "EFO_ID": "EFO_0011038",
    "EFO_Trait_Name": "anti-human herpes virus 7 antibody measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90006001-GCST90007000/GCST90006909/harmonised/GCST90006909.h.tsv.gz"
  },
  {
    "accessionId": "GCST90006900",
    "initial_individuals": "8518",
    "initial_ancestralGroup": "European",
    "pubmedId": "33204752",
    "EFO_ID": "OBA_VT0002460",
    "EFO_Trait_Name": "blood immunoglobulin amount",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90006001-GCST90007000/GCST90006900/harmonised/GCST90006900.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199836",
    "initial_individuals": "8299",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800039",
    "EFO_Trait_Name": "N-methylproline measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199836/harmonised/GCST90199836.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200689",
    "initial_individuals": "8299",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800061",
    "EFO_Trait_Name": "N6-methyllysine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200689/harmonised/GCST90200689.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200971",
    "initial_individuals": "8298",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022223",
    "EFO_Trait_Name": "metabolite ratio",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200971/harmonised/GCST90200971.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199738",
    "initial_individuals": "8297",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021169",
    "EFO_Trait_Name": "stachydrine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199738/harmonised/GCST90199738.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200388",
    "initial_individuals": "8290",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021072",
    "EFO_Trait_Name": "palmitoleate 16:1n7 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200388/harmonised/GCST90200388.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199628",
    "initial_individuals": "8289",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021004",
    "EFO_Trait_Name": "3-methylhistidine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199628/harmonised/GCST90199628.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199985",
    "initial_individuals": "8285",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800997",
    "EFO_Trait_Name": "methyl-4-hydroxybenzoate sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199985/harmonised/GCST90199985.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200323",
    "initial_individuals": "8285",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "OBA_1001005",
    "EFO_Trait_Name": "creatine amount",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200323/harmonised/GCST90200323.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199713",
    "initial_individuals": "8284",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021048",
    "EFO_Trait_Name": "docosapentaenoate n3 DPA; 22:5n3 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199713/harmonised/GCST90199713.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200320",
    "initial_individuals": "8284",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021064",
    "EFO_Trait_Name": "dihomo-linoleate 20:2n6 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200320/harmonised/GCST90200320.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199794",
    "initial_individuals": "8283",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800246",
    "EFO_Trait_Name": "1-oleoyl-GPE (18:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199794/harmonised/GCST90199794.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199731",
    "initial_individuals": "8282",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021060",
    "EFO_Trait_Name": "10-heptadecenoate 17:1n7 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199731/harmonised/GCST90199731.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200414",
    "initial_individuals": "8282",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021067",
    "EFO_Trait_Name": "myristate 14:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200414/harmonised/GCST90200414.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199824",
    "initial_individuals": "8280",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021149",
    "EFO_Trait_Name": "4-vinylphenol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199824/harmonised/GCST90199824.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199651",
    "initial_individuals": "8279",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021047",
    "EFO_Trait_Name": "docosahexaenoate DHA; 22:6n3 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199651/harmonised/GCST90199651.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199709",
    "initial_individuals": "8279",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021062",
    "EFO_Trait_Name": "adrenate 22:4n6 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199709/harmonised/GCST90199709.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200459",
    "initial_individuals": "8279",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021066",
    "EFO_Trait_Name": "margarate 17:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200459/harmonised/GCST90200459.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199793",
    "initial_individuals": "8279",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800247",
    "EFO_Trait_Name": "1-linoleoyl-GPE (18:2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199793/harmonised/GCST90199793.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199975",
    "initial_individuals": "8278",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022114",
    "EFO_Trait_Name": "Sphingomyelin (d18:2/14:0, d18:1/14:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199975/harmonised/GCST90199975.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199728",
    "initial_individuals": "8277",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021061",
    "EFO_Trait_Name": "10-nonadecenoate 19:1n9 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199728/harmonised/GCST90199728.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199744",
    "initial_individuals": "8277",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800220",
    "EFO_Trait_Name": "eicosenoate (20:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199744/harmonised/GCST90199744.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199792",
    "initial_individuals": "8276",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800245",
    "EFO_Trait_Name": "1-palmitoyl-GPE (16:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199792/harmonised/GCST90199792.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200038",
    "initial_individuals": "8276",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800406",
    "EFO_Trait_Name": "1-palmitoyl-2-palmitoleoyl-GPC(16:0/16:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200038/harmonised/GCST90200038.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200059",
    "initial_individuals": "8275",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800427",
    "EFO_Trait_Name": "behenoyl dihydrosphingomyelin (d18:0/22:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200059/harmonised/GCST90200059.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200104",
    "initial_individuals": "8274",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800491",
    "EFO_Trait_Name": "hexadecadienoate (16:2n6) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200104/harmonised/GCST90200104.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199820",
    "initial_individuals": "8273",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021046",
    "EFO_Trait_Name": "dihomo-linolenate 20:3n3 or n6 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199820/harmonised/GCST90199820.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200457",
    "initial_individuals": "8273",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021073",
    "EFO_Trait_Name": "pentadecanoate 15:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200457/harmonised/GCST90200457.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200040",
    "initial_individuals": "8273",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022117",
    "EFO_Trait_Name": "Sphingomyelin (d18:2/24:1, d18:1/24:2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200040/harmonised/GCST90200040.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199708",
    "initial_individuals": "8273",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800210",
    "EFO_Trait_Name": "propionylcarnitine (C3) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199708/harmonised/GCST90199708.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199831",
    "initial_individuals": "8273",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800269",
    "EFO_Trait_Name": "1-stearoyl-2-oleoyl-GPE (18:0/18:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199831/harmonised/GCST90199831.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200358",
    "initial_individuals": "8272",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021063",
    "EFO_Trait_Name": "arachidonate 20:4n6 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200358/harmonised/GCST90200358.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200390",
    "initial_individuals": "8272",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021074",
    "EFO_Trait_Name": "stearate 18:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200390/harmonised/GCST90200390.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200428",
    "initial_individuals": "8272",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021101",
    "EFO_Trait_Name": "caprate 10:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200428/harmonised/GCST90200428.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199947",
    "initial_individuals": "8272",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022115",
    "EFO_Trait_Name": "Sphingomyelin (d18:2/16:0, d18:1/16:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199947/harmonised/GCST90199947.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200033",
    "initial_individuals": "8272",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022116",
    "EFO_Trait_Name": "Sphingomyelin (d18:2/23:0, d18:1/23:1, d17:1/24:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200033/harmonised/GCST90200033.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199696",
    "initial_individuals": "8272",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800154",
    "EFO_Trait_Name": "trigonelline (N'-methylnicotinate) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199696/harmonised/GCST90199696.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200599",
    "initial_individuals": "8272",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800853",
    "EFO_Trait_Name": "X-23639 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200599/harmonised/GCST90200599.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200679",
    "initial_individuals": "8271",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021429",
    "EFO_Trait_Name": "N-acetylarginine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200679/harmonised/GCST90200679.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199653",
    "initial_individuals": "8271",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800191",
    "EFO_Trait_Name": "1-myristoyl-2-palmitoyl-GPC (14:0/16:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199653/harmonised/GCST90199653.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199813",
    "initial_individuals": "8271",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800259",
    "EFO_Trait_Name": "deoxycarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199813/harmonised/GCST90199813.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200041",
    "initial_individuals": "8271",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800396",
    "EFO_Trait_Name": "1-palmitoyl-2-stearoyl-GPC (16:0/18:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200041/harmonised/GCST90200041.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200569",
    "initial_individuals": "8271",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800795",
    "EFO_Trait_Name": "X-18913 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200569/harmonised/GCST90200569.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200663",
    "initial_individuals": "8271",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800926",
    "EFO_Trait_Name": "X-25420 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200663/harmonised/GCST90200663.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199712",
    "initial_individuals": "8270",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021053",
    "EFO_Trait_Name": "3-carboxy-4-methyl-5-propyl-2-furanpropanoate CMPF measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199712/harmonised/GCST90199712.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199772",
    "initial_individuals": "8270",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800227",
    "EFO_Trait_Name": "1-stearoyl-GPE (18:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199772/harmonised/GCST90199772.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199791",
    "initial_individuals": "8270",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800248",
    "EFO_Trait_Name": "1-arachidonoyl-GPE (20:4n6) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199791/harmonised/GCST90199791.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199990",
    "initial_individuals": "8270",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800995",
    "EFO_Trait_Name": "3-hydroxypyridine sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199990/harmonised/GCST90199990.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200397",
    "initial_individuals": "8269",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021071",
    "EFO_Trait_Name": "palmitate 16:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200397/harmonised/GCST90200397.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199876",
    "initial_individuals": "8269",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800300",
    "EFO_Trait_Name": "palmitoyl sphingomyelin (d18:1/16:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199876/harmonised/GCST90199876.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200035",
    "initial_individuals": "8269",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800400",
    "EFO_Trait_Name": "palmitoyl dihydrosphingomyelin (d18:0/16:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200035/harmonised/GCST90200035.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200229",
    "initial_individuals": "8269",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801046",
    "EFO_Trait_Name": "2,6-dihydroxybenzoic acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200229/harmonised/GCST90200229.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199806",
    "initial_individuals": "8268",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021057",
    "EFO_Trait_Name": "tetradecanedioate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199806/harmonised/GCST90199806.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199821",
    "initial_individuals": "8268",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800266",
    "EFO_Trait_Name": "1-linoleoyl-GPI (18:2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199821/harmonised/GCST90199821.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199916",
    "initial_individuals": "8268",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800338",
    "EFO_Trait_Name": "linoleoylcarnitine (C18:2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199916/harmonised/GCST90199916.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200012",
    "initial_individuals": "8268",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800378",
    "EFO_Trait_Name": "3-hydroxyhexanoate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200012/harmonised/GCST90200012.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199884",
    "initial_individuals": "8268",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800963",
    "EFO_Trait_Name": "2,3-dihydroxyisovalerate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199884/harmonised/GCST90199884.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199775",
    "initial_individuals": "8267",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021139",
    "EFO_Trait_Name": "gamma-glutamylisoleucine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199775/harmonised/GCST90199775.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199878",
    "initial_individuals": "8267",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022108",
    "EFO_Trait_Name": "Sphingomyelin (d18:1/18:1, d18:2/18:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199878/harmonised/GCST90199878.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199972",
    "initial_individuals": "8267",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022113",
    "EFO_Trait_Name": "Sphingomyelin (d18:1/24:1, d18:2/24:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199972/harmonised/GCST90199972.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199788",
    "initial_individuals": "8267",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800234",
    "EFO_Trait_Name": "1-arachidonoyl-GPC (20:4n6) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199788/harmonised/GCST90199788.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199934",
    "initial_individuals": "8267",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800347",
    "EFO_Trait_Name": "2-hydroxydecanoate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199934/harmonised/GCST90199934.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200081",
    "initial_individuals": "8267",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800449",
    "EFO_Trait_Name": "1-oleoyl-2-docosahexaenoyl-GPC (18:1/22:6) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200081/harmonised/GCST90200081.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200165",
    "initial_individuals": "8267",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800563",
    "EFO_Trait_Name": "octadecenedioate (C18:1-DC) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200165/harmonised/GCST90200165.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199747",
    "initial_individuals": "8266",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800024",
    "EFO_Trait_Name": "isovalerylcarnitine (C5) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199747/harmonised/GCST90199747.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199844",
    "initial_individuals": "8266",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800272",
    "EFO_Trait_Name": "1-palmitoyl-2-linoleoyl-GPE (16:0/18:2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199844/harmonised/GCST90199844.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200055",
    "initial_individuals": "8266",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800429",
    "EFO_Trait_Name": "lactosyl-N-palmitoyl-sphingosine (d18:1/16:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200055/harmonised/GCST90200055.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200083",
    "initial_individuals": "8266",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800466",
    "EFO_Trait_Name": "1-(1-enyl-palmitoyl)-2-palmitoyl-GPC (P-16:0/16:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200083/harmonised/GCST90200083.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200136",
    "initial_individuals": "8266",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800542",
    "EFO_Trait_Name": "cerotoylcarnitine (C26) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200136/harmonised/GCST90200136.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200336",
    "initial_individuals": "8266",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800607",
    "EFO_Trait_Name": "N-palmitoyl-sphingosine (d18:1/16:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200336/harmonised/GCST90200336.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200310",
    "initial_individuals": "8265",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010980",
    "EFO_Trait_Name": "3-aminoisobutyrate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200310/harmonised/GCST90200310.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200696",
    "initial_individuals": "8265",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800100",
    "EFO_Trait_Name": "N6,N6-dimethyllysine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200696/harmonised/GCST90200696.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200098",
    "initial_individuals": "8265",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800517",
    "EFO_Trait_Name": "lactosyl-N-nervonoyl-sphingosine (d18:1/24:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200098/harmonised/GCST90200098.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200251",
    "initial_individuals": "8265",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800661",
    "EFO_Trait_Name": "branched-chain, straight-chain, or cyclopropyl 10:1 fatty acid (1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200251/harmonised/GCST90200251.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200567",
    "initial_individuals": "8265",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800809",
    "EFO_Trait_Name": "X-21353 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200567/harmonised/GCST90200567.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199675",
    "initial_individuals": "8265",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "OBA_2050056",
    "EFO_Trait_Name": "serum homoarginine amount",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199675/harmonised/GCST90199675.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199660",
    "initial_individuals": "8264",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800189",
    "EFO_Trait_Name": "1,2-dipalmitoyl-GPC (16:0/16:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199660/harmonised/GCST90199660.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199711",
    "initial_individuals": "8264",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800211",
    "EFO_Trait_Name": "docosadienoate (22:2n6) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199711/harmonised/GCST90199711.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200061",
    "initial_individuals": "8264",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800419",
    "EFO_Trait_Name": "1-(1-enyl-palmitoyl)-2-oleoyl-GPE (P-16:0/18:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200061/harmonised/GCST90200061.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200078",
    "initial_individuals": "8264",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800453",
    "EFO_Trait_Name": "1-myristoyl-2-arachidonoyl-GPC (14:0/20:4) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200078/harmonised/GCST90200078.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199950",
    "initial_individuals": "8264",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800982",
    "EFO_Trait_Name": "2-aminophenol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199950/harmonised/GCST90199950.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200005",
    "initial_individuals": "8263",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022201",
    "EFO_Trait_Name": "Blood Citraconic acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200005/harmonised/GCST90200005.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200110",
    "initial_individuals": "8263",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800493",
    "EFO_Trait_Name": "palmitoleoylcarnitine (C16:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200110/harmonised/GCST90200110.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199741",
    "initial_individuals": "8263",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800670",
    "EFO_Trait_Name": "gamma-glutamylglycine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199741/harmonised/GCST90199741.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200618",
    "initial_individuals": "8263",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800865",
    "EFO_Trait_Name": "X-23782 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200618/harmonised/GCST90200618.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200641",
    "initial_individuals": "8263",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800913",
    "EFO_Trait_Name": "X-24970 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200641/harmonised/GCST90200641.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199745",
    "initial_individuals": "8262",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010451",
    "EFO_Trait_Name": "aconitate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199745/harmonised/GCST90199745.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200706",
    "initial_individuals": "8262",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021033",
    "EFO_Trait_Name": "biliverdin measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200706/harmonised/GCST90200706.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199669",
    "initial_individuals": "8262",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021038",
    "EFO_Trait_Name": "acetylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199669/harmonised/GCST90199669.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199742",
    "initial_individuals": "8262",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800223",
    "EFO_Trait_Name": "1-linoleoyl-GPC (18:2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199742/harmonised/GCST90199742.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200063",
    "initial_individuals": "8262",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800410",
    "EFO_Trait_Name": "1-palmitoyl-2-docosahexaenoyl-GPE (16:0/22:6) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200063/harmonised/GCST90200063.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200048",
    "initial_individuals": "8262",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800417",
    "EFO_Trait_Name": "1-(1-enyl-palmitoyl)-2-arachidonoyl-GPE (P-16:0/20:4) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200048/harmonised/GCST90200048.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200331",
    "initial_individuals": "8262",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800608",
    "EFO_Trait_Name": "1-palmitoyl-2-oleoyl-GPE (16:0/18:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200331/harmonised/GCST90200331.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199940",
    "initial_individuals": "8262",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800978",
    "EFO_Trait_Name": "guaiacol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199940/harmonised/GCST90199940.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200076",
    "initial_individuals": "8261",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0020014",
    "EFO_Trait_Name": "1-(1-enyl-stearoyl)-2-linoleoyl-GPE (P-18:0/18:2)* measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200076/harmonised/GCST90200076.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199958",
    "initial_individuals": "8261",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800354",
    "EFO_Trait_Name": "1-linolenoyl-GPC (18:3) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199958/harmonised/GCST90199958.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199624",
    "initial_individuals": "8260",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010992",
    "EFO_Trait_Name": "hippurate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199624/harmonised/GCST90199624.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199774",
    "initial_individuals": "8260",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021043",
    "EFO_Trait_Name": "oleoylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199774/harmonised/GCST90199774.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199807",
    "initial_individuals": "8260",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021055",
    "EFO_Trait_Name": "hexadecanedioate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199807/harmonised/GCST90199807.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199659",
    "initial_individuals": "8260",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800188",
    "EFO_Trait_Name": "1-stearoyl-GPI (18:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199659/harmonised/GCST90199659.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199861",
    "initial_individuals": "8260",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800299",
    "EFO_Trait_Name": "pregnenediol sulfate (C21H34O5S) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199861/harmonised/GCST90199861.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199997",
    "initial_individuals": "8260",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800376",
    "EFO_Trait_Name": "behenoyl sphingomyelin (d18:1/22:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199997/harmonised/GCST90199997.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200060",
    "initial_individuals": "8260",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800422",
    "EFO_Trait_Name": "1-(1-enyl-palmitoyl)-2-linoleoyl-GPC (P-16:0/18:2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200060/harmonised/GCST90200060.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200149",
    "initial_individuals": "8260",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800543",
    "EFO_Trait_Name": "ximenoylcarnitine (C26:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200149/harmonised/GCST90200149.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200243",
    "initial_individuals": "8260",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800583",
    "EFO_Trait_Name": "hydroxypalmitoyl sphingomyelin (d18:1/16:0(OH)) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200243/harmonised/GCST90200243.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200354",
    "initial_individuals": "8260",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800614",
    "EFO_Trait_Name": "linoleate (18:2n6) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200354/harmonised/GCST90200354.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200266",
    "initial_individuals": "8259",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0004725",
    "EFO_Trait_Name": "metabolite measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200266/harmonised/GCST90200266.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200371",
    "initial_individuals": "8259",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021008",
    "EFO_Trait_Name": "3- 4-hydroxyphenyl lactate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200371/harmonised/GCST90200371.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199765",
    "initial_individuals": "8259",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021508",
    "EFO_Trait_Name": "4-hydroxyhippurate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199765/harmonised/GCST90199765.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200691",
    "initial_individuals": "8259",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800067",
    "EFO_Trait_Name": "N-delta-acetylornithine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200691/harmonised/GCST90200691.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200014",
    "initial_individuals": "8259",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800379",
    "EFO_Trait_Name": "3beta-hydroxy-5-cholestenoate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200014/harmonised/GCST90200014.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200045",
    "initial_individuals": "8259",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800403",
    "EFO_Trait_Name": "1-stearoyl-2-arachidonoyl-GPE (18:0/20:4) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200045/harmonised/GCST90200045.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200145",
    "initial_individuals": "8259",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800551",
    "EFO_Trait_Name": "glycosyl ceramide (d18:1/20:0, d16:1/22:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200145/harmonised/GCST90200145.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200328",
    "initial_individuals": "8258",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021009",
    "EFO_Trait_Name": "3-methoxytyrosine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200328/harmonised/GCST90200328.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199864",
    "initial_individuals": "8258",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800160",
    "EFO_Trait_Name": "gamma-CEHC measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199864/harmonised/GCST90199864.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199909",
    "initial_individuals": "8258",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800330",
    "EFO_Trait_Name": "eicosanedioate (C20-DC) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199909/harmonised/GCST90199909.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200044",
    "initial_individuals": "8258",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800395",
    "EFO_Trait_Name": "1-(1-enyl-stearoyl)-2-oleoyl-GPE (P-18:0/18:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200044/harmonised/GCST90200044.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200335",
    "initial_individuals": "8258",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800611",
    "EFO_Trait_Name": "stearoyl sphingomyelin (d18:1/18:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200335/harmonised/GCST90200335.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199631",
    "initial_individuals": "8257",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021021",
    "EFO_Trait_Name": "3-methyl-2-oxovalerate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199631/harmonised/GCST90199631.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199748",
    "initial_individuals": "8257",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021050",
    "EFO_Trait_Name": "linolenate [alpha or gamma; 18:3n3 or 6] measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199748/harmonised/GCST90199748.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200001",
    "initial_individuals": "8257",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022109",
    "EFO_Trait_Name": "Sphingomyelin (d18:1/20:0, d16:1/22:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200001/harmonised/GCST90200001.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199727",
    "initial_individuals": "8257",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800218",
    "EFO_Trait_Name": "1-oleoyl-GPC (18:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199727/harmonised/GCST90199727.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199979",
    "initial_individuals": "8257",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800373",
    "EFO_Trait_Name": "myristoleoylcarnitine (C14:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199979/harmonised/GCST90199979.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200028",
    "initial_individuals": "8257",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800389",
    "EFO_Trait_Name": "1-stearoyl-2-oleoyl-GPC (18:0/18:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200028/harmonised/GCST90200028.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200046",
    "initial_individuals": "8257",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800392",
    "EFO_Trait_Name": "1-stearoyl-2-docosahexaenoyl-GPC (18:0/22:6) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200046/harmonised/GCST90200046.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200034",
    "initial_individuals": "8257",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800401",
    "EFO_Trait_Name": "tricosanoyl sphingomyelin (d18:1/23:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200034/harmonised/GCST90200034.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200054",
    "initial_individuals": "8257",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800409",
    "EFO_Trait_Name": "1-palmitoyl-2-arachidonoyl-GPE (16:0/20:4) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200054/harmonised/GCST90200054.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200349",
    "initial_individuals": "8257",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800616",
    "EFO_Trait_Name": "eicosapentaenoate (EPA; 20:5n3) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200349/harmonised/GCST90200349.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200570",
    "initial_individuals": "8257",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800796",
    "EFO_Trait_Name": "X-18921 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200570/harmonised/GCST90200570.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200563",
    "initial_individuals": "8257",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800810",
    "EFO_Trait_Name": "X-21355 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200563/harmonised/GCST90200563.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199666",
    "initial_individuals": "8256",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021044",
    "EFO_Trait_Name": "palmitoylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199666/harmonised/GCST90199666.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199639",
    "initial_individuals": "8256",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800004",
    "EFO_Trait_Name": "imidazole lactate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199639/harmonised/GCST90199639.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200319",
    "initial_individuals": "8256",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800122",
    "EFO_Trait_Name": "cys-gly, oxidized measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200319/harmonised/GCST90200319.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200142",
    "initial_individuals": "8256",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800170",
    "EFO_Trait_Name": "carotene diol (1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200142/harmonised/GCST90200142.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200043",
    "initial_individuals": "8256",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800391",
    "EFO_Trait_Name": "1-palmitoyl-2-docosahexaenoyl-GPC (16:0/22:6) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200043/harmonised/GCST90200043.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200249",
    "initial_individuals": "8256",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800662",
    "EFO_Trait_Name": "branched-chain, straight-chain, or cyclopropyl 12:1 fatty acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200249/harmonised/GCST90200249.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200184",
    "initial_individuals": "8256",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801025",
    "EFO_Trait_Name": "3-formylindole measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200184/harmonised/GCST90200184.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199655",
    "initial_individuals": "8255",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021022",
    "EFO_Trait_Name": "4-methyl-2-oxopentanoate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199655/harmonised/GCST90199655.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199715",
    "initial_individuals": "8255",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021068",
    "EFO_Trait_Name": "myristoleate 14:1n5 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199715/harmonised/GCST90199715.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200510",
    "initial_individuals": "8255",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021320",
    "EFO_Trait_Name": "X-12680 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200510/harmonised/GCST90200510.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199996",
    "initial_individuals": "8255",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022110",
    "EFO_Trait_Name": "Sphingomyelin (d18:1/20:1, d18:2/20:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199996/harmonised/GCST90199996.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199907",
    "initial_individuals": "8255",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800058",
    "EFO_Trait_Name": "S-methylcysteine sulfoxide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199907/harmonised/GCST90199907.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200258",
    "initial_individuals": "8255",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800113",
    "EFO_Trait_Name": "2-hydroxy-4-(methylthio)butanoic acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200258/harmonised/GCST90200258.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200187",
    "initial_individuals": "8255",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800570",
    "EFO_Trait_Name": "tetradecadienoate (14:2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200187/harmonised/GCST90200187.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199677",
    "initial_individuals": "8254",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021020",
    "EFO_Trait_Name": "3-methyl-2-oxobutyrate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199677/harmonised/GCST90199677.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199945",
    "initial_individuals": "8254",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022105",
    "EFO_Trait_Name": "Sphingomyelin (d18:1/14:0, d16:1/16:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199945/harmonised/GCST90199945.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199961",
    "initial_individuals": "8254",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800072",
    "EFO_Trait_Name": "methionine sulfone measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199961/harmonised/GCST90199961.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200058",
    "initial_individuals": "8254",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800415",
    "EFO_Trait_Name": "1-(1-enyl-stearoyl)-2-arachidonoyl-GPE (P-18:0/20:4) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200058/harmonised/GCST90200058.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200049",
    "initial_individuals": "8254",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800433",
    "EFO_Trait_Name": "myristoyl dihydrosphingomyelin (d18:0/14:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200049/harmonised/GCST90200049.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200075",
    "initial_individuals": "8254",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800440",
    "EFO_Trait_Name": "1-(1-enyl-palmitoyl)-2-linoleoyl-GPE (P-16:0/18:2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200075/harmonised/GCST90200075.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200154",
    "initial_individuals": "8254",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800557",
    "EFO_Trait_Name": "hydroxy-CMPF measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200154/harmonised/GCST90200154.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200341",
    "initial_individuals": "8254",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800613",
    "EFO_Trait_Name": "N-stearoyl-sphingosine (d18:1/18:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200341/harmonised/GCST90200341.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200534",
    "initial_individuals": "8254",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800761",
    "EFO_Trait_Name": "X-16580 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200534/harmonised/GCST90200534.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200407",
    "initial_individuals": "8253",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010546",
    "EFO_Trait_Name": "uridine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200407/harmonised/GCST90200407.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200685",
    "initial_individuals": "8253",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800271",
    "EFO_Trait_Name": "1-stearoyl-2-arachidonoyl-GPC (18:0/20:4) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200685/harmonised/GCST90200685.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200183",
    "initial_individuals": "8253",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800567",
    "EFO_Trait_Name": "N-acetyl-2-aminooctanoate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200183/harmonised/GCST90200183.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200236",
    "initial_individuals": "8253",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800588",
    "EFO_Trait_Name": "undecenoylcarnitine (C11:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200236/harmonised/GCST90200236.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200281",
    "initial_individuals": "8253",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800600",
    "EFO_Trait_Name": "phosphoethanolamine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200281/harmonised/GCST90200281.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200456",
    "initial_individuals": "8253",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800693",
    "EFO_Trait_Name": "X-11308 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200456/harmonised/GCST90200456.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200286",
    "initial_individuals": "8252",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010456",
    "EFO_Trait_Name": "allantoin measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200286/harmonised/GCST90200286.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200047",
    "initial_individuals": "8252",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022107",
    "EFO_Trait_Name": "Sphingomyelin (d18:1/17:0, d17:1/18:0, d19:1/16:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200047/harmonised/GCST90200047.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200019",
    "initial_individuals": "8252",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800082",
    "EFO_Trait_Name": "dopamine 3-O-sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200019/harmonised/GCST90200019.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200292",
    "initial_individuals": "8252",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800114",
    "EFO_Trait_Name": "trans-4-hydroxyproline measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200292/harmonised/GCST90200292.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199822",
    "initial_individuals": "8252",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800265",
    "EFO_Trait_Name": "1-oleoyl-GPI (18:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199822/harmonised/GCST90199822.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199882",
    "initial_individuals": "8252",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800312",
    "EFO_Trait_Name": "2s,3R-dihydroxybutyrate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199882/harmonised/GCST90199882.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199898",
    "initial_individuals": "8252",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800326",
    "EFO_Trait_Name": "glycoursodeoxycholate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199898/harmonised/GCST90199898.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200527",
    "initial_individuals": "8252",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800745",
    "EFO_Trait_Name": "X-13866 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200527/harmonised/GCST90200527.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199768",
    "initial_individuals": "8251",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021013",
    "EFO_Trait_Name": "phenylacetylglutamine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199768/harmonised/GCST90199768.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200276",
    "initial_individuals": "8251",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022221",
    "EFO_Trait_Name": "Blood 2,4-di-tert-butylphenol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200276/harmonised/GCST90200276.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200065",
    "initial_individuals": "8251",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800411",
    "EFO_Trait_Name": "1-stearoyl-2-docosahexaenoyl-GPE (18:0/22:6) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200065/harmonised/GCST90200065.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200052",
    "initial_individuals": "8251",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800423",
    "EFO_Trait_Name": "1-(1-enyl-palmitoyl)-2-arachidonoyl-GPC (P-16:0/20:4) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200052/harmonised/GCST90200052.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200118",
    "initial_individuals": "8251",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800532",
    "EFO_Trait_Name": "glycosyl ceramide (d18:2/24:1, d18:1/24:2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200118/harmonised/GCST90200118.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200460",
    "initial_individuals": "8251",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800694",
    "EFO_Trait_Name": "X-11372 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200460/harmonised/GCST90200460.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200611",
    "initial_individuals": "8251",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800852",
    "EFO_Trait_Name": "X-23636 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200611/harmonised/GCST90200611.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199688",
    "initial_individuals": "8250",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021002",
    "EFO_Trait_Name": "N-acetylglycine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199688/harmonised/GCST90199688.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199658",
    "initial_individuals": "8250",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800009",
    "EFO_Trait_Name": "alpha-hydroxyisocaproate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199658/harmonised/GCST90199658.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199841",
    "initial_individuals": "8250",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800276",
    "EFO_Trait_Name": "glycocholenate sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199841/harmonised/GCST90199841.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200020",
    "initial_individuals": "8250",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800377",
    "EFO_Trait_Name": "lignoceroyl sphingomyelin (d18:1/24:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200020/harmonised/GCST90200020.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200107",
    "initial_individuals": "8250",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800689",
    "EFO_Trait_Name": "gamma-glutamyl-alpha-lysine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200107/harmonised/GCST90200107.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200539",
    "initial_individuals": "8250",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800747",
    "EFO_Trait_Name": "X-14939 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200539/harmonised/GCST90200539.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200607",
    "initial_individuals": "8250",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800855",
    "EFO_Trait_Name": "X-23644 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200607/harmonised/GCST90200607.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199773",
    "initial_individuals": "8249",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021011",
    "EFO_Trait_Name": "phenol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199773/harmonised/GCST90199773.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199789",
    "initial_individuals": "8249",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800241",
    "EFO_Trait_Name": "2-palmitoyl-GPC (16:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199789/harmonised/GCST90199789.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199839",
    "initial_individuals": "8249",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800277",
    "EFO_Trait_Name": "taurocholenate sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199839/harmonised/GCST90199839.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199910",
    "initial_individuals": "8249",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800335",
    "EFO_Trait_Name": "1-(1-enyl-stearoyl)-GPE (P-18:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199910/harmonised/GCST90199910.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200088",
    "initial_individuals": "8249",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800475",
    "EFO_Trait_Name": "(S)-3-hydroxybutyrylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200088/harmonised/GCST90200088.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200340",
    "initial_individuals": "8249",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800612",
    "EFO_Trait_Name": "1-palmitoyl-2-oleoyl-GPC (16:0/18:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200340/harmonised/GCST90200340.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200608",
    "initial_individuals": "8249",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800839",
    "EFO_Trait_Name": "X-22162 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200608/harmonised/GCST90200608.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200621",
    "initial_individuals": "8249",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800863",
    "EFO_Trait_Name": "X-23739 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200621/harmonised/GCST90200621.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199723",
    "initial_individuals": "8248",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021100",
    "EFO_Trait_Name": "5-dodecenoate 12:1n7 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199723/harmonised/GCST90199723.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199787",
    "initial_individuals": "8248",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021164",
    "EFO_Trait_Name": "homostachydrine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199787/harmonised/GCST90199787.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200164",
    "initial_individuals": "8248",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800562",
    "EFO_Trait_Name": "hexadecenedioate (C16:1-DC) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200164/harmonised/GCST90200164.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200387",
    "initial_individuals": "8247",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010491",
    "EFO_Trait_Name": "glycocholate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200387/harmonised/GCST90200387.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200280",
    "initial_individuals": "8247",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010988",
    "EFO_Trait_Name": "5-oxoproline measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200280/harmonised/GCST90200280.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200313",
    "initial_individuals": "8247",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021122",
    "EFO_Trait_Name": "N1-methyladenosine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200313/harmonised/GCST90200313.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200465",
    "initial_individuals": "8247",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021258",
    "EFO_Trait_Name": "X-11787 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200465/harmonised/GCST90200465.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199795",
    "initial_individuals": "8247",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021507",
    "EFO_Trait_Name": "2-hydroxypalmitate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199795/harmonised/GCST90199795.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200405",
    "initial_individuals": "8247",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "OBA_1000995",
    "EFO_Trait_Name": "retinol amount",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200405/harmonised/GCST90200405.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200010",
    "initial_individuals": "8246",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022112",
    "EFO_Trait_Name": "Sphingomyelin (d18:1/22:1, d18:2/22:0, d16:1/24:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200010/harmonised/GCST90200010.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199786",
    "initial_individuals": "8246",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800027",
    "EFO_Trait_Name": "2-hydroxy-3-methylvalerate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199786/harmonised/GCST90199786.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199657",
    "initial_individuals": "8246",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800185",
    "EFO_Trait_Name": "sphingosine 1-phosphate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199657/harmonised/GCST90199657.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199810",
    "initial_individuals": "8246",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800257",
    "EFO_Trait_Name": "1-palmitoyl-GPI (16:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199810/harmonised/GCST90199810.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199840",
    "initial_individuals": "8245",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800279",
    "EFO_Trait_Name": "pregnenediol disulfate (C21H34O8S2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199840/harmonised/GCST90199840.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199970",
    "initial_individuals": "8245",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800370",
    "EFO_Trait_Name": "octadecenedioylcarnitine (C18:1-DC) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199970/harmonised/GCST90199970.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200085",
    "initial_individuals": "8245",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800476",
    "EFO_Trait_Name": "glycosyl-N-palmitoyl-sphingosine (d18:1/16:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200085/harmonised/GCST90200085.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200363",
    "initial_individuals": "8245",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800617",
    "EFO_Trait_Name": "choline phosphate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200363/harmonised/GCST90200363.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200347",
    "initial_individuals": "8244",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010532",
    "EFO_Trait_Name": "salicylurate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200347/harmonised/GCST90200347.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200375",
    "initial_individuals": "8244",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021137",
    "EFO_Trait_Name": "gamma-glutamylglutamate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200375/harmonised/GCST90200375.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200190",
    "initial_individuals": "8244",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800572",
    "EFO_Trait_Name": "dodecadienoate (12:2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200190/harmonised/GCST90200190.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200711",
    "initial_individuals": "8244",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800799",
    "EFO_Trait_Name": "X-19141 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200711/harmonised/GCST90200711.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199698",
    "initial_individuals": "8243",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021023",
    "EFO_Trait_Name": "isobutyrylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199698/harmonised/GCST90199698.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199716",
    "initial_individuals": "8243",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021099",
    "EFO_Trait_Name": "10-undecenoate 11:1n1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199716/harmonised/GCST90199716.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199625",
    "initial_individuals": "8243",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021650",
    "EFO_Trait_Name": "Methionine sulfoxide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199625/harmonised/GCST90199625.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200351",
    "initial_individuals": "8243",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800127",
    "EFO_Trait_Name": "N-acetylputrescine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200351/harmonised/GCST90200351.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200299",
    "initial_individuals": "8243",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800604",
    "EFO_Trait_Name": "oleoyl ethanolamide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200299/harmonised/GCST90200299.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199656",
    "initial_individuals": "8242",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010502",
    "EFO_Trait_Name": "indoxyl sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199656/harmonised/GCST90199656.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200305",
    "initial_individuals": "8242",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0020017",
    "EFO_Trait_Name": "2-aminobutyrate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200305/harmonised/GCST90200305.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199668",
    "initial_individuals": "8242",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021040",
    "EFO_Trait_Name": "hexanoylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199668/harmonised/GCST90199668.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199803",
    "initial_individuals": "8242",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021151",
    "EFO_Trait_Name": "catechol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199803/harmonised/GCST90199803.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200463",
    "initial_individuals": "8242",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021242",
    "EFO_Trait_Name": "X-11478 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200463/harmonised/GCST90200463.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200526",
    "initial_individuals": "8242",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021361",
    "EFO_Trait_Name": "X-14056 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200526/harmonised/GCST90200526.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200053",
    "initial_individuals": "8242",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022111",
    "EFO_Trait_Name": "Sphingomyelin (d18:1/21:0, d17:1/22:0, d16:1/23:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200053/harmonised/GCST90200053.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199826",
    "initial_individuals": "8242",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800036",
    "EFO_Trait_Name": "N6-acetyllysine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199826/harmonised/GCST90199826.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199750",
    "initial_individuals": "8241",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021041",
    "EFO_Trait_Name": "laurylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199750/harmonised/GCST90199750.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200312",
    "initial_individuals": "8241",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021059",
    "EFO_Trait_Name": "2-hydroxystearate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200312/harmonised/GCST90200312.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200365",
    "initial_individuals": "8241",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800132",
    "EFO_Trait_Name": "phenylpyruvate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200365/harmonised/GCST90200365.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200454",
    "initial_individuals": "8241",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800141",
    "EFO_Trait_Name": "kynurenate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200454/harmonised/GCST90200454.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199730",
    "initial_individuals": "8241",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800216",
    "EFO_Trait_Name": "myristoylcarnitine (C14) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199730/harmonised/GCST90199730.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200039",
    "initial_individuals": "8241",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800402",
    "EFO_Trait_Name": "1-stearoyl-2-linoleoyl-GPE (18:0/18:2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200039/harmonised/GCST90200039.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199869",
    "initial_individuals": "8241",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800960",
    "EFO_Trait_Name": "3-hydroxyhippurate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199869/harmonised/GCST90199869.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199697",
    "initial_individuals": "8240",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021054",
    "EFO_Trait_Name": "dodecanedioate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199697/harmonised/GCST90199697.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199721",
    "initial_individuals": "8240",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021075",
    "EFO_Trait_Name": "stearidonate 18:4n3 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199721/harmonised/GCST90199721.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200224",
    "initial_individuals": "8240",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800110",
    "EFO_Trait_Name": "2-ketocaprylate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200224/harmonised/GCST90200224.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199732",
    "initial_individuals": "8240",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800217",
    "EFO_Trait_Name": "1-stearoyl-GPC (18:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199732/harmonised/GCST90199732.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199847",
    "initial_individuals": "8240",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800958",
    "EFO_Trait_Name": "4-allylphenol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199847/harmonised/GCST90199847.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199771",
    "initial_individuals": "8239",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021123",
    "EFO_Trait_Name": "7-methylguanine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199771/harmonised/GCST90199771.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199891",
    "initial_individuals": "8239",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800054",
    "EFO_Trait_Name": "S-methylcysteine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199891/harmonised/GCST90199891.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199693",
    "initial_individuals": "8239",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800198",
    "EFO_Trait_Name": "3-hydroxydecanoate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199693/harmonised/GCST90199693.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199880",
    "initial_individuals": "8239",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800311",
    "EFO_Trait_Name": "cis-4-decenoylcarnitine (C10:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199880/harmonised/GCST90199880.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199887",
    "initial_individuals": "8239",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800313",
    "EFO_Trait_Name": "(16 or 17)-methylstearate (a19:0 or i19:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199887/harmonised/GCST90199887.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200649",
    "initial_individuals": "8239",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800898",
    "EFO_Trait_Name": "X-24588 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200649/harmonised/GCST90200649.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199690",
    "initial_individuals": "8239",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800946",
    "EFO_Trait_Name": "EDTA measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199690/harmonised/GCST90199690.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200473",
    "initial_individuals": "8238",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021261",
    "EFO_Trait_Name": "X-11795 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200473/harmonised/GCST90200473.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199714",
    "initial_individuals": "8238",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800014",
    "EFO_Trait_Name": "3-hydroxy-2-ethylpropionate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199714/harmonised/GCST90199714.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199799",
    "initial_individuals": "8238",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800030",
    "EFO_Trait_Name": "glutarylcarnitine (C5-DC) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199799/harmonised/GCST90199799.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199965",
    "initial_individuals": "8238",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800073",
    "EFO_Trait_Name": "fructosyllysine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199965/harmonised/GCST90199965.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200384",
    "initial_individuals": "8238",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800135",
    "EFO_Trait_Name": "guanidinoacetate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200384/harmonised/GCST90200384.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199952",
    "initial_individuals": "8238",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800352",
    "EFO_Trait_Name": "2-aminoheptanoate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199952/harmonised/GCST90199952.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200692",
    "initial_individuals": "8238",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800390",
    "EFO_Trait_Name": "1-palmitoyl-2-arachidonoyl-GPC (16:0/20:4n6) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200692/harmonised/GCST90200692.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200137",
    "initial_individuals": "8238",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800541",
    "EFO_Trait_Name": "lignoceroylcarnitine (C24) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200137/harmonised/GCST90200137.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200372",
    "initial_individuals": "8237",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0020990",
    "EFO_Trait_Name": "arginine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200372/harmonised/GCST90200372.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199751",
    "initial_individuals": "8237",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021141",
    "EFO_Trait_Name": "gamma-glutamylmethionine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199751/harmonised/GCST90199751.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200188",
    "initial_individuals": "8237",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800097",
    "EFO_Trait_Name": "3-amino-2-piperidone measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200188/harmonised/GCST90200188.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200246",
    "initial_individuals": "8237",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800590",
    "EFO_Trait_Name": "3-hydroxydecanoylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200246/harmonised/GCST90200246.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200543",
    "initial_individuals": "8237",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800753",
    "EFO_Trait_Name": "X-15503 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200543/harmonised/GCST90200543.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199804",
    "initial_individuals": "8236",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021116",
    "EFO_Trait_Name": "7-alpha-hydroxy-3-oxo-4-cholestenoate 7-Hoca measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199804/harmonised/GCST90199804.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200195",
    "initial_individuals": "8236",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800107",
    "EFO_Trait_Name": "N-acetyl-isoputreanine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200195/harmonised/GCST90200195.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199863",
    "initial_individuals": "8236",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800301",
    "EFO_Trait_Name": "16a-hydroxy DHEA 3-sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199863/harmonised/GCST90199863.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199923",
    "initial_individuals": "8236",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800342",
    "EFO_Trait_Name": "N-palmitoylglycine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199923/harmonised/GCST90199923.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200693",
    "initial_individuals": "8236",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800474",
    "EFO_Trait_Name": "glycochenodeoxycholate glucuronide (1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200693/harmonised/GCST90200693.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200495",
    "initial_individuals": "8236",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800717",
    "EFO_Trait_Name": "X-12462 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200495/harmonised/GCST90200495.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200533",
    "initial_individuals": "8236",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800751",
    "EFO_Trait_Name": "X-15486 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200533/harmonised/GCST90200533.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199664",
    "initial_individuals": "8235",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021662",
    "EFO_Trait_Name": "Phenyllactate (PLA) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199664/harmonised/GCST90199664.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199674",
    "initial_individuals": "8235",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022197",
    "EFO_Trait_Name": "Blood 3-hydroxymyristate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199674/harmonised/GCST90199674.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200343",
    "initial_individuals": "8235",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800128",
    "EFO_Trait_Name": "N-formylmethionine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200343/harmonised/GCST90200343.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200259",
    "initial_individuals": "8235",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800660",
    "EFO_Trait_Name": "pentose acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200259/harmonised/GCST90200259.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199892",
    "initial_individuals": "8234",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800315",
    "EFO_Trait_Name": "isoursodeoxycholate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199892/harmonised/GCST90199892.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200172",
    "initial_individuals": "8234",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800566",
    "EFO_Trait_Name": "3-carboxy-4-methyl-5-pentyl-2-furanpropionate (3-CMPFP) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200172/harmonised/GCST90200172.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199650",
    "initial_individuals": "8233",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0020012",
    "EFO_Trait_Name": "indolelactate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199650/harmonised/GCST90199650.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199926",
    "initial_individuals": "8233",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022217",
    "EFO_Trait_Name": "Blood N-acetylcarnosine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199926/harmonised/GCST90199926.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199832",
    "initial_individuals": "8233",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800037",
    "EFO_Trait_Name": "dimethylarginine (SDMA + ADMA) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199832/harmonised/GCST90199832.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199846",
    "initial_individuals": "8233",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800275",
    "EFO_Trait_Name": "glycosyl-N-stearoyl-sphingosine (d18:1/18:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199846/harmonised/GCST90199846.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200241",
    "initial_individuals": "8233",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800586",
    "EFO_Trait_Name": "pregnenetriol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200241/harmonised/GCST90200241.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200173",
    "initial_individuals": "8233",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800658",
    "EFO_Trait_Name": "glutamine conjugate of C6H10O2 (2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200173/harmonised/GCST90200173.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199938",
    "initial_individuals": "8233",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800975",
    "EFO_Trait_Name": "3-methyl catechol sulfate (1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199938/harmonised/GCST90199938.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200425",
    "initial_individuals": "8232",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0007787",
    "EFO_Trait_Name": "plasma betaine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200425/harmonised/GCST90200425.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199802",
    "initial_individuals": "8232",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800031",
    "EFO_Trait_Name": "beta-hydroxyisovaleroylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199802/harmonised/GCST90199802.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200381",
    "initial_individuals": "8232",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800136",
    "EFO_Trait_Name": "S-1-pyrroline-5-carboxylate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200381/harmonised/GCST90200381.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199733",
    "initial_individuals": "8232",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800214",
    "EFO_Trait_Name": "1-palmitoyl-GPC (16:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199733/harmonised/GCST90199733.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200105",
    "initial_individuals": "8232",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800520",
    "EFO_Trait_Name": "glycosyl-N-behenoyl-sphingadienine (d18:2/22:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200105/harmonised/GCST90200105.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200584",
    "initial_individuals": "8232",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800821",
    "EFO_Trait_Name": "X-21736 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200584/harmonised/GCST90200584.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200451",
    "initial_individuals": "8231",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021069",
    "EFO_Trait_Name": "nonadecanoate 19:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200451/harmonised/GCST90200451.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199749",
    "initial_individuals": "8231",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021143",
    "EFO_Trait_Name": "gamma-glutamylthreonine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199749/harmonised/GCST90199749.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200523",
    "initial_individuals": "8231",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021339",
    "EFO_Trait_Name": "X-12844 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200523/harmonised/GCST90200523.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199866",
    "initial_individuals": "8231",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021430",
    "EFO_Trait_Name": "N-acetyl-beta-alanine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199866/harmonised/GCST90199866.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200066",
    "initial_individuals": "8231",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800168",
    "EFO_Trait_Name": "beta-tocopherol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200066/harmonised/GCST90200066.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199808",
    "initial_individuals": "8231",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800253",
    "EFO_Trait_Name": "glycerophosphoethanolamine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199808/harmonised/GCST90199808.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199867",
    "initial_individuals": "8231",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800309",
    "EFO_Trait_Name": "tridecenedioate (C13:1-DC) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199867/harmonised/GCST90199867.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200037",
    "initial_individuals": "8231",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800404",
    "EFO_Trait_Name": "1-stearoyl-2-linoleoyl-GPC (18:0/18:2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200037/harmonised/GCST90200037.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200170",
    "initial_individuals": "8231",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800565",
    "EFO_Trait_Name": "octadecadienedioate (C18:2-DC) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200170/harmonised/GCST90200170.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200562",
    "initial_individuals": "8231",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800804",
    "EFO_Trait_Name": "X-21286 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200562/harmonised/GCST90200562.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199896",
    "initial_individuals": "8230",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0007864",
    "EFO_Trait_Name": "sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199896/harmonised/GCST90199896.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200042",
    "initial_individuals": "8230",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800397",
    "EFO_Trait_Name": "vaccenate (18:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200042/harmonised/GCST90200042.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200051",
    "initial_individuals": "8230",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800407",
    "EFO_Trait_Name": "1-palmitoyl-2-dihomo-linolenoyl-GPC (16:0/20:3n3 or 6) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200051/harmonised/GCST90200051.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200330",
    "initial_individuals": "8230",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800610",
    "EFO_Trait_Name": "1-palmitoyl-2-linoleoyl-GPC (16:0/18:2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200330/harmonised/GCST90200330.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199671",
    "initial_individuals": "8229",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800013",
    "EFO_Trait_Name": "cysteine s-sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199671/harmonised/GCST90199671.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199872",
    "initial_individuals": "8229",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800294",
    "EFO_Trait_Name": "androstenediol (3beta,17beta) monosulfate (1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199872/harmonised/GCST90199872.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199939",
    "initial_individuals": "8229",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800974",
    "EFO_Trait_Name": "4-methylcatechol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199939/harmonised/GCST90199939.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200002",
    "initial_individuals": "8229",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801004",
    "EFO_Trait_Name": "6-hydroxyindole sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200002/harmonised/GCST90200002.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199673",
    "initial_individuals": "8228",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0007001",
    "EFO_Trait_Name": "dehydroepiandrosterone sulphate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199673/harmonised/GCST90199673.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200677",
    "initial_individuals": "8228",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800019",
    "EFO_Trait_Name": "N-acetylphenylalanine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200677/harmonised/GCST90200677.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200238",
    "initial_individuals": "8228",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800587",
    "EFO_Trait_Name": "pregnenetriol disulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200238/harmonised/GCST90200238.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200446",
    "initial_individuals": "8228",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800625",
    "EFO_Trait_Name": "arachidate (20:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200446/harmonised/GCST90200446.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199777",
    "initial_individuals": "8227",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800231",
    "EFO_Trait_Name": "1-palmitoleoyl-GPC (16:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199777/harmonised/GCST90199777.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199906",
    "initial_individuals": "8227",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800334",
    "EFO_Trait_Name": "1-(1-enyl-palmitoyl)-GPE (P-16:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199906/harmonised/GCST90199906.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200030",
    "initial_individuals": "8227",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800388",
    "EFO_Trait_Name": "1,2-dilinoleoyl-GPC (18:2/18:2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200030/harmonised/GCST90200030.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200228",
    "initial_individuals": "8227",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800580",
    "EFO_Trait_Name": "3-hydroxyhexanoylcarnitine (1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200228/harmonised/GCST90200228.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199837",
    "initial_individuals": "8226",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0007897",
    "EFO_Trait_Name": "cryptoxanthin measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199837/harmonised/GCST90199837.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199720",
    "initial_individuals": "8226",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021042",
    "EFO_Trait_Name": "octanoylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199720/harmonised/GCST90199720.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200350",
    "initial_individuals": "8226",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021105",
    "EFO_Trait_Name": "laurate 12:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200350/harmonised/GCST90200350.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199691",
    "initial_individuals": "8226",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021543",
    "EFO_Trait_Name": "1-Methylhistidine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199691/harmonised/GCST90199691.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199900",
    "initial_individuals": "8226",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800055",
    "EFO_Trait_Name": "argininate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199900/harmonised/GCST90199900.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199911",
    "initial_individuals": "8226",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800060",
    "EFO_Trait_Name": "beta-citrylglutamate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199911/harmonised/GCST90199911.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200591",
    "initial_individuals": "8226",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800812",
    "EFO_Trait_Name": "X-21383 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200591/harmonised/GCST90200591.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200072",
    "initial_individuals": "8226",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801012",
    "EFO_Trait_Name": "thioproline measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200072/harmonised/GCST90200072.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199722",
    "initial_individuals": "8225",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021039",
    "EFO_Trait_Name": "decanoylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199722/harmonised/GCST90199722.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200471",
    "initial_individuals": "8225",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021228",
    "EFO_Trait_Name": "X-11381 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200471/harmonised/GCST90200471.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200233",
    "initial_individuals": "8225",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800111",
    "EFO_Trait_Name": "2,3-dihydroxy-5-methylthio-4-pentenoate (DMTPA) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200233/harmonised/GCST90200233.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199676",
    "initial_individuals": "8225",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800195",
    "EFO_Trait_Name": "1-oleoylglycerol (18:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199676/harmonised/GCST90199676.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199913",
    "initial_individuals": "8225",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800331",
    "EFO_Trait_Name": "docosadioate (C22-DC) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199913/harmonised/GCST90199913.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199943",
    "initial_individuals": "8225",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800980",
    "EFO_Trait_Name": "2-piperidinone measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199943/harmonised/GCST90199943.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200424",
    "initial_individuals": "8224",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010476",
    "EFO_Trait_Name": "dimethylglycine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200424/harmonised/GCST90200424.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199681",
    "initial_individuals": "8224",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800192",
    "EFO_Trait_Name": "2-hydroxyoctanoate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199681/harmonised/GCST90199681.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199805",
    "initial_individuals": "8223",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021056",
    "EFO_Trait_Name": "octadecanedioate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199805/harmonised/GCST90199805.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200291",
    "initial_individuals": "8223",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021668",
    "EFO_Trait_Name": "Sarcosine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200291/harmonised/GCST90200291.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199726",
    "initial_individuals": "8223",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800020",
    "EFO_Trait_Name": "N-acetylthreonine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199726/harmonised/GCST90199726.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199903",
    "initial_individuals": "8223",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800056",
    "EFO_Trait_Name": "2-oxoarginine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199903/harmonised/GCST90199903.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200194",
    "initial_individuals": "8223",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800101",
    "EFO_Trait_Name": "1-carboxyethylphenylalanine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200194/harmonised/GCST90200194.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199889",
    "initial_individuals": "8223",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800314",
    "EFO_Trait_Name": "2R,3R-dihydroxybutyrate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199889/harmonised/GCST90199889.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200248",
    "initial_individuals": "8223",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801011",
    "EFO_Trait_Name": "3,4-methyleneheptanoate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200248/harmonised/GCST90200248.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200410",
    "initial_individuals": "8223",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801065",
    "EFO_Trait_Name": "phytanate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200410/harmonised/GCST90200410.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200290",
    "initial_individuals": "8222",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021029",
    "EFO_Trait_Name": "glycerate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200290/harmonised/GCST90200290.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199842",
    "initial_individuals": "8222",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800278",
    "EFO_Trait_Name": "androstenediol (3beta,17beta) disulfate (1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199842/harmonised/GCST90199842.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200057",
    "initial_individuals": "8222",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800420",
    "EFO_Trait_Name": "1-(1-enyl-palmitoyl)-2-oleoyl-GPC (P-16:0/18:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200057/harmonised/GCST90200057.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200215",
    "initial_individuals": "8222",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801040",
    "EFO_Trait_Name": "4-ethylcatechol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200215/harmonised/GCST90200215.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200295",
    "initial_individuals": "8221",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021144",
    "EFO_Trait_Name": "gamma-glutamyltyrosine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200295/harmonised/GCST90200295.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200662",
    "initial_individuals": "8221",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800933",
    "EFO_Trait_Name": "X-25790 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200662/harmonised/GCST90200662.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199971",
    "initial_individuals": "8220",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800074",
    "EFO_Trait_Name": "3-methylglutarylcarnitine (2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199971/harmonised/GCST90199971.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200181",
    "initial_individuals": "8220",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800094",
    "EFO_Trait_Name": "N,N,N-trimethyl-alanylproline betaine (TMAP) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200181/harmonised/GCST90200181.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200303",
    "initial_individuals": "8220",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800118",
    "EFO_Trait_Name": "N-acetylalanine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200303/harmonised/GCST90200303.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200315",
    "initial_individuals": "8220",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800691",
    "EFO_Trait_Name": "gamma-glutamylhistidine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200315/harmonised/GCST90200315.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200153",
    "initial_individuals": "8219",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022205",
    "EFO_Trait_Name": "Blood N(8)-acetylspermidine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200153/harmonised/GCST90200153.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200192",
    "initial_individuals": "8219",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800098",
    "EFO_Trait_Name": "N,N-dimethylalanine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200192/harmonised/GCST90200192.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200011",
    "initial_individuals": "8219",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800148",
    "EFO_Trait_Name": "arabitol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200011/harmonised/GCST90200011.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200339",
    "initial_individuals": "8219",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800638",
    "EFO_Trait_Name": "5,6-dihydrothymine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200339/harmonised/GCST90200339.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199920",
    "initial_individuals": "8218",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010541",
    "EFO_Trait_Name": "trimethylamine-N-oxide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199920/harmonised/GCST90199920.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200356",
    "initial_individuals": "8218",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021574",
    "EFO_Trait_Name": "Adenosine 5'-monophosphate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200356/harmonised/GCST90200356.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200287",
    "initial_individuals": "8218",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800117",
    "EFO_Trait_Name": "N-acetylvaline measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200287/harmonised/GCST90200287.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200100",
    "initial_individuals": "8218",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801018",
    "EFO_Trait_Name": "perfluorooctanesulfonate (PFOS) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200100/harmonised/GCST90200100.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200252",
    "initial_individuals": "8218",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801054",
    "EFO_Trait_Name": "3,5-dichloro-2,6-dihydroxybenzoic acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200252/harmonised/GCST90200252.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200301",
    "initial_individuals": "8217",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021138",
    "EFO_Trait_Name": "gamma-glutamylglutamine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200301/harmonised/GCST90200301.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199828",
    "initial_individuals": "8217",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800038",
    "EFO_Trait_Name": "N-acetylserine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199828/harmonised/GCST90199828.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200159",
    "initial_individuals": "8217",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800561",
    "EFO_Trait_Name": "dodecenedioate (C12:1-DC) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200159/harmonised/GCST90200159.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200490",
    "initial_individuals": "8217",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800702",
    "EFO_Trait_Name": "X-12101 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200490/harmonised/GCST90200490.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200585",
    "initial_individuals": "8217",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800830",
    "EFO_Trait_Name": "X-21829 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200585/harmonised/GCST90200585.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200439",
    "initial_individuals": "8216",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021000",
    "EFO_Trait_Name": "cysteine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200439/harmonised/GCST90200439.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199819",
    "initial_individuals": "8216",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021017",
    "EFO_Trait_Name": "tryptophan betaine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199819/harmonised/GCST90199819.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199883",
    "initial_individuals": "8216",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800049",
    "EFO_Trait_Name": "cysteinylglycine disulfide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199883/harmonised/GCST90199883.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200309",
    "initial_individuals": "8216",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800119",
    "EFO_Trait_Name": "vanillylmandelate (VMA) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200309/harmonised/GCST90200309.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200018",
    "initial_individuals": "8216",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800380",
    "EFO_Trait_Name": "adipoylcarnitine (C6-DC) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200018/harmonised/GCST90200018.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199977",
    "initial_individuals": "8216",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800992",
    "EFO_Trait_Name": "4-hydroxychlorothalonil measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199977/harmonised/GCST90199977.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200032",
    "initial_individuals": "8215",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010979",
    "EFO_Trait_Name": "2-hydroxyisobutyrate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200032/harmonised/GCST90200032.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200613",
    "initial_individuals": "8215",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800862",
    "EFO_Trait_Name": "X-23680 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200613/harmonised/GCST90200613.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200147",
    "initial_individuals": "8214",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800090",
    "EFO_Trait_Name": "N,N,N-trimethyl-5-aminovalerate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200147/harmonised/GCST90200147.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200201",
    "initial_individuals": "8214",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800099",
    "EFO_Trait_Name": "6-bromotryptophan measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200201/harmonised/GCST90200201.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200364",
    "initial_individuals": "8214",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800133",
    "EFO_Trait_Name": "cysteinylglycine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200364/harmonised/GCST90200364.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200617",
    "initial_individuals": "8214",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800859",
    "EFO_Trait_Name": "X-23665 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200617/harmonised/GCST90200617.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200443",
    "initial_individuals": "8213",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021126",
    "EFO_Trait_Name": "pseudouridine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200443/harmonised/GCST90200443.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199670",
    "initial_individuals": "8213",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800945",
    "EFO_Trait_Name": "iminodiacetate (IDA) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199670/harmonised/GCST90199670.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200435",
    "initial_individuals": "8212",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0006958",
    "EFO_Trait_Name": "mannose measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200435/harmonised/GCST90200435.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200455",
    "initial_individuals": "8212",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010457",
    "EFO_Trait_Name": "Alpha ketoglutarate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200455/harmonised/GCST90200455.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199629",
    "initial_individuals": "8212",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0020018",
    "EFO_Trait_Name": "glycerophosphorylcholine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199629/harmonised/GCST90199629.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199848",
    "initial_individuals": "8212",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0020020",
    "EFO_Trait_Name": "succinylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199848/harmonised/GCST90199848.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200379",
    "initial_individuals": "8212",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021833",
    "EFO_Trait_Name": "hypotaurine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200379/harmonised/GCST90200379.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199684",
    "initial_individuals": "8212",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800199",
    "EFO_Trait_Name": "1-linoleoylglycerol (18:2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199684/harmonised/GCST90199684.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199818",
    "initial_individuals": "8211",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010533",
    "EFO_Trait_Name": "sorbitol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199818/harmonised/GCST90199818.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200708",
    "initial_individuals": "8211",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800705",
    "EFO_Trait_Name": "X-12112 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200708/harmonised/GCST90200708.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199991",
    "initial_individuals": "8211",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801066",
    "EFO_Trait_Name": "arabonate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199991/harmonised/GCST90199991.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199764",
    "initial_individuals": "8210",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021125",
    "EFO_Trait_Name": "N2,N2-dimethylguanosine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199764/harmonised/GCST90199764.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199879",
    "initial_individuals": "8210",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021163",
    "EFO_Trait_Name": "ergothioneine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199879/harmonised/GCST90199879.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199885",
    "initial_individuals": "8210",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800046",
    "EFO_Trait_Name": "alpha-ketoglutaramate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199885/harmonised/GCST90199885.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200359",
    "initial_individuals": "8210",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800130",
    "EFO_Trait_Name": "5-methylthioadenosine (MTA) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200359/harmonised/GCST90200359.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199767",
    "initial_individuals": "8210",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800631",
    "EFO_Trait_Name": "5,6-dihydrouridine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199767/harmonised/GCST90199767.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200485",
    "initial_individuals": "8210",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800701",
    "EFO_Trait_Name": "X-12100 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200485/harmonised/GCST90200485.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200661",
    "initial_individuals": "8210",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800927",
    "EFO_Trait_Name": "X-25422 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200661/harmonised/GCST90200661.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200071",
    "initial_individuals": "8209",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800473",
    "EFO_Trait_Name": "palmitoylcholine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200071/harmonised/GCST90200071.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199683",
    "initial_individuals": "8208",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021015",
    "EFO_Trait_Name": "indoleacetate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199683/harmonised/GCST90199683.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199707",
    "initial_individuals": "8208",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021132",
    "EFO_Trait_Name": "pro-hydroxy-pro measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199707/harmonised/GCST90199707.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199736",
    "initial_individuals": "8208",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800023",
    "EFO_Trait_Name": "alpha-hydroxyisovalerate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199736/harmonised/GCST90199736.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199895",
    "initial_individuals": "8208",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800322",
    "EFO_Trait_Name": "1-lignoceroyl-GPC (24:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199895/harmonised/GCST90199895.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200064",
    "initial_individuals": "8208",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800428",
    "EFO_Trait_Name": "N-palmitoyl-sphinganine (d18:0/16:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200064/harmonised/GCST90200064.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200284",
    "initial_individuals": "8208",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800601",
    "EFO_Trait_Name": "erucate (22:1n9) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200284/harmonised/GCST90200284.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200643",
    "initial_individuals": "8208",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800912",
    "EFO_Trait_Name": "X-24951 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200643/harmonised/GCST90200643.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199875",
    "initial_individuals": "8207",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800308",
    "EFO_Trait_Name": "13-HODE + 9-HODE measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199875/harmonised/GCST90199875.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200474",
    "initial_individuals": "8206",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021237",
    "EFO_Trait_Name": "X-11444 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200474/harmonised/GCST90200474.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200168",
    "initial_individuals": "8206",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800092",
    "EFO_Trait_Name": "hydroxyasparagine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200168/harmonised/GCST90200168.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199700",
    "initial_individuals": "8206",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800204",
    "EFO_Trait_Name": "3-hydroxylaurate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199700/harmonised/GCST90199700.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200487",
    "initial_individuals": "8206",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800698",
    "EFO_Trait_Name": "X-11880 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200487/harmonised/GCST90200487.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199815",
    "initial_individuals": "8205",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800034",
    "EFO_Trait_Name": "1-ribosyl-imidazoleacetate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199815/harmonised/GCST90199815.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199851",
    "initial_individuals": "8205",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800280",
    "EFO_Trait_Name": "androstenediol (3beta,17beta) disulfate (2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199851/harmonised/GCST90199851.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200082",
    "initial_individuals": "8205",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800443",
    "EFO_Trait_Name": "1-oleoyl-2-linoleoyl-GPE (18:1/18:2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200082/harmonised/GCST90200082.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200656",
    "initial_individuals": "8205",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800923",
    "EFO_Trait_Name": "X-25371 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200656/harmonised/GCST90200656.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200008",
    "initial_individuals": "8204",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021014",
    "EFO_Trait_Name": "C-glycosyltryptophan measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200008/harmonised/GCST90200008.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200462",
    "initial_individuals": "8203",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021222",
    "EFO_Trait_Name": "X-11299 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200462/harmonised/GCST90200462.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200348",
    "initial_individuals": "8203",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800175",
    "EFO_Trait_Name": "quinolinate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200348/harmonised/GCST90200348.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200257",
    "initial_individuals": "8203",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800659",
    "EFO_Trait_Name": "metabolonic lactone sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200257/harmonised/GCST90200257.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200571",
    "initial_individuals": "8203",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800808",
    "EFO_Trait_Name": "X-21339 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200571/harmonised/GCST90200571.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200566",
    "initial_individuals": "8203",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800811",
    "EFO_Trait_Name": "X-21364 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200566/harmonised/GCST90200566.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200150",
    "initial_individuals": "8202",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800544",
    "EFO_Trait_Name": "arachidonoylcarnitine (C20:4) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200150/harmonised/GCST90200150.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199638",
    "initial_individuals": "8201",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010488",
    "EFO_Trait_Name": "glycerol-3-phosphate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199638/harmonised/GCST90199638.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200322",
    "initial_individuals": "8201",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800125",
    "EFO_Trait_Name": "beta-hydroxyisovalerate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200322/harmonised/GCST90200322.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200314",
    "initial_individuals": "8200",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0020022",
    "EFO_Trait_Name": "N-acetylneuraminate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200314/harmonised/GCST90200314.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199645",
    "initial_individuals": "8200",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021167",
    "EFO_Trait_Name": "quinate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199645/harmonised/GCST90199645.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199835",
    "initial_individuals": "8199",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021115",
    "EFO_Trait_Name": "5alpha-androstan-3beta,17beta-diol disulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199835/harmonised/GCST90199835.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200171",
    "initial_individuals": "8199",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801024",
    "EFO_Trait_Name": "perfluorooctanoate (PFOA) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200171/harmonised/GCST90200171.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199746",
    "initial_individuals": "8198",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021025",
    "EFO_Trait_Name": "erythronate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199746/harmonised/GCST90199746.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200416",
    "initial_individuals": "8198",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800138",
    "EFO_Trait_Name": "trans-urocanate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200416/harmonised/GCST90200416.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200551",
    "initial_individuals": "8198",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800790",
    "EFO_Trait_Name": "X-18886 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200551/harmonised/GCST90200551.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200565",
    "initial_individuals": "8198",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800802",
    "EFO_Trait_Name": "X-21258 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200565/harmonised/GCST90200565.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199886",
    "initial_individuals": "8197",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800047",
    "EFO_Trait_Name": "3-methylglutaconate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199886/harmonised/GCST90199886.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200329",
    "initial_individuals": "8196",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800152",
    "EFO_Trait_Name": "3-phosphoglycerate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200329/harmonised/GCST90200329.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200140",
    "initial_individuals": "8196",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800171",
    "EFO_Trait_Name": "carotene diol (2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200140/harmonised/GCST90200140.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200594",
    "initial_individuals": "8195",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0020007",
    "EFO_Trait_Name": "X-21467 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200594/harmonised/GCST90200594.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200132",
    "initial_individuals": "8195",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800538",
    "EFO_Trait_Name": "linolenoylcarnitine (C18:3) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200132/harmonised/GCST90200132.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200444",
    "initial_individuals": "8195",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800647",
    "EFO_Trait_Name": "dihydroorotate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200444/harmonised/GCST90200444.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200666",
    "initial_individuals": "8195",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800922",
    "EFO_Trait_Name": "X-25343 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200666/harmonised/GCST90200666.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200279",
    "initial_individuals": "8194",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021034",
    "EFO_Trait_Name": "pantothenate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200279/harmonised/GCST90200279.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200406",
    "initial_individuals": "8194",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021829",
    "EFO_Trait_Name": "1-methylnicotinamide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200406/harmonised/GCST90200406.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200009",
    "initial_individuals": "8194",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801009",
    "EFO_Trait_Name": "3-methoxycatechol sulfate (1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200009/harmonised/GCST90200009.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200378",
    "initial_individuals": "8193",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0005843",
    "EFO_Trait_Name": "cortisol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200378/harmonised/GCST90200378.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200130",
    "initial_individuals": "8193",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800535",
    "EFO_Trait_Name": "linoleoylcholine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200130/harmonised/GCST90200130.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200401",
    "initial_individuals": "8193",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800621",
    "EFO_Trait_Name": "myo-inositol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200401/harmonised/GCST90200401.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200302",
    "initial_individuals": "8192",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0007898",
    "EFO_Trait_Name": "alpha-tocopherol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200302/harmonised/GCST90200302.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200438",
    "initial_individuals": "8192",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800140",
    "EFO_Trait_Name": "alpha-ketobutyrate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200438/harmonised/GCST90200438.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199856",
    "initial_individuals": "8192",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800293",
    "EFO_Trait_Name": "androstenediol (3alpha, 17alpha) monosulfate (3) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199856/harmonised/GCST90199856.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200421",
    "initial_individuals": "8191",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021161",
    "EFO_Trait_Name": "salicylate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200421/harmonised/GCST90200421.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200953",
    "initial_individuals": "8191",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021404",
    "EFO_Trait_Name": "glucose-to-mannose ratio",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200953/harmonised/GCST90200953.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200240",
    "initial_individuals": "8190",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800112",
    "EFO_Trait_Name": "hydroxy-N6,N6,N6-trimethyllysine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200240/harmonised/GCST90200240.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200095",
    "initial_individuals": "8188",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800483",
    "EFO_Trait_Name": "1-linoleoyl-2-linolenoyl-GPC (18:2/18:3) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200095/harmonised/GCST90200095.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200398",
    "initial_individuals": "8187",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010508",
    "EFO_Trait_Name": "malate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200398/harmonised/GCST90200398.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200709",
    "initial_individuals": "8186",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021335",
    "EFO_Trait_Name": "X-12798 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200709/harmonised/GCST90200709.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200199",
    "initial_individuals": "8186",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800173",
    "EFO_Trait_Name": "ascorbic acid 3-sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200199/harmonised/GCST90200199.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200254",
    "initial_individuals": "8185",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801055",
    "EFO_Trait_Name": "(S)-a-amino-omega-caprolactam measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200254/harmonised/GCST90200254.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199740",
    "initial_individuals": "8183",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010998",
    "EFO_Trait_Name": "p-cresol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199740/harmonised/GCST90199740.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200674",
    "initial_individuals": "8182",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021117",
    "EFO_Trait_Name": "androsterone sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200674/harmonised/GCST90200674.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199680",
    "initial_individuals": "8182",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800193",
    "EFO_Trait_Name": "3-hydroxyoctanoate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199680/harmonised/GCST90199680.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199672",
    "initial_individuals": "8181",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010517",
    "EFO_Trait_Name": "oxalate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199672/harmonised/GCST90199672.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200483",
    "initial_individuals": "8181",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021294",
    "EFO_Trait_Name": "X-12216 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200483/harmonised/GCST90200483.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200676",
    "initial_individuals": "8181",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800017",
    "EFO_Trait_Name": "N-acetylglutamine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200676/harmonised/GCST90200676.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200344",
    "initial_individuals": "8180",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800126",
    "EFO_Trait_Name": "N6,N6,N6-trimethyllysine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200344/harmonised/GCST90200344.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200491",
    "initial_individuals": "8180",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800700",
    "EFO_Trait_Name": "X-12026 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200491/harmonised/GCST90200491.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199703",
    "initial_individuals": "8179",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021145",
    "EFO_Trait_Name": "gamma-glutamylvaline measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199703/harmonised/GCST90199703.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199937",
    "initial_individuals": "8178",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800349",
    "EFO_Trait_Name": "2-aminooctanoate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199937/harmonised/GCST90199937.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200308",
    "initial_individuals": "8177",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010983",
    "EFO_Trait_Name": "3-hydroxyisobutyrate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200308/harmonised/GCST90200308.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199778",
    "initial_individuals": "8177",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010994",
    "EFO_Trait_Name": "n-methyl-2-pyridone-5-carboxamide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199778/harmonised/GCST90199778.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200382",
    "initial_individuals": "8177",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800134",
    "EFO_Trait_Name": "cystine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200382/harmonised/GCST90200382.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199762",
    "initial_individuals": "8176",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800629",
    "EFO_Trait_Name": "N6-carbamoylthreonyladenosine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199762/harmonised/GCST90199762.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199905",
    "initial_individuals": "8175",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800050",
    "EFO_Trait_Name": "formiminoglutamate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199905/harmonised/GCST90199905.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199752",
    "initial_individuals": "8174",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021120",
    "EFO_Trait_Name": "epiandrosterone sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199752/harmonised/GCST90199752.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200492",
    "initial_individuals": "8174",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800716",
    "EFO_Trait_Name": "X-12411 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200492/harmonised/GCST90200492.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200578",
    "initial_individuals": "8174",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800797",
    "EFO_Trait_Name": "X-18922 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200578/harmonised/GCST90200578.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199893",
    "initial_individuals": "8173",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800318",
    "EFO_Trait_Name": "cis-4-decenoate (10:1n6) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199893/harmonised/GCST90199893.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200705",
    "initial_individuals": "8172",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0020009",
    "EFO_Trait_Name": "ethylmalonate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200705/harmonised/GCST90200705.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199661",
    "initial_individuals": "8171",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010509",
    "EFO_Trait_Name": "maleate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199661/harmonised/GCST90199661.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199901",
    "initial_individuals": "8171",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800057",
    "EFO_Trait_Name": "1-methyl-5-imidazoleacetate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199901/harmonised/GCST90199901.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200174",
    "initial_individuals": "8171",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800568",
    "EFO_Trait_Name": "3-hydroxybutyroylglycine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200174/harmonised/GCST90200174.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199899",
    "initial_individuals": "8170",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800323",
    "EFO_Trait_Name": "1-(1-enyl-palmitoyl)-GPC (P-16:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199899/harmonised/GCST90199899.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200086",
    "initial_individuals": "8170",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800478",
    "EFO_Trait_Name": "arachidonoylcholine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200086/harmonised/GCST90200086.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200161",
    "initial_individuals": "8170",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800558",
    "EFO_Trait_Name": "2-hydroxyarachidate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200161/harmonised/GCST90200161.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199783",
    "initial_individuals": "8168",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0020013",
    "EFO_Trait_Name": "5-methyluridine (ribothymidine) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199783/harmonised/GCST90199783.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199667",
    "initial_individuals": "8167",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021171",
    "EFO_Trait_Name": "erythritol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199667/harmonised/GCST90199667.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200285",
    "initial_individuals": "8166",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010548",
    "EFO_Trait_Name": "xanthine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200285/harmonised/GCST90200285.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199932",
    "initial_individuals": "8166",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800971",
    "EFO_Trait_Name": "mannonate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199932/harmonised/GCST90199932.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199811",
    "initial_individuals": "8165",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800258",
    "EFO_Trait_Name": "glycolithocholate sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199811/harmonised/GCST90199811.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200342",
    "initial_individuals": "8164",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010490",
    "EFO_Trait_Name": "glycochenodeoxycholate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200342/harmonised/GCST90200342.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199902",
    "initial_individuals": "8164",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800051",
    "EFO_Trait_Name": "hydantoin-5-propionate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199902/harmonised/GCST90199902.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200445",
    "initial_individuals": "8163",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021103",
    "EFO_Trait_Name": "caprylate 8:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200445/harmonised/GCST90200445.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200185",
    "initial_individuals": "8163",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800690",
    "EFO_Trait_Name": "gamma-glutamylcitrulline measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200185/harmonised/GCST90200185.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200294",
    "initial_individuals": "8161",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021006",
    "EFO_Trait_Name": "pipecolate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200294/harmonised/GCST90200294.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200710",
    "initial_individuals": "8161",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800735",
    "EFO_Trait_Name": "X-13431 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200710/harmonised/GCST90200710.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199967",
    "initial_individuals": "8160",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0020023",
    "EFO_Trait_Name": "N-acetyltaurine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199967/harmonised/GCST90199967.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200644",
    "initial_individuals": "8160",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800903",
    "EFO_Trait_Name": "X-24728 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200644/harmonised/GCST90200644.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199966",
    "initial_individuals": "8157",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800359",
    "EFO_Trait_Name": "1-(1-enyl-oleoyl)-GPE (P-18:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199966/harmonised/GCST90199966.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200655",
    "initial_individuals": "8156",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800936",
    "EFO_Trait_Name": "X-25828 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200655/harmonised/GCST90200655.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199729",
    "initial_individuals": "8155",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021166",
    "EFO_Trait_Name": "piperine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199729/harmonised/GCST90199729.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200311",
    "initial_individuals": "8154",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021003",
    "EFO_Trait_Name": "4-acetamidobutanoate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200311/harmonised/GCST90200311.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199686",
    "initial_individuals": "8153",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021016",
    "EFO_Trait_Name": "indolepropionate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199686/harmonised/GCST90199686.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200360",
    "initial_individuals": "8153",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021118",
    "EFO_Trait_Name": "cortisone measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200360/harmonised/GCST90200360.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200156",
    "initial_individuals": "8152",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800552",
    "EFO_Trait_Name": "cortolone glucuronide (1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200156/harmonised/GCST90200156.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200193",
    "initial_individuals": "8152",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801028",
    "EFO_Trait_Name": "ethyl beta-glucopyranoside measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200193/harmonised/GCST90200193.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199687",
    "initial_individuals": "8151",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021032",
    "EFO_Trait_Name": "threonate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199687/harmonised/GCST90199687.h.tsv.gz"
  },
  {
    "accessionId": "GCST90709871",
    "initial_individuals": "8150",
    "initial_ancestralGroup": "European",
    "pubmedId": "41075272",
    "EFO_ID": "HP_0000201",
    "EFO_Trait_Name": "Pierre-Robin sequence",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90709001-GCST90710000/GCST90709871/harmonised/GCST90709871.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199665",
    "initial_individuals": "8148",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800012",
    "EFO_Trait_Name": "N-acetylaspartate (NAA) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199665/harmonised/GCST90199665.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199761",
    "initial_individuals": "8147",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800627",
    "EFO_Trait_Name": "N1-methylinosine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199761/harmonised/GCST90199761.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200148",
    "initial_individuals": "8145",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800545",
    "EFO_Trait_Name": "eicosenoylcarnitine (C20:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200148/harmonised/GCST90200148.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199640",
    "initial_individuals": "8144",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800003",
    "EFO_Trait_Name": "4-guanidinobutanoate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199640/harmonised/GCST90199640.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200316",
    "initial_individuals": "8144",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800151",
    "EFO_Trait_Name": "N-acetylglucosaminylasparagine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200316/harmonised/GCST90200316.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200540",
    "initial_individuals": "8144",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800749",
    "EFO_Trait_Name": "X-15461 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200540/harmonised/GCST90200540.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199816",
    "initial_individuals": "8142",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022215",
    "EFO_Trait_Name": "Blood 3,4-dihydroxybutyrate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199816/harmonised/GCST90199816.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200237",
    "initial_individuals": "8140",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800591",
    "EFO_Trait_Name": "palmitoyl-sphingosine-phosphoethanolamine (d18:1/16:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200237/harmonised/GCST90200237.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199648",
    "initial_individuals": "8139",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0008009",
    "EFO_Trait_Name": "1,5 anhydroglucitol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199648/harmonised/GCST90199648.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199830",
    "initial_individuals": "8139",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021148",
    "EFO_Trait_Name": "4-ethylphenylsulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199830/harmonised/GCST90199830.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200458",
    "initial_individuals": "8139",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021223",
    "EFO_Trait_Name": "X-11315 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200458/harmonised/GCST90200458.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200220",
    "initial_individuals": "8139",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801041",
    "EFO_Trait_Name": "4-allylcatechol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200220/harmonised/GCST90200220.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200437",
    "initial_individuals": "8137",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010477",
    "EFO_Trait_Name": "fructose measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200437/harmonised/GCST90200437.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199644",
    "initial_individuals": "8137",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021179",
    "EFO_Trait_Name": "theobromine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199644/harmonised/GCST90199644.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200470",
    "initial_individuals": "8134",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021241",
    "EFO_Trait_Name": "X-11470 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200470/harmonised/GCST90200470.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199649",
    "initial_individuals": "8134",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800184",
    "EFO_Trait_Name": "1-stearoyl-2-arachidonoyl-GPI (18:0/20:4) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199649/harmonised/GCST90199649.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199743",
    "initial_individuals": "8133",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021045",
    "EFO_Trait_Name": "stearoylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199743/harmonised/GCST90199743.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200200",
    "initial_individuals": "8133",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800103",
    "EFO_Trait_Name": "1-carboxyethylvaline measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200200/harmonised/GCST90200200.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199849",
    "initial_individuals": "8132",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800281",
    "EFO_Trait_Name": "21-hydroxypregnenolone disulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199849/harmonised/GCST90199849.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200700",
    "initial_individuals": "8131",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800598",
    "EFO_Trait_Name": "decadienedioic acid (C10:2-DC) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200700/harmonised/GCST90200700.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199838",
    "initial_individuals": "8130",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800286",
    "EFO_Trait_Name": "5alpha-pregnan-diol disulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199838/harmonised/GCST90199838.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200580",
    "initial_individuals": "8130",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800825",
    "EFO_Trait_Name": "X-21796 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200580/harmonised/GCST90200580.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199634",
    "initial_individuals": "8128",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800002",
    "EFO_Trait_Name": "5-hydroxylysine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199634/harmonised/GCST90199634.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199642",
    "initial_individuals": "8128",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800143",
    "EFO_Trait_Name": "ribitol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199642/harmonised/GCST90199642.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199833",
    "initial_individuals": "8128",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800262",
    "EFO_Trait_Name": "hexanoylglutamine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199833/harmonised/GCST90199833.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200163",
    "initial_individuals": "8128",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800564",
    "EFO_Trait_Name": "heptenedioate (C7:1-DC) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200163/harmonised/GCST90200163.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200392",
    "initial_individuals": "8128",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800642",
    "EFO_Trait_Name": "orotate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200392/harmonised/GCST90200392.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200175",
    "initial_individuals": "8128",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800655",
    "EFO_Trait_Name": "glycine conjugate of C10H14O2 (1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200175/harmonised/GCST90200175.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200559",
    "initial_individuals": "8128",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800794",
    "EFO_Trait_Name": "X-18901 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200559/harmonised/GCST90200559.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200453",
    "initial_individuals": "8127",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021204",
    "EFO_Trait_Name": "X-07765 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200453/harmonised/GCST90200453.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199993",
    "initial_individuals": "8127",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800686",
    "EFO_Trait_Name": "phenylacetylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199993/harmonised/GCST90199993.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200255",
    "initial_individuals": "8127",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801058",
    "EFO_Trait_Name": "3-bromo-5-chloro-2,6-dihydroxybenzoic acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200255/harmonised/GCST90200255.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199845",
    "initial_individuals": "8126",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800274",
    "EFO_Trait_Name": "sphinganine-1-phosphate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199845/harmonised/GCST90199845.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199678",
    "initial_individuals": "8125",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800944",
    "EFO_Trait_Name": "tartronate (hydroxymalonate) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199678/harmonised/GCST90199678.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199809",
    "initial_individuals": "8124",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021036",
    "EFO_Trait_Name": "taurolithocholate 3-sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199809/harmonised/GCST90199809.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200263",
    "initial_individuals": "8124",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800594",
    "EFO_Trait_Name": "(2 or 3)-decenoate (10:1n7 or n8) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200263/harmonised/GCST90200263.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200022",
    "initial_individuals": "8123",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800384",
    "EFO_Trait_Name": "glycochenodeoxycholate 3-sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200022/harmonised/GCST90200022.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200080",
    "initial_individuals": "8123",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800439",
    "EFO_Trait_Name": "1-palmitoyl-2-oleoyl-GPI (16:0/18:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200080/harmonised/GCST90200080.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200694",
    "initial_individuals": "8122",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800635",
    "EFO_Trait_Name": "2'-O-methylcytidine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200694/harmonised/GCST90200694.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200079",
    "initial_individuals": "8121",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800470",
    "EFO_Trait_Name": "1-oleoyl-2-arachidonoyl-GPE (18:1/20:4) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200079/harmonised/GCST90200079.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200084",
    "initial_individuals": "8120",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800477",
    "EFO_Trait_Name": "oleoylcholine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200084/harmonised/GCST90200084.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200632",
    "initial_individuals": "8119",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800871",
    "EFO_Trait_Name": "X-24307 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200632/harmonised/GCST90200632.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200517",
    "initial_individuals": "8118",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021355",
    "EFO_Trait_Name": "X-13553 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200517/harmonised/GCST90200517.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200548",
    "initial_individuals": "8118",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800785",
    "EFO_Trait_Name": "X-17676 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200548/harmonised/GCST90200548.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200682",
    "initial_individuals": "8117",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800633",
    "EFO_Trait_Name": "3-methylcytidine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200682/harmonised/GCST90200682.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200659",
    "initial_individuals": "8117",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800916",
    "EFO_Trait_Name": "X-25172 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200659/harmonised/GCST90200659.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200074",
    "initial_individuals": "8115",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800472",
    "EFO_Trait_Name": "1-linoleoyl-GPG (18:2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200074/harmonised/GCST90200074.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200332",
    "initial_individuals": "8115",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800609",
    "EFO_Trait_Name": "1-palmitoyl-2-linoleoyl-GPI (16:0/18:2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200332/harmonised/GCST90200332.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200361",
    "initial_individuals": "8114",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800640",
    "EFO_Trait_Name": "beta-alanine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200361/harmonised/GCST90200361.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200067",
    "initial_individuals": "8113",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800413",
    "EFO_Trait_Name": "1-stearoyl-2-linoleoyl-GPI (18:0/18:2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200067/harmonised/GCST90200067.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199929",
    "initial_individuals": "8112",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800345",
    "EFO_Trait_Name": "margaroylcarnitine (C17) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199929/harmonised/GCST90199929.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200512",
    "initial_individuals": "8112",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800737",
    "EFO_Trait_Name": "X-13684 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200512/harmonised/GCST90200512.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200673",
    "initial_individuals": "8111",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800201",
    "EFO_Trait_Name": "butyrylcarnitine (C4) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200673/harmonised/GCST90200673.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200077",
    "initial_individuals": "8111",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800469",
    "EFO_Trait_Name": "1-stearoyl-2-oleoyl-GPI (18:0/18:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200077/harmonised/GCST90200077.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200400",
    "initial_individuals": "8110",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800178",
    "EFO_Trait_Name": "nicotinamide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200400/harmonised/GCST90200400.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200564",
    "initial_individuals": "8109",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800807",
    "EFO_Trait_Name": "X-21319 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200564/harmonised/GCST90200564.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200373",
    "initial_individuals": "8106",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801064",
    "EFO_Trait_Name": "gluconate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200373/harmonised/GCST90200373.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200256",
    "initial_individuals": "8099",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022212",
    "EFO_Trait_Name": "Blood dibutyl sulfosuccinate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200256/harmonised/GCST90200256.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199800",
    "initial_individuals": "8097",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800032",
    "EFO_Trait_Name": "tiglylcarnitine (C5:1-DC) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199800/harmonised/GCST90199800.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200139",
    "initial_individuals": "8092",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800547",
    "EFO_Trait_Name": "dihomo-linolenoylcarnitine (C20:3n3 or 6) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200139/harmonised/GCST90200139.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199717",
    "initial_individuals": "8090",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800015",
    "EFO_Trait_Name": "1-methyl-4-imidazoleacetate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199717/harmonised/GCST90199717.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199918",
    "initial_individuals": "8090",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800059",
    "EFO_Trait_Name": "carboxyethyl-GABA measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199918/harmonised/GCST90199918.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199701",
    "initial_individuals": "8089",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010527",
    "EFO_Trait_Name": "pyridoxate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199701/harmonised/GCST90199701.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200094",
    "initial_individuals": "8089",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800169",
    "EFO_Trait_Name": "ascorbic acid 2-sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200094/harmonised/GCST90200094.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200629",
    "initial_individuals": "8088",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800875",
    "EFO_Trait_Name": "X-24337 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200629/harmonised/GCST90200629.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200598",
    "initial_individuals": "8087",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800844",
    "EFO_Trait_Name": "X-22771 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200598/harmonised/GCST90200598.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199699",
    "initial_individuals": "8085",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021175",
    "EFO_Trait_Name": "3-methylxanthine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199699/harmonised/GCST90199699.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200070",
    "initial_individuals": "8083",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800464",
    "EFO_Trait_Name": "1-(1-enyl-palmitoyl)-2-palmitoleoyl-GPC (P-16:0/16:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200070/harmonised/GCST90200070.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200214",
    "initial_individuals": "8081",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800573",
    "EFO_Trait_Name": "11beta-hydroxyandrosterone glucuronide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200214/harmonised/GCST90200214.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200669",
    "initial_individuals": "8080",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800930",
    "EFO_Trait_Name": "X-25519 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200669/harmonised/GCST90200669.h.tsv.gz"
  },
  {
    "accessionId": "GCST90129599",
    "initial_individuals": "8074",
    "initial_ancestralGroup": "European",
    "pubmedId": "36066633",
    "EFO_ID": "EFO_0005194",
    "EFO_Trait_Name": "amyloid-beta measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129599/harmonised/GCST90129599.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200631",
    "initial_individuals": "8074",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800870",
    "EFO_Trait_Name": "X-24306 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200631/harmonised/GCST90200631.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199928",
    "initial_individuals": "8073",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800343",
    "EFO_Trait_Name": "2-stearoyl-GPE (18:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199928/harmonised/GCST90199928.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200298",
    "initial_individuals": "8073",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800602",
    "EFO_Trait_Name": "3-hydroxy-3-methylglutarate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200298/harmonised/GCST90200298.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200698",
    "initial_individuals": "8069",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800109",
    "EFO_Trait_Name": "N2-acetyl,N6-methyllysine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200698/harmonised/GCST90200698.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199914",
    "initial_individuals": "8069",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800333",
    "EFO_Trait_Name": "oleoyl-linoleoyl-glycerol (18:1/18:2) [2] measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199914/harmonised/GCST90199914.h.tsv.gz"
  },
  {
    "accessionId": "GCST90012611",
    "initial_individuals": "8067",
    "initial_ancestralGroup": "European",
    "pubmedId": "33441150",
    "EFO_ID": "EFO_0803343",
    "EFO_Trait_Name": "amylase measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90012001-GCST90013000/GCST90012611/harmonised/GCST90012611.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200026",
    "initial_individuals": "8066",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800385",
    "EFO_Trait_Name": "glycodeoxycholate 3-sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200026/harmonised/GCST90200026.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199827",
    "initial_individuals": "8063",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021170",
    "EFO_Trait_Name": "thymol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199827/harmonised/GCST90199827.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200073",
    "initial_individuals": "8063",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800450",
    "EFO_Trait_Name": "1-linoleoyl-2-arachidonoyl-GPC (18:2/20:4n6) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200073/harmonised/GCST90200073.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200699",
    "initial_individuals": "8060",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800575",
    "EFO_Trait_Name": "deoxycholic acid glucuronide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200699/harmonised/GCST90200699.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200062",
    "initial_individuals": "8057",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800412",
    "EFO_Trait_Name": "1-palmitoyl-2-arachidonoyl-GPI (16:0/20:4) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200062/harmonised/GCST90200062.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200529",
    "initial_individuals": "8057",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800758",
    "EFO_Trait_Name": "X-16397 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200529/harmonised/GCST90200529.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199652",
    "initial_individuals": "8055",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800187",
    "EFO_Trait_Name": "1-stearoyl-2-oleoyl-GPS (18:0/18:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199652/harmonised/GCST90199652.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199992",
    "initial_individuals": "8049",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800371",
    "EFO_Trait_Name": "octadecanedioylcarnitine (C18-DC) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199992/harmonised/GCST90199992.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200337",
    "initial_individuals": "8048",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010537",
    "EFO_Trait_Name": "taurochenodeoxycholate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200337/harmonised/GCST90200337.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200531",
    "initial_individuals": "8048",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0020011",
    "EFO_Trait_Name": "X-16964 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200531/harmonised/GCST90200531.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200672",
    "initial_individuals": "8046",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800939",
    "EFO_Trait_Name": "X-26054 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200672/harmonised/GCST90200672.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200326",
    "initial_individuals": "8041",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021140",
    "EFO_Trait_Name": "gamma-glutamylleucine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200326/harmonised/GCST90200326.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200550",
    "initial_individuals": "8041",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800777",
    "EFO_Trait_Name": "X-17357 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200550/harmonised/GCST90200550.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199949",
    "initial_individuals": "8032",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800066",
    "EFO_Trait_Name": "6-oxopiperidine-2-carboxylate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199949/harmonised/GCST90199949.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200581",
    "initial_individuals": "8030",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800814",
    "EFO_Trait_Name": "X-21441 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200581/harmonised/GCST90200581.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199854",
    "initial_individuals": "8028",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800285",
    "EFO_Trait_Name": "5alpha-pregnan-3beta,20alpha-diol monosulfate (2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199854/harmonised/GCST90199854.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200553",
    "initial_individuals": "8025",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800783",
    "EFO_Trait_Name": "X-17653 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200553/harmonised/GCST90200553.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200418",
    "initial_individuals": "8021",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022222",
    "EFO_Trait_Name": "Blood pyridoxal measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200418/harmonised/GCST90200418.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199754",
    "initial_individuals": "8019",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021176",
    "EFO_Trait_Name": "7-methylxanthine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199754/harmonised/GCST90199754.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200112",
    "initial_individuals": "8018",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022219",
    "EFO_Trait_Name": "Blood 2,3-dihydroxy-2-methylbutyrate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200112/harmonised/GCST90200112.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200681",
    "initial_individuals": "8017",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800630",
    "EFO_Trait_Name": "orotidine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200681/harmonised/GCST90200681.h.tsv.gz"
  },
  {
    "accessionId": "GCST90406924",
    "initial_individuals": "8016",
    "initial_ancestralGroup": "European",
    "pubmedId": "38701790",
    "EFO_ID": "EFO_1001050",
    "EFO_Trait_Name": "multiple system atrophy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90406001-GCST90407000/GCST90406924/harmonised/GCST90406924.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200383",
    "initial_individuals": "8014",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010474",
    "EFO_Trait_Name": "cystathionine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200383/harmonised/GCST90200383.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199646",
    "initial_individuals": "8013",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800007",
    "EFO_Trait_Name": "gentisate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199646/harmonised/GCST90199646.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200117",
    "initial_individuals": "8012",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800533",
    "EFO_Trait_Name": "glycosyl-N-(2-hydroxynervonoyl)-sphingosine (d18:1/24:1(2OH)) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200117/harmonised/GCST90200117.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200261",
    "initial_individuals": "8010",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021614",
    "EFO_Trait_Name": "L-Cysteine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200261/harmonised/GCST90200261.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199760",
    "initial_individuals": "8006",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800951",
    "EFO_Trait_Name": "5-acetylamino-6-amino-3-methyluracil measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199760/harmonised/GCST90199760.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200436",
    "initial_individuals": "8005",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021177",
    "EFO_Trait_Name": "caffeine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200436/harmonised/GCST90200436.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200306",
    "initial_individuals": "8004",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800605",
    "EFO_Trait_Name": "isobutyrate (4:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200306/harmonised/GCST90200306.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200628",
    "initial_individuals": "8004",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800895",
    "EFO_Trait_Name": "X-24556 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200628/harmonised/GCST90200628.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200494",
    "initial_individuals": "8002",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021276",
    "EFO_Trait_Name": "X-12007 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200494/harmonised/GCST90200494.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200651",
    "initial_individuals": "8002",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800910",
    "EFO_Trait_Name": "X-24947 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200651/harmonised/GCST90200651.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199682",
    "initial_individuals": "7998",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021018",
    "EFO_Trait_Name": "homocitrulline measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199682/harmonised/GCST90199682.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200668",
    "initial_individuals": "7997",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800931",
    "EFO_Trait_Name": "X-25520 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200668/harmonised/GCST90200668.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200657",
    "initial_individuals": "7994",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800925",
    "EFO_Trait_Name": "X-25419 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200657/harmonised/GCST90200657.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200289",
    "initial_individuals": "7993",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021427",
    "EFO_Trait_Name": "N-acetylmethionine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200289/harmonised/GCST90200289.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200260",
    "initial_individuals": "7990",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800593",
    "EFO_Trait_Name": "branched chain 14:0 dicarboxylic acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200260/harmonised/GCST90200260.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199641",
    "initial_individuals": "7988",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010486",
    "EFO_Trait_Name": "glucuronate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199641/harmonised/GCST90199641.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200610",
    "initial_individuals": "7988",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800851",
    "EFO_Trait_Name": "X-23593 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200610/harmonised/GCST90200610.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200619",
    "initial_individuals": "7987",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800869",
    "EFO_Trait_Name": "X-24295 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200619/harmonised/GCST90200619.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200586",
    "initial_individuals": "7982",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800818",
    "EFO_Trait_Name": "X-21471 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200586/harmonised/GCST90200586.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200385",
    "initial_individuals": "7982",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "OBA_1000970",
    "EFO_Trait_Name": "sphingosine amount",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200385/harmonised/GCST90200385.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200688",
    "initial_individuals": "7980",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800317",
    "EFO_Trait_Name": "androsterone glucuronide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200688/harmonised/GCST90200688.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200176",
    "initial_individuals": "7980",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800657",
    "EFO_Trait_Name": "glutamine conjugate of C6H10O2 (1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200176/harmonised/GCST90200176.h.tsv.gz"
  },
  {
    "accessionId": "GCST90132313",
    "initial_individuals": "7980",
    "initial_ancestralGroup": "European",
    "pubmedId": "36352089",
    "EFO_ID": "MONDO_0010805",
    "EFO_Trait_Name": "bladder exstrophy",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90132001-GCST90133000/GCST90132313/harmonised/GCST90132313.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200592",
    "initial_individuals": "7975",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800819",
    "EFO_Trait_Name": "X-21607 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200592/harmonised/GCST90200592.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199973",
    "initial_individuals": "7973",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800991",
    "EFO_Trait_Name": "methyl glucopyranoside (alpha + beta) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199973/harmonised/GCST90199973.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200461",
    "initial_individuals": "7970",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800692",
    "EFO_Trait_Name": "X-10458 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200461/harmonised/GCST90200461.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200003",
    "initial_individuals": "7969",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800079",
    "EFO_Trait_Name": "p-cresol glucuronide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200003/harmonised/GCST90200003.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199626",
    "initial_individuals": "7965",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010551",
    "EFO_Trait_Name": "xanthurenate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199626/harmonised/GCST90199626.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200352",
    "initial_individuals": "7965",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800129",
    "EFO_Trait_Name": "methylsuccinate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200352/harmonised/GCST90200352.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199763",
    "initial_individuals": "7959",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021174",
    "EFO_Trait_Name": "1-methylxanthine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199763/harmonised/GCST90199763.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200507",
    "initial_individuals": "7957",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800730",
    "EFO_Trait_Name": "X-12822 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200507/harmonised/GCST90200507.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199756",
    "initial_individuals": "7950",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021512",
    "EFO_Trait_Name": "1,7-dimethylurate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199756/harmonised/GCST90199756.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200210",
    "initial_individuals": "7950",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801034",
    "EFO_Trait_Name": "sulfate of piperine metabolite C16H19NO3 (2) measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200210/harmonised/GCST90200210.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200362",
    "initial_individuals": "7943",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0011002",
    "EFO_Trait_Name": "succinate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200362/harmonised/GCST90200362.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200021",
    "initial_individuals": "7940",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800149",
    "EFO_Trait_Name": "N-acetylgalactosamine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200021/harmonised/GCST90200021.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200636",
    "initial_individuals": "7939",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800892",
    "EFO_Trait_Name": "X-24544 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200636/harmonised/GCST90200636.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200513",
    "initial_individuals": "7936",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800736",
    "EFO_Trait_Name": "X-13507 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200513/harmonised/GCST90200513.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200678",
    "initial_individuals": "7935",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022206",
    "EFO_Trait_Name": "Blood N-acetylasparagine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200678/harmonised/GCST90200678.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199978",
    "initial_individuals": "7935",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800078",
    "EFO_Trait_Name": "vanillactate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199978/harmonised/GCST90199978.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199718",
    "initial_individuals": "7926",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800212",
    "EFO_Trait_Name": "sebacate (C10-DC) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199718/harmonised/GCST90199718.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199635",
    "initial_individuals": "7925",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021010",
    "EFO_Trait_Name": "3-phenylpropionate hydrocinnamate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199635/harmonised/GCST90199635.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199825",
    "initial_individuals": "7920",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800954",
    "EFO_Trait_Name": "pyrraline measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199825/harmonised/GCST90199825.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199897",
    "initial_individuals": "7919",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800316",
    "EFO_Trait_Name": "4-hydroxy-2-oxoglutaric acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199897/harmonised/GCST90199897.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200434",
    "initial_individuals": "7918",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "OBA_2050345",
    "EFO_Trait_Name": "level of 9,10-dihydroxyoctadec-12-enoic acid in blood plasma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200434/harmonised/GCST90200434.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200658",
    "initial_individuals": "7916",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800917",
    "EFO_Trait_Name": "X-25265 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200658/harmonised/GCST90200658.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200413",
    "initial_individuals": "7915",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800643",
    "EFO_Trait_Name": "2'-deoxyuridine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200413/harmonised/GCST90200413.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199922",
    "initial_individuals": "7907",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800683",
    "EFO_Trait_Name": "prolylglycine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199922/harmonised/GCST90199922.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200338",
    "initial_individuals": "7906",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800124",
    "EFO_Trait_Name": "4-hydroxyphenylacetate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200338/harmonised/GCST90200338.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200667",
    "initial_individuals": "7906",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800920",
    "EFO_Trait_Name": "X-25271 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200667/harmonised/GCST90200667.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200288",
    "initial_individuals": "7905",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800116",
    "EFO_Trait_Name": "N-acetylleucine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200288/harmonised/GCST90200288.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199917",
    "initial_individuals": "7905",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800341",
    "EFO_Trait_Name": "pregnanediol-3-glucuronide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199917/harmonised/GCST90199917.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200522",
    "initial_individuals": "7905",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800741",
    "EFO_Trait_Name": "X-13728 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200522/harmonised/GCST90200522.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199942",
    "initial_individuals": "7905",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800979",
    "EFO_Trait_Name": "dimethyl sulfone measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199942/harmonised/GCST90199942.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199753",
    "initial_individuals": "7902",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800671",
    "EFO_Trait_Name": "gamma-glutamyltryptophan measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199753/harmonised/GCST90199753.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200151",
    "initial_individuals": "7899",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800555",
    "EFO_Trait_Name": "5-dodecenoylcarnitine (C12:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200151/harmonised/GCST90200151.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200511",
    "initial_individuals": "7896",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800733",
    "EFO_Trait_Name": "X-12906 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200511/harmonised/GCST90200511.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200321",
    "initial_individuals": "7892",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021509",
    "EFO_Trait_Name": "cholate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200321/harmonised/GCST90200321.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200231",
    "initial_individuals": "7891",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800579",
    "EFO_Trait_Name": "lithocholate sulfate (1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200231/harmonised/GCST90200231.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200144",
    "initial_individuals": "7887",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800546",
    "EFO_Trait_Name": "dihomo-linoleoylcarnitine (C20:2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200144/harmonised/GCST90200144.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200167",
    "initial_individuals": "7881",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800656",
    "EFO_Trait_Name": "glutamine conjugate of C7H12O2 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200167/harmonised/GCST90200167.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200143",
    "initial_individuals": "7880",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800549",
    "EFO_Trait_Name": "nervonoylcarnitine (C24:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200143/harmonised/GCST90200143.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200538",
    "initial_individuals": "7879",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800767",
    "EFO_Trait_Name": "X-17010 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200538/harmonised/GCST90200538.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200614",
    "initial_individuals": "7878",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800864",
    "EFO_Trait_Name": "X-23780 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200614/harmonised/GCST90200614.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200653",
    "initial_individuals": "7878",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800908",
    "EFO_Trait_Name": "X-24812 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200653/harmonised/GCST90200653.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200542",
    "initial_individuals": "7874",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0020024",
    "EFO_Trait_Name": "X-15728 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200542/harmonised/GCST90200542.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200198",
    "initial_individuals": "7865",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800571",
    "EFO_Trait_Name": "2-hydroxysebacate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200198/harmonised/GCST90200198.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199662",
    "initial_individuals": "7862",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800010",
    "EFO_Trait_Name": "isovalerate (i5:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199662/harmonised/GCST90199662.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200234",
    "initial_individuals": "7862",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800592",
    "EFO_Trait_Name": "picolinoylglycine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200234/harmonised/GCST90200234.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200239",
    "initial_individuals": "7857",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800585",
    "EFO_Trait_Name": "tetradecadienedioate (C14:2-DC) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200239/harmonised/GCST90200239.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199998",
    "initial_individuals": "7855",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801005",
    "EFO_Trait_Name": "propyl 4-hydroxybenzoate sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199998/harmonised/GCST90199998.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200205",
    "initial_individuals": "7848",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801027",
    "EFO_Trait_Name": "3-indoleglyoxylic acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200205/harmonised/GCST90200205.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200675",
    "initial_individuals": "7841",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0020021",
    "EFO_Trait_Name": "N-acetyltyrosine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200675/harmonised/GCST90200675.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199654",
    "initial_individuals": "7840",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021178",
    "EFO_Trait_Name": "paraxanthine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199654/harmonised/GCST90199654.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200101",
    "initial_individuals": "7837",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800494",
    "EFO_Trait_Name": "pimeloylcarnitine/3-methyladipoylcarnitine (C7-DC) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200101/harmonised/GCST90200101.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200208",
    "initial_individuals": "7833",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801032",
    "EFO_Trait_Name": "glucuronide of piperine metabolite C17H21NO3 (4) measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200208/harmonised/GCST90200208.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199779",
    "initial_individuals": "7826",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800674",
    "EFO_Trait_Name": "gamma-glutamyl-2-aminobutyrate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199779/harmonised/GCST90199779.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199888",
    "initial_individuals": "7824",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800962",
    "EFO_Trait_Name": "cinnamoylglycine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199888/harmonised/GCST90199888.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199647",
    "initial_individuals": "7822",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021180",
    "EFO_Trait_Name": "theophylline measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199647/harmonised/GCST90199647.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199964",
    "initial_individuals": "7821",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800362",
    "EFO_Trait_Name": "etiocholanolone glucuronide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199964/harmonised/GCST90199964.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243606",
    "initial_individuals": "7818",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021182",
    "EFO_Trait_Name": "X-02249 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243606/harmonised/GCST90243606.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243611",
    "initial_individuals": "7817",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021084",
    "EFO_Trait_Name": "1-linoleoylglycerophosphoethanolamine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243611/harmonised/GCST90243611.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243741",
    "initial_individuals": "7817",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021092",
    "EFO_Trait_Name": "1-stearoylglycerophosphocholine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243741/harmonised/GCST90243741.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243512",
    "initial_individuals": "7816",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021049",
    "EFO_Trait_Name": "eicosapentaenoate EPA; 20:5n3 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243512/harmonised/GCST90243512.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243531",
    "initial_individuals": "7815",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0020999",
    "EFO_Trait_Name": "2-hydroxybutyrate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243531/harmonised/GCST90243531.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243593",
    "initial_individuals": "7813",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0020942",
    "EFO_Trait_Name": "propionylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243593/harmonised/GCST90243593.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200300",
    "initial_individuals": "7813",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800120",
    "EFO_Trait_Name": "4-hydroxyphenylpyruvate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200300/harmonised/GCST90200300.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199784",
    "initial_individuals": "7812",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021001",
    "EFO_Trait_Name": "cysteine-glutathione disulfide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199784/harmonised/GCST90199784.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243833",
    "initial_individuals": "7812",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021085",
    "EFO_Trait_Name": "1-myristoylglycerophosphocholine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243833/harmonised/GCST90243833.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243740",
    "initial_individuals": "7812",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021086",
    "EFO_Trait_Name": "1-oleoylglycerophosphocholine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243740/harmonised/GCST90243740.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243675",
    "initial_individuals": "7812",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021088",
    "EFO_Trait_Name": "1-palmitoleoylglycerophosphocholine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243675/harmonised/GCST90243675.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243619",
    "initial_individuals": "7812",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021186",
    "EFO_Trait_Name": "X-03056--N-[3- 2-Oxopyrrolidin-1-yl propyl]acetamide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243619/harmonised/GCST90243619.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243594",
    "initial_individuals": "7811",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021102",
    "EFO_Trait_Name": "caproate 6:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243594/harmonised/GCST90243594.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243610",
    "initial_individuals": "7811",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021224",
    "EFO_Trait_Name": "X-11317 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243610/harmonised/GCST90243610.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199871",
    "initial_individuals": "7811",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800295",
    "EFO_Trait_Name": "androstenediol (3beta,17beta) monosulfate (2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199871/harmonised/GCST90199871.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243614",
    "initial_individuals": "7809",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021037",
    "EFO_Trait_Name": "3-dehydrocarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243614/harmonised/GCST90243614.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243720",
    "initial_individuals": "7809",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021081",
    "EFO_Trait_Name": "1-eicosatrienoylglycerophosphocholine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243720/harmonised/GCST90243720.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243749",
    "initial_individuals": "7809",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021314",
    "EFO_Trait_Name": "X-12524 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243749/harmonised/GCST90243749.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200624",
    "initial_individuals": "7807",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800873",
    "EFO_Trait_Name": "X-24328 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200624/harmonised/GCST90200624.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243624",
    "initial_individuals": "7805",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021211",
    "EFO_Trait_Name": "X-09789 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243624/harmonised/GCST90243624.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200108",
    "initial_individuals": "7805",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800516",
    "EFO_Trait_Name": "N-palmitoyl-sphingadienine (d18:2/16:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200108/harmonised/GCST90200108.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243879",
    "initial_individuals": "7804",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021113",
    "EFO_Trait_Name": "4-androsten-3beta,17beta-diol disulfate 1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243879/harmonised/GCST90243879.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243475",
    "initial_individuals": "7804",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021188",
    "EFO_Trait_Name": "X-03094 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243475/harmonised/GCST90243475.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243645",
    "initial_individuals": "7804",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021251",
    "EFO_Trait_Name": "X-11538 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243645/harmonised/GCST90243645.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200532",
    "initial_individuals": "7804",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800763",
    "EFO_Trait_Name": "X-16935 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200532/harmonised/GCST90200532.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200622",
    "initial_individuals": "7804",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800868",
    "EFO_Trait_Name": "X-23997 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200622/harmonised/GCST90200622.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243527",
    "initial_individuals": "7803",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0010504",
    "EFO_Trait_Name": "inositol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243527/harmonised/GCST90243527.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200449",
    "initial_individuals": "7803",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010535",
    "EFO_Trait_Name": "sucrose measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200449/harmonised/GCST90200449.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243738",
    "initial_individuals": "7803",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021089",
    "EFO_Trait_Name": "1-palmitoylglycerophosphocholine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243738/harmonised/GCST90243738.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243468",
    "initial_individuals": "7803",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021106",
    "EFO_Trait_Name": "pelargonate 9:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243468/harmonised/GCST90243468.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243578",
    "initial_individuals": "7802",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0010498",
    "EFO_Trait_Name": "hydroxyproline measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243578/harmonised/GCST90243578.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243451",
    "initial_individuals": "7802",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021104",
    "EFO_Trait_Name": "heptanoate 7:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243451/harmonised/GCST90243451.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199637",
    "initial_individuals": "7802",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800005",
    "EFO_Trait_Name": "N-acetylglutamate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199637/harmonised/GCST90199637.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200574",
    "initial_individuals": "7801",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800805",
    "EFO_Trait_Name": "X-21310 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200574/harmonised/GCST90200574.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243615",
    "initial_individuals": "7800",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0005408",
    "EFO_Trait_Name": "pyroglutamine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243615/harmonised/GCST90243615.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243704",
    "initial_individuals": "7799",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021065",
    "EFO_Trait_Name": "eicosenoate 20:1n9 or 11 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243704/harmonised/GCST90243704.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243598",
    "initial_individuals": "7799",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021219",
    "EFO_Trait_Name": "X-11204 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243598/harmonised/GCST90243598.h.tsv.gz"
  },
  {
    "accessionId": "GCST90129600",
    "initial_individuals": "7798",
    "initial_ancestralGroup": "European",
    "pubmedId": "36066633",
    "EFO_ID": "EFO_0004763",
    "EFO_Trait_Name": "p-tau measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129600/harmonised/GCST90129600.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243808",
    "initial_individuals": "7798",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021077",
    "EFO_Trait_Name": "1-arachidonoylglycerophosphoethanolamine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243808/harmonised/GCST90243808.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243721",
    "initial_individuals": "7798",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021079",
    "EFO_Trait_Name": "1-docosahexaenoylglycerophosphocholine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243721/harmonised/GCST90243721.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200469",
    "initial_individuals": "7798",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021243",
    "EFO_Trait_Name": "X-11483 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200469/harmonised/GCST90200469.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200093",
    "initial_individuals": "7798",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801013",
    "EFO_Trait_Name": "caffeic acid sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200093/harmonised/GCST90200093.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243754",
    "initial_individuals": "7797",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021078",
    "EFO_Trait_Name": "1-arachidonoylglycerophosphoinositol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243754/harmonised/GCST90243754.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243589",
    "initial_individuals": "7796",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0020010",
    "EFO_Trait_Name": "butyrylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243589/harmonised/GCST90243589.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243781",
    "initial_individuals": "7795",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021083",
    "EFO_Trait_Name": "1-linoleoylglycerophosphocholine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243781/harmonised/GCST90243781.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243756",
    "initial_individuals": "7795",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021318",
    "EFO_Trait_Name": "X-12644 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243756/harmonised/GCST90243756.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243591",
    "initial_individuals": "7793",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021119",
    "EFO_Trait_Name": "dehydroisoandrosterone sulfate DHEA-S measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243591/harmonised/GCST90243591.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243556",
    "initial_individuals": "7792",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021217",
    "EFO_Trait_Name": "X-10510 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243556/harmonised/GCST90243556.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243824",
    "initial_individuals": "7791",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021356",
    "EFO_Trait_Name": "X-13619 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243824/harmonised/GCST90243824.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200516",
    "initial_individuals": "7790",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021340",
    "EFO_Trait_Name": "X-12847 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200516/harmonised/GCST90200516.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243778",
    "initial_individuals": "7789",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0020019",
    "EFO_Trait_Name": "isovalerylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243778/harmonised/GCST90243778.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243480",
    "initial_individuals": "7789",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021035",
    "EFO_Trait_Name": "acetylphosphate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243480/harmonised/GCST90243480.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243650",
    "initial_individuals": "7788",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0020015",
    "EFO_Trait_Name": "X-11593 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243650/harmonised/GCST90243650.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199930",
    "initial_individuals": "7787",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800344",
    "EFO_Trait_Name": "(R)-3-hydroxybutyrylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199930/harmonised/GCST90199930.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243601",
    "initial_individuals": "7785",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021197",
    "EFO_Trait_Name": "X-06126 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243601/harmonised/GCST90243601.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243552",
    "initial_individuals": "7784",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021213",
    "EFO_Trait_Name": "X-10395 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243552/harmonised/GCST90243552.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200466",
    "initial_individuals": "7784",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800697",
    "EFO_Trait_Name": "X-11632 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200466/harmonised/GCST90200466.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243728",
    "initial_individuals": "7780",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021308",
    "EFO_Trait_Name": "X12442--5,8-tetradecadienoate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243728/harmonised/GCST90243728.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243417",
    "initial_individuals": "7780",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021510",
    "EFO_Trait_Name": "linoleate 18:2n6 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243417/harmonised/GCST90243417.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243633",
    "initial_individuals": "7779",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021240",
    "EFO_Trait_Name": "X-11469 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243633/harmonised/GCST90243633.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243859",
    "initial_individuals": "7777",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021372",
    "EFO_Trait_Name": "X-14588 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243859/harmonised/GCST90243859.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200203",
    "initial_individuals": "7777",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800106",
    "EFO_Trait_Name": "indoleacetoylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200203/harmonised/GCST90200203.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243880",
    "initial_individuals": "7776",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021114",
    "EFO_Trait_Name": "4-androsten-3beta,17beta-diol disulfate 2 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243880/harmonised/GCST90243880.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243547",
    "initial_individuals": "7776",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021207",
    "EFO_Trait_Name": "X-08988 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243547/harmonised/GCST90243547.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243648",
    "initial_individuals": "7776",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021254",
    "EFO_Trait_Name": "X-11550 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243648/harmonised/GCST90243648.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199915",
    "initial_individuals": "7776",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800062",
    "EFO_Trait_Name": "imidazole propionate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199915/harmonised/GCST90199915.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199853",
    "initial_individuals": "7772",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800284",
    "EFO_Trait_Name": "5alpha-pregnan-3beta,20beta-diol monosulfate (1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199853/harmonised/GCST90199853.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199873",
    "initial_individuals": "7772",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800303",
    "EFO_Trait_Name": "pregnenolone sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199873/harmonised/GCST90199873.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243604",
    "initial_individuals": "7771",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021221",
    "EFO_Trait_Name": "X-11261 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243604/harmonised/GCST90243604.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199865",
    "initial_individuals": "7769",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021506",
    "EFO_Trait_Name": "2-hydroxyglutarate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199865/harmonised/GCST90199865.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243432",
    "initial_individuals": "7768",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021070",
    "EFO_Trait_Name": "oleate 18:1n9 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243432/harmonised/GCST90243432.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243623",
    "initial_individuals": "7765",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021231",
    "EFO_Trait_Name": "X-11423--O-sulfo-L-tyrosine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243623/harmonised/GCST90243623.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243784",
    "initial_individuals": "7764",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021333",
    "EFO_Trait_Name": "X-12776 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243784/harmonised/GCST90243784.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243835",
    "initial_individuals": "7763",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021090",
    "EFO_Trait_Name": "1-palmitoylglycerophosphoethanolamine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243835/harmonised/GCST90243835.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200479",
    "initial_individuals": "7763",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800713",
    "EFO_Trait_Name": "X-12283 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200479/harmonised/GCST90200479.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199931",
    "initial_individuals": "7760",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800063",
    "EFO_Trait_Name": "lanthionine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199931/harmonised/GCST90199931.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243472",
    "initial_individuals": "7759",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021184",
    "EFO_Trait_Name": "X-02973 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243472/harmonised/GCST90243472.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243683",
    "initial_individuals": "7758",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021279",
    "EFO_Trait_Name": "X-12038 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243683/harmonised/GCST90243683.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200380",
    "initial_individuals": "7757",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800620",
    "EFO_Trait_Name": "glutarate (C5-DC) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200380/harmonised/GCST90200380.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243489",
    "initial_individuals": "7756",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021150",
    "EFO_Trait_Name": "benzoate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243489/harmonised/GCST90243489.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243689",
    "initial_individuals": "7753",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021142",
    "EFO_Trait_Name": "gamma-glutamylphenylalanine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243689/harmonised/GCST90243689.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200106",
    "initial_individuals": "7752",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800688",
    "EFO_Trait_Name": "4-hydroxyphenylacetylglutamine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200106/harmonised/GCST90200106.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200615",
    "initial_individuals": "7752",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800867",
    "EFO_Trait_Name": "X-23974 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200615/harmonised/GCST90200615.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243554",
    "initial_individuals": "7751",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021215",
    "EFO_Trait_Name": "X-10500 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243554/harmonised/GCST90243554.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243834",
    "initial_individuals": "7749",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021087",
    "EFO_Trait_Name": "1-oleoylglycerophosphoethanolamine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243834/harmonised/GCST90243834.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200530",
    "initial_individuals": "7747",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800772",
    "EFO_Trait_Name": "X-17335 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200530/harmonised/GCST90200530.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200109",
    "initial_individuals": "7744",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800500",
    "EFO_Trait_Name": "linoleoyl-arachidonoyl-glycerol (18:2/20:4) [2] measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200109/harmonised/GCST90200109.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200333",
    "initial_individuals": "7743",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010538",
    "EFO_Trait_Name": "taurocholate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200333/harmonised/GCST90200333.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243518",
    "initial_individuals": "7734",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021196",
    "EFO_Trait_Name": "X-05907 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243518/harmonised/GCST90243518.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199797",
    "initial_individuals": "7731",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800159",
    "EFO_Trait_Name": "gulonate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199797/harmonised/GCST90199797.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200103",
    "initial_individuals": "7731",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800499",
    "EFO_Trait_Name": "linoleoyl-arachidonoyl-glycerol (18:2/20:4) [1] measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200103/harmonised/GCST90200103.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243815",
    "initial_individuals": "7730",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021098",
    "EFO_Trait_Name": "2-stearoylglycerophosphocholine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243815/harmonised/GCST90243815.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243538",
    "initial_individuals": "7726",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021205",
    "EFO_Trait_Name": "X-08402 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243538/harmonised/GCST90243538.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200519",
    "initial_individuals": "7724",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800742",
    "EFO_Trait_Name": "X-13729 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200519/harmonised/GCST90200519.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200087",
    "initial_individuals": "7722",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800087",
    "EFO_Trait_Name": "2-methylserine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200087/harmonised/GCST90200087.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243701",
    "initial_individuals": "7711",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021287",
    "EFO_Trait_Name": "X-12095--N1-methyl-3-pyridone-4-carboxamide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243701/harmonised/GCST90243701.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243555",
    "initial_individuals": "7710",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021216",
    "EFO_Trait_Name": "X-10506 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243555/harmonised/GCST90243555.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243662",
    "initial_individuals": "7710",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021265",
    "EFO_Trait_Name": "X-11820 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243662/harmonised/GCST90243662.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199968",
    "initial_individuals": "7708",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800367",
    "EFO_Trait_Name": "1-palmitoyl-GPG (16:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199968/harmonised/GCST90199968.h.tsv.gz"
  },
  {
    "accessionId": "GCST90292522",
    "initial_individuals": "7705",
    "initial_ancestralGroup": "European",
    "pubmedId": "38443389",
    "EFO_ID": "EFO_0006999",
    "EFO_Trait_Name": "cancer aggressiveness measurement",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90292001-GCST90293000/GCST90292522/harmonised/GCST90292522.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200684",
    "initial_individuals": "7705",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800033",
    "EFO_Trait_Name": "N-acetyl-aspartyl-glutamate (NAAG) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200684/harmonised/GCST90200684.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200482",
    "initial_individuals": "7705",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800710",
    "EFO_Trait_Name": "X-12193 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200482/harmonised/GCST90200482.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200209",
    "initial_individuals": "7705",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801035",
    "EFO_Trait_Name": "sulfate of piperine metabolite C16H19NO3 (3) measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200209/harmonised/GCST90200209.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243827",
    "initial_individuals": "7701",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021005",
    "EFO_Trait_Name": "glutaroyl carnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243827/harmonised/GCST90243827.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243599",
    "initial_individuals": "7701",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021183",
    "EFO_Trait_Name": "X-02269 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243599/harmonised/GCST90243599.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243640",
    "initial_individuals": "7700",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021147",
    "EFO_Trait_Name": "HWESASXX measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243640/harmonised/GCST90243640.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200590",
    "initial_individuals": "7700",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800817",
    "EFO_Trait_Name": "X-21470 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200590/harmonised/GCST90200590.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200589",
    "initial_individuals": "7699",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800829",
    "EFO_Trait_Name": "X-21821 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200589/harmonised/GCST90200589.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243551",
    "initial_individuals": "7697",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021210",
    "EFO_Trait_Name": "X-09706 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243551/harmonised/GCST90243551.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243813",
    "initial_individuals": "7695",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021097",
    "EFO_Trait_Name": "2-palmitoylglycerophosphocholine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243813/harmonised/GCST90243813.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243520",
    "initial_individuals": "7694",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021094",
    "EFO_Trait_Name": "1-stearoylglycerophosphoinositol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243520/harmonised/GCST90243520.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200547",
    "initial_individuals": "7690",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800784",
    "EFO_Trait_Name": "X-17654 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200547/harmonised/GCST90200547.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243473",
    "initial_individuals": "7689",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021185",
    "EFO_Trait_Name": "X-03003 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243473/harmonised/GCST90243473.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243627",
    "initial_individuals": "7686",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021234",
    "EFO_Trait_Name": "X-11440 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243627/harmonised/GCST90243627.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199801",
    "initial_individuals": "7682",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021157",
    "EFO_Trait_Name": "hydroquinone sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199801/harmonised/GCST90199801.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200135",
    "initial_individuals": "7682",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800540",
    "EFO_Trait_Name": "arachidoylcarnitine (C20) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200135/harmonised/GCST90200135.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200464",
    "initial_individuals": "7679",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021269",
    "EFO_Trait_Name": "X-11849 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200464/harmonised/GCST90200464.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199766",
    "initial_individuals": "7679",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800632",
    "EFO_Trait_Name": "3-(3-amino-3-carboxypropyl)uridine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199766/harmonised/GCST90199766.h.tsv.gz"
  },
  {
    "accessionId": "GCST90012678",
    "initial_individuals": "7677",
    "initial_ancestralGroup": "European",
    "pubmedId": "33441150",
    "EFO_ID": "OBA_2050074",
    "EFO_Trait_Name": "serum IgA amount",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90012001-GCST90013000/GCST90012678/harmonised/GCST90012678.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200213",
    "initial_individuals": "7673",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801038",
    "EFO_Trait_Name": "2-naphthol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200213/harmonised/GCST90200213.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243612",
    "initial_individuals": "7671",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021225",
    "EFO_Trait_Name": "X-11327 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243612/harmonised/GCST90243612.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200031",
    "initial_individuals": "7669",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800381",
    "EFO_Trait_Name": "nonanoylcarnitine (C9) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200031/harmonised/GCST90200031.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243735",
    "initial_individuals": "7668",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0010984",
    "EFO_Trait_Name": "3-hydroxyisovalerate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243735/harmonised/GCST90243735.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243501",
    "initial_individuals": "7663",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021380",
    "EFO_Trait_Name": "X-18601 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243501/harmonised/GCST90243501.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199904",
    "initial_individuals": "7662",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022210",
    "EFO_Trait_Name": "Blood pantoate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199904/harmonised/GCST90199904.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200609",
    "initial_individuals": "7662",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800849",
    "EFO_Trait_Name": "X-23587 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200609/harmonised/GCST90200609.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200429",
    "initial_individuals": "7659",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800645",
    "EFO_Trait_Name": "cytidine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200429/harmonised/GCST90200429.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243817",
    "initial_individuals": "7656",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021352",
    "EFO_Trait_Name": "X-13496 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243817/harmonised/GCST90243817.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200157",
    "initial_individuals": "7650",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800172",
    "EFO_Trait_Name": "carotene diol (3) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200157/harmonised/GCST90200157.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199770",
    "initial_individuals": "7650",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800224",
    "EFO_Trait_Name": "1-arachidonylglycerol (20:4) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199770/harmonised/GCST90199770.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200386",
    "initial_individuals": "7649",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010475",
    "EFO_Trait_Name": "deoxycholate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200386/harmonised/GCST90200386.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200472",
    "initial_individuals": "7629",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021270",
    "EFO_Trait_Name": "X-11850 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200472/harmonised/GCST90200472.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243548",
    "initial_individuals": "7627",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021208",
    "EFO_Trait_Name": "X-09026 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243548/harmonised/GCST90243548.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243855",
    "initial_individuals": "7627",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021368",
    "EFO_Trait_Name": "X-14374 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243855/harmonised/GCST90243855.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243521",
    "initial_individuals": "7623",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021198",
    "EFO_Trait_Name": "X-06226 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243521/harmonised/GCST90243521.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243657",
    "initial_individuals": "7611",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021260",
    "EFO_Trait_Name": "X-11793--oxidized bilirubin measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243657/harmonised/GCST90243657.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199858",
    "initial_individuals": "7608",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800288",
    "EFO_Trait_Name": "5alpha-androstan-3alpha,17beta-diol monosulfate (1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199858/harmonised/GCST90199858.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200268",
    "initial_individuals": "7606",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022202",
    "EFO_Trait_Name": "Blood N-acetyl-2-aminoadipate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200268/harmonised/GCST90200268.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200680",
    "initial_individuals": "7599",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800950",
    "EFO_Trait_Name": "5-acetylamino-6-formylamino-3-methyluracil measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200680/harmonised/GCST90200680.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199954",
    "initial_individuals": "7596",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800070",
    "EFO_Trait_Name": "N2,N5-diacetylornithine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199954/harmonised/GCST90199954.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199982",
    "initial_individuals": "7592",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800998",
    "EFO_Trait_Name": "4-vinylguaiacol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199982/harmonised/GCST90199982.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200099",
    "initial_individuals": "7591",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800525",
    "EFO_Trait_Name": "N-oleoylserine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200099/harmonised/GCST90200099.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200690",
    "initial_individuals": "7588",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800065",
    "EFO_Trait_Name": "N-acetyl-1-methylhistidine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200690/harmonised/GCST90200690.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200695",
    "initial_individuals": "7582",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800636",
    "EFO_Trait_Name": "2'-O-methyluridine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200695/harmonised/GCST90200695.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243483",
    "initial_individuals": "7574",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021538",
    "EFO_Trait_Name": "N-acetylornithine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243483/harmonised/GCST90243483.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243748",
    "initial_individuals": "7566",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021313",
    "EFO_Trait_Name": "X-12510--2-aminooctanoic acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243748/harmonised/GCST90243748.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200232",
    "initial_individuals": "7565",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801049",
    "EFO_Trait_Name": "4-acetylcatechol sulfate (1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200232/harmonised/GCST90200232.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243681",
    "initial_individuals": "7564",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021278",
    "EFO_Trait_Name": "X-12029 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243681/harmonised/GCST90243681.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200369",
    "initial_individuals": "7564",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800131",
    "EFO_Trait_Name": "2-hydroxyphenylacetate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200369/harmonised/GCST90200369.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200515",
    "initial_individuals": "7555",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800732",
    "EFO_Trait_Name": "X-12849 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200515/harmonised/GCST90200515.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200283",
    "initial_individuals": "7543",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010641",
    "EFO_Trait_Name": "3-ureidopropionate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200283/harmonised/GCST90200283.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199796",
    "initial_individuals": "7540",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800249",
    "EFO_Trait_Name": "docosapentaenoate (n6 DPA; 22:5n6) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199796/harmonised/GCST90199796.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200102",
    "initial_individuals": "7540",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800484",
    "EFO_Trait_Name": "1-palmitoleoyl-2-linolenoyl-GPC (16:1/18:3) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200102/harmonised/GCST90200102.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199960",
    "initial_individuals": "7534",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800069",
    "EFO_Trait_Name": "N-formylanthranilic acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199960/harmonised/GCST90199960.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200197",
    "initial_individuals": "7526",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800105",
    "EFO_Trait_Name": "1-carboxyethylisoleucine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200197/harmonised/GCST90200197.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243814",
    "initial_individuals": "7524",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021096",
    "EFO_Trait_Name": "2-oleoylglycerophosphocholine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243814/harmonised/GCST90243814.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199695",
    "initial_individuals": "7518",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800145",
    "EFO_Trait_Name": "galactonate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199695/harmonised/GCST90199695.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199834",
    "initial_individuals": "7518",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800675",
    "EFO_Trait_Name": "gamma-glutamylalanine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199834/harmonised/GCST90199834.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199927",
    "initial_individuals": "7518",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800972",
    "EFO_Trait_Name": "histidine betaine (hercynine) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199927/harmonised/GCST90199927.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199894",
    "initial_individuals": "7514",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022216",
    "EFO_Trait_Name": "Blood 4-oxo-retinoic acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199894/harmonised/GCST90199894.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200253",
    "initial_individuals": "7512",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801056",
    "EFO_Trait_Name": "vanillic acid glycine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200253/harmonised/GCST90200253.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243860",
    "initial_individuals": "7511",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021373",
    "EFO_Trait_Name": "X-14625 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243860/harmonised/GCST90243860.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243674",
    "initial_individuals": "7507",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021076",
    "EFO_Trait_Name": "1-arachidonoylglycerophosphocholine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243674/harmonised/GCST90243674.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243493",
    "initial_individuals": "7502",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021189",
    "EFO_Trait_Name": "X-04357 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243493/harmonised/GCST90243493.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200521",
    "initial_individuals": "7501",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800744",
    "EFO_Trait_Name": "X-13844 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200521/harmonised/GCST90200521.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243469",
    "initial_individuals": "7500",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021107",
    "EFO_Trait_Name": "undecanoate 11:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243469/harmonised/GCST90243469.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243698",
    "initial_individuals": "7500",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021284",
    "EFO_Trait_Name": "X-12092 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243698/harmonised/GCST90243698.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199999",
    "initial_individuals": "7500",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800080",
    "EFO_Trait_Name": "4-methoxyphenol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199999/harmonised/GCST90199999.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243702",
    "initial_individuals": "7499",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021288",
    "EFO_Trait_Name": "X-12100--hydroxytryptophan measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243702/harmonised/GCST90243702.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200422",
    "initial_individuals": "7498",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "OBA_1000977",
    "EFO_Trait_Name": "serotonin amount",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200422/harmonised/GCST90200422.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243495",
    "initial_individuals": "7490",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021191",
    "EFO_Trait_Name": "X-04495 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243495/harmonised/GCST90243495.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199962",
    "initial_individuals": "7489",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800068",
    "EFO_Trait_Name": "acisoga measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199962/harmonised/GCST90199962.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200270",
    "initial_individuals": "7487",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801061",
    "EFO_Trait_Name": "2-methoxyhydroquinone sulfate (1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200270/harmonised/GCST90200270.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200006",
    "initial_individuals": "7484",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801008",
    "EFO_Trait_Name": "1,2,3-benzenetriol sulfate (2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200006/harmonised/GCST90200006.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243753",
    "initial_individuals": "7483",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021316",
    "EFO_Trait_Name": "X-12556 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243753/harmonised/GCST90243753.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243639",
    "initial_individuals": "7481",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021246",
    "EFO_Trait_Name": "X-11497 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243639/harmonised/GCST90243639.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240016",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0010359",
    "EFO_Trait_Name": "lysophosphatidylcholine 18:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240016/harmonised/GCST90240016.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240019",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0010362",
    "EFO_Trait_Name": "lysophosphatidylcholine 20:3 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240019/harmonised/GCST90240019.h.tsv.gz"
  },
  {
    "accessionId": "GCST90239995",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0021808",
    "EFO_Trait_Name": "dodecenoylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90239001-GCST90240000/GCST90239995/harmonised/GCST90239995.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240000",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801235",
    "EFO_Trait_Name": "octadecadienylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90239001-GCST90240000/GCST90240000/harmonised/GCST90240000.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240013",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801241",
    "EFO_Trait_Name": "lysophosphatidylcholine acyl C16:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240013/harmonised/GCST90240013.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240015",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801242",
    "EFO_Trait_Name": "lysophosphatidylcholine acyl C17:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240015/harmonised/GCST90240015.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240026",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801246",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C28:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240026/harmonised/GCST90240026.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240030",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801250",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C32:2 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240030/harmonised/GCST90240030.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240031",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801251",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C32:3 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240031/harmonised/GCST90240031.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240033",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801253",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C34:2 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240033/harmonised/GCST90240033.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240034",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801254",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C34:3 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240034/harmonised/GCST90240034.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240035",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801255",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C34:4 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240035/harmonised/GCST90240035.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240036",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801256",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C36:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240036/harmonised/GCST90240036.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240038",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801258",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C36:2 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240038/harmonised/GCST90240038.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240040",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801260",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C36:4 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240040/harmonised/GCST90240040.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240043",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801263",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C38:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240043/harmonised/GCST90240043.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240055",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801275",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C42:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240055/harmonised/GCST90240055.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240056",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801276",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C42:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240056/harmonised/GCST90240056.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240058",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801278",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C42:4 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240058/harmonised/GCST90240058.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240062",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801282",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C32:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240062/harmonised/GCST90240062.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240063",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801283",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C32:2 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240063/harmonised/GCST90240063.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240064",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801284",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C34:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240064/harmonised/GCST90240064.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240066",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801286",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C34:2 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240066/harmonised/GCST90240066.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240067",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801287",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C34:3 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240067/harmonised/GCST90240067.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240071",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801291",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C36:3 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240071/harmonised/GCST90240071.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240076",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801296",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C38:2 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240076/harmonised/GCST90240076.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240078",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801298",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C38:4 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240078/harmonised/GCST90240078.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240079",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801299",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C38:5 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240079/harmonised/GCST90240079.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240082",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801302",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C40:2 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240082/harmonised/GCST90240082.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240083",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801303",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C40:3 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240083/harmonised/GCST90240083.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240084",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801304",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C40:4 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240084/harmonised/GCST90240084.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240085",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801305",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C40:5 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240085/harmonised/GCST90240085.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240086",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801306",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C40:6 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240086/harmonised/GCST90240086.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240090",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801310",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C42:3 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240090/harmonised/GCST90240090.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240091",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801311",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C42:4 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240091/harmonised/GCST90240091.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240093",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801313",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C44:3 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240093/harmonised/GCST90240093.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240095",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801315",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C44:5 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240095/harmonised/GCST90240095.h.tsv.gz"
  },
  {
    "accessionId": "GCST002964",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801317",
    "EFO_Trait_Name": "sphingomyeline C16:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST002001-GCST003000/GCST002964/harmonised/GCST002964.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240101",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801318",
    "EFO_Trait_Name": "sphingomyeline C16:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240101/harmonised/GCST90240101.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240102",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801319",
    "EFO_Trait_Name": "sphingomyeline C18:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240102/harmonised/GCST90240102.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240103",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801320",
    "EFO_Trait_Name": "sphingomyeline C18:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240103/harmonised/GCST90240103.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240104",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801321",
    "EFO_Trait_Name": "sphingomyeline C20:2 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240104/harmonised/GCST90240104.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240106",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801323",
    "EFO_Trait_Name": "sphingomyeline C24:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240106/harmonised/GCST90240106.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240109",
    "initial_individuals": "7478",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801326",
    "EFO_Trait_Name": "hydroxysphingomyeline C14:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240109/harmonised/GCST90240109.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240017",
    "initial_individuals": "7477",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0010360",
    "EFO_Trait_Name": "lysophosphatidylcholine 18:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240017/harmonised/GCST90240017.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240020",
    "initial_individuals": "7477",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0010363",
    "EFO_Trait_Name": "lysophosphatidylcholine 20:4 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240020/harmonised/GCST90240020.h.tsv.gz"
  },
  {
    "accessionId": "GCST90239996",
    "initial_individuals": "7477",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0021809",
    "EFO_Trait_Name": "tetradecenoylcarnitine meaasurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90239001-GCST90240000/GCST90239996/harmonised/GCST90239996.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240022",
    "initial_individuals": "7477",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801244",
    "EFO_Trait_Name": "lysophosphatidylcholine acyl C28:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240022/harmonised/GCST90240022.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240027",
    "initial_individuals": "7477",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801247",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C30:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240027/harmonised/GCST90240027.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240028",
    "initial_individuals": "7477",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801248",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C32:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240028/harmonised/GCST90240028.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240032",
    "initial_individuals": "7477",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801252",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C34:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240032/harmonised/GCST90240032.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240039",
    "initial_individuals": "7477",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801259",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C36:3 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240039/harmonised/GCST90240039.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240045",
    "initial_individuals": "7477",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801265",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C38:3 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240045/harmonised/GCST90240045.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240048",
    "initial_individuals": "7477",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801268",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C38:6 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240048/harmonised/GCST90240048.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240065",
    "initial_individuals": "7477",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801285",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C34:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240065/harmonised/GCST90240065.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240069",
    "initial_individuals": "7477",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801289",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C36:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240069/harmonised/GCST90240069.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240070",
    "initial_individuals": "7477",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801290",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C36:2 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240070/harmonised/GCST90240070.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240072",
    "initial_individuals": "7477",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801292",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C36:4 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240072/harmonised/GCST90240072.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240077",
    "initial_individuals": "7477",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801297",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C38:3 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240077/harmonised/GCST90240077.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240080",
    "initial_individuals": "7477",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801300",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C38:6 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240080/harmonised/GCST90240080.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240081",
    "initial_individuals": "7477",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801301",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C40:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240081/harmonised/GCST90240081.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240088",
    "initial_individuals": "7477",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801308",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C42:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240088/harmonised/GCST90240088.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240089",
    "initial_individuals": "7477",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801309",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C42:2 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240089/harmonised/GCST90240089.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240094",
    "initial_individuals": "7477",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801314",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C44:4 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240094/harmonised/GCST90240094.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240096",
    "initial_individuals": "7477",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801316",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C44:6 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240096/harmonised/GCST90240096.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240105",
    "initial_individuals": "7477",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801322",
    "EFO_Trait_Name": "sphingomyeline C24:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240105/harmonised/GCST90240105.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240018",
    "initial_individuals": "7476",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0010361",
    "EFO_Trait_Name": "lysophosphatidylcholine 18:2 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240018/harmonised/GCST90240018.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240029",
    "initial_individuals": "7476",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801249",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C32:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240029/harmonised/GCST90240029.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240042",
    "initial_individuals": "7476",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801262",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C36:6 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240042/harmonised/GCST90240042.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240046",
    "initial_individuals": "7476",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801266",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C38:4 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240046/harmonised/GCST90240046.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240054",
    "initial_individuals": "7476",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801274",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C40:6 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240054/harmonised/GCST90240054.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240068",
    "initial_individuals": "7476",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801288",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C36:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240068/harmonised/GCST90240068.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240073",
    "initial_individuals": "7476",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801293",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C36:5 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240073/harmonised/GCST90240073.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240074",
    "initial_individuals": "7476",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801294",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C38:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240074/harmonised/GCST90240074.h.tsv.gz"
  },
  {
    "accessionId": "GCST002965",
    "initial_individuals": "7475",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0010358",
    "EFO_Trait_Name": "lysophosphatidylcholine 16:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST002001-GCST003000/GCST002965/harmonised/GCST002965.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240037",
    "initial_individuals": "7475",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801257",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C36:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240037/harmonised/GCST90240037.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240047",
    "initial_individuals": "7475",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801267",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C38:5 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240047/harmonised/GCST90240047.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240059",
    "initial_individuals": "7475",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801279",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C42:5 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240059/harmonised/GCST90240059.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243474",
    "initial_individuals": "7474",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021187",
    "EFO_Trait_Name": "X-03088 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243474/harmonised/GCST90243474.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199974",
    "initial_individuals": "7474",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800369",
    "EFO_Trait_Name": "9-hydroxystearate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199974/harmonised/GCST90199974.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240041",
    "initial_individuals": "7474",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801261",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C36:5 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240041/harmonised/GCST90240041.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240050",
    "initial_individuals": "7474",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801270",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C40:2 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240050/harmonised/GCST90240050.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240051",
    "initial_individuals": "7474",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801271",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C40:3 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240051/harmonised/GCST90240051.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240052",
    "initial_individuals": "7474",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801272",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C40:4 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240052/harmonised/GCST90240052.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240053",
    "initial_individuals": "7474",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801273",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C40:5 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240053/harmonised/GCST90240053.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240057",
    "initial_individuals": "7474",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801277",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C42:2 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240057/harmonised/GCST90240057.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240108",
    "initial_individuals": "7473",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801325",
    "EFO_Trait_Name": "sphingomyeline C26:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240108/harmonised/GCST90240108.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200509",
    "initial_individuals": "7471",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021315",
    "EFO_Trait_Name": "X-12544 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200509/harmonised/GCST90200509.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243700",
    "initial_individuals": "7467",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021286",
    "EFO_Trait_Name": "X-12094 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243700/harmonised/GCST90243700.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200593",
    "initial_individuals": "7466",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800833",
    "EFO_Trait_Name": "X-21834 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200593/harmonised/GCST90200593.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199798",
    "initial_individuals": "7465",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800029",
    "EFO_Trait_Name": "isobutyrylglycine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199798/harmonised/GCST90199798.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200502",
    "initial_individuals": "7461",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800720",
    "EFO_Trait_Name": "X-12707 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200502/harmonised/GCST90200502.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200535",
    "initial_individuals": "7448",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800771",
    "EFO_Trait_Name": "X-17325 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200535/harmonised/GCST90200535.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199757",
    "initial_individuals": "7446",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021172",
    "EFO_Trait_Name": "1,3,7-trimethylurate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199757/harmonised/GCST90199757.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200503",
    "initial_individuals": "7446",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021328",
    "EFO_Trait_Name": "X-12729 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200503/harmonised/GCST90200503.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200225",
    "initial_individuals": "7446",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801052",
    "EFO_Trait_Name": "3-hydroxy-2-methylpyridine sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200225/harmonised/GCST90200225.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199694",
    "initial_individuals": "7444",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800948",
    "EFO_Trait_Name": "1,3-dimethylurate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199694/harmonised/GCST90199694.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200480",
    "initial_individuals": "7442",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800715",
    "EFO_Trait_Name": "X-12410 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200480/harmonised/GCST90200480.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200091",
    "initial_individuals": "7440",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800479",
    "EFO_Trait_Name": "docosahexaenoylcholine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200091/harmonised/GCST90200091.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200250",
    "initial_individuals": "7438",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800599",
    "EFO_Trait_Name": "deoxycholic acid (12 or 24)-sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200250/harmonised/GCST90200250.h.tsv.gz"
  },
  {
    "accessionId": "GCST90271928",
    "initial_individuals": "7437",
    "initial_ancestralGroup": "European",
    "pubmedId": "36921087",
    "EFO_ID": "EFO_0007744",
    "EFO_Trait_Name": "lung disease severity measurement",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90271001-GCST90272000/GCST90271928/harmonised/GCST90271928.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243534",
    "initial_individuals": "7429",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021110",
    "EFO_Trait_Name": "1-palmitoylglycerol 1-monopalmitin measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243534/harmonised/GCST90243534.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200374",
    "initial_individuals": "7429",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800619",
    "EFO_Trait_Name": "sphinganine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200374/harmonised/GCST90200374.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199758",
    "initial_individuals": "7425",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800628",
    "EFO_Trait_Name": "N4-acetylcytidine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199758/harmonised/GCST90199758.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243739",
    "initial_individuals": "7422",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021082",
    "EFO_Trait_Name": "1-heptadecanoylglycerophosphocholine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243739/harmonised/GCST90243739.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243825",
    "initial_individuals": "7420",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021019",
    "EFO_Trait_Name": "2-methylbutyroylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243825/harmonised/GCST90243825.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243755",
    "initial_individuals": "7419",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021317",
    "EFO_Trait_Name": "X-12627 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243755/harmonised/GCST90243755.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199860",
    "initial_individuals": "7415",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800305",
    "EFO_Trait_Name": "andro steroid monosulfate C19H28O6S (1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199860/harmonised/GCST90199860.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243643",
    "initial_individuals": "7409",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021249",
    "EFO_Trait_Name": "X-11530 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243643/harmonised/GCST90243643.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243760",
    "initial_individuals": "7409",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021321",
    "EFO_Trait_Name": "X-12696 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243760/harmonised/GCST90243760.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243603",
    "initial_individuals": "7403",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021220",
    "EFO_Trait_Name": "X-11247 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243603/harmonised/GCST90243603.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200196",
    "initial_individuals": "7397",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022208",
    "EFO_Trait_Name": "Blood 2,2'-Methylenebis(6-tert-butyl-p-cresol) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200196/harmonised/GCST90200196.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200514",
    "initial_individuals": "7385",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021342",
    "EFO_Trait_Name": "X-12851 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200514/harmonised/GCST90200514.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243842",
    "initial_individuals": "7381",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021031",
    "EFO_Trait_Name": "threitol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243842/harmonised/GCST90243842.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200488",
    "initial_individuals": "7379",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800706",
    "EFO_Trait_Name": "X-12117 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200488/harmonised/GCST90200488.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199912",
    "initial_individuals": "7375",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800337",
    "EFO_Trait_Name": "N-oleoyltaurine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199912/harmonised/GCST90199912.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243886",
    "initial_individuals": "7371",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021052",
    "EFO_Trait_Name": "15-methylpalmitate isobar with 2-methylpalmitate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243886/harmonised/GCST90243886.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243780",
    "initial_individuals": "7369",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021093",
    "EFO_Trait_Name": "1-stearoylglycerophosphoethanolamine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243780/harmonised/GCST90243780.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200127",
    "initial_individuals": "7368",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800539",
    "EFO_Trait_Name": "behenoylcarnitine (C22) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200127/harmonised/GCST90200127.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243522",
    "initial_individuals": "7358",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021199",
    "EFO_Trait_Name": "X-06246 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243522/harmonised/GCST90243522.h.tsv.gz"
  },
  {
    "accessionId": "GCST90568464",
    "initial_individuals": "7352",
    "initial_ancestralGroup": "European",
    "pubmedId": "40746155",
    "EFO_ID": "EFO_0003060",
    "EFO_Trait_Name": "non-small cell lung carcinoma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90568001-GCST90569000/GCST90568464/harmonised/GCST90568464.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200423",
    "initial_individuals": "7348",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021802",
    "EFO_Trait_Name": "spermidine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200423/harmonised/GCST90200423.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243871",
    "initial_individuals": "7347",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "OBA_2050060",
    "EFO_Trait_Name": "serum dimethylarginine amount",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243871/harmonised/GCST90243871.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200660",
    "initial_individuals": "7335",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800938",
    "EFO_Trait_Name": "X-25957 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200660/harmonised/GCST90200660.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200024",
    "initial_individuals": "7333",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800386",
    "EFO_Trait_Name": "taurodeoxycholic acid 3-sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200024/harmonised/GCST90200024.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199955",
    "initial_individuals": "7332",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800989",
    "EFO_Trait_Name": "ferulic acid 4-sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199955/harmonised/GCST90199955.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243822",
    "initial_individuals": "7330",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021354",
    "EFO_Trait_Name": "X-13549 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243822/harmonised/GCST90243822.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200557",
    "initial_individuals": "7327",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800786",
    "EFO_Trait_Name": "X-17685 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200557/harmonised/GCST90200557.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199704",
    "initial_individuals": "7325",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800205",
    "EFO_Trait_Name": "3-hydroxysebacate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199704/harmonised/GCST90199704.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200683",
    "initial_individuals": "7324",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800028",
    "EFO_Trait_Name": "N-acetylcitrulline measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200683/harmonised/GCST90200683.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200004",
    "initial_individuals": "7315",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022203",
    "EFO_Trait_Name": "Blood N-carbamoylalanine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200004/harmonised/GCST90200004.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199823",
    "initial_individuals": "7315",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800955",
    "EFO_Trait_Name": "O-cresol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199823/harmonised/GCST90199823.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243829",
    "initial_individuals": "7311",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021358",
    "EFO_Trait_Name": "X-13671 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243829/harmonised/GCST90243829.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199705",
    "initial_individuals": "7311",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800207",
    "EFO_Trait_Name": "propionylglycine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199705/harmonised/GCST90199705.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199812",
    "initial_individuals": "7304",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800952",
    "EFO_Trait_Name": "3-(3-hydroxyphenyl)propionate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199812/harmonised/GCST90199812.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200467",
    "initial_individuals": "7295",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021271",
    "EFO_Trait_Name": "X-11852 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200467/harmonised/GCST90200467.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243463",
    "initial_individuals": "7287",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0010500",
    "EFO_Trait_Name": "hypoxanthine mesurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243463/harmonised/GCST90243463.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200334",
    "initial_individuals": "7287",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010539",
    "EFO_Trait_Name": "taurodeoxycholate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200334/harmonised/GCST90200334.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200007",
    "initial_individuals": "7286",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801010",
    "EFO_Trait_Name": "3-methoxycatechol sulfate (2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200007/harmonised/GCST90200007.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200560",
    "initial_individuals": "7281",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800774",
    "EFO_Trait_Name": "X-17351 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200560/harmonised/GCST90200560.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243564",
    "initial_individuals": "7263",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021026",
    "EFO_Trait_Name": "erythrose measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243564/harmonised/GCST90243564.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200568",
    "initial_individuals": "7259",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800801",
    "EFO_Trait_Name": "X-19438 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200568/harmonised/GCST90200568.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199988",
    "initial_individuals": "7254",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800076",
    "EFO_Trait_Name": "tyramine O-sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199988/harmonised/GCST90199988.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243567",
    "initial_individuals": "7232",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021218",
    "EFO_Trait_Name": "X-10810 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243567/harmonised/GCST90243567.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200476",
    "initial_individuals": "7230",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021266",
    "EFO_Trait_Name": "X-11843 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200476/harmonised/GCST90200476.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199980",
    "initial_individuals": "7229",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800075",
    "EFO_Trait_Name": "N-formylphenylalanine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199980/harmonised/GCST90199980.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200111",
    "initial_individuals": "7229",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800521",
    "EFO_Trait_Name": "N-stearoyl-sphingadienine (d18:2/18:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200111/harmonised/GCST90200111.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199890",
    "initial_individuals": "7226",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800052",
    "EFO_Trait_Name": "4-hydroxyglutamate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199890/harmonised/GCST90199890.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199724",
    "initial_individuals": "7223",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800021",
    "EFO_Trait_Name": "N-acetylisoleucine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199724/harmonised/GCST90199724.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200029",
    "initial_individuals": "7214",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800387",
    "EFO_Trait_Name": "linoleoyl ethanolamide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200029/harmonised/GCST90200029.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200179",
    "initial_individuals": "7206",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800569",
    "EFO_Trait_Name": "glyco-beta-muricholate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200179/harmonised/GCST90200179.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243687",
    "initial_individuals": "7197",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021283",
    "EFO_Trait_Name": "X-12063 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243687/harmonised/GCST90243687.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200481",
    "initial_individuals": "7194",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800703",
    "EFO_Trait_Name": "X-12104 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200481/harmonised/GCST90200481.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243641",
    "initial_individuals": "7193",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021247",
    "EFO_Trait_Name": "X-11521 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243641/harmonised/GCST90243641.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200468",
    "initial_individuals": "7193",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021268",
    "EFO_Trait_Name": "X-11847 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200468/harmonised/GCST90200468.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243770",
    "initial_individuals": "7178",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021331",
    "EFO_Trait_Name": "X-12749 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243770/harmonised/GCST90243770.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200652",
    "initial_individuals": "7174",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800911",
    "EFO_Trait_Name": "X-24949 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200652/harmonised/GCST90200652.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199769",
    "initial_individuals": "7168",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800226",
    "EFO_Trait_Name": "3-hydroxydodecanedioate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199769/harmonised/GCST90199769.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243496",
    "initial_individuals": "7160",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021192",
    "EFO_Trait_Name": "X-04498 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243496/harmonised/GCST90243496.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199689",
    "initial_individuals": "7158",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800203",
    "EFO_Trait_Name": "glycolithocholate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199689/harmonised/GCST90199689.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200242",
    "initial_individuals": "7157",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800584",
    "EFO_Trait_Name": "taurochenodeoxycholic acid 3-sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200242/harmonised/GCST90200242.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243629",
    "initial_individuals": "7142",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021236",
    "EFO_Trait_Name": "X-11442 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243629/harmonised/GCST90243629.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200115",
    "initial_individuals": "7141",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800531",
    "EFO_Trait_Name": "N-palmitoyl-heptadecasphingosine (d17:1/16:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200115/harmonised/GCST90200115.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199989",
    "initial_individuals": "7141",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800996",
    "EFO_Trait_Name": "4-methylguaiacol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199989/harmonised/GCST90199989.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200113",
    "initial_individuals": "7140",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800534",
    "EFO_Trait_Name": "stearoylcholine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200113/harmonised/GCST90200113.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199663",
    "initial_individuals": "7135",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800942",
    "EFO_Trait_Name": "4-acetylphenol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199663/harmonised/GCST90199663.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200498",
    "initial_individuals": "7133",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800724",
    "EFO_Trait_Name": "X-12730 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200498/harmonised/GCST90200498.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199692",
    "initial_individuals": "7125",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022198",
    "EFO_Trait_Name": "Blood citramalate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199692/harmonised/GCST90199692.h.tsv.gz"
  },
  {
    "accessionId": "GCST90444397",
    "initial_individuals": "7124",
    "initial_ancestralGroup": "European",
    "pubmedId": "39364016",
    "EFO_ID": "EFO_0600019",
    "EFO_Trait_Name": "COVID-19 symptoms measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90444001-GCST90445000/GCST90444397/harmonised/GCST90444397.h.tsv.gz"
  },
  {
    "accessionId": "GCST90006906",
    "initial_individuals": "7119",
    "initial_ancestralGroup": "European",
    "pubmedId": "33204752",
    "EFO_ID": "EFO_0011037",
    "EFO_Trait_Name": "anti-human herpes virus 6 antibody measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90006001-GCST90007000/GCST90006906/harmonised/GCST90006906.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199852",
    "initial_individuals": "7103",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800289",
    "EFO_Trait_Name": "5alpha-androstan-3beta,17alpha-diol disulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199852/harmonised/GCST90199852.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199737",
    "initial_individuals": "7100",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022207",
    "EFO_Trait_Name": "Blood N-acetylproline measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199737/harmonised/GCST90199737.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199785",
    "initial_individuals": "7100",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800025",
    "EFO_Trait_Name": "isovalerylglycine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199785/harmonised/GCST90199785.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199632",
    "initial_individuals": "7099",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800941",
    "EFO_Trait_Name": "tartarate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199632/harmonised/GCST90199632.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199702",
    "initial_individuals": "7097",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800206",
    "EFO_Trait_Name": "5-hydroxyhexanoate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199702/harmonised/GCST90199702.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199935",
    "initial_individuals": "7095",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800346",
    "EFO_Trait_Name": "glycohyocholate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199935/harmonised/GCST90199935.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243626",
    "initial_individuals": "7084",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021233",
    "EFO_Trait_Name": "X-11438 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243626/harmonised/GCST90243626.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243798",
    "initial_individuals": "7080",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021051",
    "EFO_Trait_Name": "isovalerate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243798/harmonised/GCST90243798.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243523",
    "initial_individuals": "7075",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021200",
    "EFO_Trait_Name": "X-06267 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243523/harmonised/GCST90243523.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243628",
    "initial_individuals": "7072",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021235",
    "EFO_Trait_Name": "X-11441 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243628/harmonised/GCST90243628.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200537",
    "initial_individuals": "7071",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800756",
    "EFO_Trait_Name": "X-16087 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200537/harmonised/GCST90200537.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199855",
    "initial_individuals": "7066",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800291",
    "EFO_Trait_Name": "5alpha-androstan-3beta,17beta-diol monosulfate (2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199855/harmonised/GCST90199855.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199986",
    "initial_individuals": "7063",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800999",
    "EFO_Trait_Name": "eugenol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199986/harmonised/GCST90199986.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200230",
    "initial_individuals": "7062",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801047",
    "EFO_Trait_Name": "3-ethylcatechol sulfate (1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200230/harmonised/GCST90200230.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199630",
    "initial_individuals": "7059",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021012",
    "EFO_Trait_Name": "phenylacetate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199630/harmonised/GCST90199630.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199735",
    "initial_individuals": "7054",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800022",
    "EFO_Trait_Name": "N-acetylhistidine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199735/harmonised/GCST90199735.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200282",
    "initial_individuals": "7051",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800115",
    "EFO_Trait_Name": "picolinate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200282/harmonised/GCST90200282.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200555",
    "initial_individuals": "7043",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800788",
    "EFO_Trait_Name": "X-17690 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200555/harmonised/GCST90200555.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200296",
    "initial_individuals": "7032",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801063",
    "EFO_Trait_Name": "methyl indole-3-acetate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200296/harmonised/GCST90200296.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199944",
    "initial_individuals": "7027",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800981",
    "EFO_Trait_Name": "indolin-2-one measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199944/harmonised/GCST90199944.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200206",
    "initial_individuals": "7021",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801036",
    "EFO_Trait_Name": "sulfate of piperine metabolite C18H21NO3 (1) measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200206/harmonised/GCST90200206.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199868",
    "initial_individuals": "7018",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800044",
    "EFO_Trait_Name": "N-acetyl-3-methylhistidine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199868/harmonised/GCST90199868.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200216",
    "initial_individuals": "7006",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801037",
    "EFO_Trait_Name": "sulfate of piperine metabolite C18H21NO3 (3) measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200216/harmonised/GCST90200216.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243841",
    "initial_individuals": "7002",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021360",
    "EFO_Trait_Name": "X-13859 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243841/harmonised/GCST90243841.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200433",
    "initial_individuals": "6990",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022213",
    "EFO_Trait_Name": "Blood cytosine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200433/harmonised/GCST90200433.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199870",
    "initial_individuals": "6990",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800310",
    "EFO_Trait_Name": "4-cholesten-3-one measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199870/harmonised/GCST90199870.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199969",
    "initial_individuals": "6990",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800366",
    "EFO_Trait_Name": "1-oleoyl-GPG (18:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199969/harmonised/GCST90199969.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199981",
    "initial_individuals": "6984",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801001",
    "EFO_Trait_Name": "2-acetamidophenol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199981/harmonised/GCST90199981.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243545",
    "initial_individuals": "6982",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021024",
    "EFO_Trait_Name": "levulinate 4-oxovalerate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243545/harmonised/GCST90243545.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200226",
    "initial_individuals": "6977",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801051",
    "EFO_Trait_Name": "5-hydroxy-2-methylpyridine sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200226/harmonised/GCST90200226.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200633",
    "initial_individuals": "6975",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800874",
    "EFO_Trait_Name": "X-24334 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200633/harmonised/GCST90200633.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200558",
    "initial_individuals": "6974",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800792",
    "EFO_Trait_Name": "X-18888 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200558/harmonised/GCST90200558.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243811",
    "initial_individuals": "6970",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021350",
    "EFO_Trait_Name": "X-13435 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243811/harmonised/GCST90243811.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243537",
    "initial_individuals": "6965",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021111",
    "EFO_Trait_Name": "1-stearoylglycerol 1-monostearin measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243537/harmonised/GCST90243537.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199829",
    "initial_individuals": "6958",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800263",
    "EFO_Trait_Name": "3-methyladipate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199829/harmonised/GCST90199829.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200090",
    "initial_individuals": "6954",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800481",
    "EFO_Trait_Name": "dihomo-linolenoyl-choline measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200090/harmonised/GCST90200090.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243497",
    "initial_individuals": "6948",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021193",
    "EFO_Trait_Name": "X-04499--3,4-dihydroxybutyrate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243497/harmonised/GCST90243497.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200595",
    "initial_individuals": "6944",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800845",
    "EFO_Trait_Name": "X-22776 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200595/harmonised/GCST90200595.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199862",
    "initial_individuals": "6944",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800959",
    "EFO_Trait_Name": "4-hydroxycoumarin measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199862/harmonised/GCST90199862.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200186",
    "initial_individuals": "6938",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800096",
    "EFO_Trait_Name": "8-methoxykynurenate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200186/harmonised/GCST90200186.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243620",
    "initial_individuals": "6935",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021229",
    "EFO_Trait_Name": "X-11412 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243620/harmonised/GCST90243620.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200587",
    "initial_individuals": "6916",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800820",
    "EFO_Trait_Name": "X-21733 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200587/harmonised/GCST90200587.h.tsv.gz"
  },
  {
    "accessionId": "GCST90012659",
    "initial_individuals": "6914",
    "initial_ancestralGroup": "European",
    "pubmedId": "33441150",
    "EFO_ID": "EFO_0011033",
    "EFO_Trait_Name": "ST segment duration",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90012001-GCST90013000/GCST90012659/harmonised/GCST90012659.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200545",
    "initial_individuals": "6913",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800781",
    "EFO_Trait_Name": "X-17438 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200545/harmonised/GCST90200545.h.tsv.gz"
  },
  {
    "accessionId": "GCST90012748",
    "initial_individuals": "6912",
    "initial_ancestralGroup": "European",
    "pubmedId": "33441150",
    "EFO_ID": "EFO_0011034",
    "EFO_Trait_Name": "T wave duration",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90012001-GCST90013000/GCST90012748/harmonised/GCST90012748.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243549",
    "initial_individuals": "6910",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021209",
    "EFO_Trait_Name": "X-09108 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243549/harmonised/GCST90243549.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243861",
    "initial_individuals": "6904",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021374",
    "EFO_Trait_Name": "X-14626 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243861/harmonised/GCST90243861.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200177",
    "initial_individuals": "6902",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800093",
    "EFO_Trait_Name": "N-methylhydroxyproline measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200177/harmonised/GCST90200177.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199633",
    "initial_individuals": "6902",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800181",
    "EFO_Trait_Name": "suberate (C8-DC) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199633/harmonised/GCST90199633.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199881",
    "initial_individuals": "6898",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800048",
    "EFO_Trait_Name": "5-(galactosylhydroxy)-L-lysine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199881/harmonised/GCST90199881.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199946",
    "initial_individuals": "6897",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800983",
    "EFO_Trait_Name": "3-acetylphenol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199946/harmonised/GCST90199946.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243816",
    "initial_individuals": "6894",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021095",
    "EFO_Trait_Name": "2-linoleoylglycerophosphocholine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243816/harmonised/GCST90243816.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199755",
    "initial_individuals": "6894",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800949",
    "EFO_Trait_Name": "3,7-dimethylurate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199755/harmonised/GCST90199755.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243725",
    "initial_individuals": "6892",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021080",
    "EFO_Trait_Name": "1-eicosadienoylglycerophosphocholine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243725/harmonised/GCST90243725.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200016",
    "initial_individuals": "6888",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800081",
    "EFO_Trait_Name": "dopamine 4-sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200016/harmonised/GCST90200016.h.tsv.gz"
  },
  {
    "accessionId": "GCST90451717",
    "initial_individuals": "6885",
    "initial_ancestralGroup": "European",
    "pubmedId": "39746953",
    "EFO_ID": "EFO_0020991",
    "EFO_Trait_Name": "ethanolamine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90451001-GCST90452000/GCST90451717/harmonised/GCST90451717.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243857",
    "initial_individuals": "6884",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021370",
    "EFO_Trait_Name": "X-14473 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243857/harmonised/GCST90243857.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199643",
    "initial_individuals": "6877",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010493",
    "EFO_Trait_Name": "glycodeoxycholate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199643/harmonised/GCST90199643.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200496",
    "initial_individuals": "6870",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800722",
    "EFO_Trait_Name": "X-12714 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200496/harmonised/GCST90200496.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199948",
    "initial_individuals": "6857",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800985",
    "EFO_Trait_Name": "S-allylcysteine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199948/harmonised/GCST90199948.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199933",
    "initial_individuals": "6846",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800348",
    "EFO_Trait_Name": "3b-hydroxy-5-cholenoic acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199933/harmonised/GCST90199933.h.tsv.gz"
  },
  {
    "accessionId": "GCST90432071",
    "initial_individuals": "6840",
    "initial_ancestralGroup": "European",
    "pubmedId": "38453145",
    "EFO_ID": "OBA_2001012",
    "EFO_Trait_Name": "age of onset of type 1 diabetes mellitus",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90432001-GCST90433000/GCST90432071/harmonised/GCST90432071.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200579",
    "initial_individuals": "6827",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800815",
    "EFO_Trait_Name": "X-21442 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200579/harmonised/GCST90200579.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200426",
    "initial_individuals": "6822",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800153",
    "EFO_Trait_Name": "xylose measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200426/harmonised/GCST90200426.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200478",
    "initial_individuals": "6819",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800711",
    "EFO_Trait_Name": "X-12221 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200478/harmonised/GCST90200478.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243553",
    "initial_individuals": "6807",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021214",
    "EFO_Trait_Name": "X-10429 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243553/harmonised/GCST90243553.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199780",
    "initial_individuals": "6806",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800228",
    "EFO_Trait_Name": "1-stearoyl-GPG (18:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199780/harmonised/GCST90199780.h.tsv.gz"
  },
  {
    "accessionId": "GCST90012728",
    "initial_individuals": "6798",
    "initial_ancestralGroup": "European",
    "pubmedId": "33441150",
    "EFO_ID": "OBA_1001086",
    "EFO_Trait_Name": "QRS duration",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90012001-GCST90013000/GCST90012728/harmonised/GCST90012728.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243661",
    "initial_individuals": "6790",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021264",
    "EFO_Trait_Name": "X-11818 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243661/harmonised/GCST90243661.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200552",
    "initial_individuals": "6790",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800791",
    "EFO_Trait_Name": "X-18887 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200552/harmonised/GCST90200552.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243625",
    "initial_individuals": "6782",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021232",
    "EFO_Trait_Name": "X-11437 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243625/harmonised/GCST90243625.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243524",
    "initial_individuals": "6774",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021201",
    "EFO_Trait_Name": "X-06307 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243524/harmonised/GCST90243524.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243799",
    "initial_individuals": "6770",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021345",
    "EFO_Trait_Name": "X-13069 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243799/harmonised/GCST90243799.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200635",
    "initial_individuals": "6767",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800889",
    "EFO_Trait_Name": "X-24494 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200635/harmonised/GCST90200635.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200596",
    "initial_individuals": "6764",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800856",
    "EFO_Trait_Name": "X-23655 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200596/harmonised/GCST90200596.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200357",
    "initial_individuals": "6756",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010473",
    "EFO_Trait_Name": "cyclic adenosine monophosphate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200357/harmonised/GCST90200357.h.tsv.gz"
  },
  {
    "accessionId": "GCST009926",
    "initial_individuals": "6753",
    "initial_ancestralGroup": "European",
    "pubmedId": "31729902",
    "EFO_ID": "EFO_0006865",
    "EFO_Trait_Name": "urgency urinary incontinence",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST009001-GCST010000/GCST009926/harmonised/GCST009926.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200448",
    "initial_individuals": "6737",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800626",
    "EFO_Trait_Name": "N-stearoyl-sphinganine (d18:0/18:0) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200448/harmonised/GCST90200448.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199790",
    "initial_individuals": "6697",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800240",
    "EFO_Trait_Name": "2-palmitoleoyl-GPC (16:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199790/harmonised/GCST90199790.h.tsv.gz"
  },
  {
    "accessionId": "GCST90012720",
    "initial_individuals": "6693",
    "initial_ancestralGroup": "European",
    "pubmedId": "33441150",
    "EFO_ID": "EFO_0600085",
    "EFO_Trait_Name": "PP interval",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90012001-GCST90013000/GCST90012720/harmonised/GCST90012720.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243722",
    "initial_individuals": "6676",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021303",
    "EFO_Trait_Name": "X-12405 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243722/harmonised/GCST90243722.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199874",
    "initial_individuals": "6674",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800042",
    "EFO_Trait_Name": "S-methylmethionine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199874/harmonised/GCST90199874.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200603",
    "initial_individuals": "6673",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800854",
    "EFO_Trait_Name": "X-23641 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200603/harmonised/GCST90200603.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243642",
    "initial_individuals": "6664",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021248",
    "EFO_Trait_Name": "X-11529 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243642/harmonised/GCST90243642.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200221",
    "initial_individuals": "6622",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800578",
    "EFO_Trait_Name": "glycoursodeoxycholic acid sulfate (1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200221/harmonised/GCST90200221.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200141",
    "initial_individuals": "6620",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801019",
    "EFO_Trait_Name": "ethyl alpha-glucopyranoside measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200141/harmonised/GCST90200141.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243714",
    "initial_individuals": "6608",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021299",
    "EFO_Trait_Name": "X-12244--N-acetylcarnosine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243714/harmonised/GCST90243714.h.tsv.gz"
  },
  {
    "accessionId": "GCST90239999",
    "initial_individuals": "6606",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801234",
    "EFO_Trait_Name": "octadecenoylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90239001-GCST90240000/GCST90239999/harmonised/GCST90239999.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240092",
    "initial_individuals": "6606",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801312",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C42:5 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240092/harmonised/GCST90240092.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240061",
    "initial_individuals": "6605",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801281",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C30:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240061/harmonised/GCST90240061.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240087",
    "initial_individuals": "6605",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801307",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C42:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240087/harmonised/GCST90240087.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240021",
    "initial_individuals": "6602",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801243",
    "EFO_Trait_Name": "lysophosphatidylcholine acyl C28:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240021/harmonised/GCST90240021.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240060",
    "initial_individuals": "6601",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801280",
    "EFO_Trait_Name": "phosphatidylcholine diacyl C42:6 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240060/harmonised/GCST90240060.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243810",
    "initial_individuals": "6591",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021349",
    "EFO_Trait_Name": "X-13431--nonanoylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243810/harmonised/GCST90243810.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243638",
    "initial_individuals": "6584",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021245",
    "EFO_Trait_Name": "X-11491 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243638/harmonised/GCST90243638.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200212",
    "initial_individuals": "6582",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801033",
    "EFO_Trait_Name": "glucuronide of piperine metabolite C17H21NO3 (5) measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200212/harmonised/GCST90200212.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240107",
    "initial_individuals": "6569",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801324",
    "EFO_Trait_Name": "sphingomyeline C26:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240107/harmonised/GCST90240107.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243786",
    "initial_individuals": "6566",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021334",
    "EFO_Trait_Name": "X-12786 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243786/harmonised/GCST90243786.h.tsv.gz"
  },
  {
    "accessionId": "GCST90627781",
    "initial_individuals": "6558",
    "initial_ancestralGroup": "European",
    "pubmedId": "31919107",
    "EFO_ID": "MONDO_0002461",
    "EFO_Trait_Name": "membranoproliferative glomerulonephritis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90627001-GCST90628000/GCST90627781/harmonised/GCST90627781.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240075",
    "initial_individuals": "6538",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801295",
    "EFO_Trait_Name": "phosphatidylcholine acyl-alkyl C38:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240075/harmonised/GCST90240075.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240110",
    "initial_individuals": "6538",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801327",
    "EFO_Trait_Name": "hydroxysphingomyeline C16:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240110/harmonised/GCST90240110.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240111",
    "initial_individuals": "6538",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801328",
    "EFO_Trait_Name": "hydroxysphingomyeline C22:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240111/harmonised/GCST90240111.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240112",
    "initial_individuals": "6538",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801329",
    "EFO_Trait_Name": "hydroxysphingomyeline C22:2 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240112/harmonised/GCST90240112.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240113",
    "initial_individuals": "6538",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801330",
    "EFO_Trait_Name": "hydroxysphingomyeline C24:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240113/harmonised/GCST90240113.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200489",
    "initial_individuals": "6534",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021304",
    "EFO_Trait_Name": "X-12407 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200489/harmonised/GCST90200489.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200582",
    "initial_individuals": "6526",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800824",
    "EFO_Trait_Name": "X-21752 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200582/harmonised/GCST90200582.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200625",
    "initial_individuals": "6523",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800885",
    "EFO_Trait_Name": "X-24456 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200625/harmonised/GCST90200625.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243632",
    "initial_individuals": "6519",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021239",
    "EFO_Trait_Name": "X-11452 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243632/harmonised/GCST90243632.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200222",
    "initial_individuals": "6519",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801044",
    "EFO_Trait_Name": "dihydrocaffeate sulfate (2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200222/harmonised/GCST90200222.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199919",
    "initial_individuals": "6517",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800970",
    "EFO_Trait_Name": "alliin measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199919/harmonised/GCST90199919.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200665",
    "initial_individuals": "6516",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800928",
    "EFO_Trait_Name": "X-25433 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200665/harmonised/GCST90200665.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200189",
    "initial_individuals": "6512",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801031",
    "EFO_Trait_Name": "glucuronide of piperine metabolite C17H21NO3 (3) measurement",
    "trait_annotation": "molecule",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200189/harmonised/GCST90200189.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199710",
    "initial_individuals": "6511",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "OBA_2050329",
    "EFO_Trait_Name": "blood 13,16,19-Docosatrienoic acid amount",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199710/harmonised/GCST90199710.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243585",
    "initial_individuals": "6500",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0011001",
    "EFO_Trait_Name": "scyllo-inositol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243585/harmonised/GCST90243585.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200409",
    "initial_individuals": "6497",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800623",
    "EFO_Trait_Name": "pristanate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200409/harmonised/GCST90200409.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199679",
    "initial_individuals": "6496",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022199",
    "EFO_Trait_Name": "Blood 2,3-dihydroxypyridine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199679/harmonised/GCST90199679.h.tsv.gz"
  },
  {
    "accessionId": "GCST90012634",
    "initial_individuals": "6491",
    "initial_ancestralGroup": "European",
    "pubmedId": "33441150",
    "EFO_ID": "EFO_0803346",
    "EFO_Trait_Name": "carboxyhemoglobin measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90012001-GCST90013000/GCST90012634/harmonised/GCST90012634.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200524",
    "initial_individuals": "6486",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800738",
    "EFO_Trait_Name": "X-13695 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200524/harmonised/GCST90200524.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199976",
    "initial_individuals": "6470",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800374",
    "EFO_Trait_Name": "1-dihomo-linolenylglycerol (20:3) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199976/harmonised/GCST90199976.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243710",
    "initial_individuals": "6469",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021295",
    "EFO_Trait_Name": "X-12217 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243710/harmonised/GCST90243710.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200497",
    "initial_individuals": "6449",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021330",
    "EFO_Trait_Name": "X-12740 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200497/harmonised/GCST90200497.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200506",
    "initial_individuals": "6435",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800728",
    "EFO_Trait_Name": "X-12812 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200506/harmonised/GCST90200506.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243730",
    "initial_individuals": "6432",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021310",
    "EFO_Trait_Name": "X-12450 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243730/harmonised/GCST90243730.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200036",
    "initial_individuals": "6432",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800398",
    "EFO_Trait_Name": "1-palmitoleoylglycerol (16:1) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200036/harmonised/GCST90200036.h.tsv.gz"
  },
  {
    "accessionId": "GCST90134433",
    "initial_individuals": "6411",
    "initial_ancestralGroup": "European",
    "pubmedId": "36546557",
    "EFO_ID": "HP_0009588",
    "EFO_Trait_Name": "Vestibular Schwannoma",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90134001-GCST90135000/GCST90134433/harmonised/GCST90134433.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199994",
    "initial_individuals": "6408",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022209",
    "EFO_Trait_Name": "Blood ethylparaben sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199994/harmonised/GCST90199994.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199921",
    "initial_individuals": "6398",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800969",
    "EFO_Trait_Name": "dihydroferulate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199921/harmonised/GCST90199921.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200630",
    "initial_individuals": "6391",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800893",
    "EFO_Trait_Name": "X-24546 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200630/harmonised/GCST90200630.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243607",
    "initial_individuals": "6380",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0800158",
    "EFO_Trait_Name": "heme measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243607/harmonised/GCST90243607.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199685",
    "initial_individuals": "6378",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800197",
    "EFO_Trait_Name": "2-linoleoylglycerol (18:2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199685/harmonised/GCST90199685.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243621",
    "initial_individuals": "6360",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021181",
    "EFO_Trait_Name": "X-01911 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243621/harmonised/GCST90243621.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243505",
    "initial_individuals": "6357",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021195",
    "EFO_Trait_Name": "X-05426 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243505/harmonised/GCST90243505.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200447",
    "initial_individuals": "6351",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021649",
    "EFO_Trait_Name": "Maltose measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200447/harmonised/GCST90200447.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200638",
    "initial_individuals": "6349",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800907",
    "EFO_Trait_Name": "X-24811 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200638/harmonised/GCST90200638.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243622",
    "initial_individuals": "6346",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021230",
    "EFO_Trait_Name": "X-11422--xanthine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243622/harmonised/GCST90243622.h.tsv.gz"
  },
  {
    "accessionId": "GCST90559231",
    "initial_individuals": "6346",
    "initial_ancestralGroup": "European",
    "pubmedId": "41361163",
    "EFO_ID": "MONDO_0100114",
    "EFO_Trait_Name": "dry age related macular degeneration",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90559001-GCST90560000/GCST90559231/harmonised/GCST90559231.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243809",
    "initial_individuals": "6344",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021348",
    "EFO_Trait_Name": "X-13429 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243809/harmonised/GCST90243809.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200317",
    "initial_individuals": "6320",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0005131",
    "EFO_Trait_Name": "HVA measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200317/harmonised/GCST90200317.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199936",
    "initial_individuals": "6320",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800973",
    "EFO_Trait_Name": "3-methyl catechol sulfate (2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199936/harmonised/GCST90199936.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243801",
    "initial_individuals": "6305",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021347",
    "EFO_Trait_Name": "X-13215 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243801/harmonised/GCST90243801.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199941",
    "initial_individuals": "6305",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800165",
    "EFO_Trait_Name": "gamma-CEHC glucuronide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199941/harmonised/GCST90199941.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200146",
    "initial_individuals": "6287",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800548",
    "EFO_Trait_Name": "docosahexaenoylcarnitine (C22:6) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200146/harmonised/GCST90200146.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243818",
    "initial_individuals": "6282",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021091",
    "EFO_Trait_Name": "1-palmitoylglycerophosphoinositol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243818/harmonised/GCST90243818.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200520",
    "initial_individuals": "6270",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800734",
    "EFO_Trait_Name": "X-13007 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200520/harmonised/GCST90200520.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200376",
    "initial_individuals": "6257",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800177",
    "EFO_Trait_Name": "flavin adenine dinucleotide (FAD) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200376/harmonised/GCST90200376.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200152",
    "initial_individuals": "6253",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800556",
    "EFO_Trait_Name": "2-butenoylglycine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200152/harmonised/GCST90200152.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243793",
    "initial_individuals": "6251",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021341",
    "EFO_Trait_Name": "X-12850 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243793/harmonised/GCST90243793.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200639",
    "initial_individuals": "6251",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800905",
    "EFO_Trait_Name": "X-24757 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200639/harmonised/GCST90200639.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200505",
    "initial_individuals": "6246",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800729",
    "EFO_Trait_Name": "X-12818 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200505/harmonised/GCST90200505.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200202",
    "initial_individuals": "6233",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800174",
    "EFO_Trait_Name": "delta-CEHC measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200202/harmonised/GCST90200202.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200069",
    "initial_individuals": "6227",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800687",
    "EFO_Trait_Name": "phenylacetylglutamate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200069/harmonised/GCST90200069.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243688",
    "initial_individuals": "6226",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0007899",
    "EFO_Trait_Name": "gamma-tocopherol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243688/harmonised/GCST90243688.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200297",
    "initial_individuals": "6206",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010547",
    "EFO_Trait_Name": "ursodeoxycholate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200297/harmonised/GCST90200297.h.tsv.gz"
  },
  {
    "accessionId": "GCST90006918",
    "initial_individuals": "6199",
    "initial_ancestralGroup": "European",
    "pubmedId": "33204752",
    "EFO_ID": "EFO_0009349",
    "EFO_Trait_Name": "Anti-herpes simplex virus 1 IgG measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90006001-GCST90007000/GCST90006918/harmonised/GCST90006918.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200015",
    "initial_individuals": "6193",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800083",
    "EFO_Trait_Name": "N-acetylkynurenine (2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200015/harmonised/GCST90200015.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200576",
    "initial_individuals": "6180",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800803",
    "EFO_Trait_Name": "X-21285 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200576/harmonised/GCST90200576.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200182",
    "initial_individuals": "6177",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800654",
    "EFO_Trait_Name": "glycine conjugate of C10H12O2 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200182/harmonised/GCST90200182.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200050",
    "initial_individuals": "6163",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800085",
    "EFO_Trait_Name": "5-hydroxyindole sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200050/harmonised/GCST90200050.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199817",
    "initial_individuals": "6161",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800035",
    "EFO_Trait_Name": "indoleacetylglutamine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199817/harmonised/GCST90199817.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200345",
    "initial_individuals": "6142",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0010531",
    "EFO_Trait_Name": "S-adenosylhomocysteine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200345/harmonised/GCST90200345.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200634",
    "initial_individuals": "6131",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800890",
    "EFO_Trait_Name": "X-24518 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200634/harmonised/GCST90200634.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200549",
    "initial_individuals": "6092",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800779",
    "EFO_Trait_Name": "X-17367 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200549/harmonised/GCST90200549.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200178",
    "initial_individuals": "6090",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800652",
    "EFO_Trait_Name": "glucuronide of C10H18O2 (7) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200178/harmonised/GCST90200178.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243542",
    "initial_individuals": "6064",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021511",
    "EFO_Trait_Name": "phenyllactate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243542/harmonised/GCST90243542.h.tsv.gz"
  },
  {
    "accessionId": "GCST90024775",
    "initial_individuals": "6057",
    "initial_ancestralGroup": "European",
    "pubmedId": "35668104",
    "EFO_ID": "EFO_0021455",
    "EFO_Trait_Name": "lysophosphatidylcholine 19:0 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90024001-GCST90025000/GCST90024775/harmonised/GCST90024775.h.tsv.gz"
  },
  {
    "accessionId": "GCST90025162",
    "initial_individuals": "6057",
    "initial_ancestralGroup": "European",
    "pubmedId": "35668104",
    "EFO_ID": "EFO_0021482",
    "EFO_Trait_Name": "triacylglycerol 51:1 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90025001-GCST90026000/GCST90025162/harmonised/GCST90025162.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200484",
    "initial_individuals": "6054",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800714",
    "EFO_Trait_Name": "X-12306 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200484/harmonised/GCST90200484.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243540",
    "initial_individuals": "6050",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021206",
    "EFO_Trait_Name": "X-08766 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243540/harmonised/GCST90243540.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199706",
    "initial_individuals": "6044",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800208",
    "EFO_Trait_Name": "butyrylglycine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199706/harmonised/GCST90199706.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243559",
    "initial_individuals": "6025",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0010499",
    "EFO_Trait_Name": "hyodeoxycholate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243559/harmonised/GCST90243559.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243821",
    "initial_individuals": "6022",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021353",
    "EFO_Trait_Name": "X-13548 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243821/harmonised/GCST90243821.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199781",
    "initial_individuals": "6015",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800233",
    "EFO_Trait_Name": "hexanoylglycine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199781/harmonised/GCST90199781.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200475",
    "initial_individuals": "6008",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021272",
    "EFO_Trait_Name": "X-11858 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200475/harmonised/GCST90200475.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243715",
    "initial_individuals": "6004",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021300",
    "EFO_Trait_Name": "X-12253 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243715/harmonised/GCST90243715.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199956",
    "initial_individuals": "5986",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022218",
    "EFO_Trait_Name": "Blood 1H-indole-7-acetic acid measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199956/harmonised/GCST90199956.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243812",
    "initial_individuals": "5952",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021351",
    "EFO_Trait_Name": "X-13477 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243812/harmonised/GCST90243812.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200626",
    "initial_individuals": "5952",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800879",
    "EFO_Trait_Name": "X-24418 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200626/harmonised/GCST90200626.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199983",
    "initial_individuals": "5920",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800372",
    "EFO_Trait_Name": "5alpha-androstan-3alpha,17beta-diol monosulfate (2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199983/harmonised/GCST90199983.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200588",
    "initial_individuals": "5918",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800823",
    "EFO_Trait_Name": "X-21742 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200588/harmonised/GCST90200588.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243478",
    "initial_individuals": "5917",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021027",
    "EFO_Trait_Name": "mannitol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243478/harmonised/GCST90243478.h.tsv.gz"
  },
  {
    "accessionId": "GCST90006924",
    "initial_individuals": "5915",
    "initial_ancestralGroup": "European",
    "pubmedId": "33204752",
    "EFO_ID": "EFO_0010899",
    "EFO_Trait_Name": "anti-merkel cell virus antibody measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90006001-GCST90007000/GCST90006924/harmonised/GCST90006924.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243565",
    "initial_individuals": "5912",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021152",
    "EFO_Trait_Name": "glycerol 2-phosphate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243565/harmonised/GCST90243565.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199987",
    "initial_individuals": "5897",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801000",
    "EFO_Trait_Name": "2-methoxyresorcinol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199987/harmonised/GCST90199987.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243412",
    "initial_individuals": "5889",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021030",
    "EFO_Trait_Name": "arabinose measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243412/harmonised/GCST90243412.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243732",
    "initial_individuals": "5883",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021312",
    "EFO_Trait_Name": "X-12465 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243732/harmonised/GCST90243732.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200211",
    "initial_individuals": "5882",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801043",
    "EFO_Trait_Name": "3-hydroxypyridine glucuronide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200211/harmonised/GCST90200211.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200477",
    "initial_individuals": "5878",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800709",
    "EFO_Trait_Name": "X-12127 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200477/harmonised/GCST90200477.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200508",
    "initial_individuals": "5874",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800726",
    "EFO_Trait_Name": "X-12738 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200508/harmonised/GCST90200508.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199925",
    "initial_individuals": "5865",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022211",
    "EFO_Trait_Name": "Blood succinimide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199925/harmonised/GCST90199925.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200493",
    "initial_individuals": "5848",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021277",
    "EFO_Trait_Name": "X-12013 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200493/harmonised/GCST90200493.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199776",
    "initial_individuals": "5822",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800232",
    "EFO_Trait_Name": "malonylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199776/harmonised/GCST90199776.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199734",
    "initial_individuals": "5782",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800219",
    "EFO_Trait_Name": "hyocholate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199734/harmonised/GCST90199734.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200273",
    "initial_individuals": "5778",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801062",
    "EFO_Trait_Name": "2-methoxyhydroquinone sulfate (2) measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200273/harmonised/GCST90200273.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200324",
    "initial_individuals": "5773",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800123",
    "EFO_Trait_Name": "anthranilate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200324/harmonised/GCST90200324.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199957",
    "initial_individuals": "5773",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800990",
    "EFO_Trait_Name": "3-(3-hydroxyphenyl)propionate sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199957/harmonised/GCST90199957.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200501",
    "initial_individuals": "5770",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800725",
    "EFO_Trait_Name": "X-12731 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200501/harmonised/GCST90200501.h.tsv.gz"
  },
  {
    "accessionId": "GCST90240005",
    "initial_individuals": "5758",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801238",
    "EFO_Trait_Name": "pimelylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90240001-GCST90241000/GCST90240005/harmonised/GCST90240005.h.tsv.gz"
  },
  {
    "accessionId": "GCST002961",
    "initial_individuals": "5757",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801231",
    "EFO_Trait_Name": "decadienylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST002001-GCST003000/GCST002961/harmonised/GCST002961.h.tsv.gz"
  },
  {
    "accessionId": "GCST90239998",
    "initial_individuals": "5757",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0801233",
    "EFO_Trait_Name": "tetradecadienylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90239001-GCST90240000/GCST90239998/harmonised/GCST90239998.h.tsv.gz"
  },
  {
    "accessionId": "GCST90239993",
    "initial_individuals": "5755",
    "initial_ancestralGroup": "European",
    "pubmedId": "26068415",
    "EFO_ID": "EFO_0021803",
    "EFO_Trait_Name": "decenoylcarnitine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90239001-GCST90240000/GCST90239993/harmonised/GCST90239993.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200612",
    "initial_individuals": "5745",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800861",
    "EFO_Trait_Name": "X-23678 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200612/harmonised/GCST90200612.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200504",
    "initial_individuals": "5725",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021337",
    "EFO_Trait_Name": "X-12830 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200504/harmonised/GCST90200504.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243536",
    "initial_individuals": "5717",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021109",
    "EFO_Trait_Name": "1-oleoylglycerol 1-monoolein measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243536/harmonised/GCST90243536.h.tsv.gz"
  },
  {
    "accessionId": "GCST90006895",
    "initial_individuals": "5681",
    "initial_ancestralGroup": "European",
    "pubmedId": "33204752",
    "EFO_ID": "EFO_0009347",
    "EFO_Trait_Name": "Anti-cytomegalovirus IgG measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90006001-GCST90007000/GCST90006895/harmonised/GCST90006895.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243711",
    "initial_individuals": "5649",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021296",
    "EFO_Trait_Name": "X-12230 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243711/harmonised/GCST90243711.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243768",
    "initial_individuals": "5616",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021329",
    "EFO_Trait_Name": "X-12734 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243768/harmonised/GCST90243768.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199627",
    "initial_individuals": "5606",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800006",
    "EFO_Trait_Name": "N-alpha-acetylornithine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199627/harmonised/GCST90199627.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243865",
    "initial_individuals": "5602",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021378",
    "EFO_Trait_Name": "X-14745 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243865/harmonised/GCST90243865.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200583",
    "initial_individuals": "5602",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800827",
    "EFO_Trait_Name": "X-21807 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200583/harmonised/GCST90200583.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200000",
    "initial_individuals": "5598",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801006",
    "EFO_Trait_Name": "umbelliferone sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90200000/harmonised/GCST90200000.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243653",
    "initial_individuals": "5588",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021135",
    "EFO_Trait_Name": "ADSGEGDFXAEGGGVR measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243653/harmonised/GCST90243653.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199963",
    "initial_individuals": "5582",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800363",
    "EFO_Trait_Name": "17alpha-hydroxypregnanolone glucuronide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199963/harmonised/GCST90199963.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200223",
    "initial_individuals": "5576",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800576",
    "EFO_Trait_Name": "4-methylhexanoylglutamine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200223/harmonised/GCST90200223.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199850",
    "initial_individuals": "5524",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800283",
    "EFO_Trait_Name": "5alpha-androstan-3alpha,17alpha-diol monosulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199850/harmonised/GCST90199850.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243775",
    "initial_individuals": "5520",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021173",
    "EFO_Trait_Name": "1-methylurate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243775/harmonised/GCST90243775.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243765",
    "initial_individuals": "5495",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021326",
    "EFO_Trait_Name": "X-12726 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243765/harmonised/GCST90243765.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200556",
    "initial_individuals": "5476",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800789",
    "EFO_Trait_Name": "X-18345 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200556/harmonised/GCST90200556.h.tsv.gz"
  },
  {
    "accessionId": "GCST90296484",
    "initial_individuals": "5465",
    "initial_ancestralGroup": "European",
    "pubmedId": "37572794",
    "EFO_ID": "MONDO_0008867",
    "EFO_Trait_Name": "biliary atresia",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90296001-GCST90297000/GCST90296484/harmonised/GCST90296484.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243613",
    "initial_individuals": "5462",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021226",
    "EFO_Trait_Name": "X-11334 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243613/harmonised/GCST90243613.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243684",
    "initial_individuals": "5461",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021280",
    "EFO_Trait_Name": "X-12039 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243684/harmonised/GCST90243684.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243697",
    "initial_individuals": "5457",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021121",
    "EFO_Trait_Name": "lathosterol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243697/harmonised/GCST90243697.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200627",
    "initial_individuals": "5457",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800876",
    "EFO_Trait_Name": "X-24344 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200627/harmonised/GCST90200627.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199924",
    "initial_individuals": "5440",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800064",
    "EFO_Trait_Name": "N-methyltaurine measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199924/harmonised/GCST90199924.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199951",
    "initial_individuals": "5432",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800987",
    "EFO_Trait_Name": "N-acetylalliin measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199951/harmonised/GCST90199951.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200606",
    "initial_individuals": "5423",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800841",
    "EFO_Trait_Name": "X-22509 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200606/harmonised/GCST90200606.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199953",
    "initial_individuals": "5419",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800071",
    "EFO_Trait_Name": "3-methoxytyramine sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199953/harmonised/GCST90199953.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200604",
    "initial_individuals": "5407",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800847",
    "EFO_Trait_Name": "X-23276 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200604/harmonised/GCST90200604.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200602",
    "initial_individuals": "5389",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800843",
    "EFO_Trait_Name": "X-22520 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200602/harmonised/GCST90200602.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200546",
    "initial_individuals": "5375",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800776",
    "EFO_Trait_Name": "X-17354 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200546/harmonised/GCST90200546.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243571",
    "initial_individuals": "5371",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021136",
    "EFO_Trait_Name": "DSGEGDFXAEGGGVR measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243571/harmonised/GCST90243571.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243729",
    "initial_individuals": "5357",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021309",
    "EFO_Trait_Name": "X-12443 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243729/harmonised/GCST90243729.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200544",
    "initial_individuals": "5337",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800757",
    "EFO_Trait_Name": "X-16124 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200544/harmonised/GCST90200544.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243832",
    "initial_individuals": "5325",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021359",
    "EFO_Trait_Name": "X-13741 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243832/harmonised/GCST90243832.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199725",
    "initial_individuals": "5300",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0020008",
    "EFO_Trait_Name": "campesterol measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199725/harmonised/GCST90199725.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200525",
    "initial_individuals": "5269",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800739",
    "EFO_Trait_Name": "X-13723 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200525/harmonised/GCST90200525.h.tsv.gz"
  },
  {
    "accessionId": "GCST90012607",
    "initial_individuals": "5255",
    "initial_ancestralGroup": "European",
    "pubmedId": "33441150",
    "EFO_ID": "EFO_0005667",
    "EFO_Trait_Name": "urinary albumin excretion rate",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90012001-GCST90013000/GCST90012607/harmonised/GCST90012607.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243757",
    "initial_individuals": "5254",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021319",
    "EFO_Trait_Name": "X-12645 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243757/harmonised/GCST90243757.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199739",
    "initial_individuals": "5190",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021162",
    "EFO_Trait_Name": "salicyluric glucuronide measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199739/harmonised/GCST90199739.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200500",
    "initial_individuals": "5190",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0021336",
    "EFO_Trait_Name": "X-12816 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200500/harmonised/GCST90200500.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200217",
    "initial_individuals": "5189",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801039",
    "EFO_Trait_Name": "(2,4 or 2,5)-dimethylphenol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200217/harmonised/GCST90200217.h.tsv.gz"
  },
  {
    "accessionId": "GCST90200166",
    "initial_individuals": "5188",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0801026",
    "EFO_Trait_Name": "dihydroferulic acid sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90200001-GCST90201000/GCST90200166/harmonised/GCST90200166.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199814",
    "initial_individuals": "5169",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800261",
    "EFO_Trait_Name": "alpha-hydroxycaproate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199814/harmonised/GCST90199814.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243525",
    "initial_individuals": "5161",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021202",
    "EFO_Trait_Name": "X-06350 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243525/harmonised/GCST90243525.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243796",
    "initial_individuals": "5120",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021343",
    "EFO_Trait_Name": "X-12855 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243796/harmonised/GCST90243796.h.tsv.gz"
  },
  {
    "accessionId": "GCST90006922",
    "initial_individuals": "5118",
    "initial_ancestralGroup": "European",
    "pubmedId": "33204752",
    "EFO_ID": "EFO_0010900",
    "EFO_Trait_Name": "anti-polyomavirus 2 antibody measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90006001-GCST90007000/GCST90006922/harmonised/GCST90006922.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243712",
    "initial_individuals": "5111",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021297",
    "EFO_Trait_Name": "X-12231 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243712/harmonised/GCST90243712.h.tsv.gz"
  },
  {
    "accessionId": "GCST008225",
    "initial_individuals": "5087",
    "initial_ancestralGroup": "European",
    "pubmedId": "31231134",
    "EFO_ID": "EFO_0000681",
    "EFO_Trait_Name": "renal cell carcinoma",
    "trait_annotation": "disease",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST008001-GCST009000/GCST008225/harmonised/GCST008225.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199859",
    "initial_individuals": "5082",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0800287",
    "EFO_Trait_Name": "5alpha-androstan-3alpha,17beta-diol disulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199859/harmonised/GCST90199859.h.tsv.gz"
  },
  {
    "accessionId": "GCST90199984",
    "initial_individuals": "5076",
    "initial_ancestralGroup": "European",
    "pubmedId": "36635386",
    "EFO_ID": "EFO_0022214",
    "EFO_Trait_Name": "Blood vanillic alcohol sulfate measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90199001-GCST90200000/GCST90199984/harmonised/GCST90199984.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243659",
    "initial_individuals": "5038",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021262",
    "EFO_Trait_Name": "X-11799 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243659/harmonised/GCST90243659.h.tsv.gz"
  },
  {
    "accessionId": "GCST90204146",
    "initial_individuals": "5026",
    "initial_ancestralGroup": "European",
    "pubmedId": "37768647",
    "EFO_ID": "EFO_1001294",
    "EFO_Trait_Name": "lymphocytic colitis",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90204001-GCST90205000/GCST90204146/harmonised/GCST90204146.h.tsv.gz"
  },
  {
    "accessionId": "GCST90243494",
    "initial_individuals": "5007",
    "initial_ancestralGroup": "European",
    "pubmedId": "24816252",
    "EFO_ID": "EFO_0021190",
    "EFO_Trait_Name": "X-04494 measurement",
    "trait_annotation": "measurement",
    "link": "https://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90243001-GCST90244000/GCST90243494/harmonised/GCST90243494.h.tsv.gz"
  }
] as const;
